(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File === 'function' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.bn.aF === region.bR.aF)
	{
		return 'on line ' + region.bn.aF;
	}
	return 'on lines ' + region.bn.aF + ' through ' + region.bR.aF;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = elm$core$Set$toList(x);
		y = elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = elm$core$Dict$toList(x);
		y = elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = elm$core$Dict$toList(x);
		y = elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? elm$core$Basics$LT : n ? elm$core$Basics$GT : elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === elm$core$Basics$EQ ? 0 : ord === elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return word
		? elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? elm$core$Maybe$Nothing
		: elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? elm$core$Maybe$Just(n) : elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




/**_UNUSED/
function _Json_errorToString(error)
{
	return elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? elm$core$Result$Ok(value)
		: (value instanceof String)
			? elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!elm$core$Result$isOk(result))
					{
						return elm$core$Result$Err(A2(elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return elm$core$Result$Ok(elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if (elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return elm$core$Result$Err(elm$json$Json$Decode$OneOf(elm$core$List$reverse(errors)));

		case 1:
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!elm$core$Result$isOk(result))
		{
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2(elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.dH,
		impl.ea,
		impl.d6,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	}

	_Platform_dispatchEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				p: bag.n,
				q: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.q)
		{
			x = temp.p(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		r: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		r: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2(elm$json$Json$Decode$map, func, handler.a)
				:
			A3(elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		I: func(record.I),
		bo: record.bo,
		bl: record.bl
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.I;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.bo;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.bl) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.dH,
		impl.ea,
		impl.d6,
		function(sendToApp, initialModel) {
			var view = impl.ee;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.dH,
		impl.ea,
		impl.d6,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.aJ && impl.aJ(sendToApp)
			var view = impl.ee;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.c4);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.d9) && (_VirtualDom_doc.title = title = doc.d9);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.dU;
	var onUrlRequest = impl.dV;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		aJ: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.cq === next.cq
							&& curr.b0 === next.b0
							&& curr.cm.a === next.cm.a
						)
							? elm$browser$Browser$Internal(next)
							: elm$browser$Browser$External(href)
					));
				}
			});
		},
		dH: function(flags)
		{
			return A3(impl.dH, flags, _Browser_getUrl(), key);
		},
		ee: impl.ee,
		ea: impl.ea,
		d6: impl.d6
	});
}

function _Browser_getUrl()
{
	return elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return elm$core$Result$isOk(result) ? elm$core$Maybe$Just(result.a) : elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { dC: 'hidden', c6: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { dC: 'mozHidden', c6: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { dC: 'msHidden', c6: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { dC: 'webkitHidden', c6: 'webkitvisibilitychange' }
		: { dC: 'hidden', c6: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail(elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		cA: _Browser_getScene(),
		ef: {
			a7: _Browser_window.pageXOffset,
			a8: _Browser_window.pageYOffset,
			au: _Browser_doc.documentElement.clientWidth,
			dB: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		au: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		dB: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			cA: {
				au: node.scrollWidth,
				dB: node.scrollHeight
			},
			ef: {
				a7: node.scrollLeft,
				a8: node.scrollTop,
				au: node.clientWidth,
				dB: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			cA: _Browser_getScene(),
			ef: {
				a7: x,
				a8: y,
				au: _Browser_doc.documentElement.clientWidth,
				dB: _Browser_doc.documentElement.clientHeight
			},
			dp: {
				a7: x + rect.left,
				a8: y + rect.top,
				au: rect.width,
				dB: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.ds.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done(elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done(elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.ds.b, xhr)); });
		elm$core$Maybe$isJust(request.w) && _Http_track(router, xhr, request.w.a);

		try {
			xhr.open(request.t, request.ec, true);
		} catch (e) {
			return done(elm$http$Http$BadUrl_(request.ec));
		}

		_Http_configureRequest(xhr, request);

		request.c4.a && xhr.setRequestHeader('Content-Type', request.c4.a);
		xhr.send(request.c4.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.p; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.u.a || 0;
	xhr.responseType = request.ds.d;
	xhr.withCredentials = request.X;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? elm$http$Http$GoodStatus_ : elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		ec: xhr.responseURL,
		cI: xhr.status,
		d5: xhr.statusText,
		p: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return elm$core$Dict$empty;
	}

	var headers = elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3(elm$core$Dict$update, key, function(oldValue) {
				return elm$core$Maybe$Just(elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Sending({
			d2: event.loaded,
			bm: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Receiving({
			dZ: event.loaded,
			bm: event.lengthComputable ? elm$core$Maybe$Just(event.total) : elm$core$Maybe$Nothing
		}))));
	});
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2(elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}
var author$project$Models$NoOp = {$: 35};
var author$project$Models$Site = function (id) {
	return function (categoriesId) {
		return function (name) {
			return function (rssLink) {
				return function (webLink) {
					return function (starred) {
						return function (isSelected) {
							return function (numberOfNewArticles) {
								return function (isActive) {
									return function (numberOfFailures) {
										return {bH: categoriesId, dE: id, dJ: isActive, aD: isSelected, aZ: name, dS: numberOfFailures, dT: numberOfNewArticles, d$: rssLink, d4: starred, eg: webLink};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var elm$core$Basics$False = 1;
var elm$core$Basics$True = 0;
var elm$core$Basics$EQ = 1;
var elm$core$Basics$LT = 0;
var elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var elm$core$Array$foldr = F3(
	function (func, baseCase, _n0) {
		var tree = _n0.c;
		var tail = _n0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3(elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3(elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			elm$core$Elm$JsArray$foldr,
			helper,
			A3(elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var elm$core$List$cons = _List_cons;
var elm$core$Array$toList = function (array) {
	return A3(elm$core$Array$foldr, elm$core$List$cons, _List_Nil, array);
};
var elm$core$Basics$GT = 2;
var elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3(elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var elm$core$Dict$toList = function (dict) {
	return A3(
		elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var elm$core$Dict$keys = function (dict) {
	return A3(
		elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2(elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var elm$core$Set$toList = function (_n0) {
	var dict = _n0;
	return elm$core$Dict$keys(dict);
};
var author$project$Models$createEmptySite = author$project$Models$Site(0)(
	_List_fromArray(
		[0]))('')('')('')(false)(false)(0)(true)(0);
var author$project$Models$Options = F3(
	function (articlesPerPage, articlePreviewHeightInEm, maxNumberOfFailures) {
		return {c$: articlePreviewHeightInEm, c1: articlesPerPage, dP: maxNumberOfFailures};
	});
var author$project$Models$defaultOptions = A3(author$project$Models$Options, 10, 15.0, 5);
var author$project$PanelsManager$PanelsState = elm$core$Basics$identity;
var elm$core$Basics$identity = function (x) {
	return x;
};
var author$project$PanelsManager$initialPanelsState = _List_Nil;
var author$project$Swiper$InternalState = function (touchStarted) {
	return {bq: touchStarted};
};
var author$project$Swiper$SwipingState = elm$core$Basics$identity;
var elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var elm$core$Maybe$Nothing = {$: 1};
var author$project$Swiper$initialSwipingState = author$project$Swiper$InternalState(elm$core$Maybe$Nothing);
var elm$time$Time$Posix = elm$core$Basics$identity;
var elm$time$Time$millisToPosix = elm$core$Basics$identity;
var author$project$Models$initialModel = {
	c0: _List_Nil,
	c5: _List_Nil,
	bM: 1,
	bS: _List_Nil,
	bW: false,
	dF: '',
	b6: false,
	ca: false,
	cb: elm$time$Time$millisToPosix(0),
	cd: false,
	ce: {bt: author$project$Models$NoOp, d8: ''},
	bj: author$project$Models$defaultOptions,
	cj: author$project$PanelsManager$initialPanelsState,
	cB: '',
	cD: false,
	cF: author$project$Models$createEmptySite,
	d3: _List_Nil,
	cK: author$project$Swiper$initialSwipingState,
	cQ: false
};
var elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var elm$core$Array$branchFactor = 32;
var elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var elm$core$Basics$ceiling = _Basics_ceiling;
var elm$core$Basics$fdiv = _Basics_fdiv;
var elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var elm$core$Basics$toFloat = _Basics_toFloat;
var elm$core$Array$shiftStep = elm$core$Basics$ceiling(
	A2(elm$core$Basics$logBase, 2, elm$core$Array$branchFactor));
var elm$core$Elm$JsArray$empty = _JsArray_empty;
var elm$core$Array$empty = A4(elm$core$Array$Array_elm_builtin, 0, elm$core$Array$shiftStep, elm$core$Elm$JsArray$empty, elm$core$Elm$JsArray$empty);
var elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var elm$core$List$reverse = function (list) {
	return A3(elm$core$List$foldl, elm$core$List$cons, _List_Nil, list);
};
var elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _n0 = A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodes);
			var node = _n0.a;
			var remainingNodes = _n0.b;
			var newAcc = A2(
				elm$core$List$cons,
				elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var elm$core$Basics$eq = _Utils_equal;
var elm$core$Tuple$first = function (_n0) {
	var x = _n0.a;
	return x;
};
var elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = elm$core$Basics$ceiling(nodeListSize / elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2(elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var elm$core$Basics$add = _Basics_add;
var elm$core$Basics$floor = _Basics_floor;
var elm$core$Basics$gt = _Utils_gt;
var elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var elm$core$Basics$mul = _Basics_mul;
var elm$core$Basics$sub = _Basics_sub;
var elm$core$Elm$JsArray$length = _JsArray_length;
var elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.k) {
			return A4(
				elm$core$Array$Array_elm_builtin,
				elm$core$Elm$JsArray$length(builder.m),
				elm$core$Array$shiftStep,
				elm$core$Elm$JsArray$empty,
				builder.m);
		} else {
			var treeLen = builder.k * elm$core$Array$branchFactor;
			var depth = elm$core$Basics$floor(
				A2(elm$core$Basics$logBase, elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? elm$core$List$reverse(builder.n) : builder.n;
			var tree = A2(elm$core$Array$treeFromBuilder, correctNodeList, builder.k);
			return A4(
				elm$core$Array$Array_elm_builtin,
				elm$core$Elm$JsArray$length(builder.m) + treeLen,
				A2(elm$core$Basics$max, 5, depth * elm$core$Array$shiftStep),
				tree,
				builder.m);
		}
	});
var elm$core$Basics$idiv = _Basics_idiv;
var elm$core$Basics$lt = _Utils_lt;
var elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					elm$core$Array$builderToArray,
					false,
					{n: nodeList, k: (len / elm$core$Array$branchFactor) | 0, m: tail});
			} else {
				var leaf = elm$core$Array$Leaf(
					A3(elm$core$Elm$JsArray$initialize, elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2(elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var elm$core$Basics$le = _Utils_le;
var elm$core$Basics$remainderBy = _Basics_remainderBy;
var elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return elm$core$Array$empty;
		} else {
			var tailLen = len % elm$core$Array$branchFactor;
			var tail = A3(elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - elm$core$Array$branchFactor;
			return A5(elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var elm$core$Basics$and = _Basics_and;
var elm$core$Basics$append = _Utils_append;
var elm$core$Basics$or = _Basics_or;
var elm$core$Char$toCode = _Char_toCode;
var elm$core$Char$isLower = function (_char) {
	var code = elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var elm$core$Char$isUpper = function (_char) {
	var code = elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var elm$core$Char$isAlpha = function (_char) {
	return elm$core$Char$isLower(_char) || elm$core$Char$isUpper(_char);
};
var elm$core$Char$isDigit = function (_char) {
	var code = elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var elm$core$Char$isAlphaNum = function (_char) {
	return elm$core$Char$isLower(_char) || (elm$core$Char$isUpper(_char) || elm$core$Char$isDigit(_char));
};
var elm$core$List$length = function (xs) {
	return A3(
		elm$core$List$foldl,
		F2(
			function (_n0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var elm$core$List$map2 = _List_map2;
var elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2(elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var elm$core$List$range = F2(
	function (lo, hi) {
		return A3(elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			elm$core$List$map2,
			f,
			A2(
				elm$core$List$range,
				0,
				elm$core$List$length(xs) - 1),
			xs);
	});
var elm$core$String$all = _String_all;
var elm$core$String$fromInt = _String_fromNumber;
var elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var elm$core$String$uncons = _String_uncons;
var elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var elm$json$Json$Decode$indent = function (str) {
	return A2(
		elm$core$String$join,
		'\n    ',
		A2(elm$core$String$split, '\n', str));
};
var elm$json$Json$Encode$encode = _Json_encode;
var elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + (elm$core$String$fromInt(i + 1) + (') ' + elm$json$Json$Decode$indent(
			elm$json$Json$Decode$errorToString(error))));
	});
var elm$json$Json$Decode$errorToString = function (error) {
	return A2(elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _n1 = elm$core$String$uncons(f);
						if (_n1.$ === 1) {
							return false;
						} else {
							var _n2 = _n1.a;
							var _char = _n2.a;
							var rest = _n2.b;
							return elm$core$Char$isAlpha(_char) && A2(elm$core$String$all, elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2(elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + (elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2(elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									elm$core$String$join,
									'',
									elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										elm$core$String$join,
										'',
										elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + (elm$core$String$fromInt(
								elm$core$List$length(errors)) + ' ways:'));
							return A2(
								elm$core$String$join,
								'\n\n',
								A2(
									elm$core$List$cons,
									introduction,
									A2(elm$core$List$indexedMap, elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								elm$core$String$join,
								'',
								elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + (elm$json$Json$Decode$indent(
						A2(elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var elm$core$Platform$Cmd$batch = _Platform_batch;
var elm$core$Platform$Cmd$none = elm$core$Platform$Cmd$batch(_List_Nil);
var author$project$Models$init = function (_n0) {
	return _Utils_Tuple2(author$project$Models$initialModel, elm$core$Platform$Cmd$none);
};
var author$project$Models$CloseMenu = {$: 17};
var author$project$Models$ErrorBoxMsg = function (a) {
	return {$: 32, a: a};
};
var author$project$Models$LogErr = function (a) {
	return {$: 3, a: a};
};
var author$project$Models$Outside = function (a) {
	return {$: 33, a: a};
};
var elm$json$Json$Decode$field = _Json_decodeField;
var elm$json$Json$Decode$float = _Json_decodeFloat;
var elm$json$Json$Decode$int = _Json_decodeInt;
var elm$json$Json$Decode$map3 = _Json_map3;
var elm$json$Json$Decode$oneOf = _Json_oneOf;
var elm$json$Json$Decode$succeed = _Json_succeed;
var author$project$Decoder$appOptionsDecoder = A4(
	elm$json$Json$Decode$map3,
	author$project$Models$Options,
	elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(elm$json$Json$Decode$field, 'articlesPerPage', elm$json$Json$Decode$int),
				elm$json$Json$Decode$succeed(author$project$Models$initialModel.bj.c1)
			])),
	elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(elm$json$Json$Decode$field, 'articlePreviewHeightInEm', elm$json$Json$Decode$float),
				elm$json$Json$Decode$succeed(author$project$Models$initialModel.bj.c$)
			])),
	elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(elm$json$Json$Decode$field, 'maxNumberOfFailures', elm$json$Json$Decode$int),
				elm$json$Json$Decode$succeed(author$project$Models$initialModel.bj.dP)
			])));
var author$project$Models$Article = F8(
	function (id, siteId, link, title, excerpt, starred, date, isOpen) {
		return {ba: date, dr: excerpt, dE: id, dL: isOpen, dO: link, a4: siteId, d4: starred, d9: title};
	});
var elm$json$Json$Decode$bool = _Json_decodeBool;
var elm$json$Json$Decode$map = _Json_map1;
var elm$json$Json$Decode$map8 = _Json_map8;
var elm$json$Json$Decode$string = _Json_decodeString;
var author$project$Decoder$articleDecoder = A9(
	elm$json$Json$Decode$map8,
	author$project$Models$Article,
	A2(elm$json$Json$Decode$field, 'id', elm$json$Json$Decode$int),
	A2(elm$json$Json$Decode$field, 'siteId', elm$json$Json$Decode$int),
	A2(elm$json$Json$Decode$field, 'link', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'title', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'excerpt', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'starred', elm$json$Json$Decode$bool),
	A2(
		elm$json$Json$Decode$map,
		elm$time$Time$millisToPosix,
		A2(elm$json$Json$Decode$field, 'date', elm$json$Json$Decode$int)),
	elm$json$Json$Decode$succeed(false));
var elm$json$Json$Decode$list = _Json_decodeList;
var author$project$Decoder$articlesDecoder = elm$json$Json$Decode$list(author$project$Decoder$articleDecoder);
var author$project$Models$Category = F5(
	function (id, name, isSelected, isBeingEdited, height) {
		return {dB: height, dE: id, dK: isBeingEdited, aD: isSelected, aZ: name};
	});
var elm$json$Json$Decode$map5 = _Json_map5;
var author$project$Decoder$categoryDecoder = A6(
	elm$json$Json$Decode$map5,
	author$project$Models$Category,
	A2(elm$json$Json$Decode$field, 'id', elm$json$Json$Decode$int),
	A2(elm$json$Json$Decode$field, 'name', elm$json$Json$Decode$string),
	elm$json$Json$Decode$succeed(false),
	elm$json$Json$Decode$succeed(false),
	elm$json$Json$Decode$succeed(0));
var author$project$Decoder$categoriesDecoder = elm$json$Json$Decode$list(author$project$Decoder$categoryDecoder);
var elm$json$Json$Decode$map2 = _Json_map2;
var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = elm$json$Json$Decode$map2(elm$core$Basics$apR);
var elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2(elm$core$Basics$composeR, elm$json$Json$Decode$succeed, NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var elm$json$Json$Decode$andThen = _Json_andThen;
var elm$json$Json$Decode$decodeValue = _Json_run;
var elm$json$Json$Decode$fail = _Json_fail;
var elm$json$Json$Decode$null = _Json_decodeNull;
var elm$json$Json$Decode$value = _Json_decodeValue;
var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _n0 = A2(elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_n0.$) {
				var rawValue = _n0.a;
				var _n1 = A2(
					elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_n1.$) {
					var finalResult = _n1.a;
					return elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _n1.a;
					return elm$json$Json$Decode$fail(
						elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2(elm$json$Json$Decode$andThen, handleResult, elm$json$Json$Decode$value);
	});
var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2(elm$json$Json$Decode$field, key, elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2(elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var author$project$Decoder$siteDecoder = A4(
	NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'numberOfFailures',
	elm$json$Json$Decode$int,
	0,
	A4(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'isActive',
		elm$json$Json$Decode$bool,
		true,
		A2(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			0,
			A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				false,
				A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'starred',
					elm$json$Json$Decode$bool,
					A3(
						NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'webLink',
						elm$json$Json$Decode$string,
						A3(
							NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'rssLink',
							elm$json$Json$Decode$string,
							A3(
								NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'name',
								elm$json$Json$Decode$string,
								A3(
									NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'categoriesId',
									elm$json$Json$Decode$list(elm$json$Json$Decode$int),
									A3(
										NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										elm$json$Json$Decode$int,
										elm$json$Json$Decode$succeed(author$project$Models$Site)))))))))));
var author$project$Decoder$sitesDecoder = elm$json$Json$Decode$list(author$project$Decoder$siteDecoder);
var author$project$Models$Data = F5(
	function (categories, sites, articles, options, lastRefreshedTime) {
		return {c0: articles, c5: categories, dN: lastRefreshedTime, bj: options, d3: sites};
	});
var author$project$Decoder$dataDecoder = A6(
	elm$json$Json$Decode$map5,
	author$project$Models$Data,
	A2(elm$json$Json$Decode$field, 'categories', author$project$Decoder$categoriesDecoder),
	A2(elm$json$Json$Decode$field, 'sites', author$project$Decoder$sitesDecoder),
	A2(elm$json$Json$Decode$field, 'articles', author$project$Decoder$articlesDecoder),
	A2(elm$json$Json$Decode$field, 'options', author$project$Decoder$appOptionsDecoder),
	A2(
		elm$json$Json$Decode$map,
		elm$time$Time$millisToPosix,
		A2(elm$json$Json$Decode$field, 'lastRefreshedTime', elm$json$Json$Decode$int)));
var author$project$Decoder$decodeData = function (value) {
	return A2(elm$json$Json$Decode$decodeValue, author$project$Decoder$dataDecoder, value);
};
var author$project$Decoder$decodeDbOpened = function (value) {
	return A2(elm$json$Json$Decode$decodeValue, elm$json$Json$Decode$bool, value);
};
var author$project$Decoder$decodeError = function (err) {
	return A2(elm$json$Json$Decode$decodeValue, elm$json$Json$Decode$string, err);
};
var author$project$Decoder$decodeScrollTop = function (scrollTopJson) {
	return A2(elm$json$Json$Decode$decodeValue, elm$json$Json$Decode$int, scrollTopJson);
};
var author$project$Decoder$decodeUser = function (value) {
	return A2(elm$json$Json$Decode$decodeValue, elm$json$Json$Decode$string, value);
};
var author$project$Models$DbOpened = {$: 1};
var author$project$Models$NewData = F5(
	function (a, b, c, d, e) {
		return {$: 2, a: a, b: b, c: c, d: d, e: e};
	});
var author$project$Models$PageScroll = function (a) {
	return {$: 3, a: a};
};
var author$project$Models$UserLoggedIn = function (a) {
	return {$: 0, a: a};
};
var author$project$OutsideInfo$infoForElmPort = _Platform_incomingPort(
	'infoForElmPort',
	A2(
		elm$json$Json$Decode$andThen,
		function (tag) {
			return A2(
				elm$json$Json$Decode$andThen,
				function (data) {
					return elm$json$Json$Decode$succeed(
						{de: data, d7: tag});
				},
				A2(elm$json$Json$Decode$field, 'data', elm$json$Json$Decode$value));
		},
		A2(elm$json$Json$Decode$field, 'tag', elm$json$Json$Decode$string)));
var author$project$OutsideInfo$getInfoFromOutside = F2(
	function (tagger, onError) {
		return author$project$OutsideInfo$infoForElmPort(
			function (outsideInfo) {
				var _n0 = outsideInfo.d7;
				switch (_n0) {
					case 'loginResult':
						var _n1 = author$project$Decoder$decodeUser(outsideInfo.de);
						if (!_n1.$) {
							var userUid = _n1.a;
							return tagger(
								author$project$Models$UserLoggedIn(userUid));
						} else {
							var e = _n1.a;
							return onError('Login error');
						}
					case 'dbOpened':
						var _n2 = author$project$Decoder$decodeDbOpened(outsideInfo.de);
						if (!_n2.$) {
							var dbOpened = _n2.a;
							return tagger(author$project$Models$DbOpened);
						} else {
							var e = _n2.a;
							return onError('Cannot open the DB');
						}
					case 'allData':
						var _n3 = author$project$Decoder$decodeData(outsideInfo.de);
						if (!_n3.$) {
							var data = _n3.a;
							return tagger(
								A5(author$project$Models$NewData, data.c5, data.d3, data.c0, data.bj, data.dN));
						} else {
							var e = _n3.a;
							return onError('Error receiving data');
						}
					case 'pageScroll':
						var _n4 = author$project$Decoder$decodeScrollTop(outsideInfo.de);
						if (!_n4.$) {
							var scrollTop = _n4.a;
							return tagger(
								author$project$Models$PageScroll(scrollTop));
						} else {
							var e = _n4.a;
							return author$project$Models$NoOp;
						}
					case 'error':
						var _n5 = author$project$Decoder$decodeError(outsideInfo.de);
						if (!_n5.$) {
							var errorString = _n5.a;
							return onError(errorString);
						} else {
							var e = _n5.a;
							return onError('Error received');
						}
					default:
						return onError('Unexpected info from outside ');
				}
			});
	});
var elm$browser$Browser$Events$Window = 1;
var elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {cl: pids, cJ: subs};
	});
var elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var elm$core$Dict$empty = elm$core$Dict$RBEmpty_elm_builtin;
var elm$core$Task$succeed = _Scheduler_succeed;
var elm$browser$Browser$Events$init = elm$core$Task$succeed(
	A2(elm$browser$Browser$Events$State, _List_Nil, elm$core$Dict$empty));
var elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {bT: event, b9: key};
	});
var elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var elm$core$Task$andThen = _Scheduler_andThen;
var elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			elm$core$Task$andThen,
			function (a) {
				return elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var elm$browser$Browser$Dom$NotFound = elm$core$Basics$identity;
var elm$core$Basics$never = function (_n0) {
	never:
	while (true) {
		var nvr = _n0;
		var $temp$_n0 = nvr;
		_n0 = $temp$_n0;
		continue never;
	}
};
var elm$core$Task$Perform = elm$core$Basics$identity;
var elm$core$Task$init = elm$core$Task$succeed(0);
var elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							elm$core$List$foldl,
							fn,
							acc,
							elm$core$List$reverse(r4)) : A4(elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4(elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			elm$core$Task$andThen,
			function (a) {
				return A2(
					elm$core$Task$andThen,
					function (b) {
						return elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var elm$core$Task$sequence = function (tasks) {
	return A3(
		elm$core$List$foldr,
		elm$core$Task$map2(elm$core$List$cons),
		elm$core$Task$succeed(_List_Nil),
		tasks);
};
var elm$core$Platform$sendToApp = _Platform_sendToApp;
var elm$core$Task$spawnCmd = F2(
	function (router, _n0) {
		var task = _n0;
		return _Scheduler_spawn(
			A2(
				elm$core$Task$andThen,
				elm$core$Platform$sendToApp(router),
				task));
	});
var elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			elm$core$Task$map,
			function (_n0) {
				return 0;
			},
			elm$core$Task$sequence(
				A2(
					elm$core$List$map,
					elm$core$Task$spawnCmd(router),
					commands)));
	});
var elm$core$Task$onSelfMsg = F3(
	function (_n0, _n1, _n2) {
		return elm$core$Task$succeed(0);
	});
var elm$core$Task$cmdMap = F2(
	function (tagger, _n0) {
		var task = _n0;
		return A2(elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager(elm$core$Task$init, elm$core$Task$onEffects, elm$core$Task$onSelfMsg, elm$core$Task$cmdMap);
var elm$core$Task$command = _Platform_leaf('Task');
var elm$core$Task$perform = F2(
	function (toMessage, task) {
		return elm$core$Task$command(
			A2(elm$core$Task$map, toMessage, task));
	});
var elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var elm$core$String$length = _String_length;
var elm$core$String$slice = _String_slice;
var elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			elm$core$String$slice,
			n,
			elm$core$String$length(string),
			string);
	});
var elm$core$String$startsWith = _String_startsWith;
var elm$url$Url$Http = 0;
var elm$url$Url$Https = 1;
var elm$core$String$indexes = _String_indexes;
var elm$core$String$isEmpty = function (string) {
	return string === '';
};
var elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(elm$core$String$slice, 0, n, string);
	});
var elm$core$String$contains = _String_contains;
var elm$core$String$toInt = _String_toInt;
var elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {bZ: fragment, b0: host, ck: path, cm: port_, cq: protocol, cr: query};
	});
var elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if (elm$core$String$isEmpty(str) || A2(elm$core$String$contains, '@', str)) {
			return elm$core$Maybe$Nothing;
		} else {
			var _n0 = A2(elm$core$String$indexes, ':', str);
			if (!_n0.b) {
				return elm$core$Maybe$Just(
					A6(elm$url$Url$Url, protocol, str, elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_n0.b.b) {
					var i = _n0.a;
					var _n1 = elm$core$String$toInt(
						A2(elm$core$String$dropLeft, i + 1, str));
					if (_n1.$ === 1) {
						return elm$core$Maybe$Nothing;
					} else {
						var port_ = _n1;
						return elm$core$Maybe$Just(
							A6(
								elm$url$Url$Url,
								protocol,
								A2(elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return elm$core$Maybe$Nothing;
				}
			}
		}
	});
var elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Maybe$Nothing;
		} else {
			var _n0 = A2(elm$core$String$indexes, '/', str);
			if (!_n0.b) {
				return A5(elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _n0.a;
				return A5(
					elm$url$Url$chompBeforePath,
					protocol,
					A2(elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2(elm$core$String$left, i, str));
			}
		}
	});
var elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Maybe$Nothing;
		} else {
			var _n0 = A2(elm$core$String$indexes, '?', str);
			if (!_n0.b) {
				return A4(elm$url$Url$chompBeforeQuery, protocol, elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _n0.a;
				return A4(
					elm$url$Url$chompBeforeQuery,
					protocol,
					elm$core$Maybe$Just(
						A2(elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2(elm$core$String$left, i, str));
			}
		}
	});
var elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Maybe$Nothing;
		} else {
			var _n0 = A2(elm$core$String$indexes, '#', str);
			if (!_n0.b) {
				return A3(elm$url$Url$chompBeforeFragment, protocol, elm$core$Maybe$Nothing, str);
			} else {
				var i = _n0.a;
				return A3(
					elm$url$Url$chompBeforeFragment,
					protocol,
					elm$core$Maybe$Just(
						A2(elm$core$String$dropLeft, i + 1, str)),
					A2(elm$core$String$left, i, str));
			}
		}
	});
var elm$url$Url$fromString = function (str) {
	return A2(elm$core$String$startsWith, 'http://', str) ? A2(
		elm$url$Url$chompAfterProtocol,
		0,
		A2(elm$core$String$dropLeft, 7, str)) : (A2(elm$core$String$startsWith, 'https://', str) ? A2(
		elm$url$Url$chompAfterProtocol,
		1,
		A2(elm$core$String$dropLeft, 8, str)) : elm$core$Maybe$Nothing);
};
var elm$browser$Browser$Events$spawn = F3(
	function (router, key, _n0) {
		var node = _n0.a;
		var name = _n0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						elm$core$Platform$sendToSelf,
						router,
						A2(elm$browser$Browser$Events$Event, key, event));
				}));
	});
var elm$core$Dict$Black = 1;
var elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var elm$core$Basics$compare = _Utils_compare;
var elm$core$Dict$Red = 0;
var elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _n1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _n3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5(elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _n5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _n6 = left.d;
				var _n7 = _n6.a;
				var llK = _n6.b;
				var llV = _n6.c;
				var llLeft = _n6.d;
				var llRight = _n6.e;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5(elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5(elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5(elm$core$Dict$RBNode_elm_builtin, 0, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _n1 = A2(elm$core$Basics$compare, key, nKey);
			switch (_n1) {
				case 0:
					return A5(
						elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3(elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5(elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3(elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _n0 = A3(elm$core$Dict$insertHelp, key, value, dict);
		if ((_n0.$ === -1) && (!_n0.a)) {
			var _n1 = _n0.a;
			var k = _n0.b;
			var v = _n0.c;
			var l = _n0.d;
			var r = _n0.e;
			return A5(elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _n0;
			return x;
		}
	});
var elm$core$Dict$fromList = function (assocs) {
	return A3(
		elm$core$List$foldl,
		F2(
			function (_n0, dict) {
				var key = _n0.a;
				var value = _n0.b;
				return A3(elm$core$Dict$insert, key, value, dict);
			}),
		elm$core$Dict$empty,
		assocs);
};
var elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3(elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _n0) {
				stepState:
				while (true) {
					var list = _n0.a;
					var result = _n0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _n2 = list.a;
						var lKey = _n2.a;
						var lValue = _n2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_n0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_n0 = $temp$_n0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _n3 = A3(
			elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _n3.a;
		var intermediateResult = _n3.b;
		return A3(
			elm$core$List$foldl,
			F2(
				function (_n4, result) {
					var k = _n4.a;
					var v = _n4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3(elm$core$Dict$foldl, elm$core$Dict$insert, t2, t1);
	});
var elm$core$Process$kill = _Scheduler_kill;
var elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _n6) {
				var deads = _n6.a;
				var lives = _n6.b;
				var news = _n6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						elm$core$List$cons,
						A3(elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_n4, pid, _n5) {
				var deads = _n5.a;
				var lives = _n5.b;
				var news = _n5.c;
				return _Utils_Tuple3(
					A2(elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _n2, _n3) {
				var deads = _n3.a;
				var lives = _n3.b;
				var news = _n3.c;
				return _Utils_Tuple3(
					deads,
					A3(elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2(elm$core$List$map, elm$browser$Browser$Events$addKey, subs);
		var _n0 = A6(
			elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.cl,
			elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, elm$core$Dict$empty, _List_Nil));
		var deadPids = _n0.a;
		var livePids = _n0.b;
		var makeNewPids = _n0.c;
		return A2(
			elm$core$Task$andThen,
			function (pids) {
				return elm$core$Task$succeed(
					A2(
						elm$browser$Browser$Events$State,
						newSubs,
						A2(
							elm$core$Dict$union,
							livePids,
							elm$core$Dict$fromList(pids))));
			},
			A2(
				elm$core$Task$andThen,
				function (_n1) {
					return elm$core$Task$sequence(makeNewPids);
				},
				elm$core$Task$sequence(
					A2(elm$core$List$map, elm$core$Process$kill, deadPids))));
	});
var elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _n0 = f(mx);
		if (!_n0.$) {
			var x = _n0.a;
			return A2(elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			elm$core$List$foldr,
			elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _n0, state) {
		var key = _n0.b9;
		var event = _n0.bT;
		var toMessage = function (_n2) {
			var subKey = _n2.a;
			var _n3 = _n2.b;
			var node = _n3.a;
			var name = _n3.b;
			var decoder = _n3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : elm$core$Maybe$Nothing;
		};
		var messages = A2(elm$core$List$filterMap, toMessage, state.cJ);
		return A2(
			elm$core$Task$andThen,
			function (_n1) {
				return elm$core$Task$succeed(state);
			},
			elm$core$Task$sequence(
				A2(
					elm$core$List$map,
					elm$core$Platform$sendToApp(router),
					messages)));
	});
var elm$browser$Browser$Events$subMap = F2(
	function (func, _n0) {
		var node = _n0.a;
		var name = _n0.b;
		var decoder = _n0.c;
		return A3(
			elm$browser$Browser$Events$MySub,
			node,
			name,
			A2(elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager(elm$browser$Browser$Events$init, elm$browser$Browser$Events$onEffects, elm$browser$Browser$Events$onSelfMsg, 0, elm$browser$Browser$Events$subMap);
var elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return elm$browser$Browser$Events$subscription(
			A3(elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		elm$browser$Browser$Events$on,
		1,
		'resize',
		A2(
			elm$json$Json$Decode$field,
			'target',
			A3(
				elm$json$Json$Decode$map2,
				func,
				A2(elm$json$Json$Decode$field, 'innerWidth', elm$json$Json$Decode$int),
				A2(elm$json$Json$Decode$field, 'innerHeight', elm$json$Json$Decode$int))));
};
var elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var elm$core$Platform$Sub$batch = _Platform_batch;
var author$project$Subscriptions$subscriptions = function (model) {
	return elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				author$project$OutsideInfo$getInfoFromOutside,
				author$project$Models$Outside,
				A2(elm$core$Basics$composeL, author$project$Models$ErrorBoxMsg, author$project$Models$LogErr)),
				elm$browser$Browser$Events$onResize(
				F2(
					function (height, width) {
						return model.cd ? author$project$Models$CloseMenu : author$project$Models$NoOp;
					}))
			]));
};
var Skinney$murmur3$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {_: charsProcessed, af: hash, T: seed, an: shift};
	});
var Skinney$murmur3$Murmur3$c1 = 3432918353;
var Skinney$murmur3$Murmur3$c2 = 461845907;
var elm$core$Bitwise$and = _Bitwise_and;
var elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var Skinney$murmur3$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var elm$core$Bitwise$or = _Bitwise_or;
var Skinney$murmur3$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var elm$core$Basics$neq = _Utils_notEqual;
var elm$core$Bitwise$xor = _Bitwise_xor;
var Skinney$murmur3$Murmur3$finalize = function (data) {
	var acc = data.af ? (data.T ^ A2(
		Skinney$murmur3$Murmur3$multiplyBy,
		Skinney$murmur3$Murmur3$c2,
		A2(
			Skinney$murmur3$Murmur3$rotlBy,
			15,
			A2(Skinney$murmur3$Murmur3$multiplyBy, Skinney$murmur3$Murmur3$c1, data.af)))) : data.T;
	var h0 = acc ^ data._;
	var h1 = A2(Skinney$murmur3$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2(Skinney$murmur3$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var Skinney$murmur3$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			Skinney$murmur3$Murmur3$multiplyBy,
			5,
			A2(
				Skinney$murmur3$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					Skinney$murmur3$Murmur3$multiplyBy,
					Skinney$murmur3$Murmur3$c2,
					A2(
						Skinney$murmur3$Murmur3$rotlBy,
						15,
						A2(Skinney$murmur3$Murmur3$multiplyBy, Skinney$murmur3$Murmur3$c1, k1))))) + 3864292196;
	});
var Skinney$murmur3$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.af | ((255 & elm$core$Char$toCode(c)) << data.an);
		var _n0 = data.an;
		if (_n0 === 24) {
			return {
				_: data._ + 1,
				af: 0,
				T: A2(Skinney$murmur3$Murmur3$mix, data.T, res),
				an: 0
			};
		} else {
			return {_: data._ + 1, af: res, T: data.T, an: data.an + 8};
		}
	});
var elm$core$String$foldl = _String_foldl;
var Skinney$murmur3$Murmur3$hashString = F2(
	function (seed, str) {
		return Skinney$murmur3$Murmur3$finalize(
			A3(
				elm$core$String$foldl,
				Skinney$murmur3$Murmur3$hashFold,
				A4(Skinney$murmur3$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var author$project$Models$OpmlCategory = F2(
	function (name, sites) {
		return {aZ: name, d3: sites};
	});
var elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2(elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var author$project$Export$convertCategoryInCategoryToExport = F2(
	function (sites, category) {
		return A2(
			author$project$Models$OpmlCategory,
			category.aZ,
			A2(
				elm$core$List$filter,
				function (site) {
					return A2(elm$core$List$member, category.dE, site.bH);
				},
				sites));
	});
var elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			elm$core$List$foldl,
			F2(
				function (_n0, obj) {
					var k = _n0.a;
					var v = _n0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var elm$json$Json$Encode$string = _Json_wrap;
var author$project$Export$headEncoder = elm$json$Json$Encode$object(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'title',
			elm$json$Json$Encode$string('Subscriptions'))
		]));
var author$project$Export$opmlSiteEncoder = function (site) {
	return elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				elm$json$Json$Encode$string('rss')),
				_Utils_Tuple2(
				'text',
				elm$json$Json$Encode$string(site.aZ)),
				_Utils_Tuple2(
				'title',
				elm$json$Json$Encode$string(site.aZ)),
				_Utils_Tuple2(
				'xmlurl',
				elm$json$Json$Encode$string(site.d$)),
				_Utils_Tuple2(
				'htmlUrl',
				elm$json$Json$Encode$string(site.eg))
			]));
};
var elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var author$project$Export$opmlSitesEncoder = function (sites) {
	return A2(elm$json$Json$Encode$list, author$project$Export$opmlSiteEncoder, sites);
};
var author$project$Export$opmlCategoryEncoder = function (categoryToExport) {
	return elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				elm$json$Json$Encode$string(categoryToExport.aZ)),
				_Utils_Tuple2(
				'_children',
				author$project$Export$opmlSitesEncoder(categoryToExport.d3))
			]));
};
var author$project$Export$opmlEncoder = F2(
	function (categoriesToExport, orphanSites) {
		return elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2('head', author$project$Export$headEncoder),
					_Utils_Tuple2(
					'categories',
					A2(elm$json$Json$Encode$list, author$project$Export$opmlCategoryEncoder, categoriesToExport)),
					_Utils_Tuple2(
					'orphanSites',
					A2(elm$json$Json$Encode$list, author$project$Export$opmlSiteEncoder, orphanSites))
				]));
	});
var elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var author$project$Export$encodeOpml = F2(
	function (categories, sites) {
		var orphanSites = A2(
			elm$core$List$filter,
			function (site) {
				return elm$core$List$isEmpty(site.bH);
			},
			sites);
		var categoriesToExport = A2(
			elm$core$List$map,
			author$project$Export$convertCategoryInCategoryToExport(sites),
			categories);
		return A2(author$project$Export$opmlEncoder, categoriesToExport, orphanSites);
	});
var elm$parser$Parser$deadEndsToString = function (deadEnds) {
	return 'TODO deadEndsToString';
};
var elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {bK: col, cn: problem, cy: row};
	});
var elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3(elm$parser$Parser$DeadEnd, p.cy, p.bK, p.cn);
};
var elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2(elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2(elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var elm$parser$Parser$Advanced$run = F2(
	function (_n0, src) {
		var parse = _n0;
		var _n1 = parse(
			{bK: 1, f: _List_Nil, g: 1, b: 0, cy: 1, a: src});
		if (!_n1.$) {
			var value = _n1.b;
			return elm$core$Result$Ok(value);
		} else {
			var bag = _n1.b;
			return elm$core$Result$Err(
				A2(elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var elm$parser$Parser$run = F2(
	function (parser, source) {
		var _n0 = A2(elm$parser$Parser$Advanced$run, parser, source);
		if (!_n0.$) {
			var a = _n0.a;
			return elm$core$Result$Ok(a);
		} else {
			var problems = _n0.a;
			return elm$core$Result$Err(
				A2(elm$core$List$map, elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var elm$parser$Parser$Advanced$Parser = elm$core$Basics$identity;
var elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _n0) {
		var parseA = _n0;
		return function (s0) {
			var _n1 = parseA(s0);
			if (_n1.$ === 1) {
				var p = _n1.a;
				var x = _n1.b;
				return A2(elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _n1.a;
				var a = _n1.b;
				var s1 = _n1.c;
				var _n2 = callback(a);
				var parseB = _n2;
				var _n3 = parseB(s1);
				if (_n3.$ === 1) {
					var p2 = _n3.a;
					var x = _n3.b;
					return A2(elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _n3.a;
					var b = _n3.b;
					var s2 = _n3.c;
					return A3(elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var elm$parser$Parser$andThen = elm$parser$Parser$Advanced$andThen;
var elm$parser$Parser$ExpectingEnd = {$: 10};
var elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {bK: col, dd: contextStack, cn: problem, cy: row};
	});
var elm$parser$Parser$Advanced$Empty = {$: 0};
var elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			elm$parser$Parser$Advanced$AddRight,
			elm$parser$Parser$Advanced$Empty,
			A4(elm$parser$Parser$Advanced$DeadEnd, s.cy, s.bK, x, s.f));
	});
var elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			elm$core$String$length(s.a),
			s.b) ? A3(elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			elm$parser$Parser$Advanced$Bad,
			false,
			A2(elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var elm$parser$Parser$end = elm$parser$Parser$Advanced$end(elm$parser$Parser$ExpectingEnd);
var elm$core$Basics$always = F2(
	function (a, _n0) {
		return a;
	});
var elm$parser$Parser$Advanced$map2 = F3(
	function (func, _n0, _n1) {
		var parseA = _n0;
		var parseB = _n1;
		return function (s0) {
			var _n2 = parseA(s0);
			if (_n2.$ === 1) {
				var p = _n2.a;
				var x = _n2.b;
				return A2(elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _n2.a;
				var a = _n2.b;
				var s1 = _n2.c;
				var _n3 = parseB(s1);
				if (_n3.$ === 1) {
					var p2 = _n3.a;
					var x = _n3.b;
					return A2(elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _n3.a;
					var b = _n3.b;
					var s2 = _n3.c;
					return A3(
						elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3(elm$parser$Parser$Advanced$map2, elm$core$Basics$always, keepParser, ignoreParser);
	});
var elm$parser$Parser$ignorer = elm$parser$Parser$Advanced$ignorer;
var elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3(elm$parser$Parser$Advanced$map2, elm$core$Basics$apL, parseFunc, parseArg);
	});
var elm$parser$Parser$keeper = elm$parser$Parser$Advanced$keeper;
var elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2(elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _n1 = parse(s0);
				if (!_n1.$) {
					var step = _n1;
					return step;
				} else {
					var step = _n1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2(elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3(elm$parser$Parser$Advanced$oneOfHelp, s, elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var elm$parser$Parser$oneOf = elm$parser$Parser$Advanced$oneOf;
var elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3(elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var elm$parser$Parser$succeed = elm$parser$Parser$Advanced$succeed;
var elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$core$Basics$negate = function (n) {
	return -n;
};
var elm$core$Basics$not = _Basics_not;
var elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var elm$parser$Parser$Advanced$token = function (_n0) {
	var str = _n0.a;
	var expecting = _n0.b;
	var progress = !elm$core$String$isEmpty(str);
	return function (s) {
		var _n1 = A5(elm$parser$Parser$Advanced$isSubString, str, s.b, s.cy, s.bK, s.a);
		var newOffset = _n1.a;
		var newRow = _n1.b;
		var newCol = _n1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			elm$parser$Parser$Advanced$Bad,
			false,
			A2(elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{bK: newCol, f: s.f, g: s.g, b: newOffset, cy: newRow, a: s.a});
	};
};
var elm$parser$Parser$Advanced$symbol = elm$parser$Parser$Advanced$token;
var elm$parser$Parser$symbol = function (str) {
	return elm$parser$Parser$Advanced$symbol(
		A2(
			elm$parser$Parser$Advanced$Token,
			str,
			elm$parser$Parser$ExpectingSymbol(str)));
};
var elm$core$Basics$round = _Basics_round;
var elm$core$String$toFloat = _String_toFloat;
var elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3(elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.a);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.b, offset) < 0,
					0,
					{bK: col, f: s0.f, g: s0.g, b: offset, cy: row, a: s0.a});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5(elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.b, s.cy, s.bK, s);
	};
};
var elm$parser$Parser$chompWhile = elm$parser$Parser$Advanced$chompWhile;
var elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _n0) {
		var parse = _n0;
		return function (s0) {
			var _n1 = parse(s0);
			if (_n1.$ === 1) {
				var p = _n1.a;
				var x = _n1.b;
				return A2(elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _n1.a;
				var a = _n1.b;
				var s1 = _n1.c;
				return A3(
					elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3(elm$core$String$slice, s0.b, s1.b, s0.a),
						a),
					s1);
			}
		};
	});
var elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2(elm$parser$Parser$Advanced$mapChompedString, elm$core$Basics$always, parser);
};
var elm$parser$Parser$getChompedString = elm$parser$Parser$Advanced$getChompedString;
var elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			elm$parser$Parser$Advanced$Bad,
			false,
			A2(elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var elm$parser$Parser$problem = function (msg) {
	return elm$parser$Parser$Advanced$problem(
		elm$parser$Parser$Problem(msg));
};
var rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	elm$parser$Parser$andThen,
	function (str) {
		if (elm$core$String$length(str) <= 9) {
			var _n0 = elm$core$String$toFloat('0.' + str);
			if (!_n0.$) {
				var floatVal = _n0.a;
				return elm$parser$Parser$succeed(
					elm$core$Basics$round(floatVal * 1000));
			} else {
				return elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + elm$core$String$fromInt(
					elm$core$String$length(str)));
		}
	},
	elm$parser$Parser$getChompedString(
		elm$parser$Parser$chompWhile(elm$core$Char$isDigit)));
var rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var elm$core$String$append = _String_append;
var elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var elm$parser$Parser$UnexpectedChar = {$: 11};
var elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3(elm$parser$Parser$Advanced$isSubChar, isGood, s.b, s.a);
			return _Utils_eq(newOffset, -1) ? A2(
				elm$parser$Parser$Advanced$Bad,
				false,
				A2(elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				elm$parser$Parser$Advanced$Good,
				true,
				0,
				{bK: 1, f: s.f, g: s.g, b: s.b + 1, cy: s.cy + 1, a: s.a}) : A3(
				elm$parser$Parser$Advanced$Good,
				true,
				0,
				{bK: s.bK + 1, f: s.f, g: s.g, b: newOffset, cy: s.cy, a: s.a}));
		};
	});
var elm$parser$Parser$chompIf = function (isGood) {
	return A2(elm$parser$Parser$Advanced$chompIf, isGood, elm$parser$Parser$UnexpectedChar);
};
var elm$parser$Parser$Advanced$map = F2(
	function (func, _n0) {
		var parse = _n0;
		return function (s0) {
			var _n1 = parse(s0);
			if (!_n1.$) {
				var p = _n1.a;
				var a = _n1.b;
				var s1 = _n1.c;
				return A3(
					elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _n1.a;
				var x = _n1.b;
				return A2(elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var elm$parser$Parser$map = elm$parser$Parser$Advanced$map;
var elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return elm$parser$Parser$Advanced$Done(a);
	}
};
var elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _n0 = callback(state);
			var parse = _n0;
			var _n1 = parse(s0);
			if (!_n1.$) {
				var p1 = _n1.a;
				var step = _n1.b;
				var s1 = _n1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3(elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _n1.a;
				var x = _n1.b;
				return A2(elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4(elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					elm$parser$Parser$map,
					elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			elm$core$String$length(str),
			quantity)) {
			var _n0 = elm$core$String$toInt(str);
			if (!_n0.$) {
				var intVal = _n0.a;
				return A2(
					elm$parser$Parser$map,
					elm$parser$Parser$Done,
					elm$parser$Parser$succeed(intVal));
			} else {
				return elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				elm$parser$Parser$map,
				function (nextChar) {
					return elm$parser$Parser$Loop(
						A2(elm$core$String$append, str, nextChar));
				},
				elm$parser$Parser$getChompedString(
					elm$parser$Parser$chompIf(elm$core$Char$isDigit)));
		}
	};
	return A2(elm$parser$Parser$loop, '', helper);
};
var rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return elm$parser$Parser$problem(
		'Invalid day: ' + elm$core$String$fromInt(day));
};
var elm$core$Basics$modBy = _Basics_modBy;
var rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2(elm$core$Basics$modBy, 4, year)) && (A2(elm$core$Basics$modBy, 100, year) || (!A2(elm$core$Basics$modBy, 400, year)));
};
var rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_n0) {
	var year = _n0.a;
	var month = _n0.b;
	var dayInMonth = _n0.c;
	if (dayInMonth < 0) {
		return rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + (rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return elm$parser$Parser$problem(
					'Invalid month: \"' + (elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	elm$parser$Parser$andThen,
	rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		elm$parser$Parser$keeper,
		A2(
			elm$parser$Parser$keeper,
			A2(
				elm$parser$Parser$keeper,
				elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						elm$parser$Parser$keeper,
						A2(
							elm$parser$Parser$ignorer,
							elm$parser$Parser$succeed(elm$core$Basics$identity),
							elm$parser$Parser$symbol('-')),
						rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					elm$parser$Parser$keeper,
					A2(
						elm$parser$Parser$ignorer,
						elm$parser$Parser$succeed(elm$core$Basics$identity),
						elm$parser$Parser$symbol('-')),
					rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		elm$parser$Parser$keeper,
		elm$parser$Parser$succeed(elm$core$Basics$identity),
		elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					elm$parser$Parser$map,
					function (_n0) {
						return 0;
					},
					elm$parser$Parser$symbol('Z')),
					A2(
					elm$parser$Parser$keeper,
					A2(
						elm$parser$Parser$keeper,
						A2(
							elm$parser$Parser$keeper,
							elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										elm$parser$Parser$map,
										function (_n1) {
											return 1;
										},
										elm$parser$Parser$symbol('+')),
										A2(
										elm$parser$Parser$map,
										function (_n2) {
											return -1;
										},
										elm$parser$Parser$symbol('-'))
									]))),
						rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								elm$parser$Parser$keeper,
								A2(
									elm$parser$Parser$ignorer,
									elm$parser$Parser$succeed(elm$core$Basics$identity),
									elm$parser$Parser$symbol(':')),
								rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								elm$parser$Parser$succeed(0)
							]))),
					A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(0),
					elm$parser$Parser$end)
				])));
}();
var rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	elm$parser$Parser$andThen,
	function (datePart) {
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					elm$parser$Parser$keeper,
					A2(
						elm$parser$Parser$keeper,
						A2(
							elm$parser$Parser$keeper,
							A2(
								elm$parser$Parser$keeper,
								A2(
									elm$parser$Parser$keeper,
									A2(
										elm$parser$Parser$ignorer,
										elm$parser$Parser$succeed(
											rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										elm$parser$Parser$symbol('T')),
									rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											elm$parser$Parser$keeper,
											A2(
												elm$parser$Parser$ignorer,
												elm$parser$Parser$succeed(elm$core$Basics$identity),
												elm$parser$Parser$symbol(':')),
											rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										elm$parser$Parser$keeper,
										A2(
											elm$parser$Parser$ignorer,
											elm$parser$Parser$succeed(elm$core$Basics$identity),
											elm$parser$Parser$symbol(':')),
										rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
									]))),
						elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									elm$parser$Parser$keeper,
									A2(
										elm$parser$Parser$ignorer,
										elm$parser$Parser$succeed(elm$core$Basics$identity),
										elm$parser$Parser$symbol('.')),
									rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									elm$parser$Parser$succeed(0)
								]))),
					A2(elm$parser$Parser$ignorer, rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, elm$parser$Parser$end)),
					A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(
						A6(rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					elm$parser$Parser$end)
				]));
	},
	rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2(elm$parser$Parser$run, rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var rtfeldman$elm_iso8601_date_strings$Iso8601$decoder = A2(
	elm$json$Json$Decode$andThen,
	function (str) {
		var _n0 = rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
		if (_n0.$ === 1) {
			var deadEnds = _n0.a;
			return elm$json$Json$Decode$fail(
				elm$parser$Parser$deadEndsToString(deadEnds));
		} else {
			var time = _n0.a;
			return elm$json$Json$Decode$succeed(time);
		}
	},
	elm$json$Json$Decode$string);
var author$project$Decoder$feedArticleDecoder = function (siteId) {
	return A9(
		elm$json$Json$Decode$map8,
		author$project$Models$Article,
		elm$json$Json$Decode$succeed(0),
		elm$json$Json$Decode$succeed(siteId),
		A2(elm$json$Json$Decode$field, 'link', elm$json$Json$Decode$string),
		A2(elm$json$Json$Decode$field, 'title', elm$json$Json$Decode$string),
		A2(elm$json$Json$Decode$field, 'content', elm$json$Json$Decode$string),
		elm$json$Json$Decode$succeed(false),
		A2(elm$json$Json$Decode$field, 'isoDate', rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
		elm$json$Json$Decode$succeed(false));
};
var author$project$Decoder$feedDecoder = function (siteId) {
	return A2(
		elm$json$Json$Decode$field,
		'items',
		elm$json$Json$Decode$list(
			author$project$Decoder$feedArticleDecoder(siteId)));
};
var author$project$Models$GetArticles = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return elm$core$Result$Err(
				f(e));
		}
	});
var elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _n1 = A2(elm$core$Basics$compare, targetKey, key);
				switch (_n1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _n1 = dict.d;
			var lClr = _n1.a;
			var lK = _n1.b;
			var lV = _n1.c;
			var lLeft = _n1.d;
			var lRight = _n1.e;
			var _n2 = dict.e;
			var rClr = _n2.a;
			var rK = _n2.b;
			var rV = _n2.c;
			var rLeft = _n2.d;
			var _n3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _n2.e;
			return A5(
				elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5(elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _n4 = dict.d;
			var lClr = _n4.a;
			var lK = _n4.b;
			var lV = _n4.c;
			var lLeft = _n4.d;
			var lRight = _n4.e;
			var _n5 = dict.e;
			var rClr = _n5.a;
			var rK = _n5.b;
			var rV = _n5.c;
			var rLeft = _n5.d;
			var rRight = _n5.e;
			if (clr === 1) {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _n1 = dict.d;
			var lClr = _n1.a;
			var lK = _n1.b;
			var lV = _n1.c;
			var _n2 = _n1.d;
			var _n3 = _n2.a;
			var llK = _n2.b;
			var llV = _n2.c;
			var llLeft = _n2.d;
			var llRight = _n2.e;
			var lRight = _n1.e;
			var _n4 = dict.e;
			var rClr = _n4.a;
			var rK = _n4.b;
			var rV = _n4.c;
			var rLeft = _n4.d;
			var rRight = _n4.e;
			return A5(
				elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5(elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _n5 = dict.d;
			var lClr = _n5.a;
			var lK = _n5.b;
			var lV = _n5.c;
			var lLeft = _n5.d;
			var lRight = _n5.e;
			var _n6 = dict.e;
			var rClr = _n6.a;
			var rK = _n6.b;
			var rV = _n6.c;
			var rLeft = _n6.d;
			var rRight = _n6.e;
			if (clr === 1) {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _n1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5(elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_n2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _n3 = right.a;
							var _n4 = right.d;
							var _n5 = _n4.a;
							return elm$core$Dict$moveRedRight(dict);
						} else {
							break _n2$2;
						}
					} else {
						var _n6 = right.a;
						var _n7 = right.d;
						return elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _n2$2;
				}
			}
			return dict;
		}
	});
var elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _n3 = lLeft.a;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					elm$core$Dict$removeMin(left),
					right);
			} else {
				var _n4 = elm$core$Dict$moveRedLeft(dict);
				if (_n4.$ === -1) {
					var nColor = _n4.a;
					var nKey = _n4.b;
					var nValue = _n4.c;
					var nLeft = _n4.d;
					var nRight = _n4.e;
					return A5(
						elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _n4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _n6 = lLeft.a;
						return A5(
							elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2(elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _n7 = elm$core$Dict$moveRedLeft(dict);
						if (_n7.$ === -1) {
							var nColor = _n7.a;
							var nKey = _n7.b;
							var nValue = _n7.c;
							var nLeft = _n7.d;
							var nRight = _n7.e;
							return A5(
								elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2(elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2(elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7(elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _n1 = elm$core$Dict$getMin(right);
				if (_n1.$ === -1) {
					var minKey = _n1.b;
					var minValue = _n1.c;
					return A5(
						elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						elm$core$Dict$removeMin(right));
				} else {
					return elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2(elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var elm$core$Dict$remove = F2(
	function (key, dict) {
		var _n0 = A2(elm$core$Dict$removeHelp, key, dict);
		if ((_n0.$ === -1) && (!_n0.a)) {
			var _n1 = _n0.a;
			var k = _n0.b;
			var v = _n0.c;
			var l = _n0.d;
			var r = _n0.e;
			return A5(elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _n0;
			return x;
		}
	});
var elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _n0 = alter(
			A2(elm$core$Dict$get, targetKey, dictionary));
		if (!_n0.$) {
			var value = _n0.a;
			return A3(elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2(elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return elm$core$Result$Err(e);
		}
	});
var elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var elm$http$Http$NetworkError_ = {$: 2};
var elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var elm$http$Http$Timeout_ = {$: 1};
var elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			elm$core$Basics$identity,
			A2(elm$core$Basics$composeR, toResult, toMsg));
	});
var elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var elm$http$Http$NetworkError = {$: 2};
var elm$http$Http$Timeout = {$: 1};
var elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return elm$core$Result$Err(
					elm$http$Http$BadUrl(url));
			case 1:
				return elm$core$Result$Err(elm$http$Http$Timeout);
			case 2:
				return elm$core$Result$Err(elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return elm$core$Result$Err(
					elm$http$Http$BadStatus(metadata.cI));
			default:
				var body = response.b;
				return A2(
					elm$core$Result$mapError,
					elm$http$Http$BadBody,
					toResult(body));
		}
	});
var elm$json$Json$Decode$decodeString = _Json_runOnString;
var elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			elm$http$Http$expectStringResponse,
			toMsg,
			elm$http$Http$resolve(
				function (string) {
					return A2(
						elm$core$Result$mapError,
						elm$json$Json$Decode$errorToString,
						A2(elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var elm$http$Http$emptyBody = _Http_emptyBody;
var elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var elm$http$Http$State = F2(
	function (reqs, subs) {
		return {cu: reqs, cJ: subs};
	});
var elm$http$Http$init = elm$core$Task$succeed(
	A2(elm$http$Http$State, elm$core$Dict$empty, _List_Nil));
var elm$core$Process$spawn = _Scheduler_spawn;
var elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _n2 = A2(elm$core$Dict$get, tracker, reqs);
					if (_n2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _n2.a;
						return A2(
							elm$core$Task$andThen,
							function (_n3) {
								return A3(
									elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2(elm$core$Dict$remove, tracker, reqs));
							},
							elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						elm$core$Task$andThen,
						function (pid) {
							var _n4 = req.w;
							if (_n4.$ === 1) {
								return A3(elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _n4.a;
								return A3(
									elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3(elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			elm$core$Task$andThen,
			function (reqs) {
				return elm$core$Task$succeed(
					A2(elm$http$Http$State, reqs, subs));
			},
			A3(elm$http$Http$updateReqs, router, cmds, state.cu));
	});
var elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _n0) {
		var actualTracker = _n0.a;
		var toMsg = _n0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? elm$core$Maybe$Just(
			A2(
				elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : elm$core$Maybe$Nothing;
	});
var elm$http$Http$onSelfMsg = F3(
	function (router, _n0, state) {
		var tracker = _n0.a;
		var progress = _n0.b;
		return A2(
			elm$core$Task$andThen,
			function (_n1) {
				return elm$core$Task$succeed(state);
			},
			elm$core$Task$sequence(
				A2(
					elm$core$List$filterMap,
					A3(elm$http$Http$maybeSend, router, tracker, progress),
					state.cJ)));
	});
var elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return elm$http$Http$Request(
				{
					X: r.X,
					c4: r.c4,
					ds: A2(_Http_mapExpect, func, r.ds),
					p: r.p,
					t: r.t,
					u: r.u,
					w: r.w,
					ec: r.ec
				});
		}
	});
var elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$http$Http$subMap = F2(
	function (func, _n0) {
		var tracker = _n0.a;
		var toMsg = _n0.b;
		return A2(
			elm$http$Http$MySub,
			tracker,
			A2(elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager(elm$http$Http$init, elm$http$Http$onEffects, elm$http$Http$onSelfMsg, elm$http$Http$cmdMap, elm$http$Http$subMap);
var elm$http$Http$command = _Platform_leaf('Http');
var elm$http$Http$subscription = _Platform_leaf('Http');
var elm$http$Http$request = function (r) {
	return elm$http$Http$command(
		elm$http$Http$Request(
			{X: false, c4: r.c4, ds: r.ds, p: r.p, t: r.t, u: r.u, w: r.w, ec: r.ec}));
};
var elm$http$Http$get = function (r) {
	return elm$http$Http$request(
		{c4: elm$http$Http$emptyBody, ds: r.ds, p: _List_Nil, t: 'GET', u: elm$core$Maybe$Nothing, w: elm$core$Maybe$Nothing, ec: r.ec});
};
var author$project$GetFeeds$getSiteFeed = function (site) {
	return elm$http$Http$get(
		{
			ds: A2(
				elm$http$Http$expectJson,
				author$project$Models$GetArticles(site.dE),
				author$project$Decoder$feedDecoder(site.dE)),
			ec: 'https://rss2json.fbedussi.now.sh/?url=' + site.d$
		});
};
var author$project$GetFeeds$getFeeds = function (sites) {
	return A2(
		elm$core$List$map,
		function (site) {
			return author$project$GetFeeds$getSiteFeed(site);
		},
		A2(
			elm$core$List$filter,
			function (site) {
				return site.dJ;
			},
			sites));
};
var elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var elm$time$Time$posixToMillis = function (_n0) {
	var millis = _n0;
	return millis;
};
var author$project$Helpers$lessThanOneDayDifference = F2(
	function (articleDate, lastRefreshTime) {
		var difference = elm$core$Basics$abs(
			elm$time$Time$posixToMillis(articleDate) - elm$time$Time$posixToMillis(lastRefreshTime));
		return _Utils_cmp(difference, ((1000 * 60) * 60) * 25) < 0;
	});
var author$project$Helpers$countNewArticlesInSite = F3(
	function (siteId, articles, lastRefreshTime) {
		return elm$core$List$length(
			A2(
				elm$core$List$filter,
				function (article) {
					return _Utils_eq(article.a4, siteId) && A2(author$project$Helpers$lessThanOneDayDifference, article.ba, lastRefreshTime);
				},
				articles));
	});
var author$project$Helpers$createErrorMsg = function (text) {
	return {
		dE: elm$core$String$fromInt(
			A2(Skinney$murmur3$Murmur3$hashString, 1234, text)),
		d8: text
	};
};
var author$project$Helpers$dateDescending = F2(
	function (article1, article2) {
		var _n0 = A2(
			elm$core$Basics$compare,
			elm$time$Time$posixToMillis(article1.ba),
			elm$time$Time$posixToMillis(article2.ba));
		switch (_n0) {
			case 0:
				return 2;
			case 1:
				return 1;
			default:
				return 0;
		}
	});
var elm$core$Process$sleep = _Process_sleep;
var author$project$Helpers$delay = F2(
	function (time, msg) {
		return A2(
			elm$core$Task$perform,
			elm$core$Basics$identity,
			A2(
				elm$core$Task$andThen,
				elm$core$Basics$always(
					elm$core$Task$succeed(msg)),
				elm$core$Process$sleep(
					elm$time$Time$posixToMillis(time))));
	});
var author$project$Helpers$getDataToSaveInDb = function (model) {
	return _Utils_Tuple3(
		model.c5,
		model.d3,
		A2(
			elm$core$List$filter,
			function (article) {
				return article.d4;
			},
			model.c0));
};
var author$project$Helpers$extractId = elm$core$List$map(
	function (entity) {
		return entity.dE;
	});
var elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3(elm$core$List$foldr, elm$core$List$cons, ys, xs);
		}
	});
var author$project$Helpers$mergeArticles = F2(
	function (baseArticles, overrideArticles) {
		var overrideArticleIds = author$project$Helpers$extractId(overrideArticles);
		var filteredBaseArticles = A2(
			elm$core$List$filter,
			function (baseArticle) {
				return !A2(elm$core$List$member, baseArticle.dE, overrideArticleIds);
			},
			baseArticles);
		return A2(elm$core$List$append, overrideArticles, filteredBaseArticles);
	});
var author$project$Helpers$toggleSelected = F2(
	function (items, id) {
		return A2(
			elm$core$List$map,
			function (item) {
				return _Utils_eq(item.dE, id) ? _Utils_update(
					item,
					{aD: !item.aD}) : _Utils_update(
					item,
					{aD: false});
			},
			items);
	});
var author$project$Import$opmlSiteDecoder = A2(
	NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	0,
	A2(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		true,
		A2(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			0,
			A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				false,
				A2(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
					false,
					A3(
						NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'_htmlUrl',
						elm$json$Json$Decode$string,
						A3(
							NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'_xmlUrl',
							elm$json$Json$Decode$string,
							A3(
								NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'_title',
								elm$json$Json$Decode$string,
								A2(
									NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
									_List_Nil,
									A2(
										NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
										0,
										elm$json$Json$Decode$succeed(author$project$Models$Site)))))))))));
var author$project$Import$opmlCategoryDecoder = A3(
	elm$json$Json$Decode$map2,
	author$project$Models$OpmlCategory,
	A2(elm$json$Json$Decode$field, '_title', elm$json$Json$Decode$string),
	A2(
		elm$json$Json$Decode$field,
		'outline',
		elm$json$Json$Decode$list(author$project$Import$opmlSiteDecoder)));
var elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var author$project$Import$fakeSiteList = F6(
	function (id, categoriesId, name, rssLink, webLink, starred) {
		return elm$core$List$singleton(
			author$project$Models$Site(id)(categoriesId)(name)(rssLink)(webLink)(starred)(false)(0)(true)(0));
	});
var elm$json$Json$Decode$map6 = _Json_map6;
var author$project$Import$opmlLooseSiteDecoder = A3(
	elm$json$Json$Decode$map2,
	author$project$Models$OpmlCategory,
	elm$json$Json$Decode$succeed(''),
	A7(
		elm$json$Json$Decode$map6,
		author$project$Import$fakeSiteList,
		elm$json$Json$Decode$succeed(0),
		elm$json$Json$Decode$succeed(_List_Nil),
		A2(elm$json$Json$Decode$field, '_title', elm$json$Json$Decode$string),
		A2(elm$json$Json$Decode$field, '_xmlUrl', elm$json$Json$Decode$string),
		A2(elm$json$Json$Decode$field, '_htmlUrl', elm$json$Json$Decode$string),
		elm$json$Json$Decode$succeed(false)));
var author$project$Import$opmlDecoder = A2(
	elm$json$Json$Decode$field,
	'body',
	A2(
		elm$json$Json$Decode$field,
		'outline',
		elm$json$Json$Decode$list(
			elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[author$project$Import$opmlCategoryDecoder, author$project$Import$opmlLooseSiteDecoder])))));
var author$project$Import$decodeOpml = function (importData) {
	return A2(elm$json$Json$Decode$decodeString, author$project$Import$opmlDecoder, importData);
};
var author$project$Import$extractCategoryFromOpml = F2(
	function (index, opmlCategory) {
		return A5(author$project$Models$Category, index, opmlCategory.aZ, false, false, 0);
	});
var author$project$Import$extractSiteFromOpml = F2(
	function (categoryId, site) {
		return _Utils_update(
			site,
			{
				bH: _List_fromArray(
					[categoryId])
			});
	});
var author$project$Import$extractSitesFromOpml = F2(
	function (categoryIndex, opmlCategory) {
		return A2(
			elm$core$List$map,
			author$project$Import$extractSiteFromOpml(categoryIndex),
			opmlCategory.d3);
	});
var author$project$Import$opmlErrorToString = function (err) {
	return 'opmlCategory decoding error';
};
var elm$core$List$concat = function (lists) {
	return A3(elm$core$List$foldr, elm$core$List$append, _List_Nil, lists);
};
var author$project$Import$executeImport = function (model) {
	var opmlCategoriesResult = author$project$Import$decodeOpml(model.dF);
	if (!opmlCategoriesResult.$) {
		var opmlCategories = opmlCategoriesResult.a;
		var _n1 = A3(
			elm$core$List$foldl,
			F2(
				function (opmlCategory, _n2) {
					var filteredCategories_intermediate = _n2.a;
					var looseSites_intermediate = _n2.b;
					return elm$core$String$isEmpty(opmlCategory.aZ) ? _Utils_Tuple2(
						filteredCategories_intermediate,
						_Utils_ap(looseSites_intermediate, opmlCategory.d3)) : _Utils_Tuple2(
						_Utils_ap(
							filteredCategories_intermediate,
							_List_fromArray(
								[opmlCategory])),
						looseSites_intermediate);
				}),
			_Utils_Tuple2(_List_Nil, _List_Nil),
			opmlCategories);
		var filteredCategories = _n1.a;
		var looseSites = _n1.b;
		var categories = A2(elm$core$List$indexedMap, author$project$Import$extractCategoryFromOpml, filteredCategories);
		var sites = A2(
			elm$core$List$indexedMap,
			F2(
				function (index, site) {
					return _Utils_update(
						site,
						{dE: index});
				}),
			A2(
				elm$core$List$append,
				looseSites,
				elm$core$List$concat(
					A2(elm$core$List$indexedMap, author$project$Import$extractSitesFromOpml, filteredCategories))));
		return _Utils_update(
			model,
			{c5: categories, d3: sites});
	} else {
		var err = opmlCategoriesResult.a;
		return _Utils_update(
			model,
			{
				bS: _Utils_ap(
					model.bS,
					_List_fromArray(
						[
							author$project$Helpers$createErrorMsg(
							author$project$Import$opmlErrorToString(err))
						]))
			});
	}
};
var author$project$Models$AddArticleInDb = function (a) {
	return {$: 9, a: a};
};
var author$project$Models$AddCategoryInDb = function (a) {
	return {$: 3, a: a};
};
var author$project$Models$AddSiteInDb = function (a) {
	return {$: 6, a: a};
};
var author$project$Models$ExportData = function (a) {
	return {$: 18, a: a};
};
var author$project$Models$InitReadMoreButtons = {$: 15};
var author$project$Models$OpenErrorMsg = function (a) {
	return {$: 0, a: a};
};
var author$project$Models$PanelEditSite = 0;
var author$project$Models$PanelImport = 1;
var author$project$Models$PanelSettings = 4;
var author$project$Models$RegisterTime = function (a) {
	return {$: 25, a: a};
};
var author$project$Models$RequestRemoveErrorMsg = function (a) {
	return {$: 1, a: a};
};
var author$project$Models$SaveAllData = function (a) {
	return {$: 13, a: a};
};
var author$project$Models$SaveLastRefreshedTime = function (a) {
	return {$: 12, a: a};
};
var author$project$Models$SaveOptions = function (a) {
	return {$: 11, a: a};
};
var author$project$Models$ScrollToTopViaJs = {$: 16};
var author$project$Models$SignOutViaJs = {$: 17};
var author$project$Models$ToggleExcerptViaJs = F3(
	function (a, b, c) {
		return {$: 14, a: a, b: b, c: c};
	});
var author$project$Models$ToggleOpenTab = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var author$project$Models$UpdateSiteInDb = function (a) {
	return {$: 8, a: a};
};
var author$project$Models$panelToString = function (panel) {
	switch (panel) {
		case 0:
			return 'PanelEditSite';
		case 1:
			return 'PanelImport';
		case 2:
			return 'PanelModal';
		case 3:
			return 'PanelMenu';
		default:
			return 'PanelSettings';
	}
};
var elm$json$Json$Encode$bool = _Json_wrap;
var elm$json$Json$Encode$int = _Json_wrap;
var author$project$OutsideInfo$encodeArticle = function (article) {
	return elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				elm$json$Json$Encode$int(article.dE)),
				_Utils_Tuple2(
				'siteId',
				elm$json$Json$Encode$int(article.a4)),
				_Utils_Tuple2(
				'link',
				elm$json$Json$Encode$string(article.dO)),
				_Utils_Tuple2(
				'title',
				elm$json$Json$Encode$string(article.d9)),
				_Utils_Tuple2(
				'excerpt',
				elm$json$Json$Encode$string(article.dr)),
				_Utils_Tuple2(
				'starred',
				elm$json$Json$Encode$bool(article.d4)),
				_Utils_Tuple2(
				'date',
				elm$json$Json$Encode$int(
					elm$time$Time$posixToMillis(article.ba)))
			]));
};
var author$project$OutsideInfo$encodeCategory = function (category) {
	return elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				elm$json$Json$Encode$int(category.dE)),
				_Utils_Tuple2(
				'name',
				elm$json$Json$Encode$string(category.aZ))
			]));
};
var author$project$OutsideInfo$encodeIdList = function (ids) {
	return A2(elm$json$Json$Encode$list, elm$json$Json$Encode$int, ids);
};
var elm$json$Json$Encode$float = _Json_wrap;
var author$project$OutsideInfo$encodeOptions = function (options) {
	return elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'articlesPerPage',
				elm$json$Json$Encode$int(options.c1)),
				_Utils_Tuple2(
				'articlePreviewHeightInEm',
				elm$json$Json$Encode$float(options.c$)),
				_Utils_Tuple2(
				'maxNumberOfFailures',
				elm$json$Json$Encode$int(options.dP))
			]));
};
var author$project$OutsideInfo$encodeSite = function (site) {
	return elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				elm$json$Json$Encode$int(site.dE)),
				_Utils_Tuple2(
				'categoriesId',
				A2(elm$json$Json$Encode$list, elm$json$Json$Encode$int, site.bH)),
				_Utils_Tuple2(
				'name',
				elm$json$Json$Encode$string(site.aZ)),
				_Utils_Tuple2(
				'rssLink',
				elm$json$Json$Encode$string(site.d$)),
				_Utils_Tuple2(
				'webLink',
				elm$json$Json$Encode$string(site.eg)),
				_Utils_Tuple2(
				'starred',
				elm$json$Json$Encode$bool(site.d4)),
				_Utils_Tuple2(
				'isActive',
				elm$json$Json$Encode$bool(site.dJ)),
				_Utils_Tuple2(
				'numberOfFailures',
				elm$json$Json$Encode$int(site.dS))
			]));
};
var author$project$OutsideInfo$infoForOutside = _Platform_outgoingPort(
	'infoForOutside',
	function ($) {
		return elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'data',
					elm$core$Basics$identity($.de)),
					_Utils_Tuple2(
					'tag',
					elm$json$Json$Encode$string($.d7))
				]));
	});
var elm$json$Json$Encode$null = _Json_encodeNull;
var author$project$OutsideInfo$sendInfoOutside = function (info) {
	switch (info.$) {
		case 0:
			var loginData = info.a;
			var loginPayload = elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'method',
						elm$json$Json$Encode$string('email')),
						_Utils_Tuple2(
						'email',
						elm$json$Json$Encode$string(loginData.dq)),
						_Utils_Tuple2(
						'password',
						elm$json$Json$Encode$string(loginData.dX))
					]));
			return author$project$OutsideInfo$infoForOutside(
				{de: loginPayload, d7: 'login'});
		case 1:
			var userUid = info.a;
			return author$project$OutsideInfo$infoForOutside(
				{
					de: elm$json$Json$Encode$string(userUid),
					d7: 'openDb'
				});
		case 2:
			return author$project$OutsideInfo$infoForOutside(
				{
					de: elm$json$Json$Encode$string(''),
					d7: 'readAllData'
				});
		case 3:
			var category = info.a;
			return author$project$OutsideInfo$infoForOutside(
				{
					de: author$project$OutsideInfo$encodeCategory(category),
					d7: 'addCategory'
				});
		case 4:
			var categoryToDeleteIds = info.a;
			return author$project$OutsideInfo$infoForOutside(
				{
					de: author$project$OutsideInfo$encodeIdList(categoryToDeleteIds),
					d7: 'deleteCategories'
				});
		case 5:
			var category = info.a;
			return author$project$OutsideInfo$infoForOutside(
				{
					de: author$project$OutsideInfo$encodeCategory(category),
					d7: 'updateCategory'
				});
		case 6:
			var site = info.a;
			return author$project$OutsideInfo$infoForOutside(
				{
					de: author$project$OutsideInfo$encodeSite(site),
					d7: 'addSite'
				});
		case 7:
			var siteToDeleteIds = info.a;
			return author$project$OutsideInfo$infoForOutside(
				{
					de: author$project$OutsideInfo$encodeIdList(siteToDeleteIds),
					d7: 'deleteSites'
				});
		case 8:
			var site = info.a;
			return author$project$OutsideInfo$infoForOutside(
				{
					de: author$project$OutsideInfo$encodeSite(site),
					d7: 'updateSite'
				});
		case 9:
			var article = info.a;
			return author$project$OutsideInfo$infoForOutside(
				{
					de: author$project$OutsideInfo$encodeArticle(article),
					d7: 'addArticle'
				});
		case 10:
			var articleToDeleteIds = info.a;
			return author$project$OutsideInfo$infoForOutside(
				{
					de: author$project$OutsideInfo$encodeIdList(articleToDeleteIds),
					d7: 'deleteArticles'
				});
		case 11:
			var options = info.a;
			return author$project$OutsideInfo$infoForOutside(
				{
					de: author$project$OutsideInfo$encodeOptions(options),
					d7: 'saveOptions'
				});
		case 12:
			var lastRefreshedTime = info.a;
			var refreshedTimeData = elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'lastRefreshedTime',
						elm$json$Json$Encode$int(
							elm$time$Time$posixToMillis(lastRefreshedTime)))
					]));
			return author$project$OutsideInfo$infoForOutside(
				{de: refreshedTimeData, d7: 'saveLastRefreshedTime'});
		case 13:
			var _n1 = info.a;
			var categories = _n1.a;
			var sites = _n1.b;
			var articles = _n1.c;
			var allData = elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'categories',
						A2(elm$json$Json$Encode$list, author$project$OutsideInfo$encodeCategory, categories)),
						_Utils_Tuple2(
						'sites',
						A2(elm$json$Json$Encode$list, author$project$OutsideInfo$encodeSite, sites)),
						_Utils_Tuple2(
						'articles',
						A2(elm$json$Json$Encode$list, author$project$OutsideInfo$encodeArticle, articles))
					]));
			return author$project$OutsideInfo$infoForOutside(
				{de: allData, d7: 'saveAllData'});
		case 14:
			var domId = info.a;
			var toOpen = info.b;
			var articlePreviewHeight = info.c;
			var excerptData = elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'domId',
						elm$json$Json$Encode$string(domId)),
						_Utils_Tuple2(
						'toOpen',
						elm$json$Json$Encode$bool(toOpen)),
						_Utils_Tuple2(
						'originalMaxHeight',
						elm$json$Json$Encode$float(articlePreviewHeight))
					]));
			return author$project$OutsideInfo$infoForOutside(
				{de: excerptData, d7: 'toggleExcerpt'});
		case 15:
			return author$project$OutsideInfo$infoForOutside(
				{de: elm$json$Json$Encode$null, d7: 'initReadMoreButtons'});
		case 16:
			return author$project$OutsideInfo$infoForOutside(
				{de: elm$json$Json$Encode$null, d7: 'scrollToTop'});
		case 17:
			return author$project$OutsideInfo$infoForOutside(
				{de: elm$json$Json$Encode$null, d7: 'signOut'});
		default:
			var data = info.a;
			return author$project$OutsideInfo$infoForOutside(
				{de: data, d7: 'exportData'});
	}
};
var author$project$Models$LoginData = F3(
	function (email, password, authenticated) {
		return {c2: authenticated, dq: email, dX: password};
	});
var author$project$Models$OpenDb = function (a) {
	return {$: 1, a: a};
};
var author$project$Models$ReadAllData = {$: 2};
var author$project$OutsideInfo$switchInfoForElm = F2(
	function (infoForElm, model) {
		switch (infoForElm.$) {
			case 0:
				var userUid = infoForElm.a;
				var loginData = A3(author$project$Models$LoginData, 'model.loginData.email', '', true);
				return _Utils_Tuple2(
					model,
					author$project$OutsideInfo$sendInfoOutside(
						author$project$Models$OpenDb(userUid)));
			case 1:
				return _Utils_Tuple2(
					model,
					author$project$OutsideInfo$sendInfoOutside(author$project$Models$ReadAllData));
			case 2:
				var categories = infoForElm.a;
				var sites = infoForElm.b;
				var savedArticles = infoForElm.c;
				var options = infoForElm.d;
				var lastRefreshedTime = infoForElm.e;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c0: savedArticles, c5: categories, cb: lastRefreshedTime, bj: options, d3: sites}),
					elm$core$Platform$Cmd$none);
			default:
				var scrollTop = infoForElm.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b6: scrollTop > 1000}),
					elm$core$Platform$Cmd$none);
		}
	});
var author$project$PanelsManager$Closed = 2;
var author$project$PanelsManager$closeAllPanels = function (panelsState) {
	var stateWrappers = panelsState;
	return A2(
		elm$core$List$map,
		function (stateWrapper) {
			var _n1 = stateWrapper;
			var id = _n1.a;
			var state = _n1.b;
			return _Utils_Tuple2(id, 2);
		},
		stateWrappers);
};
var author$project$PanelsManager$closePanel = F2(
	function (panelId, panelsState) {
		var stateWrappers = panelsState;
		return A2(
			elm$core$List$map,
			function (stateWrapper) {
				var _n1 = stateWrapper;
				var id = _n1.a;
				var state = _n1.b;
				return _Utils_eq(panelId, id) ? _Utils_Tuple2(id, 2) : _Utils_Tuple2(id, state);
			},
			stateWrappers);
	});
var author$project$PanelsManager$closePanelsFuzzy = F2(
	function (panelId, panelsState) {
		var stateWrappers = panelsState;
		return A2(
			elm$core$List$map,
			function (stateWrapper) {
				var _n1 = stateWrapper;
				var id = _n1.a;
				var state = _n1.b;
				return A2(elm$core$String$contains, panelId, id) ? _Utils_Tuple2(id, 2) : _Utils_Tuple2(id, state);
			},
			stateWrappers);
	});
var author$project$PanelsManager$Initial = 0;
var elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return elm$core$Maybe$Just(x);
	} else {
		return elm$core$Maybe$Nothing;
	}
};
var author$project$PanelsManager$getPanelState = F2(
	function (panelId, panelsState) {
		var stateWrappers = panelsState;
		var panelState = elm$core$List$head(
			A2(
				elm$core$List$filter,
				function (stateWrapper) {
					var _n3 = stateWrapper;
					var id = _n3.a;
					var state = _n3.b;
					return _Utils_eq(panelId, id);
				},
				stateWrappers));
		if (!panelState.$) {
			var _n2 = panelState.a;
			var id = _n2.a;
			var state = _n2.b;
			return state;
		} else {
			return 0;
		}
	});
var author$project$PanelsManager$initPanel_ = F3(
	function (panelId, panelsState, panelState) {
		var stateWrappers = panelsState;
		return A2(
			elm$core$List$append,
			_List_fromArray(
				[
					_Utils_Tuple2(panelId, panelState)
				]),
			A2(
				elm$core$List$filter,
				function (stateWrapper) {
					var _n1 = stateWrapper;
					var id = _n1.a;
					var state = _n1.b;
					return !_Utils_eq(panelId, id);
				},
				stateWrappers));
	});
var author$project$PanelsManager$initPanel = F2(
	function (panelId, panelsState) {
		return A3(author$project$PanelsManager$initPanel_, panelId, panelsState, 0);
	});
var author$project$PanelsManager$Open = 1;
var author$project$PanelsManager$isPanelOpen = function (panelState) {
	return panelState === 1;
};
var author$project$PanelsManager$openPanel = F2(
	function (panelId, panelsState) {
		return A3(author$project$PanelsManager$initPanel_, panelId, panelsState, 1);
	});
var author$project$Swiper$Right = 0;
var author$project$Swiper$isGreaterThanThreshold = F3(
	function (threshold, shouldBeGreater, shouldBeSmaller) {
		return (_Utils_cmp(shouldBeGreater, shouldBeSmaller) > 0) && (_Utils_cmp(shouldBeGreater - shouldBeSmaller, threshold) > 0);
	});
var author$project$Swiper$checkSwiped = F4(
	function (start, end, dir, threshold) {
		var isGreater = author$project$Swiper$isGreaterThanThreshold(threshold);
		switch (dir) {
			case 1:
				return A2(isGreater, end.az, start.az);
			case 0:
				return A2(isGreater, start.az, end.az);
			case 2:
				return A2(isGreater, start.aA, end.aA);
			default:
				return A2(isGreater, end.aA, start.aA);
		}
	});
var author$project$Swiper$startTouchSequence = function (coords) {
	return {
		bq: elm$core$Maybe$Just(coords)
	};
};
var author$project$Swiper$hasSwiped = F4(
	function (threshold, dir, evt, _n0) {
		var touchStarted = _n0.bq;
		if (!evt.$) {
			var coords = evt.a;
			return _Utils_Tuple2(
				author$project$Swiper$startTouchSequence(coords),
				false);
		} else {
			var coords = evt.a;
			if (touchStarted.$ === 1) {
				return _Utils_Tuple2(author$project$Swiper$initialSwipingState, false);
			} else {
				var firstTouch = touchStarted.a;
				return _Utils_Tuple2(
					author$project$Swiper$initialSwipingState,
					A4(author$project$Swiper$checkSwiped, firstTouch, coords, dir, threshold));
			}
		}
	});
var author$project$Swiper$hasSwipedRight = function (threshold) {
	return A2(author$project$Swiper$hasSwiped, threshold, 0);
};
var elm$core$List$sortBy = _List_sortBy;
var elm$core$List$sort = function (xs) {
	return A2(elm$core$List$sortBy, elm$core$Basics$identity, xs);
};
var author$project$Helpers$getMaxId = function (ids) {
	return elm$core$List$head(
		elm$core$List$reverse(
			elm$core$List$sort(ids)));
};
var author$project$Helpers$incrementMaxId = function (maxId) {
	if (!maxId.$) {
		var id = maxId.a;
		return id + 1;
	} else {
		return 1;
	}
};
var author$project$Helpers$getNextId = function (entities) {
	return author$project$Helpers$incrementMaxId(
		author$project$Helpers$getMaxId(
			author$project$Helpers$extractId(entities)));
};
var author$project$Update$createNewCategory = function (categories) {
	var nextId = author$project$Helpers$getNextId(categories);
	return A5(author$project$Models$Category, nextId, 'New Category', true, true, 0);
};
var author$project$Update$createNewSite = function (sites) {
	var nextId = author$project$Helpers$getNextId(sites);
	return author$project$Models$Site(nextId)(_List_Nil)('New Site')('')('')(false)(false)(0)(true)(0);
};
var author$project$Update$incrementNumberOfFailures = F2(
	function (maxNumberOfFailures, site) {
		var newNumberOfFailures = site.dS + 1;
		return _Utils_update(
			site,
			{
				dJ: (_Utils_cmp(newNumberOfFailures, maxNumberOfFailures) > 0) ? false : site.dJ,
				dS: newNumberOfFailures
			});
	});
var author$project$Update$findSiteAndIncrementNumberOfFailures = F3(
	function (maxNumberOfFailures, sites, siteId) {
		return A2(
			elm$core$List$map,
			function (site) {
				return _Utils_eq(site.dE, siteId) ? A2(author$project$Update$incrementNumberOfFailures, maxNumberOfFailures, site) : site;
			},
			sites);
	});
var author$project$Update$updateCategoriesHeight = F3(
	function (height, id, categories) {
		return A2(
			elm$core$List$map,
			function (category) {
				var newHeight = _Utils_eq(category.dE, id) ? height : 0;
				return _Utils_update(
					category,
					{dB: newHeight});
			},
			categories);
	});
var author$project$Models$PanelModal = 2;
var author$project$Helpers$closeModal = function (panelsState) {
	return A2(
		author$project$PanelsManager$closePanel,
		author$project$Models$panelToString(2),
		panelsState);
};
var author$project$Helpers$openModal = function (panelsState) {
	return A2(
		author$project$PanelsManager$openPanel,
		author$project$Models$panelToString(2),
		panelsState);
};
var author$project$Models$DeleteArticlesInDb = function (a) {
	return {$: 10, a: a};
};
var author$project$Models$DeleteCategories = function (a) {
	return {$: 1, a: a};
};
var author$project$Models$DeleteCategoriesInDb = function (a) {
	return {$: 4, a: a};
};
var author$project$Models$DeleteCategoryAndSites = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var author$project$Models$DeleteMsg = function (a) {
	return {$: 31, a: a};
};
var author$project$Models$DeleteSites = function (a) {
	return {$: 3, a: a};
};
var author$project$Models$DeleteSitesInDb = function (a) {
	return {$: 7, a: a};
};
var author$project$Models$Modal = F2(
	function (text, action) {
		return {bt: action, d8: text};
	});
var author$project$Update$Delete$deleteContents = F2(
	function (contents, contentToDeleteIds) {
		return A2(
			elm$core$List$filter,
			function (content) {
				return !A2(elm$core$List$member, content.dE, contentToDeleteIds);
			},
			contents);
	});
var author$project$Update$Delete$deleteSitesArticles = F2(
	function (articles, sitesToDeleteId) {
		return A3(
			elm$core$List$foldl,
			F2(
				function (article, _n0) {
					var articleToKeep = _n0.a;
					var articleToDeleteInDbIds = _n0.b;
					return A2(elm$core$List$member, article.a4, sitesToDeleteId) ? (article.d4 ? _Utils_Tuple2(
						articleToKeep,
						_Utils_ap(
							articleToDeleteInDbIds,
							_List_fromArray(
								[article.dE]))) : _Utils_Tuple2(articleToKeep, articleToDeleteInDbIds)) : _Utils_Tuple2(
						_Utils_ap(
							articleToKeep,
							_List_fromArray(
								[article])),
						articleToDeleteInDbIds);
				}),
			_Utils_Tuple2(_List_Nil, _List_Nil),
			articles);
	});
var author$project$Update$Delete$handleDeleteMsgs = F2(
	function (model, msg) {
		switch (msg.$) {
			case 0:
				var categoryToDeleteIds = msg.a;
				var modalData = A2(
					author$project$Models$Modal,
					'Are you sure you want to delete this category?',
					author$project$Models$DeleteMsg(
						author$project$Models$DeleteCategories(categoryToDeleteIds)));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ce: modalData,
							cj: author$project$Helpers$openModal(model.cj)
						}),
					elm$core$Platform$Cmd$none);
			case 1:
				var categoryToDeleteIds = msg.a;
				var updatedCategories = A2(author$project$Update$Delete$deleteContents, model.c5, categoryToDeleteIds);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c5: updatedCategories,
							cj: author$project$Helpers$closeModal(model.cj)
						}),
					author$project$OutsideInfo$sendInfoOutside(
						author$project$Models$DeleteCategoriesInDb(categoryToDeleteIds)));
			case 2:
				var sitesToDeleteId = msg.a;
				var modalData = A2(
					author$project$Models$Modal,
					'Are you sure you want to delete this site?',
					author$project$Models$DeleteMsg(
						author$project$Models$DeleteSites(sitesToDeleteId)));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ce: modalData,
							cj: author$project$Helpers$openModal(model.cj)
						}),
					elm$core$Platform$Cmd$none);
			case 3:
				var sitesToDeleteId = msg.a;
				var updatedSites = A2(author$project$Update$Delete$deleteContents, model.d3, sitesToDeleteId);
				var _n1 = A2(author$project$Update$Delete$deleteSitesArticles, model.c0, sitesToDeleteId);
				var updatedArticles = _n1.a;
				var articleToDeleteInDbIds = _n1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c0: updatedArticles,
							cj: A2(
								elm$core$Basics$composeR,
								author$project$PanelsManager$closePanel(
									author$project$Models$panelToString(0)),
								author$project$Helpers$closeModal)(model.cj),
							d3: updatedSites
						}),
					elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								author$project$OutsideInfo$sendInfoOutside(
								author$project$Models$DeleteSitesInDb(sitesToDeleteId)),
								author$project$OutsideInfo$sendInfoOutside(
								author$project$Models$DeleteArticlesInDb(articleToDeleteInDbIds))
							])));
			case 4:
				var categoryToDeleteIds = msg.a;
				var sitesToDeleteId = msg.b;
				var modalData = A2(
					author$project$Models$Modal,
					'Are you sure you want to delete this category and all its sites?',
					author$project$Models$DeleteMsg(
						A2(author$project$Models$DeleteCategoryAndSites, categoryToDeleteIds, sitesToDeleteId)));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ce: modalData,
							cj: author$project$Helpers$openModal(model.cj)
						}),
					elm$core$Platform$Cmd$none);
			case 5:
				var categoryToDeleteIds = msg.a;
				var sitesToDeleteId = msg.b;
				var updatedSites = A2(author$project$Update$Delete$deleteContents, model.d3, sitesToDeleteId);
				var updatedCategories = A2(author$project$Update$Delete$deleteContents, model.c5, categoryToDeleteIds);
				var _n2 = A2(author$project$Update$Delete$deleteSitesArticles, model.c0, sitesToDeleteId);
				var updatedArticles = _n2.a;
				var articleToDeleteInDbIds = _n2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c0: updatedArticles,
							c5: updatedCategories,
							cj: author$project$Helpers$closeModal(model.cj),
							d3: updatedSites
						}),
					elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								author$project$OutsideInfo$sendInfoOutside(
								author$project$Models$DeleteSitesInDb(sitesToDeleteId)),
								author$project$OutsideInfo$sendInfoOutside(
								author$project$Models$DeleteCategoriesInDb(categoryToDeleteIds)),
								author$project$OutsideInfo$sendInfoOutside(
								author$project$Models$DeleteArticlesInDb(articleToDeleteInDbIds))
							])));
			default:
				var articleToDeleteIds = msg.a;
				var updatedArticles = A2(
					elm$core$List$map,
					function (article) {
						return A2(elm$core$List$member, article.dE, articleToDeleteIds) ? _Utils_update(
							article,
							{d4: false}) : article;
					},
					model.c0);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c0: updatedArticles}),
					author$project$OutsideInfo$sendInfoOutside(
						author$project$Models$DeleteArticlesInDb(articleToDeleteIds)));
		}
	});
var author$project$Models$UpdateCategoryInDb = function (a) {
	return {$: 5, a: a};
};
var author$project$Update$EditCategory$handleEditCategoryMsgs = F2(
	function (model, msg) {
		switch (msg.$) {
			case 0:
				var categoryToEditId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c5: A2(
								elm$core$List$map,
								function (category) {
									return _Utils_eq(category.dE, categoryToEditId) ? _Utils_update(
										category,
										{dK: true, aD: true}) : category;
								},
								model.c5)
						}),
					elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c5: A2(
								elm$core$List$map,
								function (category) {
									return category.dK ? _Utils_update(
										category,
										{dK: false}) : category;
								},
								model.c5)
						}),
					elm$core$Platform$Cmd$none);
			default:
				var category = msg.a;
				var newName = msg.b;
				var updateCategory = _Utils_update(
					category,
					{aZ: newName});
				var updatedCategories = A2(
					elm$core$List$map,
					function (modelCategory) {
						return _Utils_eq(modelCategory.dE, category.dE) ? updateCategory : modelCategory;
					},
					model.c5);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c5: updatedCategories}),
					author$project$OutsideInfo$sendInfoOutside(
						author$project$Models$UpdateCategoryInDb(updateCategory)));
		}
	});
var author$project$Helpers$sendMsg = function (msg) {
	return A2(
		elm$core$Task$perform,
		function (_n0) {
			return msg;
		},
		elm$core$Task$succeed(0));
};
var author$project$Models$CloseEditSitePanel = {$: 1};
var author$project$Models$EditSiteMsg = function (a) {
	return {$: 30, a: a};
};
var author$project$Update$EditSite$handleEditSiteMsgs = F2(
	function (model, msg) {
		switch (msg.$) {
			case 0:
				var site = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cj: A2(
								author$project$PanelsManager$openPanel,
								author$project$Models$panelToString(0),
								model.cj),
							cF: site
						}),
					elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cj: A2(
								author$project$PanelsManager$closePanel,
								author$project$Models$panelToString(0),
								model.cj)
						}),
					elm$core$Platform$Cmd$none);
			case 2:
				var siteToUpdate = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cF: siteToUpdate}),
					elm$core$Platform$Cmd$none);
			default:
				var updatedSites = A2(
					elm$core$List$map,
					function (site) {
						return _Utils_eq(site.dE, model.cF.dE) ? model.cF : site;
					},
					model.d3);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{d3: updatedSites}),
					elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								author$project$OutsideInfo$sendInfoOutside(
								author$project$Models$UpdateSiteInDb(model.cF)),
								author$project$Helpers$sendMsg(
								author$project$Models$EditSiteMsg(author$project$Models$CloseEditSitePanel))
							])));
		}
	});
var author$project$Models$RemoveErrorMsg = function (a) {
	return {$: 2, a: a};
};
var author$project$Update$ErrorBox$handleErrorBoxMsgs = F2(
	function (model, msg) {
		switch (msg.$) {
			case 0:
				var errorMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cj: A2(author$project$PanelsManager$openPanel, errorMsg.dE, model.cj)
						}),
					elm$core$Platform$Cmd$none);
			case 1:
				var msgToRemove = msg.a;
				var updatedPanelsState = A2(author$project$PanelsManager$closePanel, msgToRemove.dE, model.cj);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cj: updatedPanelsState}),
					A2(
						author$project$Helpers$delay,
						elm$time$Time$millisToPosix(1500),
						author$project$Models$ErrorBoxMsg(
							author$project$Models$RemoveErrorMsg(msgToRemove))));
			case 2:
				var msgToRemove = msg.a;
				var newErrorMsgs = A2(
					elm$core$List$filter,
					function (modelMsg) {
						return !_Utils_eq(modelMsg.dE, msgToRemove.dE);
					},
					model.bS);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: newErrorMsgs}),
					elm$core$Platform$Cmd$none);
			default:
				var err = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: _Utils_ap(
								model.bS,
								_List_fromArray(
									[
										author$project$Helpers$createErrorMsg('Error')
									]))
						}),
					elm$core$Platform$Cmd$none);
		}
	});
var elm$browser$Browser$Dom$focus = _Browser_call('focus');
var elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
var elm$core$List$sortWith = _List_sortWith;
var elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var elm$core$Task$onError = _Scheduler_onError;
var elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return elm$core$Task$command(
			A2(
				elm$core$Task$onError,
				A2(
					elm$core$Basics$composeL,
					A2(elm$core$Basics$composeL, elm$core$Task$succeed, resultToMessage),
					elm$core$Result$Err),
				A2(
					elm$core$Task$andThen,
					A2(
						elm$core$Basics$composeL,
						A2(elm$core$Basics$composeL, elm$core$Task$succeed, resultToMessage),
						elm$core$Result$Ok),
					task)));
	});
var elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$time$Time$customZone = elm$time$Time$Zone;
var elm$time$Time$now = _Time_now(elm$time$Time$millisToPosix);
var author$project$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ca: false}),
					elm$core$Platform$Cmd$none);
			case 1:
				var keyCode = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ca: keyCode === '\t'}),
					elm$core$Platform$Cmd$none);
			case 9:
				var categoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c5: A2(author$project$Helpers$toggleSelected, model.c5, categoryId),
							bM: 1,
							d3: A2(
								elm$core$List$map,
								function (site) {
									return _Utils_update(
										site,
										{aD: false});
								},
								model.d3)
						}),
					A2(
						elm$core$Task$attempt,
						author$project$Models$ToggleOpenTab(categoryId),
						elm$browser$Browser$Dom$getViewportOf(
							'cat_' + (elm$core$String$fromInt(categoryId) + '_inner'))));
			case 10:
				var categoryId = msg.a;
				var innerViewport = msg.b;
				var category = elm$core$List$head(
					A2(
						elm$core$List$filter,
						function (cat) {
							return _Utils_eq(cat.dE, categoryId);
						},
						model.c5));
				var selected = function () {
					if (!category.$) {
						var cat = category.a;
						return cat.aD;
					} else {
						return false;
					}
				}();
				var catHeight = function () {
					if (!innerViewport.$) {
						var height = innerViewport.a;
						return elm$core$Basics$round(height.ef.dB);
					} else {
						return 0;
					}
				}();
				var targetHeight = selected ? catHeight : 0;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c5: A3(author$project$Update$updateCategoriesHeight, targetHeight, categoryId, model.c5)
						}),
					elm$core$Platform$Cmd$none);
			case 2:
				var siteId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bM: 1,
							d3: A2(author$project$Helpers$toggleSelected, model.d3, siteId)
						}),
					elm$core$Platform$Cmd$none);
			case 3:
				var categoryId = msg.a;
				var panelId = 'cat_' + elm$core$String$fromInt(categoryId);
				var isOpen = author$project$PanelsManager$isPanelOpen(
					A2(author$project$PanelsManager$getPanelState, panelId, model.cj));
				var updatedPanelsState = (isOpen ? author$project$PanelsManager$closePanel(panelId) : author$project$PanelsManager$openPanel(panelId))(
					A2(author$project$PanelsManager$closePanelsFuzzy, 'cat_', model.cj));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cj: updatedPanelsState}),
					elm$core$Platform$Cmd$none);
			case 14:
				var panel = msg.a;
				var isOpen = author$project$PanelsManager$isPanelOpen(
					A2(
						author$project$PanelsManager$getPanelState,
						author$project$Models$panelToString(panel),
						model.cj));
				var updatedPanelsState = isOpen ? A2(
					author$project$PanelsManager$closePanel,
					author$project$Models$panelToString(panel),
					model.cj) : A2(
					author$project$PanelsManager$openPanel,
					author$project$Models$panelToString(panel),
					model.cj);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cj: updatedPanelsState}),
					elm$core$Platform$Cmd$none);
			case 15:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cD: !model.cD}),
					elm$core$Platform$Cmd$none);
			case 16:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cd: !model.cd}),
					elm$core$Platform$Cmd$none);
			case 17:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cd: false}),
					elm$core$Platform$Cmd$none);
			case 18:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cj: A2(
								author$project$PanelsManager$openPanel,
								author$project$Models$panelToString(1),
								A2(
									author$project$PanelsManager$closePanel,
									author$project$Models$panelToString(4),
									model.cj))
						}),
					elm$core$Platform$Cmd$none);
			case 6:
				var importData = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dF: importData}),
					elm$core$Platform$Cmd$none);
			case 5:
				var newModel = author$project$Import$executeImport(model);
				return _Utils_Tuple2(
					newModel,
					author$project$OutsideInfo$sendInfoOutside(
						author$project$Models$SaveAllData(
							author$project$Helpers$getDataToSaveInDb(newModel))));
			case 31:
				var msgToDelete = msg.a;
				return A2(author$project$Update$Delete$handleDeleteMsgs, model, msgToDelete);
			case 11:
				var newCategory = author$project$Update$createNewCategory(model.c5);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c5: A2(
								elm$core$List$append,
								model.c5,
								_List_fromArray(
									[newCategory]))
						}),
					elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								elm$core$Task$attempt,
								function (_n3) {
									return author$project$Models$NoOp;
								},
								elm$browser$Browser$Dom$focus(
									'editCategoryName-' + elm$core$String$fromInt(newCategory.dE))),
								author$project$OutsideInfo$sendInfoOutside(
								author$project$Models$AddCategoryInDb(newCategory))
							])));
			case 29:
				var editCategoryMsg = msg.a;
				return A2(author$project$Update$EditCategory$handleEditCategoryMsgs, model, editCategoryMsg);
			case 30:
				var editSiteMsg = msg.a;
				return A2(author$project$Update$EditSite$handleEditSiteMsgs, model, editSiteMsg);
			case 12:
				var newSite = author$project$Update$createNewSite(model.d3);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cj: A2(
								author$project$PanelsManager$openPanel,
								author$project$Models$panelToString(0),
								model.cj),
							cF: newSite,
							d3: A2(
								elm$core$List$append,
								model.d3,
								_List_fromArray(
									[newSite]))
						}),
					author$project$OutsideInfo$sendInfoOutside(
						author$project$Models$AddSiteInDb(newSite)));
			case 8:
				var siteId = msg.a;
				var rssResult = msg.b;
				var updatedModel = _Utils_update(
					model,
					{bW: false});
				if (!rssResult.$) {
					var feeds = rssResult.a;
					var rssArticles = A2(
						elm$core$List$map,
						function (article) {
							return _Utils_update(
								article,
								{
									dr: article.dr,
									dE: A2(Skinney$murmur3$Murmur3$hashString, 12345, article.dO)
								});
						},
						feeds);
					var mergedArticles = A2(author$project$Helpers$mergeArticles, rssArticles, model.c0);
					var _n5 = A3(
						elm$core$List$foldl,
						F2(
							function (site, _n6) {
								var updatedSites_ = _n6.a;
								var sitesToResetFailures_ = _n6.b;
								if (_Utils_eq(site.dE, siteId)) {
									var updatedSite = _Utils_update(
										site,
										{
											dS: 0,
											dT: A3(author$project$Helpers$countNewArticlesInSite, site.dE, rssArticles, model.cb)
										});
									var newSitesToResetFailures = (!_Utils_eq(site.dS, updatedSite.dS)) ? _Utils_ap(
										sitesToResetFailures_,
										_List_fromArray(
											[updatedSite])) : sitesToResetFailures_;
									return _Utils_Tuple2(
										_Utils_ap(
											updatedSites_,
											_List_fromArray(
												[updatedSite])),
										newSitesToResetFailures);
								} else {
									return _Utils_Tuple2(
										_Utils_ap(
											updatedSites_,
											_List_fromArray(
												[site])),
										sitesToResetFailures_);
								}
							}),
						_Utils_Tuple2(_List_Nil, _List_Nil),
						model.d3);
					var updatedSites = _n5.a;
					var sitesToResetFailures = _n5.b;
					return _Utils_Tuple2(
						_Utils_update(
							updatedModel,
							{
								c0: A2(elm$core$List$sortWith, author$project$Helpers$dateDescending, mergedArticles),
								d3: updatedSites
							}),
						elm$core$Platform$Cmd$batch(
							A2(
								elm$core$List$cons,
								author$project$OutsideInfo$sendInfoOutside(author$project$Models$InitReadMoreButtons),
								A2(
									elm$core$List$map,
									function (site) {
										return author$project$OutsideInfo$sendInfoOutside(
											author$project$Models$UpdateSiteInDb(site));
									},
									sitesToResetFailures))));
				} else {
					var err = rssResult.a;
					var failedSite = elm$core$List$head(
						A2(
							elm$core$List$filter,
							function (site) {
								return _Utils_eq(site.dE, siteId);
							},
							model.d3));
					var errorBaseText = 'Error reading feeds for site: ';
					var _n7 = function () {
						if (!failedSite.$) {
							var site = failedSite.a;
							return _Utils_Tuple2(
								author$project$OutsideInfo$sendInfoOutside(
									author$project$Models$UpdateSiteInDb(
										A2(author$project$Update$incrementNumberOfFailures, model.bj.dP, site))),
								author$project$Helpers$createErrorMsg(
									_Utils_ap(errorBaseText, site.aZ)));
						} else {
							return _Utils_Tuple2(
								elm$core$Platform$Cmd$none,
								author$project$Helpers$createErrorMsg(
									_Utils_ap(
										errorBaseText,
										elm$core$String$fromInt(siteId))));
						}
					}();
					var updateFailedSiteCmd = _n7.a;
					var errorMsg = _n7.b;
					var updatedPanelsState = A2(author$project$PanelsManager$initPanel, errorMsg.dE, model.cj);
					return _Utils_Tuple2(
						_Utils_update(
							updatedModel,
							{
								bS: _Utils_ap(
									A2(
										elm$core$List$filter,
										function (e) {
											return !_Utils_eq(e.dE, errorMsg.dE);
										},
										model.bS),
									_List_fromArray(
										[errorMsg])),
								cj: updatedPanelsState,
								d3: A3(author$project$Update$findSiteAndIncrementNumberOfFailures, model.bj.dP, model.d3, siteId)
							}),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									author$project$Helpers$delay,
									elm$time$Time$millisToPosix(1000),
									author$project$Models$ErrorBoxMsg(
										author$project$Models$OpenErrorMsg(errorMsg))),
									A2(
									author$project$Helpers$delay,
									elm$time$Time$millisToPosix(10000),
									author$project$Models$ErrorBoxMsg(
										author$project$Models$RequestRemoveErrorMsg(errorMsg))),
									updateFailedSiteCmd
								])));
				}
			case 13:
				var articleToSave = msg.a;
				var udatedArticleToSave = _Utils_update(
					articleToSave,
					{d4: true});
				var updatedArticles = A2(
					elm$core$List$map,
					function (article) {
						return _Utils_eq(article.dE, articleToSave.dE) ? udatedArticleToSave : article;
					},
					model.c0);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c0: updatedArticles}),
					author$project$OutsideInfo$sendInfoOutside(
						author$project$Models$AddArticleInDb(udatedArticleToSave)));
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bW: true}),
					elm$core$Platform$Cmd$batch(
						A2(
							elm$core$List$cons,
							A2(elm$core$Task$perform, author$project$Models$RegisterTime, elm$time$Time$now),
							author$project$GetFeeds$getFeeds(model.d3))));
			case 25:
				var time = msg.a;
				return _Utils_Tuple2(
					model,
					author$project$OutsideInfo$sendInfoOutside(
						author$project$Models$SaveLastRefreshedTime(time)));
			case 33:
				var infoForElm = msg.a;
				return A2(author$project$OutsideInfo$switchInfoForElm, infoForElm, model);
			case 20:
				var searchTerm = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cB: searchTerm}),
					elm$core$Platform$Cmd$none);
			case 19:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cd: false,
							cj: author$project$PanelsManager$closeAllPanels(model.cj)
						}),
					elm$core$Platform$Cmd$none);
			case 21:
				var pageNumber = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bM: pageNumber}),
					author$project$OutsideInfo$sendInfoOutside(author$project$Models$ScrollToTopViaJs));
			case 22:
				var newArticlesPerPage = msg.a;
				var options = model.bj;
				var updatedOptions = _Utils_update(
					options,
					{c1: newArticlesPerPage});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bj: updatedOptions}),
					author$project$OutsideInfo$sendInfoOutside(
						author$project$Models$SaveOptions(updatedOptions)));
			case 23:
				var rows = msg.a;
				var options = model.bj;
				var updatedOptions = _Utils_update(
					options,
					{
						c$: A2(
							elm$core$Maybe$withDefault,
							options.c$,
							elm$core$String$toFloat(rows))
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bj: updatedOptions}),
					elm$core$Platform$Cmd$none);
			case 24:
				var newMax = msg.a;
				var options = model.bj;
				var newMaxInt = A2(
					elm$core$Maybe$withDefault,
					author$project$Models$defaultOptions.dP,
					elm$core$String$toInt(newMax));
				var updatedOptions = _Utils_update(
					options,
					{dP: newMaxInt});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bj: updatedOptions}),
					elm$core$Platform$Cmd$none);
			case 26:
				var evt = msg.a;
				var _n9 = A3(author$project$Swiper$hasSwipedRight, 100, evt, model.cK);
				var newState = _n9.a;
				var swipedRight = _n9.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cd: !swipedRight, cK: newState, cQ: swipedRight}),
					elm$core$Platform$Cmd$none);
			case 4:
				var articleId = msg.a;
				var domId = msg.b;
				var toOpen = msg.c;
				var updatedArticles = A2(
					elm$core$List$map,
					function (article) {
						return _Utils_eq(article.dE, articleId) ? _Utils_update(
							article,
							{dL: toOpen}) : article;
					},
					model.c0);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c0: updatedArticles}),
					author$project$OutsideInfo$sendInfoOutside(
						A3(author$project$Models$ToggleExcerptViaJs, domId, toOpen, model.bj.c$)));
			case 27:
				return _Utils_Tuple2(
					model,
					author$project$OutsideInfo$sendInfoOutside(author$project$Models$ScrollToTopViaJs));
			case 32:
				var errorBoxMsg = msg.a;
				return A2(author$project$Update$ErrorBox$handleErrorBoxMsgs, model, errorBoxMsg);
			case 28:
				return _Utils_Tuple2(
					model,
					author$project$OutsideInfo$sendInfoOutside(author$project$Models$SignOutViaJs));
			case 34:
				return _Utils_Tuple2(
					model,
					author$project$OutsideInfo$sendInfoOutside(
						author$project$Models$ExportData(
							A2(author$project$Export$encodeOpml, model.c5, model.d3))));
			default:
				return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
		}
	});
var elm$core$Char$fromCode = _Char_fromCode;
var rtfeldman$elm_css$Html$Styled$Events$keyCode = A2(elm$json$Json$Decode$field, 'keyCode', elm$json$Json$Decode$int);
var elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var rtfeldman$elm_css$VirtualDom$Styled$on = F2(
	function (eventName, handler) {
		return A3(
			rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2(elm$virtual_dom$VirtualDom$on, eventName, handler),
			_List_Nil,
			'');
	});
var rtfeldman$elm_css$Html$Styled$Events$on = F2(
	function (event, decoder) {
		return A2(
			rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var author$project$Helpers$onKeyDown = function (tagger) {
	return A2(
		rtfeldman$elm_css$Html$Styled$Events$on,
		'keydown',
		A2(
			elm$json$Json$Decode$map,
			function (code) {
				return tagger(
					elm$core$Char$fromCode(code));
			},
			rtfeldman$elm_css$Html$Styled$Events$keyCode));
};
var author$project$Models$SetMouseNavigation = {$: 0};
var author$project$Models$VerifyKeyboardNavigation = function (a) {
	return {$: 1, a: a};
};
var author$project$PanelsManager$isSomePanelOpen = F2(
	function (panelId, panelsState) {
		var stateWrappers = panelsState;
		return !elm$core$List$isEmpty(
			A2(
				elm$core$List$filter,
				function (stateWrapper) {
					var _n1 = stateWrapper;
					var id = _n1.a;
					var state = _n1.b;
					return (state === 1) && A2(elm$core$String$contains, panelId, id);
				},
				stateWrappers));
	});
var author$project$Models$ScrollToTop = {$: 27};
var rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
	return {$: 6, a: a};
};
var rtfeldman$elm_css$Css$batch = rtfeldman$elm_css$Css$Preprocess$ApplyStyles;
var author$project$PartialViews$UiKit$noStyle = rtfeldman$elm_css$Css$batch(_List_Nil);
var rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
	return {$: 0, a: a};
};
var rtfeldman$elm_css$Css$property = F2(
	function (key, value) {
		return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var author$project$PartialViews$UiKit$clipZero = A2(rtfeldman$elm_css$Css$property, 'clip', 'rect(0 0 0 0)');
var rtfeldman$elm_css$Css$Structure$Compatible = 0;
var rtfeldman$elm_css$Css$absolute = {aH: 0, ed: 'absolute'};
var rtfeldman$elm_css$Css$prop1 = F2(
	function (key, arg) {
		return A2(rtfeldman$elm_css$Css$property, key, arg.ed);
	});
var rtfeldman$elm_css$Css$border = rtfeldman$elm_css$Css$prop1('border');
var rtfeldman$elm_css$Css$height = rtfeldman$elm_css$Css$prop1('height');
var rtfeldman$elm_css$Css$hidden = {r: 0, ak: 0, ed: 'hidden', aP: 0};
var rtfeldman$elm_css$Css$margin = rtfeldman$elm_css$Css$prop1('margin');
var rtfeldman$elm_css$Css$overflow = rtfeldman$elm_css$Css$prop1('overflow');
var rtfeldman$elm_css$Css$padding = rtfeldman$elm_css$Css$prop1('padding');
var rtfeldman$elm_css$Css$position = rtfeldman$elm_css$Css$prop1('position');
var rtfeldman$elm_css$Css$PxUnits = 0;
var elm$core$String$fromFloat = _String_fromNumber;
var rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
	function (units, unitLabel, numericValue) {
		return {
			bs: 0,
			bG: 0,
			ac: 0,
			o: 0,
			aE: 0,
			ah: 0,
			H: 0,
			ai: 0,
			aj: 0,
			P: 0,
			Q: 0,
			A: 0,
			K: numericValue,
			aq: 0,
			as: unitLabel,
			aO: units,
			ed: _Utils_ap(
				elm$core$String$fromFloat(numericValue),
				unitLabel)
		};
	});
var rtfeldman$elm_css$Css$px = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'px');
var rtfeldman$elm_css$Css$width = rtfeldman$elm_css$Css$prop1('width');
var rtfeldman$elm_css$Css$UnitlessInteger = 0;
var rtfeldman$elm_css$Css$zero = {aE: 0, ah: 0, H: 0, ai: 0, aj: 0, P: 0, Q: 0, aG: 0, K: 0, a0: 0, as: '', aO: 0, ed: '0'};
var author$project$PartialViews$UiKit$visuallyHiddenStyle = rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			rtfeldman$elm_css$Css$border(rtfeldman$elm_css$Css$zero),
			rtfeldman$elm_css$Css$height(
			rtfeldman$elm_css$Css$px(1)),
			rtfeldman$elm_css$Css$margin(
			rtfeldman$elm_css$Css$px(-1)),
			rtfeldman$elm_css$Css$overflow(rtfeldman$elm_css$Css$hidden),
			rtfeldman$elm_css$Css$padding(rtfeldman$elm_css$Css$zero),
			rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$absolute),
			rtfeldman$elm_css$Css$width(
			rtfeldman$elm_css$Css$px(1)),
			author$project$PartialViews$UiKit$clipZero
		]));
var rtfeldman$elm_css$Css$EmUnits = 0;
var rtfeldman$elm_css$Css$em = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'em');
var rtfeldman$elm_css$Css$marginLeft = rtfeldman$elm_css$Css$prop1('margin-left');
var rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var rtfeldman$elm_css$VirtualDom$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$Node;
var rtfeldman$elm_css$Html$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$node;
var rtfeldman$elm_css$Html$Styled$span = rtfeldman$elm_css$Html$Styled$node('span');
var elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var elm$core$String$cons = _String_cons;
var rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
	return {bJ: elm$core$Maybe$Nothing, b1: _List_Nil, cg: _List_Nil, cG: snippets};
};
var elm$core$List$concatMap = F2(
	function (f, list) {
		return elm$core$List$concat(
			A2(elm$core$List$map, f, list));
	});
var rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_n0) {
	var declarations = _n0;
	return declarations;
};
var elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return elm$core$Maybe$Just(xs);
	} else {
		return elm$core$Maybe$Nothing;
	}
};
var elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2(elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var elm$core$List$takeTailRec = F2(
	function (n, list) {
		return elm$core$List$reverse(
			A3(elm$core$List$takeReverse, n, list, _List_Nil));
	});
var elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _n0 = _Utils_Tuple2(n, list);
			_n0$1:
			while (true) {
				_n0$5:
				while (true) {
					if (!_n0.b.b) {
						return list;
					} else {
						if (_n0.b.b.b) {
							switch (_n0.a) {
								case 1:
									break _n0$1;
								case 2:
									var _n2 = _n0.b;
									var x = _n2.a;
									var _n3 = _n2.b;
									var y = _n3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_n0.b.b.b.b) {
										var _n4 = _n0.b;
										var x = _n4.a;
										var _n5 = _n4.b;
										var y = _n5.a;
										var _n6 = _n5.b;
										var z = _n6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _n0$5;
									}
								default:
									if (_n0.b.b.b.b && _n0.b.b.b.b.b) {
										var _n7 = _n0.b;
										var x = _n7.a;
										var _n8 = _n7.b;
										var y = _n8.a;
										var _n9 = _n8.b;
										var z = _n9.a;
										var _n10 = _n9.b;
										var w = _n10.a;
										var tl = _n10.b;
										return (ctr > 1000) ? A2(
											elm$core$List$cons,
											x,
											A2(
												elm$core$List$cons,
												y,
												A2(
													elm$core$List$cons,
													z,
													A2(
														elm$core$List$cons,
														w,
														A2(elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											elm$core$List$cons,
											x,
											A2(
												elm$core$List$cons,
												y,
												A2(
													elm$core$List$cons,
													z,
													A2(
														elm$core$List$cons,
														w,
														A3(elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _n0$5;
									}
							}
						} else {
							if (_n0.a === 1) {
								break _n0$1;
							} else {
								break _n0$5;
							}
						}
					}
				}
				return list;
			}
			var _n1 = _n0.b;
			var x = _n1.a;
			return _List_fromArray(
				[x]);
		}
	});
var elm$core$List$take = F2(
	function (n, list) {
		return A3(elm$core$List$takeFast, 0, n, list);
	});
var elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return elm$core$Maybe$Just(
				f(value));
		} else {
			return elm$core$Maybe$Nothing;
		}
	});
var rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		if (!declarations.b) {
			return _List_Nil;
		} else {
			if (!declarations.a.$) {
				var _n1 = declarations.a.a;
				var firstSelector = _n1.a;
				var otherSelectors = _n1.b;
				var rest = declarations.b;
				return _Utils_ap(
					A2(elm$core$List$cons, firstSelector, otherSelectors),
					rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
			} else {
				var rest = declarations.b;
				var $temp$declarations = rest;
				declarations = $temp$declarations;
				continue collectSelectors;
			}
		}
	}
};
var rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
	last:
	while (true) {
		if (!list.b) {
			return elm$core$Maybe$Nothing;
		} else {
			if (!list.b.b) {
				var singleton = list.a;
				return elm$core$Maybe$Just(singleton);
			} else {
				var rest = list.b;
				var $temp$list = rest;
				list = $temp$list;
				continue last;
			}
		}
	}
};
var rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
	lastDeclaration:
	while (true) {
		if (!declarations.b) {
			return elm$core$Maybe$Nothing;
		} else {
			if (!declarations.b.b) {
				var x = declarations.a;
				return elm$core$Maybe$Just(
					_List_fromArray(
						[x]));
			} else {
				var xs = declarations.b;
				var $temp$declarations = xs;
				declarations = $temp$declarations;
				continue lastDeclaration;
			}
		}
	}
};
var rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
	oneOf:
	while (true) {
		if (!maybes.b) {
			return elm$core$Maybe$Nothing;
		} else {
			var maybe = maybes.a;
			var rest = maybes.b;
			if (maybe.$ === 1) {
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue oneOf;
			} else {
				return maybe;
			}
		}
	}
};
var rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
	return {$: 9, a: a};
};
var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
	var expandTuples = function (tuplesToExpand) {
		if (!tuplesToExpand.b) {
			return _List_Nil;
		} else {
			var properties = tuplesToExpand.a;
			var rest = tuplesToExpand.b;
			return A2(
				elm$core$List$cons,
				properties,
				expandTuples(rest));
		}
	};
	var newTuples = expandTuples(tuples);
	return _List_fromArray(
		[
			rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
		]);
};
var rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {$: 3, a: a, b: b, c: c, d: d, e: e};
	});
var rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
	function (str1, str2, str3, str4, declaration) {
		if (!declaration.$) {
			var structureStyleBlock = declaration.a;
			return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
		} else {
			return declaration;
		}
	});
var rtfeldman$elm_css$Css$Structure$MediaRule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
	function (mediaQueries, declaration) {
		switch (declaration.$) {
			case 0:
				var structureStyleBlock = declaration.a;
				return A2(
					rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[structureStyleBlock]));
			case 1:
				var newMediaQueries = declaration.a;
				var structureStyleBlocks = declaration.b;
				return A2(
					rtfeldman$elm_css$Css$Structure$MediaRule,
					_Utils_ap(mediaQueries, newMediaQueries),
					structureStyleBlocks);
			case 2:
				var str = declaration.a;
				var declarations = declaration.b;
				return A2(
					rtfeldman$elm_css$Css$Structure$SupportsRule,
					str,
					A2(
						elm$core$List$map,
						rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
						declarations));
			case 3:
				var str1 = declaration.a;
				var str2 = declaration.b;
				var str3 = declaration.c;
				var str4 = declaration.d;
				var structureStyleBlock = declaration.e;
				return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			case 4:
				return declaration;
			case 5:
				return declaration;
			case 6:
				return declaration;
			case 7:
				return declaration;
			case 8:
				return declaration;
			default:
				return declaration;
		}
	});
var rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
	return {$: 8, a: a};
};
var rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
	return {$: 5, a: a};
};
var rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
	return {$: 6, a: a};
};
var rtfeldman$elm_css$Css$Structure$PageRule = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var rtfeldman$elm_css$Css$Structure$Selector = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
	return {$: 7, a: a};
};
var rtfeldman$elm_css$Css$Structure$mapLast = F2(
	function (update, list) {
		if (!list.b) {
			return list;
		} else {
			if (!list.b.b) {
				var only = list.a;
				return _List_fromArray(
					[
						update(only)
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					elm$core$List$cons,
					first,
					A2(rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
			}
		}
	});
var rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
	function (property, _n0) {
		var firstSelector = _n0.a;
		var otherSelectors = _n0.b;
		var properties = _n0.c;
		return A3(
			rtfeldman$elm_css$Css$Structure$StyleBlock,
			firstSelector,
			otherSelectors,
			_Utils_ap(
				properties,
				_List_fromArray(
					[property])));
	});
var rtfeldman$elm_css$Css$Structure$appendProperty = F2(
	function (property, declarations) {
		if (!declarations.b) {
			return declarations;
		} else {
			if (!declarations.b.b) {
				switch (declarations.a.$) {
					case 0:
						var styleBlock = declarations.a.a;
						return _List_fromArray(
							[
								rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
								A2(rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
							]);
					case 1:
						var _n1 = declarations.a;
						var mediaQueries = _n1.a;
						var styleBlocks = _n1.b;
						return _List_fromArray(
							[
								A2(
								rtfeldman$elm_css$Css$Structure$MediaRule,
								mediaQueries,
								A2(
									rtfeldman$elm_css$Css$Structure$mapLast,
									rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
									styleBlocks))
							]);
					default:
						return declarations;
				}
			} else {
				var first = declarations.a;
				var rest = declarations.b;
				return A2(
					elm$core$List$cons,
					first,
					A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
			}
		}
	});
var rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
	function (f, styleBlock) {
		if (!styleBlock.b.b) {
			var only = styleBlock.a;
			var properties = styleBlock.c;
			return _List_fromArray(
				[
					A3(rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
					A3(
					rtfeldman$elm_css$Css$Structure$StyleBlock,
					f(only),
					_List_Nil,
					_List_Nil)
				]);
		} else {
			var first = styleBlock.a;
			var rest = styleBlock.b;
			var properties = styleBlock.c;
			var newRest = A2(elm$core$List$map, f, rest);
			var newFirst = f(first);
			return _List_fromArray(
				[
					A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
					A3(rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
				]);
		}
	});
var rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
	function (pseudo, _n0) {
		var sequence = _n0.a;
		var selectors = _n0.b;
		return A3(
			rtfeldman$elm_css$Css$Structure$Selector,
			sequence,
			selectors,
			elm$core$Maybe$Just(pseudo));
	});
var rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
	function (pseudo, styleBlock) {
		return A2(
			rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
			styleBlock);
	});
var rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
	return {$: 1, a: a};
};
var rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
	function (selector, sequence) {
		switch (sequence.$) {
			case 0:
				var typeSelector = sequence.a;
				var list = sequence.b;
				return A2(
					rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
					typeSelector,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			case 1:
				var list = sequence.a;
				return rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			default:
				var str = sequence.a;
				var list = sequence.b;
				return A2(
					rtfeldman$elm_css$Css$Structure$CustomSelector,
					str,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
		}
	});
var rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
	function (selector, list) {
		if (!list.b) {
			return _List_Nil;
		} else {
			if (!list.b.b) {
				var _n1 = list.a;
				var combinator = _n1.a;
				var sequence = _n1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						combinator,
						A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					elm$core$List$cons,
					first,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
			}
		}
	});
var rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
	function (repeatableSimpleSelector, selector) {
		if (!selector.b.b) {
			var sequence = selector.a;
			var pseudoElement = selector.c;
			return A3(
				rtfeldman$elm_css$Css$Structure$Selector,
				A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
				_List_Nil,
				pseudoElement);
		} else {
			var firstSelector = selector.a;
			var tuples = selector.b;
			var pseudoElement = selector.c;
			return A3(
				rtfeldman$elm_css$Css$Structure$Selector,
				firstSelector,
				A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
				pseudoElement);
		}
	});
var rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
	function (selector, styleBlock) {
		return A2(
			rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
			styleBlock);
	});
var rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
	function (update, declarations) {
		_n0$12:
		while (true) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 0:
							var styleBlock = declarations.a.a;
							return A2(
								elm$core$List$map,
								rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
								update(styleBlock));
						case 1:
							if (declarations.a.b.b) {
								if (!declarations.a.b.b.b) {
									var _n1 = declarations.a;
									var mediaQueries = _n1.a;
									var _n2 = _n1.b;
									var styleBlock = _n2.a;
									return _List_fromArray(
										[
											A2(
											rtfeldman$elm_css$Css$Structure$MediaRule,
											mediaQueries,
											update(styleBlock))
										]);
								} else {
									var _n3 = declarations.a;
									var mediaQueries = _n3.a;
									var _n4 = _n3.b;
									var first = _n4.a;
									var rest = _n4.b;
									var _n5 = A2(
										rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
										update,
										_List_fromArray(
											[
												A2(rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
											]));
									if ((_n5.b && (_n5.a.$ === 1)) && (!_n5.b.b)) {
										var _n6 = _n5.a;
										var newMediaQueries = _n6.a;
										var newStyleBlocks = _n6.b;
										return _List_fromArray(
											[
												A2(
												rtfeldman$elm_css$Css$Structure$MediaRule,
												newMediaQueries,
												A2(elm$core$List$cons, first, newStyleBlocks))
											]);
									} else {
										var newDeclarations = _n5;
										return newDeclarations;
									}
								}
							} else {
								break _n0$12;
							}
						case 2:
							var _n7 = declarations.a;
							var str = _n7.a;
							var nestedDeclarations = _n7.b;
							return _List_fromArray(
								[
									A2(
									rtfeldman$elm_css$Css$Structure$SupportsRule,
									str,
									A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
								]);
						case 3:
							var _n8 = declarations.a;
							var str1 = _n8.a;
							var str2 = _n8.b;
							var str3 = _n8.c;
							var str4 = _n8.d;
							var styleBlock = _n8.e;
							return A2(
								elm$core$List$map,
								A4(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
								update(styleBlock));
						case 4:
							var _n9 = declarations.a;
							return declarations;
						case 5:
							return declarations;
						case 6:
							return declarations;
						case 7:
							return declarations;
						case 8:
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _n0$12;
				}
			}
		}
		var first = declarations.a;
		var rest = declarations.b;
		return A2(
			elm$core$List$cons,
			first,
			A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
	});
var rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
	function (mediaQueries, declaration) {
		if (!declaration.$) {
			var styleBlock = declaration.a;
			return A2(
				rtfeldman$elm_css$Css$Structure$MediaRule,
				mediaQueries,
				_List_fromArray(
					[styleBlock]));
		} else {
			return declaration;
		}
	});
var rtfeldman$elm_css$Hash$murmurSeed = 15739;
var elm$core$String$fromList = _String_fromList;
var rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					elm$core$List$cons,
					rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					elm$core$List$cons,
					rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2(elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var rtfeldman$elm_hex$Hex$toString = function (num) {
	return elm$core$String$fromList(
		(num < 0) ? A2(
			elm$core$List$cons,
			'-',
			A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var rtfeldman$elm_css$Hash$fromString = function (str) {
	return A2(
		elm$core$String$cons,
		'_',
		rtfeldman$elm_hex$Hex$toString(
			A2(Skinney$murmur3$Murmur3$hashString, rtfeldman$elm_css$Hash$murmurSeed, str)));
};
var rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
	function (nestedStyles, rest, f, declarations) {
		var withoutParent = function (decls) {
			return A2(
				elm$core$Maybe$withDefault,
				_List_Nil,
				elm$core$List$tail(decls));
		};
		var nextResult = A2(
			rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			rest,
			A2(
				elm$core$Maybe$withDefault,
				_List_Nil,
				rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		var newDeclarations = function () {
			var _n14 = _Utils_Tuple2(
				elm$core$List$head(nextResult),
				rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
			if ((!_n14.a.$) && (!_n14.b.$)) {
				var nextResultParent = _n14.a.a;
				var originalParent = _n14.b.a;
				return _Utils_ap(
					A2(
						elm$core$List$take,
						elm$core$List$length(declarations) - 1,
						declarations),
					_List_fromArray(
						[
							(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
						]));
			} else {
				return declarations;
			}
		}();
		var insertStylesToNestedDecl = function (lastDecl) {
			return elm$core$List$concat(
				A2(
					rtfeldman$elm_css$Css$Structure$mapLast,
					rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
					A2(
						elm$core$List$map,
						elm$core$List$singleton,
						A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
		};
		var initialResult = A2(
			elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				elm$core$Maybe$map,
				insertStylesToNestedDecl,
				rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		return _Utils_ap(
			newDeclarations,
			_Utils_ap(
				withoutParent(initialResult),
				withoutParent(nextResult)));
	});
var rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
	function (styles, declarations) {
		if (!styles.b) {
			return declarations;
		} else {
			switch (styles.a.$) {
				case 0:
					var property = styles.a.a;
					var rest = styles.b;
					return A2(
						rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
				case 1:
					var _n4 = styles.a;
					var selector = _n4.a;
					var nestedStyles = _n4.b;
					var rest = styles.b;
					return A4(
						rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
						declarations);
				case 2:
					var _n5 = styles.a;
					var selectorCombinator = _n5.a;
					var snippets = _n5.b;
					var rest = styles.b;
					var chain = F2(
						function (_n9, _n10) {
							var originalSequence = _n9.a;
							var originalTuples = _n9.b;
							var originalPseudoElement = _n9.c;
							var newSequence = _n10.a;
							var newTuples = _n10.b;
							var newPseudoElement = _n10.c;
							return A3(
								rtfeldman$elm_css$Css$Structure$Selector,
								originalSequence,
								_Utils_ap(
									originalTuples,
									A2(
										elm$core$List$cons,
										_Utils_Tuple2(selectorCombinator, newSequence),
										newTuples)),
								rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
									_List_fromArray(
										[newPseudoElement, originalPseudoElement])));
						});
					var expandDeclaration = function (declaration) {
						switch (declaration.$) {
							case 0:
								var _n7 = declaration.a;
								var firstSelector = _n7.a;
								var otherSelectors = _n7.b;
								var nestedStyles = _n7.c;
								var newSelectors = A2(
									elm$core$List$concatMap,
									function (originalSelector) {
										return A2(
											elm$core$List$map,
											chain(originalSelector),
											A2(elm$core$List$cons, firstSelector, otherSelectors));
									},
									rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
								var newDeclarations = function () {
									if (!newSelectors.b) {
										return _List_Nil;
									} else {
										var first = newSelectors.a;
										var remainder = newSelectors.b;
										return _List_fromArray(
											[
												rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
											]);
									}
								}();
								return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
							case 1:
								var mediaQueries = declaration.a;
								var styleBlocks = declaration.b;
								return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
							case 2:
								var str = declaration.a;
								var otherSnippets = declaration.b;
								return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
							case 3:
								var str1 = declaration.a;
								var str2 = declaration.b;
								var str3 = declaration.c;
								var str4 = declaration.d;
								var styleBlock = declaration.e;
								return A2(
									elm$core$List$map,
									A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
									rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
							case 4:
								var str = declaration.a;
								var properties = declaration.b;
								return _List_fromArray(
									[
										A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
									]);
							case 5:
								var properties = declaration.a;
								return _List_fromArray(
									[
										rtfeldman$elm_css$Css$Structure$FontFace(properties)
									]);
							case 6:
								var properties = declaration.a;
								return _List_fromArray(
									[
										rtfeldman$elm_css$Css$Structure$Viewport(properties)
									]);
							case 7:
								var properties = declaration.a;
								return _List_fromArray(
									[
										rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
									]);
							default:
								var tuples = declaration.a;
								return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
						}
					};
					return elm$core$List$concat(
						_Utils_ap(
							_List_fromArray(
								[
									A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
								]),
							A2(
								elm$core$List$map,
								expandDeclaration,
								A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
				case 3:
					var _n11 = styles.a;
					var pseudoElement = _n11.a;
					var nestedStyles = _n11.b;
					var rest = styles.b;
					return A4(
						rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
						declarations);
				case 5:
					var str = styles.a.a;
					var rest = styles.b;
					var name = rtfeldman$elm_css$Hash$fromString(str);
					var newProperty = 'animation-name:' + name;
					var newDeclarations = A2(
						rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2(rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
					return A2(
						elm$core$List$append,
						newDeclarations,
						_List_fromArray(
							[
								rtfeldman$elm_css$Css$Structure$Keyframes(
								{df: str, aZ: name})
							]));
				case 4:
					var _n12 = styles.a;
					var mediaQueries = _n12.a;
					var nestedStyles = _n12.b;
					var rest = styles.b;
					var extraDeclarations = function () {
						var _n13 = rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
						if (!_n13.b) {
							return _List_Nil;
						} else {
							var firstSelector = _n13.a;
							var otherSelectors = _n13.b;
							return A2(
								elm$core$List$map,
								rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
								A2(
									rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
									nestedStyles,
									elm$core$List$singleton(
										rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
											A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
						}
					}();
					return _Utils_ap(
						A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
						extraDeclarations);
				default:
					var otherStyles = styles.a.a;
					var rest = styles.b;
					return A2(
						rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						_Utils_ap(otherStyles, rest),
						declarations);
			}
		}
	});
var rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_n2) {
	var firstSelector = _n2.a;
	var otherSelectors = _n2.b;
	var styles = _n2.c;
	return A2(
		rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
		styles,
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
				A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
			]));
};
var rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
	if (!snippetDeclarations.b) {
		return _List_Nil;
	} else {
		var first = snippetDeclarations.a;
		var rest = snippetDeclarations.b;
		return _Utils_ap(
			rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
			rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
	}
};
var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
	function (mediaQueries, styleBlocks) {
		var handleStyleBlock = function (styleBlock) {
			return A2(
				elm$core$List$map,
				rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
				rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		};
		return A2(elm$core$List$concatMap, handleStyleBlock, styleBlocks);
	});
var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
	function (str, snippets) {
		var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return _List_fromArray(
			[
				A2(rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
			]);
	});
var rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
	switch (snippetDeclaration.$) {
		case 0:
			var styleBlock = snippetDeclaration.a;
			return rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
		case 1:
			var mediaQueries = snippetDeclaration.a;
			var styleBlocks = snippetDeclaration.b;
			return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
		case 2:
			var str = snippetDeclaration.a;
			var snippets = snippetDeclaration.b;
			return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
		case 3:
			var str1 = snippetDeclaration.a;
			var str2 = snippetDeclaration.b;
			var str3 = snippetDeclaration.c;
			var str4 = snippetDeclaration.d;
			var styleBlock = snippetDeclaration.e;
			return A2(
				elm$core$List$map,
				A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
				rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		case 4:
			var str = snippetDeclaration.a;
			var properties = snippetDeclaration.b;
			return _List_fromArray(
				[
					A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
				]);
		case 5:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$FontFace(properties)
				]);
		case 6:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$Viewport(properties)
				]);
		case 7:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
				]);
		default:
			var tuples = snippetDeclaration.a;
			return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
	}
};
var rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_n0) {
	var charset = _n0.bJ;
	var imports = _n0.b1;
	var namespaces = _n0.cg;
	var snippets = _n0.cG;
	var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
		A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
	return {bJ: charset, dg: declarations, b1: imports, cg: namespaces};
};
var elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			elm$core$List$any,
			A2(elm$core$Basics$composeL, elm$core$Basics$not, isOkay),
			list);
	});
var rtfeldman$elm_css$Css$Structure$compactHelp = F2(
	function (declaration, _n0) {
		var keyframesByName = _n0.a;
		var declarations = _n0.b;
		switch (declaration.$) {
			case 0:
				var _n2 = declaration.a;
				var properties = _n2.c;
				return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2(elm$core$List$cons, declaration, declarations));
			case 1:
				var styleBlocks = declaration.b;
				return A2(
					elm$core$List$all,
					function (_n3) {
						var properties = _n3.c;
						return elm$core$List$isEmpty(properties);
					},
					styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2(elm$core$List$cons, declaration, declarations));
			case 2:
				var otherDeclarations = declaration.b;
				return elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2(elm$core$List$cons, declaration, declarations));
			case 3:
				return _Utils_Tuple2(
					keyframesByName,
					A2(elm$core$List$cons, declaration, declarations));
			case 4:
				var properties = declaration.b;
				return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2(elm$core$List$cons, declaration, declarations));
			case 5:
				var properties = declaration.a;
				return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2(elm$core$List$cons, declaration, declarations));
			case 6:
				var record = declaration.a;
				return elm$core$String$isEmpty(record.df) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					A3(elm$core$Dict$insert, record.aZ, record.df, keyframesByName),
					declarations);
			case 7:
				var properties = declaration.a;
				return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2(elm$core$List$cons, declaration, declarations));
			case 8:
				var properties = declaration.a;
				return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2(elm$core$List$cons, declaration, declarations));
			default:
				var tuples = declaration.a;
				return A2(
					elm$core$List$all,
					function (_n4) {
						var properties = _n4.b;
						return elm$core$List$isEmpty(properties);
					},
					tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2(elm$core$List$cons, declaration, declarations));
		}
	});
var rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
	function (keyframesByName, compactedDeclarations) {
		return A2(
			elm$core$List$append,
			A2(
				elm$core$List$map,
				function (_n0) {
					var name = _n0.a;
					var decl = _n0.b;
					return rtfeldman$elm_css$Css$Structure$Keyframes(
						{df: decl, aZ: name});
				},
				elm$core$Dict$toList(keyframesByName)),
			compactedDeclarations);
	});
var rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_n0) {
	var charset = _n0.bJ;
	var imports = _n0.b1;
	var namespaces = _n0.cg;
	var declarations = _n0.dg;
	var _n1 = A3(
		elm$core$List$foldr,
		rtfeldman$elm_css$Css$Structure$compactHelp,
		_Utils_Tuple2(elm$core$Dict$empty, _List_Nil),
		declarations);
	var keyframesByName = _n1.a;
	var compactedDeclarations = _n1.b;
	var finalDeclarations = A2(rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
	return {bJ: charset, dg: finalDeclarations, b1: imports, cg: namespaces};
};
var rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
	return A2(
		elm$core$Maybe$withDefault,
		'',
		A2(
			elm$core$Maybe$map,
			function (str) {
				return '@charset \"' + (str + '\"');
			},
			charset));
};
var rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
	return '(' + (expression.bV + (A2(
		elm$core$Maybe$withDefault,
		'',
		A2(
			elm$core$Maybe$map,
			elm$core$Basics$append(': '),
			expression.ed)) + ')'));
};
var rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
	switch (mediaType) {
		case 0:
			return 'print';
		case 1:
			return 'screen';
		default:
			return 'speech';
	}
};
var rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
	var prefixWith = F3(
		function (str, mediaType, expressions) {
			return str + (' ' + A2(
				elm$core$String$join,
				' and ',
				A2(
					elm$core$List$cons,
					rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
		});
	switch (mediaQuery.$) {
		case 0:
			var expressions = mediaQuery.a;
			return A2(
				elm$core$String$join,
				' and ',
				A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions));
		case 1:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'only', mediaType, expressions);
		case 2:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'not', mediaType, expressions);
		default:
			var str = mediaQuery.a;
			return str;
	}
};
var rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
	function (name, mediaQuery) {
		return '@import \"' + (name + (rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
	});
var rtfeldman$elm_css$Css$Structure$Output$importToString = function (_n0) {
	var name = _n0.a;
	var mediaQueries = _n0.b;
	return A2(
		elm$core$String$join,
		'\n',
		A2(
			elm$core$List$map,
			rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
			mediaQueries));
};
var rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_n0) {
	var prefix = _n0.a;
	var str = _n0.b;
	return '@namespace ' + (prefix + ('\"' + (str + '\"')));
};
var rtfeldman$elm_css$Css$Structure$Output$spaceIndent = '    ';
var rtfeldman$elm_css$Css$Structure$Output$indent = function (str) {
	return _Utils_ap(rtfeldman$elm_css$Css$Structure$Output$spaceIndent, str);
};
var rtfeldman$elm_css$Css$Structure$Output$noIndent = '';
var rtfeldman$elm_css$Css$Structure$Output$emitProperty = function (str) {
	return str + ';';
};
var rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
	return A2(
		elm$core$String$join,
		'\n',
		A2(
			elm$core$List$map,
			A2(elm$core$Basics$composeL, rtfeldman$elm_css$Css$Structure$Output$indent, rtfeldman$elm_css$Css$Structure$Output$emitProperty),
			properties));
};
var rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_n0) {
	var str = _n0;
	return '::' + str;
};
var rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
	switch (combinator) {
		case 0:
			return '+';
		case 1:
			return '~';
		case 2:
			return '>';
		default:
			return '';
	}
};
var rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
	switch (repeatableSimpleSelector.$) {
		case 0:
			var str = repeatableSimpleSelector.a;
			return '.' + str;
		case 1:
			var str = repeatableSimpleSelector.a;
			return '#' + str;
		case 2:
			var str = repeatableSimpleSelector.a;
			return ':' + str;
		default:
			var str = repeatableSimpleSelector.a;
			return '[' + (str + ']');
	}
};
var rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
	switch (simpleSelectorSequence.$) {
		case 0:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return A2(
				elm$core$String$join,
				'',
				A2(
					elm$core$List$cons,
					str,
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
		case 1:
			var repeatableSimpleSelectors = simpleSelectorSequence.a;
			return elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A2(
				elm$core$String$join,
				'',
				A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors));
		default:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return A2(
				elm$core$String$join,
				'',
				A2(
					elm$core$List$cons,
					str,
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
	}
};
var rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_n0) {
	var combinator = _n0.a;
	var sequence = _n0.b;
	return A2(
		elm$core$String$join,
		' ',
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator),
				rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence)
			]));
};
var rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_n0) {
	var simpleSelectorSequence = _n0.a;
	var chain = _n0.b;
	var pseudoElement = _n0.c;
	var segments = A2(
		elm$core$List$cons,
		rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
		A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
	var pseudoElementsString = A2(
		elm$core$String$join,
		'',
		_List_fromArray(
			[
				A2(
				elm$core$Maybe$withDefault,
				'',
				A2(elm$core$Maybe$map, rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement))
			]));
	return A2(
		elm$core$String$append,
		A2(
			elm$core$String$join,
			' ',
			A2(
				elm$core$List$filter,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
				segments)),
		pseudoElementsString);
};
var rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = F2(
	function (indentLevel, _n0) {
		var firstSelector = _n0.a;
		var otherSelectors = _n0.b;
		var properties = _n0.c;
		var selectorStr = A2(
			elm$core$String$join,
			', ',
			A2(
				elm$core$List$map,
				rtfeldman$elm_css$Css$Structure$Output$selectorToString,
				A2(elm$core$List$cons, firstSelector, otherSelectors)));
		return A2(
			elm$core$String$join,
			'',
			_List_fromArray(
				[
					selectorStr,
					' {\n',
					indentLevel,
					rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties),
					'\n',
					indentLevel,
					'}'
				]));
	});
var rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
	switch (decl.$) {
		case 0:
			var styleBlock = decl.a;
			return A2(rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, rtfeldman$elm_css$Css$Structure$Output$noIndent, styleBlock);
		case 1:
			var mediaQueries = decl.a;
			var styleBlocks = decl.b;
			var query = A2(
				elm$core$String$join,
				',\n',
				A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, mediaQueries));
			var blocks = A2(
				elm$core$String$join,
				'\n\n',
				A2(
					elm$core$List$map,
					A2(
						elm$core$Basics$composeL,
						rtfeldman$elm_css$Css$Structure$Output$indent,
						rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(rtfeldman$elm_css$Css$Structure$Output$spaceIndent)),
					styleBlocks));
			return '@media ' + (query + (' {\n' + (blocks + '\n}')));
		case 2:
			return 'TODO';
		case 3:
			return 'TODO';
		case 4:
			return 'TODO';
		case 5:
			return 'TODO';
		case 6:
			var name = decl.a.aZ;
			var declaration = decl.a.df;
			return '@keyframes ' + (name + (' {\n' + (declaration + '\n}')));
		case 7:
			return 'TODO';
		case 8:
			return 'TODO';
		default:
			return 'TODO';
	}
};
var rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_n0) {
	var charset = _n0.bJ;
	var imports = _n0.b1;
	var namespaces = _n0.cg;
	var declarations = _n0.dg;
	return A2(
		elm$core$String$join,
		'\n\n',
		A2(
			elm$core$List$filter,
			A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset),
					A2(
					elm$core$String$join,
					'\n',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$importToString, imports)),
					A2(
					elm$core$String$join,
					'\n',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$namespaceToString, namespaces)),
					A2(
					elm$core$String$join,
					'\n\n',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, declarations))
				])));
};
var rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp = function (sheet) {
	return rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
		rtfeldman$elm_css$Css$Structure$compactStylesheet(
			rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
};
var rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (styles) {
	return A2(
		elm$core$String$join,
		'\n\n',
		A2(elm$core$List$map, rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp, styles));
};
var rtfeldman$elm_css$Css$Preprocess$Snippet = elm$core$Basics$identity;
var rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
	function (styles, sequence) {
		var selector = A3(rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3(rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
			]);
	});
var rtfeldman$elm_css$VirtualDom$Styled$murmurSeed = 15739;
var rtfeldman$elm_css$VirtualDom$Styled$getClassname = function (styles) {
	return elm$core$List$isEmpty(styles) ? 'unstyled' : A2(
		elm$core$String$cons,
		'_',
		rtfeldman$elm_hex$Hex$toString(
			A2(
				Skinney$murmur3$Murmur3$hashString,
				rtfeldman$elm_css$VirtualDom$Styled$murmurSeed,
				rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
					elm$core$List$singleton(
						rtfeldman$elm_css$Css$Preprocess$stylesheet(
							elm$core$List$singleton(
								A2(
									rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
									styles,
									rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil)))))))));
};
var rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
	var classname = rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
	var classProperty = A2(
		elm$virtual_dom$VirtualDom$property,
		'className',
		elm$json$Json$Encode$string(classname));
	return A3(rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, styles, classname);
};
var rtfeldman$elm_css$Html$Styled$styled = F4(
	function (fn, styles, attrs, children) {
		return A2(
			fn,
			A2(
				elm$core$List$cons,
				rtfeldman$elm_css$Html$Styled$Internal$css(styles),
				attrs),
			children);
	});
var elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
	return {$: 4, a: a};
};
var rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
	return rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
		elm$virtual_dom$VirtualDom$text(str));
};
var rtfeldman$elm_css$Html$Styled$text = rtfeldman$elm_css$VirtualDom$Styled$text;
var author$project$PartialViews$IconButton$iconButton_ = F5(
	function (element, icon, labelData, styles, attributes) {
		var _n0 = labelData;
		var label = _n0.a;
		var showLabel = _n0.b;
		var hiddenStyle = showLabel ? author$project$PartialViews$UiKit$noStyle : author$project$PartialViews$UiKit$visuallyHiddenStyle;
		return A4(
			rtfeldman$elm_css$Html$Styled$styled,
			element,
			styles,
			attributes,
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[icon])),
					A4(
					rtfeldman$elm_css$Html$Styled$styled,
					rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$marginLeft(
							rtfeldman$elm_css$Css$em(0.5)),
							hiddenStyle
						]),
					_List_Nil,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text(label)
						]))
				]));
	});
var author$project$PartialViews$UiKit$appearance = function (val) {
	return rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				A2(rtfeldman$elm_css$Css$property, 'appearance', val),
				A2(rtfeldman$elm_css$Css$property, '-webkit-appearance', val)
			]));
};
var author$project$PartialViews$UiKit$distancesInRem = {be: 2.75, bf: 2.25, cz: 1.75, cR: 3.25, cS: 1.25, cT: 3.75, br: 0.75, cU: 4.25, cV: 0.25};
var author$project$PartialViews$UiKit$buttonHeightInRem = author$project$PartialViews$UiKit$distancesInRem.bf;
var author$project$PartialViews$UiKit$hairlineWidthInPx = 2;
var author$project$PartialViews$UiKit$inputHeightInRem = author$project$PartialViews$UiKit$distancesInRem.be;
var rtfeldman$elm_css$Css$calcExpressionToString = function (expression) {
	if (!expression) {
		return '+';
	} else {
		return '-';
	}
};
var rtfeldman$elm_css$Css$cssFunction = F2(
	function (funcName, args) {
		return funcName + ('(' + (A2(elm$core$String$join, ', ', args) + ')'));
	});
var rtfeldman$elm_css$Css$calc = F3(
	function (firstExpr, expression, secondExpr) {
		var withoutCalcStr = function (l) {
			return A2(elm$core$String$startsWith, 'calc(', l.ed) ? A2(elm$core$String$dropLeft, 4, l.ed) : l.ed;
		};
		var calcs = A2(
			elm$core$String$join,
			' ',
			_List_fromArray(
				[
					withoutCalcStr(firstExpr),
					rtfeldman$elm_css$Css$calcExpressionToString(expression),
					withoutCalcStr(secondExpr)
				]));
		var value = A2(
			rtfeldman$elm_css$Css$cssFunction,
			'calc',
			_List_fromArray(
				[calcs]));
		return {bG: 0, ac: 0, o: 0, aE: 0, ah: 0, H: 0, ai: 0, aj: 0, P: 0, Q: 0, A: 0, aq: 0, ed: value};
	});
var elm$core$String$foldr = _String_foldr;
var elm$core$String$toList = function (string) {
	return A3(elm$core$String$foldr, elm$core$List$cons, _List_Nil, string);
};
var rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
	return A2(elm$core$String$startsWith, '#', str) ? str : A2(elm$core$String$cons, '#', str);
};
var rtfeldman$elm_css$Css$erroneousHex = function (str) {
	return {
		aw: 1,
		ay: 0,
		z: 0,
		aC: 0,
		aI: 0,
		ed: rtfeldman$elm_css$Css$withPrecedingHash(str)
	};
};
var elm$core$String$toLower = _String_toLower;
var elm$core$Basics$pow = _Basics_pow;
var elm$core$String$fromChar = function (_char) {
	return A2(elm$core$String$cons, _char, '');
};
var rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2(elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return elm$core$Result$Err(
							elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var rtfeldman$elm_hex$Hex$fromString = function (str) {
	if (elm$core$String$isEmpty(str)) {
		return elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2(elm$core$String$startsWith, '-', str)) {
				var list = A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					elm$core$List$tail(
						elm$core$String$toList(str)));
				return A2(
					elm$core$Result$map,
					elm$core$Basics$negate,
					A3(
						rtfeldman$elm_hex$Hex$fromStringHelp,
						elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					rtfeldman$elm_hex$Hex$fromStringHelp,
					elm$core$String$length(str) - 1,
					elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2(elm$core$Result$mapError, formatError, result);
	}
};
var rtfeldman$elm_css$Css$validHex = F5(
	function (str, _n0, _n1, _n2, _n3) {
		var r1 = _n0.a;
		var r2 = _n0.b;
		var g1 = _n1.a;
		var g2 = _n1.b;
		var b1 = _n2.a;
		var b2 = _n2.b;
		var a1 = _n3.a;
		var a2 = _n3.b;
		var toResult = A2(
			elm$core$Basics$composeR,
			elm$core$String$fromList,
			A2(elm$core$Basics$composeR, elm$core$String$toLower, rtfeldman$elm_hex$Hex$fromString));
		var results = _Utils_Tuple2(
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[r1, r2])),
				toResult(
					_List_fromArray(
						[g1, g2]))),
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[b1, b2])),
				toResult(
					_List_fromArray(
						[a1, a2]))));
		if ((((!results.a.a.$) && (!results.a.b.$)) && (!results.b.a.$)) && (!results.b.b.$)) {
			var _n5 = results.a;
			var red = _n5.a.a;
			var green = _n5.b.a;
			var _n6 = results.b;
			var blue = _n6.a.a;
			var alpha = _n6.b.a;
			return {
				aw: alpha / 255,
				ay: blue,
				z: 0,
				aC: green,
				aI: red,
				ed: rtfeldman$elm_css$Css$withPrecedingHash(str)
			};
		} else {
			return rtfeldman$elm_css$Css$erroneousHex(str);
		}
	});
var rtfeldman$elm_css$Css$hex = function (str) {
	var withoutHash = A2(elm$core$String$startsWith, '#', str) ? A2(elm$core$String$dropLeft, 1, str) : str;
	var _n0 = elm$core$String$toList(withoutHash);
	_n0$4:
	while (true) {
		if ((_n0.b && _n0.b.b) && _n0.b.b.b) {
			if (!_n0.b.b.b.b) {
				var r = _n0.a;
				var _n1 = _n0.b;
				var g = _n1.a;
				var _n2 = _n1.b;
				var b = _n2.a;
				return A5(
					rtfeldman$elm_css$Css$validHex,
					str,
					_Utils_Tuple2(r, r),
					_Utils_Tuple2(g, g),
					_Utils_Tuple2(b, b),
					_Utils_Tuple2('f', 'f'));
			} else {
				if (!_n0.b.b.b.b.b) {
					var r = _n0.a;
					var _n3 = _n0.b;
					var g = _n3.a;
					var _n4 = _n3.b;
					var b = _n4.a;
					var _n5 = _n4.b;
					var a = _n5.a;
					return A5(
						rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(a, a));
				} else {
					if (_n0.b.b.b.b.b.b) {
						if (!_n0.b.b.b.b.b.b.b) {
							var r1 = _n0.a;
							var _n6 = _n0.b;
							var r2 = _n6.a;
							var _n7 = _n6.b;
							var g1 = _n7.a;
							var _n8 = _n7.b;
							var g2 = _n8.a;
							var _n9 = _n8.b;
							var b1 = _n9.a;
							var _n10 = _n9.b;
							var b2 = _n10.a;
							return A5(
								rtfeldman$elm_css$Css$validHex,
								str,
								_Utils_Tuple2(r1, r2),
								_Utils_Tuple2(g1, g2),
								_Utils_Tuple2(b1, b2),
								_Utils_Tuple2('f', 'f'));
						} else {
							if (_n0.b.b.b.b.b.b.b.b && (!_n0.b.b.b.b.b.b.b.b.b)) {
								var r1 = _n0.a;
								var _n11 = _n0.b;
								var r2 = _n11.a;
								var _n12 = _n11.b;
								var g1 = _n12.a;
								var _n13 = _n12.b;
								var g2 = _n13.a;
								var _n14 = _n13.b;
								var b1 = _n14.a;
								var _n15 = _n14.b;
								var b2 = _n15.a;
								var _n16 = _n15.b;
								var a1 = _n16.a;
								var _n17 = _n16.b;
								var a2 = _n17.a;
								return A5(
									rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(a1, a2));
							} else {
								break _n0$4;
							}
						}
					} else {
						break _n0$4;
					}
				}
			}
		} else {
			break _n0$4;
		}
	}
	return rtfeldman$elm_css$Css$erroneousHex(str);
};
var rtfeldman$elm_css$Css$int = function (val) {
	return {
		G: 0,
		aX: 0,
		Q: 0,
		A: 0,
		aG: 0,
		a_: 0,
		K: val,
		as: '',
		aO: 0,
		ed: elm$core$String$fromInt(val)
	};
};
var rtfeldman$elm_css$Css$Subtraction = 1;
var rtfeldman$elm_css$Css$minus = 1;
var rtfeldman$elm_css$Css$RemUnits = 0;
var rtfeldman$elm_css$Css$rem = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'rem');
var rtfeldman$elm_css$Css$rgba = F4(
	function (r, g, b, alpha) {
		return {
			aw: alpha,
			ay: b,
			z: 0,
			aC: g,
			aI: r,
			ed: A2(
				rtfeldman$elm_css$Css$cssFunction,
				'rgba',
				_Utils_ap(
					A2(
						elm$core$List$map,
						elm$core$String$fromInt,
						_List_fromArray(
							[r, g, b])),
					_List_fromArray(
						[
							elm$core$String$fromFloat(alpha)
						])))
		};
	});
var author$project$PartialViews$UiKit$theme = {
	bB: rtfeldman$elm_css$Css$hex('000000'),
	bE: {bP: 900},
	bF: rtfeldman$elm_css$Css$rem(author$project$PartialViews$UiKit$buttonHeightInRem),
	aS: rtfeldman$elm_css$Css$hex('EAC435'),
	c7: rtfeldman$elm_css$Css$hex('ff0000'),
	c8: rtfeldman$elm_css$Css$hex('ffffff'),
	c9: rtfeldman$elm_css$Css$hex('e4e4e4'),
	da: rtfeldman$elm_css$Css$hex('008080'),
	aT: rtfeldman$elm_css$Css$hex('03CEA4'),
	db: rtfeldman$elm_css$Css$hex('673C4F'),
	dc: rtfeldman$elm_css$Css$hex('FB4D3D'),
	bL: A4(rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0),
	dh: rtfeldman$elm_css$Css$rem(author$project$PartialViews$UiKit$distancesInRem.be),
	di: rtfeldman$elm_css$Css$rem(author$project$PartialViews$UiKit$distancesInRem.bf),
	dj: rtfeldman$elm_css$Css$rem(author$project$PartialViews$UiKit$distancesInRem.cz),
	dk: rtfeldman$elm_css$Css$rem(author$project$PartialViews$UiKit$distancesInRem.cR),
	dl: rtfeldman$elm_css$Css$rem(author$project$PartialViews$UiKit$distancesInRem.cS),
	dm: rtfeldman$elm_css$Css$rem(author$project$PartialViews$UiKit$distancesInRem.cT),
	aV: rtfeldman$elm_css$Css$rem(author$project$PartialViews$UiKit$distancesInRem.br),
	dn: rtfeldman$elm_css$Css$rem(author$project$PartialViews$UiKit$distancesInRem.cU),
	$7: rtfeldman$elm_css$Css$rem(author$project$PartialViews$UiKit$distancesInRem.cV),
	bY: rtfeldman$elm_css$Css$rem(1),
	dv: rtfeldman$elm_css$Css$rem(1.25),
	dw: rtfeldman$elm_css$Css$rem(1),
	dx: rtfeldman$elm_css$Css$rem(1.5),
	dy: rtfeldman$elm_css$Css$px(author$project$PartialViews$UiKit$hairlineWidthInPx),
	b_: rtfeldman$elm_css$Css$rem(author$project$PartialViews$UiKit$buttonHeightInRem + (author$project$PartialViews$UiKit$distancesInRem.br * 2)),
	ag: A3(
		rtfeldman$elm_css$Css$calc,
		rtfeldman$elm_css$Css$rem(author$project$PartialViews$UiKit$inputHeightInRem),
		rtfeldman$elm_css$Css$minus,
		rtfeldman$elm_css$Css$px(author$project$PartialViews$UiKit$hairlineWidthInPx)),
	eh: rtfeldman$elm_css$Css$hex('ffffff'),
	cX: {
		c3: rtfeldman$elm_css$Css$int(1),
		bO: rtfeldman$elm_css$Css$int(60),
		dz: rtfeldman$elm_css$Css$int(10),
		dA: rtfeldman$elm_css$Css$int(30),
		cc: rtfeldman$elm_css$Css$int(50),
		dQ: rtfeldman$elm_css$Css$int(40),
		ci: rtfeldman$elm_css$Css$int(20),
		cE: rtfeldman$elm_css$Css$int(70)
	}
};
var author$project$PartialViews$UiKit$transition = function (val) {
	return A2(rtfeldman$elm_css$Css$property, 'transition', val);
};
var rtfeldman$elm_css$Css$backgroundColor = function (c) {
	return A2(rtfeldman$elm_css$Css$property, 'background-color', c.ed);
};
var rtfeldman$elm_css$Css$bold = {G: 0, ed: 'bold'};
var rtfeldman$elm_css$Css$prop3 = F4(
	function (key, argA, argB, argC) {
		return A2(
			rtfeldman$elm_css$Css$property,
			key,
			A2(
				elm$core$String$join,
				' ',
				_List_fromArray(
					[argA.ed, argB.ed, argC.ed])));
	});
var rtfeldman$elm_css$Css$border3 = rtfeldman$elm_css$Css$prop3('border');
var rtfeldman$elm_css$Css$borderRadius = rtfeldman$elm_css$Css$prop1('border-radius');
var rtfeldman$elm_css$Css$color = function (c) {
	return A2(rtfeldman$elm_css$Css$property, 'color', c.ed);
};
var rtfeldman$elm_css$Css$display = rtfeldman$elm_css$Css$prop1('display');
var rtfeldman$elm_css$Css$Preprocess$ExtendSelector = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var rtfeldman$elm_css$Css$Structure$PseudoClassSelector = function (a) {
	return {$: 2, a: a};
};
var rtfeldman$elm_css$Css$pseudoClass = function (_class) {
	return rtfeldman$elm_css$Css$Preprocess$ExtendSelector(
		rtfeldman$elm_css$Css$Structure$PseudoClassSelector(_class));
};
var rtfeldman$elm_css$Css$firstChild = rtfeldman$elm_css$Css$pseudoClass('first-child');
var rtfeldman$elm_css$Css$fontWeight = function (_n0) {
	var value = _n0.ed;
	return A2(rtfeldman$elm_css$Css$property, 'font-weight', value);
};
var rtfeldman$elm_css$Css$hover = rtfeldman$elm_css$Css$pseudoClass('hover');
var rtfeldman$elm_css$Css$inlineBlock = {j: 0, ed: 'inline-block'};
var rtfeldman$elm_css$Css$minHeight = rtfeldman$elm_css$Css$prop1('min-height');
var rtfeldman$elm_css$Css$prop2 = F3(
	function (key, argA, argB) {
		return A2(
			rtfeldman$elm_css$Css$property,
			key,
			A2(
				elm$core$String$join,
				' ',
				_List_fromArray(
					[argA.ed, argB.ed])));
	});
var rtfeldman$elm_css$Css$padding2 = rtfeldman$elm_css$Css$prop2('padding');
var rtfeldman$elm_css$Css$solid = {r: 0, U: 0, ed: 'solid'};
var rtfeldman$elm_css$Css$textTransform = rtfeldman$elm_css$Css$prop1('text-transform');
var rtfeldman$elm_css$Css$transparent = {z: 0, ed: 'transparent'};
var rtfeldman$elm_css$Css$uppercase = {V: 0, ed: 'uppercase'};
var author$project$PartialViews$UiKit$btnStyle = function (selected) {
	return rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
				rtfeldman$elm_css$Css$minHeight(author$project$PartialViews$UiKit$theme.bF),
				A2(rtfeldman$elm_css$Css$padding2, author$project$PartialViews$UiKit$theme.$7, author$project$PartialViews$UiKit$theme.aV),
				selected ? rtfeldman$elm_css$Css$backgroundColor(author$project$PartialViews$UiKit$theme.aT) : rtfeldman$elm_css$Css$backgroundColor(author$project$PartialViews$UiKit$theme.da),
				rtfeldman$elm_css$Css$color(author$project$PartialViews$UiKit$theme.eh),
				author$project$PartialViews$UiKit$appearance('none'),
				A3(
				rtfeldman$elm_css$Css$border3,
				rtfeldman$elm_css$Css$px(2),
				rtfeldman$elm_css$Css$solid,
				rtfeldman$elm_css$Css$transparent),
				author$project$PartialViews$UiKit$transition('all 0.5s'),
				rtfeldman$elm_css$Css$textTransform(rtfeldman$elm_css$Css$uppercase),
				rtfeldman$elm_css$Css$fontWeight(rtfeldman$elm_css$Css$bold),
				rtfeldman$elm_css$Css$borderRadius(
				rtfeldman$elm_css$Css$px(3)),
				rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$backgroundColor(author$project$PartialViews$UiKit$theme.aT)
					])),
				rtfeldman$elm_css$Css$firstChild(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$marginLeft(rtfeldman$elm_css$Css$zero)
					]))
			]));
};
var rtfeldman$elm_css$Html$Styled$button = rtfeldman$elm_css$Html$Styled$node('button');
var author$project$PartialViews$UiKit$btn = A2(
	rtfeldman$elm_css$Html$Styled$styled,
	rtfeldman$elm_css$Html$Styled$button,
	_List_fromArray(
		[
			author$project$PartialViews$UiKit$btnStyle(false)
		]));
var author$project$PartialViews$IconButton$iconButton = F3(
	function (icon, labelData, attributes) {
		return A5(author$project$PartialViews$IconButton$iconButton_, author$project$PartialViews$UiKit$btn, icon, labelData, _List_Nil, attributes);
	});
var rtfeldman$elm_css$Css$currentColor = {z: 0, ed: 'currentColor'};
var rtfeldman$elm_css$Css$fill = rtfeldman$elm_css$Css$prop1('fill');
var rtfeldman$elm_css$Css$middle = rtfeldman$elm_css$Css$prop1('middle');
var rtfeldman$elm_css$Css$Internal$property = F2(
	function (key, value) {
		return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
	function (functionName, desiredKey, style) {
		getOverloadedProperty:
		while (true) {
			switch (style.$) {
				case 0:
					var str = style.a;
					var key = A2(
						elm$core$Maybe$withDefault,
						'',
						elm$core$List$head(
							A2(elm$core$String$split, ':', str)));
					return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
				case 1:
					var selector = style.a;
					return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
				case 2:
					var combinator = style.a;
					return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
				case 3:
					var pseudoElement = style.a;
					return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
				case 4:
					return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
				case 5:
					return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
				default:
					if (!style.a.b) {
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
					} else {
						if (!style.a.b.b) {
							var _n1 = style.a;
							var only = _n1.a;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = only;
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						} else {
							var _n2 = style.a;
							var first = _n2.a;
							var rest = _n2.b;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						}
					}
			}
		}
	});
var rtfeldman$elm_css$Css$Internal$IncompatibleUnits = 0;
var rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3(rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '', 0);
var rtfeldman$elm_css$Css$verticalAlign = function (fn) {
	return A3(
		rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'verticalAlign',
		'vertical-align',
		fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var author$project$PartialViews$Icons$iconStyle = rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
			rtfeldman$elm_css$Css$width(
			rtfeldman$elm_css$Css$em(1)),
			rtfeldman$elm_css$Css$height(
			rtfeldman$elm_css$Css$em(1)),
			rtfeldman$elm_css$Css$fill(rtfeldman$elm_css$Css$currentColor),
			rtfeldman$elm_css$Css$verticalAlign(rtfeldman$elm_css$Css$middle)
		]));
var rtfeldman$elm_css$VirtualDom$Styled$NodeNS = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var rtfeldman$elm_css$VirtualDom$Styled$nodeNS = rtfeldman$elm_css$VirtualDom$Styled$NodeNS;
var rtfeldman$elm_css$Svg$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$nodeNS('http://www.w3.org/2000/svg');
var rtfeldman$elm_css$Svg$Styled$path = rtfeldman$elm_css$Svg$Styled$node('path');
var elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var rtfeldman$elm_css$Svg$Styled$Internal$css = function (styles) {
	var classname = rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
	var classAttribute = A2(elm$virtual_dom$VirtualDom$attribute, 'class', classname);
	return A3(rtfeldman$elm_css$VirtualDom$Styled$Attribute, classAttribute, styles, classname);
};
var rtfeldman$elm_css$Svg$Styled$styled = F2(
	function (fn, styles) {
		var stylesAttribute = rtfeldman$elm_css$Svg$Styled$Internal$css(styles);
		return F2(
			function (attrs, children) {
				return A2(
					fn,
					A2(elm$core$List$cons, stylesAttribute, attrs),
					children);
			});
	});
var rtfeldman$elm_css$Svg$Styled$svg = rtfeldman$elm_css$Svg$Styled$node('svg');
var rtfeldman$elm_css$VirtualDom$Styled$attribute = F2(
	function (key, value) {
		return A3(
			rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2(elm$virtual_dom$VirtualDom$attribute, key, value),
			_List_Nil,
			'');
	});
var rtfeldman$elm_css$Svg$Styled$Attributes$d = rtfeldman$elm_css$VirtualDom$Styled$attribute('d');
var rtfeldman$elm_css$Svg$Styled$Attributes$viewBox = rtfeldman$elm_css$VirtualDom$Styled$attribute('viewBox');
var author$project$PartialViews$Icons$arrowTop = function (styles) {
	return A4(
		rtfeldman$elm_css$Svg$Styled$styled,
		rtfeldman$elm_css$Svg$Styled$svg,
		_Utils_ap(
			_List_fromArray(
				[author$project$PartialViews$Icons$iconStyle]),
			styles),
		_List_fromArray(
			[
				rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 16 16')
			]),
		_List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M13.707 6.293l-5-5c-0.39-0.391-1.024-0.391-1.414 0l-5 5c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l3.293-3.293v9.586c0 0.552 0.448 1 1 1s1-0.448 1-1v-9.586l3.293 3.293c0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293c0.391-0.391 0.391-1.024 0-1.414z')
					]),
				_List_Nil)
			]));
};
var rtfeldman$elm_css$Css$Media$feature = F2(
	function (key, _n0) {
		var value = _n0.ed;
		return {
			bV: key,
			ed: elm$core$Maybe$Just(value)
		};
	});
var rtfeldman$elm_css$Css$Media$minWidth = function (value) {
	return A2(rtfeldman$elm_css$Css$Media$feature, 'min-width', value);
};
var rtfeldman$elm_css$Css$Structure$OnlyQuery = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var rtfeldman$elm_css$Css$Media$only = rtfeldman$elm_css$Css$Structure$OnlyQuery;
var rtfeldman$elm_css$Css$Structure$Screen = 1;
var rtfeldman$elm_css$Css$Media$screen = 1;
var rtfeldman$elm_css$Css$Preprocess$WithMedia = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var rtfeldman$elm_css$Css$Media$withMedia = rtfeldman$elm_css$Css$Preprocess$WithMedia;
var author$project$PartialViews$UiKit$onDesktop = rtfeldman$elm_css$Css$Media$withMedia(
	_List_fromArray(
		[
			A2(
			rtfeldman$elm_css$Css$Media$only,
			rtfeldman$elm_css$Css$Media$screen,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Media$minWidth(
					rtfeldman$elm_css$Css$px(author$project$PartialViews$UiKit$theme.bE.bP))
				]))
		]));
var elm$html$Html$Attributes$attribute = elm$virtual_dom$VirtualDom$attribute;
var fapian$elm_html_aria$Html$Attributes$Aria$boolAttribute = F2(
	function (name, val) {
		return A2(
			elm$html$Html$Attributes$attribute,
			name,
			A2(
				elm$json$Json$Encode$encode,
				0,
				elm$json$Json$Encode$bool(val)));
	});
var fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden = fapian$elm_html_aria$Html$Attributes$Aria$boolAttribute('aria-hidden');
var rtfeldman$elm_css$Css$bottom = rtfeldman$elm_css$Css$prop1('bottom');
var rtfeldman$elm_css$Css$fixed = {ax: 0, aH: 0, a5: 0, ed: 'fixed'};
var rtfeldman$elm_css$Css$none = {Y: 0, bC: 0, r: 0, c: 0, j: 0, dD: 0, b3: 0, bd: 0, aj: 0, P: 0, A: 0, e: 0, d: 0, bh: 0, a0: 0, dY: 0, x: 0, a1: 0, d0: 0, ap: 0, V: 0, v: 0, i: 0, eb: 0, ed: 'none'};
var rtfeldman$elm_css$Css$opacity = rtfeldman$elm_css$Css$prop1('opacity');
var rtfeldman$elm_css$Css$pointerEvents = rtfeldman$elm_css$Css$prop1('pointer-events');
var rtfeldman$elm_css$Css$pointerEventsAll = A2(rtfeldman$elm_css$Css$property, 'pointer-events', 'all');
var rtfeldman$elm_css$Css$right = rtfeldman$elm_css$Css$prop1('right');
var rtfeldman$elm_css$VirtualDom$Styled$property = F2(
	function (key, value) {
		return A3(
			rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2(elm$virtual_dom$VirtualDom$property, key, value),
			_List_Nil,
			'');
	});
var rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			elm$json$Json$Encode$string(string));
	});
var rtfeldman$elm_css$Html$Styled$Attributes$class = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
var rtfeldman$elm_css$VirtualDom$Styled$unstyledAttribute = function (prop) {
	return A3(rtfeldman$elm_css$VirtualDom$Styled$Attribute, prop, _List_Nil, '');
};
var rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled = rtfeldman$elm_css$VirtualDom$Styled$unstyledAttribute;
var rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
	return A2(
		rtfeldman$elm_css$Html$Styled$Events$on,
		'click',
		elm$json$Json$Decode$succeed(msg));
};
var author$project$PartialViews$BackToTop$backToTop = function (isBackToTopVisible) {
	var _n0 = isBackToTopVisible ? _Utils_Tuple3(1, rtfeldman$elm_css$Css$pointerEventsAll, false) : _Utils_Tuple3(
		0,
		rtfeldman$elm_css$Css$pointerEvents(rtfeldman$elm_css$Css$none),
		true);
	var opacityValue = _n0.a;
	var pointerEventsRule = _n0.b;
	var hidden = _n0.c;
	return A4(
		rtfeldman$elm_css$Html$Styled$styled,
		rtfeldman$elm_css$Html$Styled$span,
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$fixed),
				rtfeldman$elm_css$Css$right(author$project$PartialViews$UiKit$theme.dj),
				rtfeldman$elm_css$Css$bottom(author$project$PartialViews$UiKit$theme.dl),
				rtfeldman$elm_css$Css$opacity(
				rtfeldman$elm_css$Css$int(opacityValue)),
				pointerEventsRule,
				author$project$PartialViews$UiKit$transition('opacity 0.3s'),
				author$project$PartialViews$UiKit$onDesktop(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$bottom(author$project$PartialViews$UiKit$theme.dn)
					]))
			]),
		_List_fromArray(
			[
				rtfeldman$elm_css$Html$Styled$Attributes$class('backToTopButton'),
				rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled(
				fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(hidden))
			]),
		_List_fromArray(
			[
				A3(
				author$project$PartialViews$IconButton$iconButton,
				author$project$PartialViews$Icons$arrowTop(
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$fill(author$project$PartialViews$UiKit$theme.eh)
						])),
				_Utils_Tuple2('backToTop', false),
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$Models$ScrollToTop)
					]))
			]));
};
var author$project$Models$RequestDeleteSites = function (a) {
	return {$: 2, a: a};
};
var author$project$Models$SaveSite = {$: 3};
var author$project$Models$UpdateSite = function (a) {
	return {$: 2, a: a};
};
var author$project$PartialViews$EditSiteLayer$convertCategoryIdToInt = function (string) {
	return A2(
		elm$core$Maybe$withDefault,
		0,
		elm$core$String$toInt(string));
};
var rtfeldman$elm_css$Html$Styled$option = rtfeldman$elm_css$Html$Styled$node('option');
var rtfeldman$elm_css$Html$Styled$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			elm$json$Json$Encode$bool(bool));
	});
var rtfeldman$elm_css$Html$Styled$Attributes$selected = rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('selected');
var rtfeldman$elm_css$Html$Styled$Attributes$value = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
var author$project$PartialViews$EditSiteLayer$renderCategoryOptions = F2(
	function (siteCategoriesId, category) {
		return A2(
			rtfeldman$elm_css$Html$Styled$option,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$value(
					elm$core$String$fromInt(category.dE)),
					rtfeldman$elm_css$Html$Styled$Attributes$selected(
					A2(elm$core$List$member, category.dE, siteCategoriesId) ? true : false)
				]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$text(category.aZ)
				]));
	});
var author$project$PartialViews$Icons$deleteIcon = function (styles) {
	return A4(
		rtfeldman$elm_css$Svg$Styled$styled,
		rtfeldman$elm_css$Svg$Styled$svg,
		_Utils_ap(
			_List_fromArray(
				[author$project$PartialViews$Icons$iconStyle]),
			styles),
		_List_fromArray(
			[
				rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 16 16')
			]),
		_List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M2 5v10c0 0.55 0.45 1 1 1h9c0.55 0 1-0.45 1-1v-10h-11zM5 14h-1v-7h1v7zM7 14h-1v-7h1v7zM9 14h-1v-7h1v7zM11 14h-1v-7h1v7z')
					]),
				_List_Nil),
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M13.25 2h-3.25v-1.25c0-0.412-0.338-0.75-0.75-0.75h-3.5c-0.412 0-0.75 0.338-0.75 0.75v1.25h-3.25c-0.413 0-0.75 0.337-0.75 0.75v1.25h13v-1.25c0-0.413-0.338-0.75-0.75-0.75zM9 2h-3v-0.987h3v0.987z')
					]),
				_List_Nil)
			]));
};
var author$project$PartialViews$UiKit$pseudoContent = A2(rtfeldman$elm_css$Css$property, 'content', '\"\"');
var rtfeldman$elm_css$Css$Preprocess$WithPseudoElement = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var rtfeldman$elm_css$Css$Structure$PseudoElement = elm$core$Basics$identity;
var rtfeldman$elm_css$Css$pseudoElement = function (element) {
	return rtfeldman$elm_css$Css$Preprocess$WithPseudoElement(element);
};
var rtfeldman$elm_css$Css$after = rtfeldman$elm_css$Css$pseudoElement('after');
var rtfeldman$elm_css$Css$left = rtfeldman$elm_css$Css$prop1('left');
var rtfeldman$elm_css$Css$PercentageUnits = 0;
var rtfeldman$elm_css$Css$pct = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '%');
var rtfeldman$elm_css$Css$relative = {aH: 0, ed: 'relative'};
var rtfeldman$elm_css$Css$top = rtfeldman$elm_css$Css$prop1('top');
var rtfeldman$elm_css$Html$Styled$input = rtfeldman$elm_css$Html$Styled$node('input');
var rtfeldman$elm_css$Html$Styled$label = rtfeldman$elm_css$Html$Styled$node('label');
var rtfeldman$elm_css$Html$Styled$Attributes$checked = rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('checked');
var rtfeldman$elm_css$Html$Styled$Attributes$for = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('htmlFor');
var rtfeldman$elm_css$Html$Styled$Attributes$id = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('id');
var rtfeldman$elm_css$Html$Styled$Attributes$type_ = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('type');
var author$project$PartialViews$UiKit$checkbox = F3(
	function (checkboxId, selected, clickHandler) {
		return A2(
			rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$class('checkboxContainer')
				]),
			_List_fromArray(
				[
					A4(
					rtfeldman$elm_css$Html$Styled$styled,
					rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$none)
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
							rtfeldman$elm_css$Html$Styled$Attributes$checked(selected),
							rtfeldman$elm_css$Html$Styled$Attributes$id(checkboxId),
							clickHandler
						]),
					_List_Nil),
					A4(
					rtfeldman$elm_css$Html$Styled$styled,
					rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
							rtfeldman$elm_css$Css$width(author$project$PartialViews$UiKit$theme.ag),
							rtfeldman$elm_css$Css$height(author$project$PartialViews$UiKit$theme.ag),
							A3(rtfeldman$elm_css$Css$border3, author$project$PartialViews$UiKit$theme.dy, rtfeldman$elm_css$Css$solid, author$project$PartialViews$UiKit$theme.c9),
							rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$relative),
							rtfeldman$elm_css$Css$after(
							_List_fromArray(
								[
									author$project$PartialViews$UiKit$pseudoContent,
									rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$absolute),
									rtfeldman$elm_css$Css$top(
									rtfeldman$elm_css$Css$pct(15)),
									rtfeldman$elm_css$Css$left(
									rtfeldman$elm_css$Css$pct(15)),
									rtfeldman$elm_css$Css$width(
									rtfeldman$elm_css$Css$pct(70)),
									rtfeldman$elm_css$Css$height(
									rtfeldman$elm_css$Css$pct(70)),
									selected ? rtfeldman$elm_css$Css$backgroundColor(author$project$PartialViews$UiKit$theme.da) : rtfeldman$elm_css$Css$backgroundColor(rtfeldman$elm_css$Css$transparent)
								]))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$for(checkboxId)
						]),
					_List_Nil)
				]));
	});
var rtfeldman$elm_css$Css$alignItems = function (fn) {
	return A3(
		rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignItems',
		'align-items',
		fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var rtfeldman$elm_css$Css$center = rtfeldman$elm_css$Css$prop1('center');
var rtfeldman$elm_css$Css$row = {bc: 0, aB: 0, ed: 'row'};
var rtfeldman$elm_css$Css$column = _Utils_update(
	rtfeldman$elm_css$Css$row,
	{ed: 'column'});
var rtfeldman$elm_css$Css$displayFlex = A2(rtfeldman$elm_css$Css$property, 'display', 'flex');
var rtfeldman$elm_css$Css$flexDirection = rtfeldman$elm_css$Css$prop1('flex-direction');
var rtfeldman$elm_css$Css$marginBottom = rtfeldman$elm_css$Css$prop1('margin-bottom');
var rtfeldman$elm_css$Html$Styled$div = rtfeldman$elm_css$Html$Styled$node('div');
var author$project$PartialViews$UiKit$inputRow = F2(
	function (attributes, children) {
		return A4(
			rtfeldman$elm_css$Html$Styled$styled,
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$marginBottom(
					rtfeldman$elm_css$Css$rem(0.5)),
					rtfeldman$elm_css$Css$displayFlex,
					rtfeldman$elm_css$Css$flexDirection(rtfeldman$elm_css$Css$column),
					author$project$PartialViews$UiKit$onDesktop(
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$alignItems(rtfeldman$elm_css$Css$center),
							rtfeldman$elm_css$Css$flexDirection(rtfeldman$elm_css$Css$row),
							rtfeldman$elm_css$Css$height(author$project$PartialViews$UiKit$theme.ag)
						]))
				]),
			_Utils_ap(
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$class('inputRow')
					]),
				attributes),
			children);
	});
var rtfeldman$elm_css$Css$flex = rtfeldman$elm_css$Css$prop1('flex');
var author$project$PartialViews$UiKit$inputRowLabel = F2(
	function (inputId, labelText) {
		return A4(
			rtfeldman$elm_css$Html$Styled$styled,
			rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					author$project$PartialViews$UiKit$onDesktop(
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$flex(
							rtfeldman$elm_css$Css$int(1))
						]))
				]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$class('inputLabel'),
					rtfeldman$elm_css$Html$Styled$Attributes$for(inputId)
				]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$text(labelText + ' ')
				]));
	});
var author$project$PartialViews$UiKit$standardPadding = rtfeldman$elm_css$Css$padding(author$project$PartialViews$UiKit$theme.aV);
var author$project$PartialViews$UiKit$input = A2(
	rtfeldman$elm_css$Html$Styled$styled,
	rtfeldman$elm_css$Html$Styled$input,
	_List_fromArray(
		[
			rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
			rtfeldman$elm_css$Css$height(author$project$PartialViews$UiKit$theme.ag),
			author$project$PartialViews$UiKit$standardPadding,
			A3(rtfeldman$elm_css$Css$border3, author$project$PartialViews$UiKit$theme.dy, rtfeldman$elm_css$Css$solid, author$project$PartialViews$UiKit$theme.c9)
		]));
var rtfeldman$elm_css$Html$Styled$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3(elm$core$List$foldr, elm$json$Json$Decode$field, decoder, fields);
	});
var rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
	elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	elm$json$Json$Decode$string);
var rtfeldman$elm_css$Html$Styled$Events$onInput = function (tagger) {
	return A2(
		rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
		'input',
		A2(
			elm$json$Json$Decode$map,
			rtfeldman$elm_css$Html$Styled$Events$alwaysStop,
			A2(elm$json$Json$Decode$map, tagger, rtfeldman$elm_css$Html$Styled$Events$targetValue)));
};
var author$project$PartialViews$UiKit$inputRowText = F4(
	function (idText, labelText, val, inputHandler) {
		return A2(
			author$project$PartialViews$UiKit$inputRow,
			_List_Nil,
			_List_fromArray(
				[
					A2(author$project$PartialViews$UiKit$inputRowLabel, idText, labelText),
					A4(
					rtfeldman$elm_css$Html$Styled$styled,
					author$project$PartialViews$UiKit$input,
					_List_fromArray(
						[
							author$project$PartialViews$UiKit$onDesktop(
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$flex(
									rtfeldman$elm_css$Css$int(5))
								]))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('input'),
							rtfeldman$elm_css$Html$Styled$Attributes$id(idText),
							rtfeldman$elm_css$Html$Styled$Attributes$value(val),
							rtfeldman$elm_css$Html$Styled$Events$onInput(inputHandler),
							rtfeldman$elm_css$Html$Styled$Attributes$type_('text')
						]),
					_List_Nil)
				]));
	});
var author$project$PartialViews$UiKit$layerInner = F2(
	function (attributes, children) {
		return A4(
			rtfeldman$elm_css$Html$Styled$styled,
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$width(
					rtfeldman$elm_css$Css$pct(100))
				]),
			_Utils_ap(
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$class('layer-inner')
					]),
				attributes),
			children);
	});
var rtfeldman$elm_css$Html$Styled$select = rtfeldman$elm_css$Html$Styled$node('select');
var author$project$PartialViews$UiKit$select = A2(
	rtfeldman$elm_css$Html$Styled$styled,
	rtfeldman$elm_css$Html$Styled$select,
	_List_fromArray(
		[
			rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
			rtfeldman$elm_css$Css$height(author$project$PartialViews$UiKit$theme.ag),
			A2(rtfeldman$elm_css$Css$padding2, author$project$PartialViews$UiKit$theme.$7, author$project$PartialViews$UiKit$theme.dl),
			A3(rtfeldman$elm_css$Css$border3, author$project$PartialViews$UiKit$theme.dy, rtfeldman$elm_css$Css$solid, author$project$PartialViews$UiKit$theme.c9),
			rtfeldman$elm_css$Css$backgroundColor(author$project$PartialViews$UiKit$theme.c8)
		]));
var rtfeldman$elm_css$Css$justifyContent = function (fn) {
	return A3(
		rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'justifyContent',
		'justify-content',
		fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var rtfeldman$elm_css$Css$spaceBetween = rtfeldman$elm_css$Css$prop1('space-between');
var author$project$PartialViews$EditSiteLayer$renderEditSiteForm = F2(
	function (site, categories) {
		return A2(
			author$project$PartialViews$UiKit$layerInner,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					author$project$PartialViews$UiKit$inputRow,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('inputLabel')
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('Site id: ')
								])),
							A2(
							rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('input is-disabled')
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text(
									elm$core$String$fromInt(site.dE) + (' - Number of failures: ' + elm$core$String$fromInt(site.dS)))
								]))
						])),
					A4(
					author$project$PartialViews$UiKit$inputRowText,
					'siteNameInput',
					'Name',
					site.aZ,
					function (name) {
						return author$project$Models$EditSiteMsg(
							author$project$Models$UpdateSite(
								_Utils_update(
									site,
									{aZ: name})));
					}),
					A4(
					author$project$PartialViews$UiKit$inputRowText,
					'rssLinkInput',
					'Rss link',
					site.d$,
					function (rssLink) {
						return author$project$Models$EditSiteMsg(
							author$project$Models$UpdateSite(
								_Utils_update(
									site,
									{d$: rssLink})));
					}),
					A4(
					author$project$PartialViews$UiKit$inputRowText,
					'webLinkInput',
					'Web link',
					site.eg,
					function (webLink) {
						return author$project$Models$EditSiteMsg(
							author$project$Models$UpdateSite(
								_Utils_update(
									site,
									{eg: webLink})));
					}),
					A2(
					author$project$PartialViews$UiKit$inputRow,
					_List_Nil,
					_List_fromArray(
						[
							A4(
							rtfeldman$elm_css$Html$Styled$styled,
							rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$flex(
									rtfeldman$elm_css$Css$int(1))
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('fakeCheckboxLabel')
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('Starred')
								])),
							A4(
							rtfeldman$elm_css$Html$Styled$styled,
							rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$flex(
									rtfeldman$elm_css$Css$int(5))
								]),
							_List_Nil,
							_List_fromArray(
								[
									A3(
									author$project$PartialViews$UiKit$checkbox,
									'starredCheckbox',
									site.d4,
									rtfeldman$elm_css$Html$Styled$Events$onClick(
										author$project$Models$EditSiteMsg(
											author$project$Models$UpdateSite(
												_Utils_update(
													site,
													{d4: !site.d4})))))
								]))
						])),
					A2(
					author$project$PartialViews$UiKit$inputRow,
					_List_Nil,
					_List_fromArray(
						[
							A4(
							rtfeldman$elm_css$Html$Styled$styled,
							rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$flex(
									rtfeldman$elm_css$Css$int(1))
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('fakeCheckboxLabel')
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('Active')
								])),
							A4(
							rtfeldman$elm_css$Html$Styled$styled,
							rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$flex(
									rtfeldman$elm_css$Css$int(5))
								]),
							_List_Nil,
							_List_fromArray(
								[
									A3(
									author$project$PartialViews$UiKit$checkbox,
									'activeCheckbox',
									site.dJ,
									rtfeldman$elm_css$Html$Styled$Events$onClick(
										author$project$Models$EditSiteMsg(
											author$project$Models$UpdateSite(
												_Utils_update(
													site,
													{dJ: !site.dJ})))))
								]))
						])),
					A2(
					author$project$PartialViews$UiKit$inputRow,
					_List_Nil,
					_List_fromArray(
						[
							A2(author$project$PartialViews$UiKit$inputRowLabel, 'selectCategory', 'Select a category'),
							A4(
							rtfeldman$elm_css$Html$Styled$styled,
							author$project$PartialViews$UiKit$select,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$flex(
									rtfeldman$elm_css$Css$int(5))
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('siteCategorySelect'),
									rtfeldman$elm_css$Html$Styled$Events$onInput(
									function (categoryId) {
										return author$project$Models$EditSiteMsg(
											author$project$Models$UpdateSite(
												_Utils_update(
													site,
													{
														bH: _List_fromArray(
															[
																author$project$PartialViews$EditSiteLayer$convertCategoryIdToInt(categoryId)
															])
													})));
									}),
									rtfeldman$elm_css$Html$Styled$Attributes$id('selectCategory')
								]),
							A2(
								elm$core$List$cons,
								A2(
									rtfeldman$elm_css$Html$Styled$option,
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$Attributes$selected(
											elm$core$List$isEmpty(site.bH) ? true : false)
										]),
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$text('Pick a category')
										])),
								A2(
									elm$core$List$map,
									author$project$PartialViews$EditSiteLayer$renderCategoryOptions(site.bH),
									categories)))
						])),
					A4(
					rtfeldman$elm_css$Html$Styled$styled,
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$displayFlex,
							rtfeldman$elm_css$Css$justifyContent(rtfeldman$elm_css$Css$spaceBetween)
						]),
					_List_Nil,
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									author$project$PartialViews$UiKit$btn,
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$Events$onClick(
											author$project$Models$EditSiteMsg(author$project$Models$SaveSite))
										]),
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$text('save')
										]))
								])),
							A3(
							author$project$PartialViews$IconButton$iconButton,
							author$project$PartialViews$Icons$deleteIcon(_List_Nil),
							_Utils_Tuple2('delete', true),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Events$onClick(
									author$project$Models$DeleteMsg(
										author$project$Models$RequestDeleteSites(
											_List_fromArray(
												[site.dE]))))
								]))
						]))
				]));
	});
var author$project$PartialViews$Icons$closeIcon = function (styles) {
	return A4(
		rtfeldman$elm_css$Svg$Styled$styled,
		rtfeldman$elm_css$Svg$Styled$svg,
		_Utils_ap(
			_List_fromArray(
				[author$project$PartialViews$Icons$iconStyle]),
			styles),
		_List_fromArray(
			[
				rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 16 16')
			]),
		_List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M15.854 12.854c-0-0-0-0-0-0l-4.854-4.854 4.854-4.854c0-0 0-0 0-0 0.052-0.052 0.090-0.113 0.114-0.178 0.066-0.178 0.028-0.386-0.114-0.529l-2.293-2.293c-0.143-0.143-0.351-0.181-0.529-0.114-0.065 0.024-0.126 0.062-0.178 0.114 0 0-0 0-0 0l-4.854 4.854-4.854-4.854c-0-0-0-0-0-0-0.052-0.052-0.113-0.090-0.178-0.114-0.178-0.066-0.386-0.029-0.529 0.114l-2.293 2.293c-0.143 0.143-0.181 0.351-0.114 0.529 0.024 0.065 0.062 0.126 0.114 0.178 0 0 0 0 0 0l4.854 4.854-4.854 4.854c-0 0-0 0-0 0-0.052 0.052-0.090 0.113-0.114 0.178-0.066 0.178-0.029 0.386 0.114 0.529l2.293 2.293c0.143 0.143 0.351 0.181 0.529 0.114 0.065-0.024 0.126-0.062 0.178-0.114 0-0 0-0 0-0l4.854-4.854 4.854 4.854c0 0 0 0 0 0 0.052 0.052 0.113 0.090 0.178 0.114 0.178 0.066 0.386 0.029 0.529-0.114l2.293-2.293c0.143-0.143 0.181-0.351 0.114-0.529-0.024-0.065-0.062-0.126-0.114-0.178z')
					]),
				_List_Nil)
			]));
};
var rtfeldman$elm_css$Css$fontSize = rtfeldman$elm_css$Css$prop1('font-size');
var rtfeldman$elm_css$Css$initial = {bv: 0, bw: 0, ax: 0, bx: 0, Y: 0, by: 0, Z: 0, D: 0, r: 0, aR: 0, z: 0, c: 0, j: 0, ac: 0, bc: 0, aB: 0, aW: 0, N: 0, o: 0, ad: 0, h: 0, G: 0, aX: 0, b8: 0, bd: 0, aE: 0, ah: 0, H: 0, ai: 0, aj: 0, P: 0, Q: 0, A: 0, aY: 0, e: 0, d: 0, bh: 0, aG: 0, K: 0, a0: 0, ak: 0, x: 0, a5: 0, ap: 0, U: 0, aq: 0, ar: 0, V: 0, v: 0, as: '', aO: 0, ed: 'initial', aP: 0, M: 0};
var rtfeldman$elm_css$Css$inherit = _Utils_update(
	rtfeldman$elm_css$Css$initial,
	{ed: 'inherit'});
var author$project$PartialViews$UiKit$btnNoStyleStyle = rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			author$project$PartialViews$UiKit$appearance('none'),
			rtfeldman$elm_css$Css$border(rtfeldman$elm_css$Css$zero),
			rtfeldman$elm_css$Css$backgroundColor(rtfeldman$elm_css$Css$inherit),
			rtfeldman$elm_css$Css$fontSize(author$project$PartialViews$UiKit$theme.bY),
			rtfeldman$elm_css$Css$padding(rtfeldman$elm_css$Css$zero),
			rtfeldman$elm_css$Css$color(rtfeldman$elm_css$Css$currentColor)
		]));
var author$project$PartialViews$UiKit$btnNoStyle = A2(
	rtfeldman$elm_css$Html$Styled$styled,
	rtfeldman$elm_css$Html$Styled$button,
	_List_fromArray(
		[author$project$PartialViews$UiKit$btnNoStyleStyle]));
var rtfeldman$elm_css$Css$textAlign = function (fn) {
	return A3(
		rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'textAlign',
		'text-align',
		fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var author$project$PartialViews$UiKit$closeButton = function (closer) {
	return A4(
		rtfeldman$elm_css$Html$Styled$styled,
		rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$textAlign(rtfeldman$elm_css$Css$right),
				rtfeldman$elm_css$Css$marginBottom(author$project$PartialViews$UiKit$theme.dl),
				rtfeldman$elm_css$Css$color(author$project$PartialViews$UiKit$theme.da)
			]),
		_List_fromArray(
			[
				rtfeldman$elm_css$Html$Styled$Attributes$class('closeButtonWrapper')
			]),
		_List_fromArray(
			[
				A2(
				author$project$PartialViews$UiKit$btnNoStyle,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Events$onClick(closer)
					]),
				_List_fromArray(
					[
						author$project$PartialViews$Icons$closeIcon(_List_Nil),
						A4(
						rtfeldman$elm_css$Html$Styled$styled,
						rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[author$project$PartialViews$UiKit$visuallyHiddenStyle]),
						_List_Nil,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text('close')
							]))
					]))
			]));
};
var rtfeldman$elm_css$Css$zIndex = rtfeldman$elm_css$Css$prop1('z-index');
var author$project$PartialViews$UiKit$layerStyle = rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$fixed),
			rtfeldman$elm_css$Css$zIndex(author$project$PartialViews$UiKit$theme.cX.cc),
			rtfeldman$elm_css$Css$backgroundColor(author$project$PartialViews$UiKit$theme.c8),
			author$project$PartialViews$UiKit$standardPadding,
			A3(
			rtfeldman$elm_css$Css$border3,
			rtfeldman$elm_css$Css$px(2),
			rtfeldman$elm_css$Css$solid,
			author$project$PartialViews$UiKit$theme.c9)
		]));
var rtfeldman$elm_css$Css$valuesOrNone = function (list) {
	return elm$core$List$isEmpty(list) ? {ed: 'none'} : {
		ed: A2(
			elm$core$String$join,
			' ',
			A2(
				elm$core$List$map,
				function ($) {
					return $.ed;
				},
				list))
	};
};
var rtfeldman$elm_css$Css$transforms = A2(
	elm$core$Basics$composeL,
	rtfeldman$elm_css$Css$prop1('transform'),
	rtfeldman$elm_css$Css$valuesOrNone);
var rtfeldman$elm_css$Css$translateY = function (_n0) {
	var value = _n0.ed;
	return {
		i: 0,
		ed: A2(
			rtfeldman$elm_css$Css$cssFunction,
			'translateY',
			_List_fromArray(
				[value]))
	};
};
var author$project$PartialViews$UiKit$layerTop = F3(
	function (closer, attributes, children) {
		return A4(
			rtfeldman$elm_css$Html$Styled$styled,
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					author$project$PartialViews$UiKit$layerStyle,
					rtfeldman$elm_css$Css$top(rtfeldman$elm_css$Css$zero),
					rtfeldman$elm_css$Css$left(rtfeldman$elm_css$Css$zero),
					rtfeldman$elm_css$Css$width(
					rtfeldman$elm_css$Css$pct(100)),
					rtfeldman$elm_css$Css$transforms(
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$translateY(
							rtfeldman$elm_css$Css$pct(-100))
						]))
				]),
			attributes,
			_Utils_ap(
				_List_fromArray(
					[
						author$project$PartialViews$UiKit$closeButton(closer)
					]),
				children));
	});
var author$project$PartialViews$EditSiteLayer$editSiteLayer = F3(
	function (animationClass, site, categories) {
		return A3(
			author$project$PartialViews$UiKit$layerTop,
			author$project$Models$EditSiteMsg(author$project$Models$CloseEditSitePanel),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$class('editSiteLayer' + animationClass)
				]),
			_List_fromArray(
				[
					A2(author$project$PartialViews$EditSiteLayer$renderEditSiteForm, site, categories)
				]));
	});
var author$project$PanelsManager$getPanelClass = F4(
	function (initialClass, openClass, closedClass, panelState) {
		return (panelState === 1) ? (' ' + (openClass + ' ')) : ((panelState === 2) ? (' ' + (closedClass + ' ')) : (' ' + (initialClass + ' ')));
	});
var fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel = elm$html$Html$Attributes$attribute('aria-label');
var author$project$PartialViews$UiKit$closeBtn = function (clickHandler) {
	return A2(
		author$project$PartialViews$UiKit$btnNoStyle,
		_List_fromArray(
			[
				rtfeldman$elm_css$Html$Styled$Attributes$class('closeButton'),
				rtfeldman$elm_css$Html$Styled$Events$onClick(clickHandler),
				rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled(
				fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel('close'))
			]),
		_List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled(
						fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true))
					]),
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$text(
						elm$core$String$fromChar(
							elm$core$Char$fromCode(215)))
					]))
			]));
};
var author$project$PartialViews$UiKit$errorMessage = F2(
	function (animationClass, errorMsg) {
		return A4(
			rtfeldman$elm_css$Html$Styled$styled,
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$backgroundColor(author$project$PartialViews$UiKit$theme.c7),
					rtfeldman$elm_css$Css$color(author$project$PartialViews$UiKit$theme.eh),
					rtfeldman$elm_css$Css$height(
					rtfeldman$elm_css$Css$rem(2.5)),
					rtfeldman$elm_css$Css$overflow(rtfeldman$elm_css$Css$hidden)
				]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$class('errorMsg' + animationClass)
				]),
			_List_fromArray(
				[
					A4(
					rtfeldman$elm_css$Html$Styled$styled,
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$displayFlex,
							rtfeldman$elm_css$Css$justifyContent(rtfeldman$elm_css$Css$spaceBetween),
							A3(
							rtfeldman$elm_css$Css$border3,
							rtfeldman$elm_css$Css$px(2),
							rtfeldman$elm_css$Css$solid,
							author$project$PartialViews$UiKit$theme.eh),
							author$project$PartialViews$UiKit$standardPadding
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('errorMsg-inner')
						]),
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('errorMsg-text')
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text(errorMsg.d8)
								])),
							author$project$PartialViews$UiKit$closeBtn(
							author$project$Models$ErrorBoxMsg(
								author$project$Models$RequestRemoveErrorMsg(errorMsg)))
						]))
				]));
	});
var author$project$PartialViews$ErrorContainer$renderErrorMsg = F2(
	function (panelsState, errorMsg) {
		var panelId = elm$core$String$fromInt(
			A2(Skinney$murmur3$Murmur3$hashString, 1234, errorMsg.d8));
		var animationClass = A4(
			author$project$PanelsManager$getPanelClass,
			'expand',
			'',
			'collapse',
			A2(author$project$PanelsManager$getPanelState, panelId, panelsState));
		return A2(author$project$PartialViews$UiKit$errorMessage, animationClass, errorMsg);
	});
var author$project$PartialViews$ErrorContainer$errorContainer = F2(
	function (panelsState, errorMsgs) {
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$class('errorContainer')
				]),
			A2(
				elm$core$List$map,
				author$project$PartialViews$ErrorContainer$renderErrorMsg(panelsState),
				errorMsgs));
	});
var author$project$Models$RefreshFeeds = {$: 7};
var author$project$Models$ToggleMenu = {$: 16};
var rtfeldman$elm_css$Svg$Styled$Attributes$style = rtfeldman$elm_css$VirtualDom$Styled$attribute('style');
var author$project$PartialViews$Icons$logo = function (styles) {
	return A4(
		rtfeldman$elm_css$Svg$Styled$styled,
		rtfeldman$elm_css$Svg$Styled$svg,
		styles,
		_List_fromArray(
			[
				rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 82.211 31.35')
			]),
		_List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M10.563 0C4.75 0 .023 4.717.002 10.52H0v15.455h3.066V10.52A7.426 7.426 0 0 1 5.262 5.27a7.447 7.447 0 0 1 5.3-2.19V0zM8.422 6.299a2.133 2.133 0 0 0-2.127 2.133c0 1.175.959 2.13 2.127 2.13a2.126 2.126 0 0 0 2.121-2.13 2.125 2.125 0 0 0-2.121-2.133zM12.062 8.558h3.066v17.417h-3.066zM17.617 15.355c0 4.548 2.895 8.421 6.932 9.907a12.876 12.876 0 0 1-8.285 3.011v3.077c8.82 0 16-7.177 16-15.995h-3.069c0 2.743-.865 5.284-2.33 7.377a7.426 7.426 0 0 1-3.974-2.074 7.453 7.453 0 0 1-2.194-5.303h-3.08z'),
						rtfeldman$elm_css$Svg$Styled$Attributes$style('fill: #008080')
					]),
				_List_Nil),
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M37.38 14.102h3.875v-.877H37.38V10.82c0-3.027.735-4.328 2.63-4.328 1.612 0 2.291.877 2.291 1.697v.594c0 .255.226.849.905.849.481 0 .877-.368.877-.82 0-2.122-2.206-3.14-4.101-3.14-1.273 0-2.263.48-2.914 1.414-.735 1.075-1.131 2.744-1.131 4.922v1.216h-3.705v.877h3.705V24.34c0 .82-.368 1.3-1.273 1.3h-1.612v.878h7.213v-.877h-1.64c-.906 0-1.245-.425-1.245-1.301V14.1z'),
						rtfeldman$elm_css$Svg$Styled$Attributes$style('fill: #4d4d4d')
					]),
				_List_Nil),
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M53.565 19.447c0-3.988-2.574-6.646-5.685-6.646-2.97 0-5.912 2.856-5.912 7.297 0 3.111 1.839 6.958 6.194 6.958 2.291 0 3.48-.764 5.714-3.62l-.736-.51c-1.3 1.782-2.517 3.253-4.695 3.253-2.856 0-5.034-2.941-5.034-6.081v-.65h10.154zm-10.098-.876c.424-2.885 2.263-4.894 4.413-4.894 1.244 0 2.206.396 2.941 1.188.764.792 1.16 2.037 1.273 3.706h-8.627zM66.742 19.447c0-3.988-2.573-6.646-5.685-6.646-2.97 0-5.911 2.856-5.911 7.297 0 3.111 1.838 6.958 6.194 6.958 2.291 0 3.48-.764 5.714-3.62l-.736-.51c-1.3 1.782-2.517 3.253-4.695 3.253-2.857 0-5.035-2.941-5.035-6.081v-.65h10.154zm-10.097-.876c.424-2.885 2.263-4.894 4.412-4.894 1.245 0 2.207.396 2.942 1.188.764.792 1.16 2.037 1.273 3.706h-8.627zM79.694 5.673c-1.386.764-2.602 1.16-3.62 1.16v.876c1.951 0 2.177.085 2.177.792v6.195c-1.018-1.047-2.29-1.556-3.818-1.556-3.507 0-6.11 3.055-6.11 6.477 0 4.243 2.292 7.1 5.63 7.1 2.12 0 3.224-.623 4.298-2.009v1.81h3.96v-.876h-1.16c-.735 0-1.357-.368-1.357-1.556V5.673zm-1.443 16.942c-.367 1.556-1.866 3.112-3.931 3.112-3.253 0-4.412-3.48-4.412-6.11 0-3.649 2.375-5.487 4.525-5.487 2.065 0 3.507 1.442 3.818 2.15v6.335z'),
						rtfeldman$elm_css$Svg$Styled$Attributes$style('fill: #4d4d4d')
					]),
				_List_Nil)
			]));
};
var rtfeldman$elm_css$Svg$Styled$Attributes$id = rtfeldman$elm_css$VirtualDom$Styled$attribute('id');
var author$project$PartialViews$Icons$menuIcon = function (styles) {
	return A4(
		rtfeldman$elm_css$Svg$Styled$styled,
		rtfeldman$elm_css$Svg$Styled$svg,
		_Utils_ap(
			_List_fromArray(
				[author$project$PartialViews$Icons$iconStyle]),
			styles),
		_List_fromArray(
			[
				rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 16 16')
			]),
		_List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M1 11.246h14v1.5H1zM1'),
						rtfeldman$elm_css$Svg$Styled$Attributes$id('bottom')
					]),
				_List_Nil),
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M1 7.246h14v1.5H1zM1'),
						rtfeldman$elm_css$Svg$Styled$Attributes$id('central')
					]),
				_List_Nil),
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M1 3.246h14v1.5H1z'),
						rtfeldman$elm_css$Svg$Styled$Attributes$id('top')
					]),
				_List_Nil),
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M1 7.246h14v1.5H1z'),
						rtfeldman$elm_css$Svg$Styled$Attributes$id('centralBis')
					]),
				_List_Nil)
			]));
};
var author$project$PartialViews$Icons$refreshIcon = function (styles) {
	return A4(
		rtfeldman$elm_css$Svg$Styled$styled,
		rtfeldman$elm_css$Svg$Styled$svg,
		_Utils_ap(
			_List_fromArray(
				[author$project$PartialViews$Icons$iconStyle]),
			styles),
		_List_fromArray(
			[
				rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 16 16')
			]),
		_List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M13.901 2.599c-1.463-1.597-3.565-2.599-5.901-2.599-4.418 0-8 3.582-8 8h1.5c0-3.59 2.91-6.5 6.5-6.5 1.922 0 3.649 0.835 4.839 2.161l-2.339 2.339h5.5v-5.5l-2.099 2.099z')
					]),
				_List_Nil),
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M14.5 8c0 3.59-2.91 6.5-6.5 6.5-1.922 0-3.649-0.835-4.839-2.161l2.339-2.339h-5.5v5.5l2.099-2.099c1.463 1.597 3.565 2.599 5.901 2.599 4.418 0 8-3.582 8-8h-1.5z')
					]),
				_List_Nil)
			]));
};
var rtfeldman$elm_css$Css$borderBottom3 = rtfeldman$elm_css$Css$prop3('border-bottom');
var rtfeldman$elm_css$Css$flexStart = rtfeldman$elm_css$Css$prop1('flex-start');
var rtfeldman$elm_css$Css$inline = {j: 0, ed: 'inline'};
var rtfeldman$elm_css$Css$sticky = {aH: 0, ed: 'sticky'};
var rtfeldman$elm_css$Html$Styled$header = rtfeldman$elm_css$Html$Styled$node('header');
var author$project$PartialViews$Header$siteHeader = function (isRefreshButtonVisible) {
	return A4(
		rtfeldman$elm_css$Html$Styled$styled,
		rtfeldman$elm_css$Html$Styled$header,
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$displayFlex,
				rtfeldman$elm_css$Css$justifyContent(rtfeldman$elm_css$Css$spaceBetween),
				rtfeldman$elm_css$Css$alignItems(rtfeldman$elm_css$Css$center),
				rtfeldman$elm_css$Css$padding(author$project$PartialViews$UiKit$theme.aV),
				A3(rtfeldman$elm_css$Css$borderBottom3, author$project$PartialViews$UiKit$theme.dy, rtfeldman$elm_css$Css$solid, author$project$PartialViews$UiKit$theme.c9),
				rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$fixed),
				rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$sticky),
				rtfeldman$elm_css$Css$top(rtfeldman$elm_css$Css$zero),
				rtfeldman$elm_css$Css$width(
				rtfeldman$elm_css$Css$pct(100)),
				rtfeldman$elm_css$Css$backgroundColor(author$project$PartialViews$UiKit$theme.c8),
				rtfeldman$elm_css$Css$zIndex(author$project$PartialViews$UiKit$theme.cX.dA),
				author$project$PartialViews$UiKit$onDesktop(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$justifyContent(rtfeldman$elm_css$Css$flexStart),
						rtfeldman$elm_css$Css$zIndex(author$project$PartialViews$UiKit$theme.cX.dz)
					]))
			]),
		_List_Nil,
		_List_fromArray(
			[
				A4(
				rtfeldman$elm_css$Html$Styled$styled,
				author$project$PartialViews$UiKit$btnNoStyle,
				_List_fromArray(
					[
						author$project$PartialViews$UiKit$onDesktop(
						_List_fromArray(
							[
								rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$none)
							]))
					]),
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$Models$ToggleMenu)
					]),
				_List_fromArray(
					[
						author$project$PartialViews$Icons$menuIcon(
						_List_fromArray(
							[
								rtfeldman$elm_css$Css$fill(author$project$PartialViews$UiKit$theme.da),
								rtfeldman$elm_css$Css$width(author$project$PartialViews$UiKit$theme.bF),
								rtfeldman$elm_css$Css$height(author$project$PartialViews$UiKit$theme.bF)
							]))
					])),
				author$project$PartialViews$Icons$logo(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$height(
						rtfeldman$elm_css$Css$rem(2))
					])),
				A4(
				rtfeldman$elm_css$Html$Styled$styled,
				rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$none),
						author$project$PartialViews$UiKit$onDesktop(
						_List_fromArray(
							[
								rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inline),
								rtfeldman$elm_css$Css$flex(
								rtfeldman$elm_css$Css$int(1))
							]))
					]),
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$class('separator')
					]),
				_List_Nil),
				A3(
				author$project$PartialViews$IconButton$iconButton,
				author$project$PartialViews$Icons$refreshIcon(_List_Nil),
				_Utils_Tuple2('refresh', false),
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$class(
						'refreshButton ' + (isRefreshButtonVisible ? 'popIn' : 'popOut')),
						rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$Models$RefreshFeeds)
					]))
			]));
};
var author$project$Models$ExecuteImport = {$: 5};
var author$project$Models$StoreImportData = function (a) {
	return {$: 6, a: a};
};
var author$project$Models$TogglePanel = function (a) {
	return {$: 14, a: a};
};
var rtfeldman$elm_css$Html$Styled$p = rtfeldman$elm_css$Html$Styled$node('p');
var rtfeldman$elm_css$Html$Styled$textarea = rtfeldman$elm_css$Html$Styled$node('textarea');
var author$project$PartialViews$ImportLayer$importLayer = function (animationClass) {
	return A3(
		author$project$PartialViews$UiKit$layerTop,
		author$project$Models$TogglePanel(1),
		_List_fromArray(
			[
				rtfeldman$elm_css$Html$Styled$Attributes$class('importLayer' + animationClass)
			]),
		_List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$class('layer-inner')
					]),
				_List_fromArray(
					[
						A2(
						rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Attributes$class('importForm')
							]),
						_List_fromArray(
							[
								A2(
								rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$Attributes$class('impoertInstructions')
									]),
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$text('Paste your OPML converted into Json in the text area below and click \"import\"')
									])),
								A2(
								rtfeldman$elm_css$Html$Styled$textarea,
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$Attributes$class('importArea'),
										rtfeldman$elm_css$Html$Styled$Events$onInput(author$project$Models$StoreImportData)
									]),
								_List_Nil),
								A2(
								rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$Attributes$class('button-group')
									]),
								_List_fromArray(
									[
										A2(
										author$project$PartialViews$UiKit$btn,
										_List_fromArray(
											[
												rtfeldman$elm_css$Html$Styled$Attributes$class('executeImportButton button'),
												rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$Models$ExecuteImport)
											]),
										_List_fromArray(
											[
												rtfeldman$elm_css$Html$Styled$text('import')
											]))
									]))
							]))
					]))
			]));
};
var author$project$Helpers$getArticlesInSites = F2(
	function (sitesId, articles) {
		return A2(
			elm$core$List$filter,
			function (article) {
				return A2(
					elm$core$List$any,
					function (siteId) {
						return _Utils_eq(siteId, article.a4);
					},
					sitesId);
			},
			articles);
	});
var author$project$Helpers$isSiteInCategories = F2(
	function (categoryIds, site) {
		return A2(
			elm$core$List$any,
			function (siteCategoryId) {
				return A2(elm$core$List$member, siteCategoryId, categoryIds);
			},
			site.bH);
	});
var author$project$Helpers$getSitesInCategories = F2(
	function (categoryIds, sites) {
		return A2(
			elm$core$List$filter,
			author$project$Helpers$isSiteInCategories(categoryIds),
			sites);
	});
var author$project$Helpers$getSelectedArticles = F3(
	function (categories, sites, articles) {
		var selectedSiteIds = author$project$Helpers$extractId(
			A2(
				elm$core$List$filter,
				function (site) {
					return site.aD;
				},
				sites));
		var selectedCategories = A2(
			elm$core$List$filter,
			function (category) {
				return category.aD;
			},
			categories);
		var sitesInSelectedCategory = elm$core$List$isEmpty(selectedCategories) ? sites : A2(
			author$project$Helpers$getSitesInCategories,
			author$project$Helpers$extractId(selectedCategories),
			sites);
		var articlesSelected = elm$core$List$isEmpty(selectedSiteIds) ? A2(
			author$project$Helpers$getArticlesInSites,
			author$project$Helpers$extractId(sitesInSelectedCategory),
			articles) : A2(author$project$Helpers$getArticlesInSites, selectedSiteIds, articles);
		return articlesSelected;
	});
var author$project$Helpers$getArticleSite = F2(
	function (sites, article) {
		var selectedSite = elm$core$List$head(
			A2(
				elm$core$List$filter,
				function (site) {
					return _Utils_eq(site.dE, article.a4);
				},
				sites));
		if (!selectedSite.$) {
			var site = selectedSite.a;
			return site;
		} else {
			return author$project$Models$createEmptySite;
		}
	});
var author$project$HtmlParserUtils$findElements = F2(
	function (match, nodes) {
		var f = F2(
			function (node, results) {
				if (node.$ === 1) {
					var tagName = node.a;
					var attrs = node.b;
					var children = node.c;
					return A2(match, tagName, attrs) ? _Utils_ap(
						results,
						A2(
							elm$core$List$cons,
							node,
							A2(author$project$HtmlParserUtils$findElements, match, children))) : _Utils_ap(
						results,
						A2(author$project$HtmlParserUtils$findElements, match, children));
				} else {
					return results;
				}
			});
		return A3(elm$core$List$foldl, f, _List_Nil, nodes);
	});
var author$project$HtmlParserUtils$getElementsByTagName = F2(
	function (tagName, nodes) {
		var targetTagName = elm$core$String$toLower(tagName);
		var match = F2(
			function (tagNameToCheck, _n0) {
				return _Utils_eq(tagNameToCheck, targetTagName);
			});
		return A2(author$project$HtmlParserUtils$findElements, match, nodes);
	});
var author$project$HtmlParserUtils$getValue = F2(
	function (targetName, attrs) {
		getValue:
		while (true) {
			if (!attrs.b) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n1 = attrs.a;
				var name = _n1.a;
				var value = _n1.b;
				var tail = attrs.b;
				if (_Utils_eq(name, targetName)) {
					return elm$core$Maybe$Just(value);
				} else {
					var $temp$targetName = targetName,
						$temp$attrs = tail;
					targetName = $temp$targetName;
					attrs = $temp$attrs;
					continue getValue;
				}
			}
		}
	});
var author$project$HtmlParserUtils$mapElements = F2(
	function (f, nodes) {
		return A2(
			elm$core$List$filterMap,
			function (node) {
				if (node.$ === 1) {
					var tagName = node.a;
					var attrs = node.b;
					var children = node.c;
					return elm$core$Maybe$Just(
						A3(f, tagName, attrs, children));
				} else {
					return elm$core$Maybe$Nothing;
				}
			},
			nodes);
	});
var author$project$Models$DeleteArticles = function (a) {
	return {$: 6, a: a};
};
var author$project$Models$SaveArticle = function (a) {
	return {$: 13, a: a};
};
var author$project$Models$ToggleExcerpt = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var author$project$Models$toEnglishMonth = function (month) {
	switch (month) {
		case 0:
			return 'Jan';
		case 1:
			return 'Feb';
		case 2:
			return 'Mar';
		case 3:
			return 'Apr';
		case 4:
			return 'May';
		case 5:
			return 'Jun';
		case 6:
			return 'Jul';
		case 7:
			return 'Aug';
		case 8:
			return 'Sep';
		case 9:
			return 'Oct';
		case 10:
			return 'Nov';
		default:
			return 'Dec';
	}
};
var author$project$PartialViews$UiKit$clear = function (val) {
	return A2(rtfeldman$elm_css$Css$property, 'clear', val);
};
var rtfeldman$elm_css$Css$backgroundImage = rtfeldman$elm_css$Css$prop1('background-image');
var rtfeldman$elm_css$Css$backgroundPosition = function (fn) {
	return A3(
		rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'backgroundPosition',
		'background-position',
		fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var rtfeldman$elm_css$Css$backgroundRepeat = rtfeldman$elm_css$Css$prop1('background-repeat');
var rtfeldman$elm_css$Css$backgroundSize = rtfeldman$elm_css$Css$prop1('background-size');
var rtfeldman$elm_css$Css$cover = {H: 0, ed: 'cover'};
var rtfeldman$elm_css$Css$float = function (fn) {
	return A3(
		rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'float',
		'float',
		fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var rtfeldman$elm_css$Css$prop4 = F5(
	function (key, argA, argB, argC, argD) {
		return A2(
			rtfeldman$elm_css$Css$property,
			key,
			A2(
				elm$core$String$join,
				' ',
				_List_fromArray(
					[argA.ed, argB.ed, argC.ed, argD.ed])));
	});
var rtfeldman$elm_css$Css$margin4 = rtfeldman$elm_css$Css$prop4('margin');
var rtfeldman$elm_css$Css$noRepeat = {Z: 0, D: 0, ed: 'no-repeat'};
var rtfeldman$elm_css$Css$url = function (urlValue) {
	return {Y: 0, ed: 'url(' + (urlValue + ')')};
};
var author$project$PartialViews$Article$articleImage = function (imageUrl) {
	return elm$core$String$isEmpty(imageUrl) ? rtfeldman$elm_css$Html$Styled$text('') : A4(
		rtfeldman$elm_css$Html$Styled$styled,
		rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$backgroundImage(
				rtfeldman$elm_css$Css$url(imageUrl)),
				rtfeldman$elm_css$Css$width(
				rtfeldman$elm_css$Css$rem(13)),
				rtfeldman$elm_css$Css$height(
				rtfeldman$elm_css$Css$rem(9)),
				rtfeldman$elm_css$Css$backgroundSize(rtfeldman$elm_css$Css$cover),
				rtfeldman$elm_css$Css$backgroundRepeat(rtfeldman$elm_css$Css$noRepeat),
				rtfeldman$elm_css$Css$backgroundPosition(rtfeldman$elm_css$Css$center),
				A4(rtfeldman$elm_css$Css$margin4, rtfeldman$elm_css$Css$zero, author$project$PartialViews$UiKit$theme.aV, author$project$PartialViews$UiKit$theme.aV, rtfeldman$elm_css$Css$zero),
				author$project$PartialViews$UiKit$clear('both'),
				rtfeldman$elm_css$Css$borderRadius(
				rtfeldman$elm_css$Css$px(3)),
				author$project$PartialViews$UiKit$onDesktop(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$float(rtfeldman$elm_css$Css$left)
					]))
			]),
		_List_fromArray(
			[
				rtfeldman$elm_css$Html$Styled$Attributes$class('article-image')
			]),
		_List_Nil);
};
var rtfeldman$elm_css$Css$block = {j: 0, ed: 'block'};
var rtfeldman$elm_css$Css$collectStops = elm$core$List$map(
	function (_n0) {
		var c = _n0.a;
		var len = _n0.b;
		return A2(
			elm$core$String$append,
			c.ed,
			A2(
				elm$core$Maybe$withDefault,
				'',
				A2(
					elm$core$Maybe$map,
					A2(
						elm$core$Basics$composeL,
						elm$core$String$cons(' '),
						function ($) {
							return $.ed;
						}),
					len)));
	});
var rtfeldman$elm_css$Css$linearGradient = F3(
	function (firstStop, secondStop, otherStops) {
		return {
			Y: 0,
			d: 0,
			ed: A2(
				rtfeldman$elm_css$Css$cssFunction,
				'linear-gradient',
				rtfeldman$elm_css$Css$collectStops(
					_Utils_ap(
						_List_fromArray(
							[firstStop, secondStop]),
						otherStops)))
		};
	});
var rtfeldman$elm_css$Css$stop2 = F2(
	function (c, len) {
		return _Utils_Tuple2(
			c,
			elm$core$Maybe$Just(len));
	});
var rtfeldman$elm_css$Css$Preprocess$NestSnippet = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var rtfeldman$elm_css$Css$Structure$Descendant = 3;
var rtfeldman$elm_css$Css$Global$descendants = rtfeldman$elm_css$Css$Preprocess$NestSnippet(3);
var rtfeldman$elm_css$Css$Global$selector = F2(
	function (selectorStr, styles) {
		return A2(
			rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
			styles,
			A2(rtfeldman$elm_css$Css$Structure$CustomSelector, selectorStr, _List_Nil));
	});
var rtfeldman$elm_css$Html$Styled$article = rtfeldman$elm_css$Html$Styled$node('article');
var author$project$PartialViews$UiKit$article = A2(
	rtfeldman$elm_css$Html$Styled$styled,
	rtfeldman$elm_css$Html$Styled$article,
	_List_fromArray(
		[
			rtfeldman$elm_css$Css$Global$descendants(
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Css$Global$selector,
					'a',
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$color(author$project$PartialViews$UiKit$theme.da)
						]))
				])),
			author$project$PartialViews$UiKit$clear('both'),
			rtfeldman$elm_css$Css$overflow(rtfeldman$elm_css$Css$hidden),
			rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$relative),
			rtfeldman$elm_css$Css$after(
			_List_fromArray(
				[
					author$project$PartialViews$UiKit$pseudoContent,
					rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$block),
					rtfeldman$elm_css$Css$bottom(rtfeldman$elm_css$Css$zero),
					rtfeldman$elm_css$Css$left(rtfeldman$elm_css$Css$zero),
					rtfeldman$elm_css$Css$width(
					rtfeldman$elm_css$Css$pct(100)),
					rtfeldman$elm_css$Css$height(author$project$PartialViews$UiKit$theme.dn),
					rtfeldman$elm_css$Css$backgroundImage(
					A3(
						rtfeldman$elm_css$Css$linearGradient,
						A2(
							rtfeldman$elm_css$Css$stop2,
							author$project$PartialViews$UiKit$theme.bL,
							rtfeldman$elm_css$Css$pct(0)),
						A2(
							rtfeldman$elm_css$Css$stop2,
							author$project$PartialViews$UiKit$theme.c8,
							rtfeldman$elm_css$Css$pct(60)),
						_List_Nil))
				]))
		]));
var rtfeldman$elm_css$Css$textDecoration = rtfeldman$elm_css$Css$prop1('text-decoration');
var rtfeldman$elm_css$Html$Styled$h2 = rtfeldman$elm_css$Html$Styled$node('h2');
var author$project$PartialViews$UiKit$articleTitle = A2(
	rtfeldman$elm_css$Html$Styled$styled,
	rtfeldman$elm_css$Html$Styled$h2,
	_List_fromArray(
		[
			rtfeldman$elm_css$Css$Global$descendants(
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Css$Global$selector,
					'a',
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$color(author$project$PartialViews$UiKit$theme.da),
							rtfeldman$elm_css$Css$textDecoration(rtfeldman$elm_css$Css$none),
							rtfeldman$elm_css$Css$backgroundImage(rtfeldman$elm_css$Css$none)
						]))
				])),
			rtfeldman$elm_css$Css$marginBottom(
			rtfeldman$elm_css$Css$em(0.5))
		]));
var rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap = rtfeldman$elm_css$VirtualDom$Styled$attribute('stroke-linecap');
var rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin = rtfeldman$elm_css$VirtualDom$Styled$attribute('stroke-linejoin');
var rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth = rtfeldman$elm_css$VirtualDom$Styled$attribute('stroke-width');
var author$project$PartialViews$Icons$starIcon = function (styles) {
	return A4(
		rtfeldman$elm_css$Svg$Styled$styled,
		rtfeldman$elm_css$Svg$Styled$svg,
		_Utils_ap(
			_List_fromArray(
				[author$project$PartialViews$Icons$iconStyle]),
			styles),
		_List_fromArray(
			[
				rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 79.087 75.38')
			]),
		_List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M63.743 73.86L39.757 56.285 15.939 74.18l9.303-28.243L.862 28.815l29.735.12L39.347.458l9.076 28.317 29.787-.478-24.127 17.38z'),
						rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth('3'),
						rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap('round'),
						rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin('bevel')
					]),
				_List_Nil)
			]));
};
var author$project$PartialViews$UiKit$stroke = function (val) {
	return A2(rtfeldman$elm_css$Css$property, 'stroke', val);
};
var rtfeldman$elm_css$Css$marginRight = rtfeldman$elm_css$Css$prop1('margin-right');
var rtfeldman$elm_css$Html$Styled$Events$targetChecked = A2(
	elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	elm$json$Json$Decode$bool);
var rtfeldman$elm_css$Html$Styled$Events$onCheck = function (tagger) {
	return A2(
		rtfeldman$elm_css$Html$Styled$Events$on,
		'change',
		A2(elm$json$Json$Decode$map, tagger, rtfeldman$elm_css$Html$Styled$Events$targetChecked));
};
var author$project$PartialViews$UiKit$starBtn = F3(
	function (idString, selected, clickHandle) {
		var iconFill = selected ? author$project$PartialViews$UiKit$theme.aS : A4(rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0);
		return A4(
			rtfeldman$elm_css$Html$Styled$styled,
			rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$marginRight(author$project$PartialViews$UiKit$theme.aV)
				]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$class('starBtn')
				]),
			_List_fromArray(
				[
					A4(
					rtfeldman$elm_css$Html$Styled$styled,
					rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$none)
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
							rtfeldman$elm_css$Html$Styled$Attributes$id('starred_' + idString),
							rtfeldman$elm_css$Html$Styled$Events$onCheck(clickHandle),
							rtfeldman$elm_css$Html$Styled$Attributes$checked(selected)
						]),
					_List_Nil),
					A2(
					rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$for('starred_' + idString),
							rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled(
							fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel('starred'))
						]),
					_List_fromArray(
						[
							author$project$PartialViews$Icons$starIcon(
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$width(
									rtfeldman$elm_css$Css$rem(1.3)),
									rtfeldman$elm_css$Css$height(
									rtfeldman$elm_css$Css$rem(1.3)),
									author$project$PartialViews$UiKit$stroke(author$project$PartialViews$UiKit$theme.aS.ed),
									author$project$PartialViews$UiKit$transition('fill 0.5s'),
									rtfeldman$elm_css$Css$fill(iconFill)
								]))
						]))
				]));
	});
var elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return elm$core$Basics$floor(numerator / denominator);
	});
var elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.bn, posixMinutes) < 0) {
					return posixMinutes + era.b;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var elm$time$Time$toAdjustedMinutes = F2(
	function (_n0, time) {
		var defaultOffset = _n0.a;
		var eras = _n0.b;
		return A3(
			elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				elm$time$Time$flooredDiv,
				elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var elm$core$Basics$ge = _Utils_ge;
var elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2(elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		bN: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		cf: month,
		cW: year + ((month <= 2) ? 1 : 0)
	};
};
var elm$time$Time$toDay = F2(
	function (zone, time) {
		return elm$time$Time$toCivil(
			A2(elm$time$Time$toAdjustedMinutes, zone, time)).bN;
	});
var elm$time$Time$Apr = 3;
var elm$time$Time$Aug = 7;
var elm$time$Time$Dec = 11;
var elm$time$Time$Feb = 1;
var elm$time$Time$Jan = 0;
var elm$time$Time$Jul = 6;
var elm$time$Time$Jun = 5;
var elm$time$Time$Mar = 2;
var elm$time$Time$May = 4;
var elm$time$Time$Nov = 10;
var elm$time$Time$Oct = 9;
var elm$time$Time$Sep = 8;
var elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _n0 = elm$time$Time$toCivil(
			A2(elm$time$Time$toAdjustedMinutes, zone, time)).cf;
		switch (_n0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var elm$time$Time$toYear = F2(
	function (zone, time) {
		return elm$time$Time$toCivil(
			A2(elm$time$Time$toAdjustedMinutes, zone, time)).cW;
	});
var elm$time$Time$utc = A2(elm$time$Time$Zone, 0, _List_Nil);
var elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var elm$parser$Parser$Advanced$backtrackable = function (_n0) {
	var parse = _n0;
	return function (s0) {
		var _n1 = parse(s0);
		if (_n1.$ === 1) {
			var x = _n1.b;
			return A2(elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _n1.b;
			var s1 = _n1.c;
			return A3(elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var elm$parser$Parser$backtrackable = elm$parser$Parser$Advanced$backtrackable;
var hecrj$html_parser$Html$Parser$Element = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var hecrj$html_parser$Html$Parser$chompOneOrMore = function (fn) {
	return A2(
		elm$parser$Parser$ignorer,
		elm$parser$Parser$chompIf(fn),
		elm$parser$Parser$chompWhile(fn));
};
var hecrj$html_parser$Html$Parser$isSpaceCharacter = function (c) {
	return (c === ' ') || ((c === '\t') || ((c === '\n') || ((c === '\u000d') || (c === '\u000c'))));
};
var hecrj$html_parser$Html$Parser$closingTag = function (name) {
	var chompName = A2(
		elm$parser$Parser$andThen,
		function (closingName) {
			return _Utils_eq(
				elm$core$String$toLower(closingName),
				name) ? elm$parser$Parser$succeed(0) : elm$parser$Parser$problem('closing tag does not match opening tag: ' + name);
		},
		elm$parser$Parser$getChompedString(
			hecrj$html_parser$Html$Parser$chompOneOrMore(
				function (c) {
					return (!hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && (c !== '>');
				})));
	return A2(
		elm$parser$Parser$ignorer,
		A2(
			elm$parser$Parser$ignorer,
			A2(
				elm$parser$Parser$ignorer,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$chompIf(
						elm$core$Basics$eq('<')),
					elm$parser$Parser$chompIf(
						elm$core$Basics$eq('/'))),
				chompName),
			elm$parser$Parser$chompWhile(hecrj$html_parser$Html$Parser$isSpaceCharacter)),
		elm$parser$Parser$chompIf(
			elm$core$Basics$eq('>')));
};
var elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var elm$parser$Parser$toToken = function (str) {
	return A2(
		elm$parser$Parser$Advanced$Token,
		str,
		elm$parser$Parser$Expecting(str));
};
var elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			elm$parser$Parser$Advanced$AddRight,
			elm$parser$Parser$Advanced$Empty,
			A4(elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var elm$parser$Parser$Advanced$chompUntil = function (_n0) {
	var str = _n0.a;
	var expecting = _n0.b;
	return function (s) {
		var _n1 = A5(elm$parser$Parser$Advanced$findSubString, str, s.b, s.cy, s.bK, s.a);
		var newOffset = _n1.a;
		var newRow = _n1.b;
		var newCol = _n1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			elm$parser$Parser$Advanced$Bad,
			false,
			A4(elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.f)) : A3(
			elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.b, newOffset) < 0,
			0,
			{bK: newCol, f: s.f, g: s.g, b: newOffset, cy: newRow, a: s.a});
	};
};
var elm$parser$Parser$chompUntil = function (str) {
	return elm$parser$Parser$Advanced$chompUntil(
		elm$parser$Parser$toToken(str));
};
var elm$parser$Parser$token = function (str) {
	return elm$parser$Parser$Advanced$token(
		elm$parser$Parser$toToken(str));
};
var hecrj$html_parser$Html$Parser$Comment = function (a) {
	return {$: 2, a: a};
};
var hecrj$html_parser$Html$Parser$comment = A2(
	elm$parser$Parser$keeper,
	A2(
		elm$parser$Parser$ignorer,
		A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(hecrj$html_parser$Html$Parser$Comment),
			elm$parser$Parser$token('<!')),
		elm$parser$Parser$token('--')),
	A2(
		elm$parser$Parser$ignorer,
		elm$parser$Parser$getChompedString(
			elm$parser$Parser$chompUntil('-->')),
		elm$parser$Parser$token('-->')));
var hecrj$html_parser$Html$Parser$voidElements = _List_fromArray(
	['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
var hecrj$html_parser$Html$Parser$isVoidElement = function (name) {
	return A2(elm$core$List$member, name, hecrj$html_parser$Html$Parser$voidElements);
};
var hecrj$html_parser$Html$Parser$many = function (parser_) {
	return A2(
		elm$parser$Parser$loop,
		_List_Nil,
		function (list) {
			return elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						elm$parser$Parser$map,
						function (_new) {
							return elm$parser$Parser$Loop(
								A2(elm$core$List$cons, _new, list));
						},
						parser_),
						elm$parser$Parser$succeed(
						elm$parser$Parser$Done(
							elm$core$List$reverse(list)))
					]));
		});
};
var hecrj$html_parser$Html$Parser$isTagAttributeCharacter = function (c) {
	return (!hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '>') && ((c !== '/') && (c !== '=')))));
};
var hecrj$html_parser$Html$Parser$tagAttributeName = A2(
	elm$parser$Parser$map,
	elm$core$String$toLower,
	elm$parser$Parser$getChompedString(
		hecrj$html_parser$Html$Parser$chompOneOrMore(hecrj$html_parser$Html$Parser$isTagAttributeCharacter)));
var hecrj$html_parser$Html$Parser$chompSemicolon = elm$parser$Parser$chompIf(
	elm$core$Basics$eq(';'));
var hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict = elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Aacute', 'Á'),
			_Utils_Tuple2('aacute', 'á'),
			_Utils_Tuple2('Abreve', 'Ă'),
			_Utils_Tuple2('abreve', 'ă'),
			_Utils_Tuple2('ac', '∾'),
			_Utils_Tuple2('acd', '∿'),
			_Utils_Tuple2('acE', '∾̳'),
			_Utils_Tuple2('Acirc', 'Â'),
			_Utils_Tuple2('acirc', 'â'),
			_Utils_Tuple2('acute', '´'),
			_Utils_Tuple2('Acy', 'А'),
			_Utils_Tuple2('acy', 'а'),
			_Utils_Tuple2('AElig', 'Æ'),
			_Utils_Tuple2('aelig', 'æ'),
			_Utils_Tuple2('af', '\u2061'),
			_Utils_Tuple2('Afr', '\ud835\udd04'),
			_Utils_Tuple2('afr', '\ud835\udd1e'),
			_Utils_Tuple2('Agrave', 'À'),
			_Utils_Tuple2('agrave', 'à'),
			_Utils_Tuple2('alefsym', 'ℵ'),
			_Utils_Tuple2('aleph', 'ℵ'),
			_Utils_Tuple2('Alpha', 'Α'),
			_Utils_Tuple2('alpha', 'α'),
			_Utils_Tuple2('Amacr', 'Ā'),
			_Utils_Tuple2('amacr', 'ā'),
			_Utils_Tuple2('amalg', '⨿'),
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('AMP', '&'),
			_Utils_Tuple2('andand', '⩕'),
			_Utils_Tuple2('And', '⩓'),
			_Utils_Tuple2('and', '∧'),
			_Utils_Tuple2('andd', '⩜'),
			_Utils_Tuple2('andslope', '⩘'),
			_Utils_Tuple2('andv', '⩚'),
			_Utils_Tuple2('ang', '∠'),
			_Utils_Tuple2('ange', '⦤'),
			_Utils_Tuple2('angle', '∠'),
			_Utils_Tuple2('angmsdaa', '⦨'),
			_Utils_Tuple2('angmsdab', '⦩'),
			_Utils_Tuple2('angmsdac', '⦪'),
			_Utils_Tuple2('angmsdad', '⦫'),
			_Utils_Tuple2('angmsdae', '⦬'),
			_Utils_Tuple2('angmsdaf', '⦭'),
			_Utils_Tuple2('angmsdag', '⦮'),
			_Utils_Tuple2('angmsdah', '⦯'),
			_Utils_Tuple2('angmsd', '∡'),
			_Utils_Tuple2('angrt', '∟'),
			_Utils_Tuple2('angrtvb', '⊾'),
			_Utils_Tuple2('angrtvbd', '⦝'),
			_Utils_Tuple2('angsph', '∢'),
			_Utils_Tuple2('angst', 'Å'),
			_Utils_Tuple2('angzarr', '⍼'),
			_Utils_Tuple2('Aogon', 'Ą'),
			_Utils_Tuple2('aogon', 'ą'),
			_Utils_Tuple2('Aopf', '\ud835\udd38'),
			_Utils_Tuple2('aopf', '\ud835\udd52'),
			_Utils_Tuple2('apacir', '⩯'),
			_Utils_Tuple2('ap', '≈'),
			_Utils_Tuple2('apE', '⩰'),
			_Utils_Tuple2('ape', '≊'),
			_Utils_Tuple2('apid', '≋'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('ApplyFunction', '\u2061'),
			_Utils_Tuple2('approx', '≈'),
			_Utils_Tuple2('approxeq', '≊'),
			_Utils_Tuple2('Aring', 'Å'),
			_Utils_Tuple2('aring', 'å'),
			_Utils_Tuple2('Ascr', '\ud835\udc9c'),
			_Utils_Tuple2('ascr', '\ud835\udcb6'),
			_Utils_Tuple2('Assign', '≔'),
			_Utils_Tuple2('ast', '*'),
			_Utils_Tuple2('asymp', '≈'),
			_Utils_Tuple2('asympeq', '≍'),
			_Utils_Tuple2('Atilde', 'Ã'),
			_Utils_Tuple2('atilde', 'ã'),
			_Utils_Tuple2('Auml', 'Ä'),
			_Utils_Tuple2('auml', 'ä'),
			_Utils_Tuple2('awconint', '∳'),
			_Utils_Tuple2('awint', '⨑'),
			_Utils_Tuple2('backcong', '≌'),
			_Utils_Tuple2('backepsilon', '϶'),
			_Utils_Tuple2('backprime', '‵'),
			_Utils_Tuple2('backsim', '∽'),
			_Utils_Tuple2('backsimeq', '⋍'),
			_Utils_Tuple2('Backslash', '∖'),
			_Utils_Tuple2('Barv', '⫧'),
			_Utils_Tuple2('barvee', '⊽'),
			_Utils_Tuple2('barwed', '⌅'),
			_Utils_Tuple2('Barwed', '⌆'),
			_Utils_Tuple2('barwedge', '⌅'),
			_Utils_Tuple2('bbrk', '⎵'),
			_Utils_Tuple2('bbrktbrk', '⎶'),
			_Utils_Tuple2('bcong', '≌'),
			_Utils_Tuple2('Bcy', 'Б'),
			_Utils_Tuple2('bcy', 'б'),
			_Utils_Tuple2('bdquo', '„'),
			_Utils_Tuple2('becaus', '∵'),
			_Utils_Tuple2('because', '∵'),
			_Utils_Tuple2('Because', '∵'),
			_Utils_Tuple2('bemptyv', '⦰'),
			_Utils_Tuple2('bepsi', '϶'),
			_Utils_Tuple2('bernou', 'ℬ'),
			_Utils_Tuple2('Bernoullis', 'ℬ'),
			_Utils_Tuple2('Beta', 'Β'),
			_Utils_Tuple2('beta', 'β'),
			_Utils_Tuple2('beth', 'ℶ'),
			_Utils_Tuple2('between', '≬'),
			_Utils_Tuple2('Bfr', '\ud835\udd05'),
			_Utils_Tuple2('bfr', '\ud835\udd1f'),
			_Utils_Tuple2('bigcap', '⋂'),
			_Utils_Tuple2('bigcirc', '◯'),
			_Utils_Tuple2('bigcup', '⋃'),
			_Utils_Tuple2('bigodot', '⨀'),
			_Utils_Tuple2('bigoplus', '⨁'),
			_Utils_Tuple2('bigotimes', '⨂'),
			_Utils_Tuple2('bigsqcup', '⨆'),
			_Utils_Tuple2('bigstar', '★'),
			_Utils_Tuple2('bigtriangledown', '▽'),
			_Utils_Tuple2('bigtriangleup', '△'),
			_Utils_Tuple2('biguplus', '⨄'),
			_Utils_Tuple2('bigvee', '⋁'),
			_Utils_Tuple2('bigwedge', '⋀'),
			_Utils_Tuple2('bkarow', '⤍'),
			_Utils_Tuple2('blacklozenge', '⧫'),
			_Utils_Tuple2('blacksquare', '▪'),
			_Utils_Tuple2('blacktriangle', '▴'),
			_Utils_Tuple2('blacktriangledown', '▾'),
			_Utils_Tuple2('blacktriangleleft', '◂'),
			_Utils_Tuple2('blacktriangleright', '▸'),
			_Utils_Tuple2('blank', '␣'),
			_Utils_Tuple2('blk12', '▒'),
			_Utils_Tuple2('blk14', '░'),
			_Utils_Tuple2('blk34', '▓'),
			_Utils_Tuple2('block', '█'),
			_Utils_Tuple2('bne', '=⃥'),
			_Utils_Tuple2('bnequiv', '≡⃥'),
			_Utils_Tuple2('bNot', '⫭'),
			_Utils_Tuple2('bnot', '⌐'),
			_Utils_Tuple2('Bopf', '\ud835\udd39'),
			_Utils_Tuple2('bopf', '\ud835\udd53'),
			_Utils_Tuple2('bot', '⊥'),
			_Utils_Tuple2('bottom', '⊥'),
			_Utils_Tuple2('bowtie', '⋈'),
			_Utils_Tuple2('boxbox', '⧉'),
			_Utils_Tuple2('boxdl', '┐'),
			_Utils_Tuple2('boxdL', '╕'),
			_Utils_Tuple2('boxDl', '╖'),
			_Utils_Tuple2('boxDL', '╗'),
			_Utils_Tuple2('boxdr', '┌'),
			_Utils_Tuple2('boxdR', '╒'),
			_Utils_Tuple2('boxDr', '╓'),
			_Utils_Tuple2('boxDR', '╔'),
			_Utils_Tuple2('boxh', '─'),
			_Utils_Tuple2('boxH', '═'),
			_Utils_Tuple2('boxhd', '┬'),
			_Utils_Tuple2('boxHd', '╤'),
			_Utils_Tuple2('boxhD', '╥'),
			_Utils_Tuple2('boxHD', '╦'),
			_Utils_Tuple2('boxhu', '┴'),
			_Utils_Tuple2('boxHu', '╧'),
			_Utils_Tuple2('boxhU', '╨'),
			_Utils_Tuple2('boxHU', '╩'),
			_Utils_Tuple2('boxminus', '⊟'),
			_Utils_Tuple2('boxplus', '⊞'),
			_Utils_Tuple2('boxtimes', '⊠'),
			_Utils_Tuple2('boxul', '┘'),
			_Utils_Tuple2('boxuL', '╛'),
			_Utils_Tuple2('boxUl', '╜'),
			_Utils_Tuple2('boxUL', '╝'),
			_Utils_Tuple2('boxur', '└'),
			_Utils_Tuple2('boxuR', '╘'),
			_Utils_Tuple2('boxUr', '╙'),
			_Utils_Tuple2('boxUR', '╚'),
			_Utils_Tuple2('boxv', '│'),
			_Utils_Tuple2('boxV', '║'),
			_Utils_Tuple2('boxvh', '┼'),
			_Utils_Tuple2('boxvH', '╪'),
			_Utils_Tuple2('boxVh', '╫'),
			_Utils_Tuple2('boxVH', '╬'),
			_Utils_Tuple2('boxvl', '┤'),
			_Utils_Tuple2('boxvL', '╡'),
			_Utils_Tuple2('boxVl', '╢'),
			_Utils_Tuple2('boxVL', '╣'),
			_Utils_Tuple2('boxvr', '├'),
			_Utils_Tuple2('boxvR', '╞'),
			_Utils_Tuple2('boxVr', '╟'),
			_Utils_Tuple2('boxVR', '╠'),
			_Utils_Tuple2('bprime', '‵'),
			_Utils_Tuple2('breve', '˘'),
			_Utils_Tuple2('Breve', '˘'),
			_Utils_Tuple2('brvbar', '¦'),
			_Utils_Tuple2('bscr', '\ud835\udcb7'),
			_Utils_Tuple2('Bscr', 'ℬ'),
			_Utils_Tuple2('bsemi', '⁏'),
			_Utils_Tuple2('bsim', '∽'),
			_Utils_Tuple2('bsime', '⋍'),
			_Utils_Tuple2('bsolb', '⧅'),
			_Utils_Tuple2('bsol', '\\'),
			_Utils_Tuple2('bsolhsub', '⟈'),
			_Utils_Tuple2('bull', '•'),
			_Utils_Tuple2('bullet', '•'),
			_Utils_Tuple2('bump', '≎'),
			_Utils_Tuple2('bumpE', '⪮'),
			_Utils_Tuple2('bumpe', '≏'),
			_Utils_Tuple2('Bumpeq', '≎'),
			_Utils_Tuple2('bumpeq', '≏'),
			_Utils_Tuple2('Cacute', 'Ć'),
			_Utils_Tuple2('cacute', 'ć'),
			_Utils_Tuple2('capand', '⩄'),
			_Utils_Tuple2('capbrcup', '⩉'),
			_Utils_Tuple2('capcap', '⩋'),
			_Utils_Tuple2('cap', '∩'),
			_Utils_Tuple2('Cap', '⋒'),
			_Utils_Tuple2('capcup', '⩇'),
			_Utils_Tuple2('capdot', '⩀'),
			_Utils_Tuple2('CapitalDifferentialD', 'ⅅ'),
			_Utils_Tuple2('caps', '∩︀'),
			_Utils_Tuple2('caret', '⁁'),
			_Utils_Tuple2('caron', 'ˇ'),
			_Utils_Tuple2('Cayleys', 'ℭ'),
			_Utils_Tuple2('ccaps', '⩍'),
			_Utils_Tuple2('Ccaron', 'Č'),
			_Utils_Tuple2('ccaron', 'č'),
			_Utils_Tuple2('Ccedil', 'Ç'),
			_Utils_Tuple2('ccedil', 'ç'),
			_Utils_Tuple2('Ccirc', 'Ĉ'),
			_Utils_Tuple2('ccirc', 'ĉ'),
			_Utils_Tuple2('Cconint', '∰'),
			_Utils_Tuple2('ccups', '⩌'),
			_Utils_Tuple2('ccupssm', '⩐'),
			_Utils_Tuple2('Cdot', 'Ċ'),
			_Utils_Tuple2('cdot', 'ċ'),
			_Utils_Tuple2('cedil', '¸'),
			_Utils_Tuple2('Cedilla', '¸'),
			_Utils_Tuple2('cemptyv', '⦲'),
			_Utils_Tuple2('cent', '¢'),
			_Utils_Tuple2('centerdot', '·'),
			_Utils_Tuple2('CenterDot', '·'),
			_Utils_Tuple2('cfr', '\ud835\udd20'),
			_Utils_Tuple2('Cfr', 'ℭ'),
			_Utils_Tuple2('CHcy', 'Ч'),
			_Utils_Tuple2('chcy', 'ч'),
			_Utils_Tuple2('check', '✓'),
			_Utils_Tuple2('checkmark', '✓'),
			_Utils_Tuple2('Chi', 'Χ'),
			_Utils_Tuple2('chi', 'χ'),
			_Utils_Tuple2('circ', 'ˆ'),
			_Utils_Tuple2('circeq', '≗'),
			_Utils_Tuple2('circlearrowleft', '↺'),
			_Utils_Tuple2('circlearrowright', '↻'),
			_Utils_Tuple2('circledast', '⊛'),
			_Utils_Tuple2('circledcirc', '⊚'),
			_Utils_Tuple2('circleddash', '⊝'),
			_Utils_Tuple2('CircleDot', '⊙'),
			_Utils_Tuple2('circledR', '®'),
			_Utils_Tuple2('circledS', 'Ⓢ'),
			_Utils_Tuple2('CircleMinus', '⊖'),
			_Utils_Tuple2('CirclePlus', '⊕'),
			_Utils_Tuple2('CircleTimes', '⊗'),
			_Utils_Tuple2('cir', '○'),
			_Utils_Tuple2('cirE', '⧃'),
			_Utils_Tuple2('cire', '≗'),
			_Utils_Tuple2('cirfnint', '⨐'),
			_Utils_Tuple2('cirmid', '⫯'),
			_Utils_Tuple2('cirscir', '⧂'),
			_Utils_Tuple2('ClockwiseContourIntegral', '∲'),
			_Utils_Tuple2('CloseCurlyDoubleQuote', '”'),
			_Utils_Tuple2('CloseCurlyQuote', '’'),
			_Utils_Tuple2('clubs', '♣'),
			_Utils_Tuple2('clubsuit', '♣'),
			_Utils_Tuple2('colon', ':'),
			_Utils_Tuple2('Colon', '∷'),
			_Utils_Tuple2('Colone', '⩴'),
			_Utils_Tuple2('colone', '≔'),
			_Utils_Tuple2('coloneq', '≔'),
			_Utils_Tuple2('comma', ','),
			_Utils_Tuple2('commat', '@'),
			_Utils_Tuple2('comp', '∁'),
			_Utils_Tuple2('compfn', '∘'),
			_Utils_Tuple2('complement', '∁'),
			_Utils_Tuple2('complexes', 'ℂ'),
			_Utils_Tuple2('cong', '≅'),
			_Utils_Tuple2('congdot', '⩭'),
			_Utils_Tuple2('Congruent', '≡'),
			_Utils_Tuple2('conint', '∮'),
			_Utils_Tuple2('Conint', '∯'),
			_Utils_Tuple2('ContourIntegral', '∮'),
			_Utils_Tuple2('copf', '\ud835\udd54'),
			_Utils_Tuple2('Copf', 'ℂ'),
			_Utils_Tuple2('coprod', '∐'),
			_Utils_Tuple2('Coproduct', '∐'),
			_Utils_Tuple2('copy', '©'),
			_Utils_Tuple2('COPY', '©'),
			_Utils_Tuple2('copysr', '℗'),
			_Utils_Tuple2('CounterClockwiseContourIntegral', '∳'),
			_Utils_Tuple2('crarr', '↵'),
			_Utils_Tuple2('cross', '✗'),
			_Utils_Tuple2('Cross', '⨯'),
			_Utils_Tuple2('Cscr', '\ud835\udc9e'),
			_Utils_Tuple2('cscr', '\ud835\udcb8'),
			_Utils_Tuple2('csub', '⫏'),
			_Utils_Tuple2('csube', '⫑'),
			_Utils_Tuple2('csup', '⫐'),
			_Utils_Tuple2('csupe', '⫒'),
			_Utils_Tuple2('ctdot', '⋯'),
			_Utils_Tuple2('cudarrl', '⤸'),
			_Utils_Tuple2('cudarrr', '⤵'),
			_Utils_Tuple2('cuepr', '⋞'),
			_Utils_Tuple2('cuesc', '⋟'),
			_Utils_Tuple2('cularr', '↶'),
			_Utils_Tuple2('cularrp', '⤽'),
			_Utils_Tuple2('cupbrcap', '⩈'),
			_Utils_Tuple2('cupcap', '⩆'),
			_Utils_Tuple2('CupCap', '≍'),
			_Utils_Tuple2('cup', '∪'),
			_Utils_Tuple2('Cup', '⋓'),
			_Utils_Tuple2('cupcup', '⩊'),
			_Utils_Tuple2('cupdot', '⊍'),
			_Utils_Tuple2('cupor', '⩅'),
			_Utils_Tuple2('cups', '∪︀'),
			_Utils_Tuple2('curarr', '↷'),
			_Utils_Tuple2('curarrm', '⤼'),
			_Utils_Tuple2('curlyeqprec', '⋞'),
			_Utils_Tuple2('curlyeqsucc', '⋟'),
			_Utils_Tuple2('curlyvee', '⋎'),
			_Utils_Tuple2('curlywedge', '⋏'),
			_Utils_Tuple2('curren', '¤'),
			_Utils_Tuple2('curvearrowleft', '↶'),
			_Utils_Tuple2('curvearrowright', '↷'),
			_Utils_Tuple2('cuvee', '⋎'),
			_Utils_Tuple2('cuwed', '⋏'),
			_Utils_Tuple2('cwconint', '∲'),
			_Utils_Tuple2('cwint', '∱'),
			_Utils_Tuple2('cylcty', '⌭'),
			_Utils_Tuple2('dagger', '†'),
			_Utils_Tuple2('Dagger', '‡'),
			_Utils_Tuple2('daleth', 'ℸ'),
			_Utils_Tuple2('darr', '↓'),
			_Utils_Tuple2('Darr', '↡'),
			_Utils_Tuple2('dArr', '⇓'),
			_Utils_Tuple2('dash', '‐'),
			_Utils_Tuple2('Dashv', '⫤'),
			_Utils_Tuple2('dashv', '⊣'),
			_Utils_Tuple2('dbkarow', '⤏'),
			_Utils_Tuple2('dblac', '˝'),
			_Utils_Tuple2('Dcaron', 'Ď'),
			_Utils_Tuple2('dcaron', 'ď'),
			_Utils_Tuple2('Dcy', 'Д'),
			_Utils_Tuple2('dcy', 'д'),
			_Utils_Tuple2('ddagger', '‡'),
			_Utils_Tuple2('ddarr', '⇊'),
			_Utils_Tuple2('DD', 'ⅅ'),
			_Utils_Tuple2('dd', 'ⅆ'),
			_Utils_Tuple2('DDotrahd', '⤑'),
			_Utils_Tuple2('ddotseq', '⩷'),
			_Utils_Tuple2('deg', '°'),
			_Utils_Tuple2('Del', '∇'),
			_Utils_Tuple2('Delta', 'Δ'),
			_Utils_Tuple2('delta', 'δ'),
			_Utils_Tuple2('demptyv', '⦱'),
			_Utils_Tuple2('dfisht', '⥿'),
			_Utils_Tuple2('Dfr', '\ud835\udd07'),
			_Utils_Tuple2('dfr', '\ud835\udd21'),
			_Utils_Tuple2('dHar', '⥥'),
			_Utils_Tuple2('dharl', '⇃'),
			_Utils_Tuple2('dharr', '⇂'),
			_Utils_Tuple2('DiacriticalAcute', '´'),
			_Utils_Tuple2('DiacriticalDot', '˙'),
			_Utils_Tuple2('DiacriticalDoubleAcute', '˝'),
			_Utils_Tuple2('DiacriticalGrave', '`'),
			_Utils_Tuple2('DiacriticalTilde', '˜'),
			_Utils_Tuple2('diam', '⋄'),
			_Utils_Tuple2('diamond', '⋄'),
			_Utils_Tuple2('Diamond', '⋄'),
			_Utils_Tuple2('diamondsuit', '♦'),
			_Utils_Tuple2('diams', '♦'),
			_Utils_Tuple2('die', '¨'),
			_Utils_Tuple2('DifferentialD', 'ⅆ'),
			_Utils_Tuple2('digamma', 'ϝ'),
			_Utils_Tuple2('disin', '⋲'),
			_Utils_Tuple2('div', '÷'),
			_Utils_Tuple2('divide', '÷'),
			_Utils_Tuple2('divideontimes', '⋇'),
			_Utils_Tuple2('divonx', '⋇'),
			_Utils_Tuple2('DJcy', 'Ђ'),
			_Utils_Tuple2('djcy', 'ђ'),
			_Utils_Tuple2('dlcorn', '⌞'),
			_Utils_Tuple2('dlcrop', '⌍'),
			_Utils_Tuple2('dollar', '$'),
			_Utils_Tuple2('Dopf', '\ud835\udd3b'),
			_Utils_Tuple2('dopf', '\ud835\udd55'),
			_Utils_Tuple2('Dot', '¨'),
			_Utils_Tuple2('dot', '˙'),
			_Utils_Tuple2('DotDot', '⃜'),
			_Utils_Tuple2('doteq', '≐'),
			_Utils_Tuple2('doteqdot', '≑'),
			_Utils_Tuple2('DotEqual', '≐'),
			_Utils_Tuple2('dotminus', '∸'),
			_Utils_Tuple2('dotplus', '∔'),
			_Utils_Tuple2('dotsquare', '⊡'),
			_Utils_Tuple2('doublebarwedge', '⌆'),
			_Utils_Tuple2('DoubleContourIntegral', '∯'),
			_Utils_Tuple2('DoubleDot', '¨'),
			_Utils_Tuple2('DoubleDownArrow', '⇓'),
			_Utils_Tuple2('DoubleLeftArrow', '⇐'),
			_Utils_Tuple2('DoubleLeftRightArrow', '⇔'),
			_Utils_Tuple2('DoubleLeftTee', '⫤'),
			_Utils_Tuple2('DoubleLongLeftArrow', '⟸'),
			_Utils_Tuple2('DoubleLongLeftRightArrow', '⟺'),
			_Utils_Tuple2('DoubleLongRightArrow', '⟹'),
			_Utils_Tuple2('DoubleRightArrow', '⇒'),
			_Utils_Tuple2('DoubleRightTee', '⊨'),
			_Utils_Tuple2('DoubleUpArrow', '⇑'),
			_Utils_Tuple2('DoubleUpDownArrow', '⇕'),
			_Utils_Tuple2('DoubleVerticalBar', '∥'),
			_Utils_Tuple2('DownArrowBar', '⤓'),
			_Utils_Tuple2('downarrow', '↓'),
			_Utils_Tuple2('DownArrow', '↓'),
			_Utils_Tuple2('Downarrow', '⇓'),
			_Utils_Tuple2('DownArrowUpArrow', '⇵'),
			_Utils_Tuple2('DownBreve', '̑'),
			_Utils_Tuple2('downdownarrows', '⇊'),
			_Utils_Tuple2('downharpoonleft', '⇃'),
			_Utils_Tuple2('downharpoonright', '⇂'),
			_Utils_Tuple2('DownLeftRightVector', '⥐'),
			_Utils_Tuple2('DownLeftTeeVector', '⥞'),
			_Utils_Tuple2('DownLeftVectorBar', '⥖'),
			_Utils_Tuple2('DownLeftVector', '↽'),
			_Utils_Tuple2('DownRightTeeVector', '⥟'),
			_Utils_Tuple2('DownRightVectorBar', '⥗'),
			_Utils_Tuple2('DownRightVector', '⇁'),
			_Utils_Tuple2('DownTeeArrow', '↧'),
			_Utils_Tuple2('DownTee', '⊤'),
			_Utils_Tuple2('drbkarow', '⤐'),
			_Utils_Tuple2('drcorn', '⌟'),
			_Utils_Tuple2('drcrop', '⌌'),
			_Utils_Tuple2('Dscr', '\ud835\udc9f'),
			_Utils_Tuple2('dscr', '\ud835\udcb9'),
			_Utils_Tuple2('DScy', 'Ѕ'),
			_Utils_Tuple2('dscy', 'ѕ'),
			_Utils_Tuple2('dsol', '⧶'),
			_Utils_Tuple2('Dstrok', 'Đ'),
			_Utils_Tuple2('dstrok', 'đ'),
			_Utils_Tuple2('dtdot', '⋱'),
			_Utils_Tuple2('dtri', '▿'),
			_Utils_Tuple2('dtrif', '▾'),
			_Utils_Tuple2('duarr', '⇵'),
			_Utils_Tuple2('duhar', '⥯'),
			_Utils_Tuple2('dwangle', '⦦'),
			_Utils_Tuple2('DZcy', 'Џ'),
			_Utils_Tuple2('dzcy', 'џ'),
			_Utils_Tuple2('dzigrarr', '⟿'),
			_Utils_Tuple2('Eacute', 'É'),
			_Utils_Tuple2('eacute', 'é'),
			_Utils_Tuple2('easter', '⩮'),
			_Utils_Tuple2('Ecaron', 'Ě'),
			_Utils_Tuple2('ecaron', 'ě'),
			_Utils_Tuple2('Ecirc', 'Ê'),
			_Utils_Tuple2('ecirc', 'ê'),
			_Utils_Tuple2('ecir', '≖'),
			_Utils_Tuple2('ecolon', '≕'),
			_Utils_Tuple2('Ecy', 'Э'),
			_Utils_Tuple2('ecy', 'э'),
			_Utils_Tuple2('eDDot', '⩷'),
			_Utils_Tuple2('Edot', 'Ė'),
			_Utils_Tuple2('edot', 'ė'),
			_Utils_Tuple2('eDot', '≑'),
			_Utils_Tuple2('ee', 'ⅇ'),
			_Utils_Tuple2('efDot', '≒'),
			_Utils_Tuple2('Efr', '\ud835\udd08'),
			_Utils_Tuple2('efr', '\ud835\udd22'),
			_Utils_Tuple2('eg', '⪚'),
			_Utils_Tuple2('Egrave', 'È'),
			_Utils_Tuple2('egrave', 'è'),
			_Utils_Tuple2('egs', '⪖'),
			_Utils_Tuple2('egsdot', '⪘'),
			_Utils_Tuple2('el', '⪙'),
			_Utils_Tuple2('Element', '∈'),
			_Utils_Tuple2('elinters', '⏧'),
			_Utils_Tuple2('ell', 'ℓ'),
			_Utils_Tuple2('els', '⪕'),
			_Utils_Tuple2('elsdot', '⪗'),
			_Utils_Tuple2('Emacr', 'Ē'),
			_Utils_Tuple2('emacr', 'ē'),
			_Utils_Tuple2('empty', '∅'),
			_Utils_Tuple2('emptyset', '∅'),
			_Utils_Tuple2('EmptySmallSquare', '◻'),
			_Utils_Tuple2('emptyv', '∅'),
			_Utils_Tuple2('EmptyVerySmallSquare', '▫'),
			_Utils_Tuple2('emsp13', '\u2004'),
			_Utils_Tuple2('emsp14', '\u2005'),
			_Utils_Tuple2('emsp', '\u2003'),
			_Utils_Tuple2('ENG', 'Ŋ'),
			_Utils_Tuple2('eng', 'ŋ'),
			_Utils_Tuple2('ensp', '\u2002'),
			_Utils_Tuple2('Eogon', 'Ę'),
			_Utils_Tuple2('eogon', 'ę'),
			_Utils_Tuple2('Eopf', '\ud835\udd3c'),
			_Utils_Tuple2('eopf', '\ud835\udd56'),
			_Utils_Tuple2('epar', '⋕'),
			_Utils_Tuple2('eparsl', '⧣'),
			_Utils_Tuple2('eplus', '⩱'),
			_Utils_Tuple2('epsi', 'ε'),
			_Utils_Tuple2('Epsilon', 'Ε'),
			_Utils_Tuple2('epsilon', 'ε'),
			_Utils_Tuple2('epsiv', 'ϵ'),
			_Utils_Tuple2('eqcirc', '≖'),
			_Utils_Tuple2('eqcolon', '≕'),
			_Utils_Tuple2('eqsim', '≂'),
			_Utils_Tuple2('eqslantgtr', '⪖'),
			_Utils_Tuple2('eqslantless', '⪕'),
			_Utils_Tuple2('Equal', '⩵'),
			_Utils_Tuple2('equals', '='),
			_Utils_Tuple2('EqualTilde', '≂'),
			_Utils_Tuple2('equest', '≟'),
			_Utils_Tuple2('Equilibrium', '⇌'),
			_Utils_Tuple2('equiv', '≡'),
			_Utils_Tuple2('equivDD', '⩸'),
			_Utils_Tuple2('eqvparsl', '⧥'),
			_Utils_Tuple2('erarr', '⥱'),
			_Utils_Tuple2('erDot', '≓'),
			_Utils_Tuple2('escr', 'ℯ'),
			_Utils_Tuple2('Escr', 'ℰ'),
			_Utils_Tuple2('esdot', '≐'),
			_Utils_Tuple2('Esim', '⩳'),
			_Utils_Tuple2('esim', '≂'),
			_Utils_Tuple2('Eta', 'Η'),
			_Utils_Tuple2('eta', 'η'),
			_Utils_Tuple2('ETH', 'Ð'),
			_Utils_Tuple2('eth', 'ð'),
			_Utils_Tuple2('Euml', 'Ë'),
			_Utils_Tuple2('euml', 'ë'),
			_Utils_Tuple2('euro', '€'),
			_Utils_Tuple2('excl', '!'),
			_Utils_Tuple2('exist', '∃'),
			_Utils_Tuple2('Exists', '∃'),
			_Utils_Tuple2('expectation', 'ℰ'),
			_Utils_Tuple2('exponentiale', 'ⅇ'),
			_Utils_Tuple2('ExponentialE', 'ⅇ'),
			_Utils_Tuple2('fallingdotseq', '≒'),
			_Utils_Tuple2('Fcy', 'Ф'),
			_Utils_Tuple2('fcy', 'ф'),
			_Utils_Tuple2('female', '♀'),
			_Utils_Tuple2('ffilig', 'ﬃ'),
			_Utils_Tuple2('fflig', 'ﬀ'),
			_Utils_Tuple2('ffllig', 'ﬄ'),
			_Utils_Tuple2('Ffr', '\ud835\udd09'),
			_Utils_Tuple2('ffr', '\ud835\udd23'),
			_Utils_Tuple2('filig', 'ﬁ'),
			_Utils_Tuple2('FilledSmallSquare', '◼'),
			_Utils_Tuple2('FilledVerySmallSquare', '▪'),
			_Utils_Tuple2('fjlig', 'fj'),
			_Utils_Tuple2('flat', '♭'),
			_Utils_Tuple2('fllig', 'ﬂ'),
			_Utils_Tuple2('fltns', '▱'),
			_Utils_Tuple2('fnof', 'ƒ'),
			_Utils_Tuple2('Fopf', '\ud835\udd3d'),
			_Utils_Tuple2('fopf', '\ud835\udd57'),
			_Utils_Tuple2('forall', '∀'),
			_Utils_Tuple2('ForAll', '∀'),
			_Utils_Tuple2('fork', '⋔'),
			_Utils_Tuple2('forkv', '⫙'),
			_Utils_Tuple2('Fouriertrf', 'ℱ'),
			_Utils_Tuple2('fpartint', '⨍'),
			_Utils_Tuple2('frac12', '½'),
			_Utils_Tuple2('frac13', '⅓'),
			_Utils_Tuple2('frac14', '¼'),
			_Utils_Tuple2('frac15', '⅕'),
			_Utils_Tuple2('frac16', '⅙'),
			_Utils_Tuple2('frac18', '⅛'),
			_Utils_Tuple2('frac23', '⅔'),
			_Utils_Tuple2('frac25', '⅖'),
			_Utils_Tuple2('frac34', '¾'),
			_Utils_Tuple2('frac35', '⅗'),
			_Utils_Tuple2('frac38', '⅜'),
			_Utils_Tuple2('frac45', '⅘'),
			_Utils_Tuple2('frac56', '⅚'),
			_Utils_Tuple2('frac58', '⅝'),
			_Utils_Tuple2('frac78', '⅞'),
			_Utils_Tuple2('frasl', '⁄'),
			_Utils_Tuple2('frown', '⌢'),
			_Utils_Tuple2('fscr', '\ud835\udcbb'),
			_Utils_Tuple2('Fscr', 'ℱ'),
			_Utils_Tuple2('gacute', 'ǵ'),
			_Utils_Tuple2('Gamma', 'Γ'),
			_Utils_Tuple2('gamma', 'γ'),
			_Utils_Tuple2('Gammad', 'Ϝ'),
			_Utils_Tuple2('gammad', 'ϝ'),
			_Utils_Tuple2('gap', '⪆'),
			_Utils_Tuple2('Gbreve', 'Ğ'),
			_Utils_Tuple2('gbreve', 'ğ'),
			_Utils_Tuple2('Gcedil', 'Ģ'),
			_Utils_Tuple2('Gcirc', 'Ĝ'),
			_Utils_Tuple2('gcirc', 'ĝ'),
			_Utils_Tuple2('Gcy', 'Г'),
			_Utils_Tuple2('gcy', 'г'),
			_Utils_Tuple2('Gdot', 'Ġ'),
			_Utils_Tuple2('gdot', 'ġ'),
			_Utils_Tuple2('ge', '≥'),
			_Utils_Tuple2('gE', '≧'),
			_Utils_Tuple2('gEl', '⪌'),
			_Utils_Tuple2('gel', '⋛'),
			_Utils_Tuple2('geq', '≥'),
			_Utils_Tuple2('geqq', '≧'),
			_Utils_Tuple2('geqslant', '⩾'),
			_Utils_Tuple2('gescc', '⪩'),
			_Utils_Tuple2('ges', '⩾'),
			_Utils_Tuple2('gesdot', '⪀'),
			_Utils_Tuple2('gesdoto', '⪂'),
			_Utils_Tuple2('gesdotol', '⪄'),
			_Utils_Tuple2('gesl', '⋛︀'),
			_Utils_Tuple2('gesles', '⪔'),
			_Utils_Tuple2('Gfr', '\ud835\udd0a'),
			_Utils_Tuple2('gfr', '\ud835\udd24'),
			_Utils_Tuple2('gg', '≫'),
			_Utils_Tuple2('Gg', '⋙'),
			_Utils_Tuple2('ggg', '⋙'),
			_Utils_Tuple2('gimel', 'ℷ'),
			_Utils_Tuple2('GJcy', 'Ѓ'),
			_Utils_Tuple2('gjcy', 'ѓ'),
			_Utils_Tuple2('gla', '⪥'),
			_Utils_Tuple2('gl', '≷'),
			_Utils_Tuple2('glE', '⪒'),
			_Utils_Tuple2('glj', '⪤'),
			_Utils_Tuple2('gnap', '⪊'),
			_Utils_Tuple2('gnapprox', '⪊'),
			_Utils_Tuple2('gne', '⪈'),
			_Utils_Tuple2('gnE', '≩'),
			_Utils_Tuple2('gneq', '⪈'),
			_Utils_Tuple2('gneqq', '≩'),
			_Utils_Tuple2('gnsim', '⋧'),
			_Utils_Tuple2('Gopf', '\ud835\udd3e'),
			_Utils_Tuple2('gopf', '\ud835\udd58'),
			_Utils_Tuple2('grave', '`'),
			_Utils_Tuple2('GreaterEqual', '≥'),
			_Utils_Tuple2('GreaterEqualLess', '⋛'),
			_Utils_Tuple2('GreaterFullEqual', '≧'),
			_Utils_Tuple2('GreaterGreater', '⪢'),
			_Utils_Tuple2('GreaterLess', '≷'),
			_Utils_Tuple2('GreaterSlantEqual', '⩾'),
			_Utils_Tuple2('GreaterTilde', '≳'),
			_Utils_Tuple2('Gscr', '\ud835\udca2'),
			_Utils_Tuple2('gscr', 'ℊ'),
			_Utils_Tuple2('gsim', '≳'),
			_Utils_Tuple2('gsime', '⪎'),
			_Utils_Tuple2('gsiml', '⪐'),
			_Utils_Tuple2('gtcc', '⪧'),
			_Utils_Tuple2('gtcir', '⩺'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('GT', '>'),
			_Utils_Tuple2('Gt', '≫'),
			_Utils_Tuple2('gtdot', '⋗'),
			_Utils_Tuple2('gtlPar', '⦕'),
			_Utils_Tuple2('gtquest', '⩼'),
			_Utils_Tuple2('gtrapprox', '⪆'),
			_Utils_Tuple2('gtrarr', '⥸'),
			_Utils_Tuple2('gtrdot', '⋗'),
			_Utils_Tuple2('gtreqless', '⋛'),
			_Utils_Tuple2('gtreqqless', '⪌'),
			_Utils_Tuple2('gtrless', '≷'),
			_Utils_Tuple2('gtrsim', '≳'),
			_Utils_Tuple2('gvertneqq', '≩︀'),
			_Utils_Tuple2('gvnE', '≩︀'),
			_Utils_Tuple2('Hacek', 'ˇ'),
			_Utils_Tuple2('hairsp', '\u200a'),
			_Utils_Tuple2('half', '½'),
			_Utils_Tuple2('hamilt', 'ℋ'),
			_Utils_Tuple2('HARDcy', 'Ъ'),
			_Utils_Tuple2('hardcy', 'ъ'),
			_Utils_Tuple2('harrcir', '⥈'),
			_Utils_Tuple2('harr', '↔'),
			_Utils_Tuple2('hArr', '⇔'),
			_Utils_Tuple2('harrw', '↭'),
			_Utils_Tuple2('Hat', '^'),
			_Utils_Tuple2('hbar', 'ℏ'),
			_Utils_Tuple2('Hcirc', 'Ĥ'),
			_Utils_Tuple2('hcirc', 'ĥ'),
			_Utils_Tuple2('hearts', '♥'),
			_Utils_Tuple2('heartsuit', '♥'),
			_Utils_Tuple2('hellip', '…'),
			_Utils_Tuple2('hercon', '⊹'),
			_Utils_Tuple2('hfr', '\ud835\udd25'),
			_Utils_Tuple2('Hfr', 'ℌ'),
			_Utils_Tuple2('HilbertSpace', 'ℋ'),
			_Utils_Tuple2('hksearow', '⤥'),
			_Utils_Tuple2('hkswarow', '⤦'),
			_Utils_Tuple2('hoarr', '⇿'),
			_Utils_Tuple2('homtht', '∻'),
			_Utils_Tuple2('hookleftarrow', '↩'),
			_Utils_Tuple2('hookrightarrow', '↪'),
			_Utils_Tuple2('hopf', '\ud835\udd59'),
			_Utils_Tuple2('Hopf', 'ℍ'),
			_Utils_Tuple2('horbar', '―'),
			_Utils_Tuple2('HorizontalLine', '─'),
			_Utils_Tuple2('hscr', '\ud835\udcbd'),
			_Utils_Tuple2('Hscr', 'ℋ'),
			_Utils_Tuple2('hslash', 'ℏ'),
			_Utils_Tuple2('Hstrok', 'Ħ'),
			_Utils_Tuple2('hstrok', 'ħ'),
			_Utils_Tuple2('HumpDownHump', '≎'),
			_Utils_Tuple2('HumpEqual', '≏'),
			_Utils_Tuple2('hybull', '⁃'),
			_Utils_Tuple2('hyphen', '‐'),
			_Utils_Tuple2('Iacute', 'Í'),
			_Utils_Tuple2('iacute', 'í'),
			_Utils_Tuple2('ic', '\u2063'),
			_Utils_Tuple2('Icirc', 'Î'),
			_Utils_Tuple2('icirc', 'î'),
			_Utils_Tuple2('Icy', 'И'),
			_Utils_Tuple2('icy', 'и'),
			_Utils_Tuple2('Idot', 'İ'),
			_Utils_Tuple2('IEcy', 'Е'),
			_Utils_Tuple2('iecy', 'е'),
			_Utils_Tuple2('iexcl', '¡'),
			_Utils_Tuple2('iff', '⇔'),
			_Utils_Tuple2('ifr', '\ud835\udd26'),
			_Utils_Tuple2('Ifr', 'ℑ'),
			_Utils_Tuple2('Igrave', 'Ì'),
			_Utils_Tuple2('igrave', 'ì'),
			_Utils_Tuple2('ii', 'ⅈ'),
			_Utils_Tuple2('iiiint', '⨌'),
			_Utils_Tuple2('iiint', '∭'),
			_Utils_Tuple2('iinfin', '⧜'),
			_Utils_Tuple2('iiota', '℩'),
			_Utils_Tuple2('IJlig', 'Ĳ'),
			_Utils_Tuple2('ijlig', 'ĳ'),
			_Utils_Tuple2('Imacr', 'Ī'),
			_Utils_Tuple2('imacr', 'ī'),
			_Utils_Tuple2('image', 'ℑ'),
			_Utils_Tuple2('ImaginaryI', 'ⅈ'),
			_Utils_Tuple2('imagline', 'ℐ'),
			_Utils_Tuple2('imagpart', 'ℑ'),
			_Utils_Tuple2('imath', 'ı'),
			_Utils_Tuple2('Im', 'ℑ'),
			_Utils_Tuple2('imof', '⊷'),
			_Utils_Tuple2('imped', 'Ƶ'),
			_Utils_Tuple2('Implies', '⇒'),
			_Utils_Tuple2('incare', '℅'),
			_Utils_Tuple2('in', '∈'),
			_Utils_Tuple2('infin', '∞'),
			_Utils_Tuple2('infintie', '⧝'),
			_Utils_Tuple2('inodot', 'ı'),
			_Utils_Tuple2('intcal', '⊺'),
			_Utils_Tuple2('int', '∫'),
			_Utils_Tuple2('Int', '∬'),
			_Utils_Tuple2('integers', 'ℤ'),
			_Utils_Tuple2('Integral', '∫'),
			_Utils_Tuple2('intercal', '⊺'),
			_Utils_Tuple2('Intersection', '⋂'),
			_Utils_Tuple2('intlarhk', '⨗'),
			_Utils_Tuple2('intprod', '⨼'),
			_Utils_Tuple2('InvisibleComma', '\u2063'),
			_Utils_Tuple2('InvisibleTimes', '\u2062'),
			_Utils_Tuple2('IOcy', 'Ё'),
			_Utils_Tuple2('iocy', 'ё'),
			_Utils_Tuple2('Iogon', 'Į'),
			_Utils_Tuple2('iogon', 'į'),
			_Utils_Tuple2('Iopf', '\ud835\udd40'),
			_Utils_Tuple2('iopf', '\ud835\udd5a'),
			_Utils_Tuple2('Iota', 'Ι'),
			_Utils_Tuple2('iota', 'ι'),
			_Utils_Tuple2('iprod', '⨼'),
			_Utils_Tuple2('iquest', '¿'),
			_Utils_Tuple2('iscr', '\ud835\udcbe'),
			_Utils_Tuple2('Iscr', 'ℐ'),
			_Utils_Tuple2('isin', '∈'),
			_Utils_Tuple2('isindot', '⋵'),
			_Utils_Tuple2('isinE', '⋹'),
			_Utils_Tuple2('isins', '⋴'),
			_Utils_Tuple2('isinsv', '⋳'),
			_Utils_Tuple2('isinv', '∈'),
			_Utils_Tuple2('it', '\u2062'),
			_Utils_Tuple2('Itilde', 'Ĩ'),
			_Utils_Tuple2('itilde', 'ĩ'),
			_Utils_Tuple2('Iukcy', 'І'),
			_Utils_Tuple2('iukcy', 'і'),
			_Utils_Tuple2('Iuml', 'Ï'),
			_Utils_Tuple2('iuml', 'ï'),
			_Utils_Tuple2('Jcirc', 'Ĵ'),
			_Utils_Tuple2('jcirc', 'ĵ'),
			_Utils_Tuple2('Jcy', 'Й'),
			_Utils_Tuple2('jcy', 'й'),
			_Utils_Tuple2('Jfr', '\ud835\udd0d'),
			_Utils_Tuple2('jfr', '\ud835\udd27'),
			_Utils_Tuple2('jmath', 'ȷ'),
			_Utils_Tuple2('Jopf', '\ud835\udd41'),
			_Utils_Tuple2('jopf', '\ud835\udd5b'),
			_Utils_Tuple2('Jscr', '\ud835\udca5'),
			_Utils_Tuple2('jscr', '\ud835\udcbf'),
			_Utils_Tuple2('Jsercy', 'Ј'),
			_Utils_Tuple2('jsercy', 'ј'),
			_Utils_Tuple2('Jukcy', 'Є'),
			_Utils_Tuple2('jukcy', 'є'),
			_Utils_Tuple2('Kappa', 'Κ'),
			_Utils_Tuple2('kappa', 'κ'),
			_Utils_Tuple2('kappav', 'ϰ'),
			_Utils_Tuple2('Kcedil', 'Ķ'),
			_Utils_Tuple2('kcedil', 'ķ'),
			_Utils_Tuple2('Kcy', 'К'),
			_Utils_Tuple2('kcy', 'к'),
			_Utils_Tuple2('Kfr', '\ud835\udd0e'),
			_Utils_Tuple2('kfr', '\ud835\udd28'),
			_Utils_Tuple2('kgreen', 'ĸ'),
			_Utils_Tuple2('KHcy', 'Х'),
			_Utils_Tuple2('khcy', 'х'),
			_Utils_Tuple2('KJcy', 'Ќ'),
			_Utils_Tuple2('kjcy', 'ќ'),
			_Utils_Tuple2('Kopf', '\ud835\udd42'),
			_Utils_Tuple2('kopf', '\ud835\udd5c'),
			_Utils_Tuple2('Kscr', '\ud835\udca6'),
			_Utils_Tuple2('kscr', '\ud835\udcc0'),
			_Utils_Tuple2('lAarr', '⇚'),
			_Utils_Tuple2('Lacute', 'Ĺ'),
			_Utils_Tuple2('lacute', 'ĺ'),
			_Utils_Tuple2('laemptyv', '⦴'),
			_Utils_Tuple2('lagran', 'ℒ'),
			_Utils_Tuple2('Lambda', 'Λ'),
			_Utils_Tuple2('lambda', 'λ'),
			_Utils_Tuple2('lang', '⟨'),
			_Utils_Tuple2('Lang', '⟪'),
			_Utils_Tuple2('langd', '⦑'),
			_Utils_Tuple2('langle', '⟨'),
			_Utils_Tuple2('lap', '⪅'),
			_Utils_Tuple2('Laplacetrf', 'ℒ'),
			_Utils_Tuple2('laquo', '«'),
			_Utils_Tuple2('larrb', '⇤'),
			_Utils_Tuple2('larrbfs', '⤟'),
			_Utils_Tuple2('larr', '←'),
			_Utils_Tuple2('Larr', '↞'),
			_Utils_Tuple2('lArr', '⇐'),
			_Utils_Tuple2('larrfs', '⤝'),
			_Utils_Tuple2('larrhk', '↩'),
			_Utils_Tuple2('larrlp', '↫'),
			_Utils_Tuple2('larrpl', '⤹'),
			_Utils_Tuple2('larrsim', '⥳'),
			_Utils_Tuple2('larrtl', '↢'),
			_Utils_Tuple2('latail', '⤙'),
			_Utils_Tuple2('lAtail', '⤛'),
			_Utils_Tuple2('lat', '⪫'),
			_Utils_Tuple2('late', '⪭'),
			_Utils_Tuple2('lates', '⪭︀'),
			_Utils_Tuple2('lbarr', '⤌'),
			_Utils_Tuple2('lBarr', '⤎'),
			_Utils_Tuple2('lbbrk', '❲'),
			_Utils_Tuple2('lbrace', '{'),
			_Utils_Tuple2('lbrack', '['),
			_Utils_Tuple2('lbrke', '⦋'),
			_Utils_Tuple2('lbrksld', '⦏'),
			_Utils_Tuple2('lbrkslu', '⦍'),
			_Utils_Tuple2('Lcaron', 'Ľ'),
			_Utils_Tuple2('lcaron', 'ľ'),
			_Utils_Tuple2('Lcedil', 'Ļ'),
			_Utils_Tuple2('lcedil', 'ļ'),
			_Utils_Tuple2('lceil', '⌈'),
			_Utils_Tuple2('lcub', '{'),
			_Utils_Tuple2('Lcy', 'Л'),
			_Utils_Tuple2('lcy', 'л'),
			_Utils_Tuple2('ldca', '⤶'),
			_Utils_Tuple2('ldquo', '“'),
			_Utils_Tuple2('ldquor', '„'),
			_Utils_Tuple2('ldrdhar', '⥧'),
			_Utils_Tuple2('ldrushar', '⥋'),
			_Utils_Tuple2('ldsh', '↲'),
			_Utils_Tuple2('le', '≤'),
			_Utils_Tuple2('lE', '≦'),
			_Utils_Tuple2('LeftAngleBracket', '⟨'),
			_Utils_Tuple2('LeftArrowBar', '⇤'),
			_Utils_Tuple2('leftarrow', '←'),
			_Utils_Tuple2('LeftArrow', '←'),
			_Utils_Tuple2('Leftarrow', '⇐'),
			_Utils_Tuple2('LeftArrowRightArrow', '⇆'),
			_Utils_Tuple2('leftarrowtail', '↢'),
			_Utils_Tuple2('LeftCeiling', '⌈'),
			_Utils_Tuple2('LeftDoubleBracket', '⟦'),
			_Utils_Tuple2('LeftDownTeeVector', '⥡'),
			_Utils_Tuple2('LeftDownVectorBar', '⥙'),
			_Utils_Tuple2('LeftDownVector', '⇃'),
			_Utils_Tuple2('LeftFloor', '⌊'),
			_Utils_Tuple2('leftharpoondown', '↽'),
			_Utils_Tuple2('leftharpoonup', '↼'),
			_Utils_Tuple2('leftleftarrows', '⇇'),
			_Utils_Tuple2('leftrightarrow', '↔'),
			_Utils_Tuple2('LeftRightArrow', '↔'),
			_Utils_Tuple2('Leftrightarrow', '⇔'),
			_Utils_Tuple2('leftrightarrows', '⇆'),
			_Utils_Tuple2('leftrightharpoons', '⇋'),
			_Utils_Tuple2('leftrightsquigarrow', '↭'),
			_Utils_Tuple2('LeftRightVector', '⥎'),
			_Utils_Tuple2('LeftTeeArrow', '↤'),
			_Utils_Tuple2('LeftTee', '⊣'),
			_Utils_Tuple2('LeftTeeVector', '⥚'),
			_Utils_Tuple2('leftthreetimes', '⋋'),
			_Utils_Tuple2('LeftTriangleBar', '⧏'),
			_Utils_Tuple2('LeftTriangle', '⊲'),
			_Utils_Tuple2('LeftTriangleEqual', '⊴'),
			_Utils_Tuple2('LeftUpDownVector', '⥑'),
			_Utils_Tuple2('LeftUpTeeVector', '⥠'),
			_Utils_Tuple2('LeftUpVectorBar', '⥘'),
			_Utils_Tuple2('LeftUpVector', '↿'),
			_Utils_Tuple2('LeftVectorBar', '⥒'),
			_Utils_Tuple2('LeftVector', '↼'),
			_Utils_Tuple2('lEg', '⪋'),
			_Utils_Tuple2('leg', '⋚'),
			_Utils_Tuple2('leq', '≤'),
			_Utils_Tuple2('leqq', '≦'),
			_Utils_Tuple2('leqslant', '⩽'),
			_Utils_Tuple2('lescc', '⪨'),
			_Utils_Tuple2('les', '⩽'),
			_Utils_Tuple2('lesdot', '⩿'),
			_Utils_Tuple2('lesdoto', '⪁'),
			_Utils_Tuple2('lesdotor', '⪃'),
			_Utils_Tuple2('lesg', '⋚︀'),
			_Utils_Tuple2('lesges', '⪓'),
			_Utils_Tuple2('lessapprox', '⪅'),
			_Utils_Tuple2('lessdot', '⋖'),
			_Utils_Tuple2('lesseqgtr', '⋚'),
			_Utils_Tuple2('lesseqqgtr', '⪋'),
			_Utils_Tuple2('LessEqualGreater', '⋚'),
			_Utils_Tuple2('LessFullEqual', '≦'),
			_Utils_Tuple2('LessGreater', '≶'),
			_Utils_Tuple2('lessgtr', '≶'),
			_Utils_Tuple2('LessLess', '⪡'),
			_Utils_Tuple2('lesssim', '≲'),
			_Utils_Tuple2('LessSlantEqual', '⩽'),
			_Utils_Tuple2('LessTilde', '≲'),
			_Utils_Tuple2('lfisht', '⥼'),
			_Utils_Tuple2('lfloor', '⌊'),
			_Utils_Tuple2('Lfr', '\ud835\udd0f'),
			_Utils_Tuple2('lfr', '\ud835\udd29'),
			_Utils_Tuple2('lg', '≶'),
			_Utils_Tuple2('lgE', '⪑'),
			_Utils_Tuple2('lHar', '⥢'),
			_Utils_Tuple2('lhard', '↽'),
			_Utils_Tuple2('lharu', '↼'),
			_Utils_Tuple2('lharul', '⥪'),
			_Utils_Tuple2('lhblk', '▄'),
			_Utils_Tuple2('LJcy', 'Љ'),
			_Utils_Tuple2('ljcy', 'љ'),
			_Utils_Tuple2('llarr', '⇇'),
			_Utils_Tuple2('ll', '≪'),
			_Utils_Tuple2('Ll', '⋘'),
			_Utils_Tuple2('llcorner', '⌞'),
			_Utils_Tuple2('Lleftarrow', '⇚'),
			_Utils_Tuple2('llhard', '⥫'),
			_Utils_Tuple2('lltri', '◺'),
			_Utils_Tuple2('Lmidot', 'Ŀ'),
			_Utils_Tuple2('lmidot', 'ŀ'),
			_Utils_Tuple2('lmoustache', '⎰'),
			_Utils_Tuple2('lmoust', '⎰'),
			_Utils_Tuple2('lnap', '⪉'),
			_Utils_Tuple2('lnapprox', '⪉'),
			_Utils_Tuple2('lne', '⪇'),
			_Utils_Tuple2('lnE', '≨'),
			_Utils_Tuple2('lneq', '⪇'),
			_Utils_Tuple2('lneqq', '≨'),
			_Utils_Tuple2('lnsim', '⋦'),
			_Utils_Tuple2('loang', '⟬'),
			_Utils_Tuple2('loarr', '⇽'),
			_Utils_Tuple2('lobrk', '⟦'),
			_Utils_Tuple2('longleftarrow', '⟵'),
			_Utils_Tuple2('LongLeftArrow', '⟵'),
			_Utils_Tuple2('Longleftarrow', '⟸'),
			_Utils_Tuple2('longleftrightarrow', '⟷'),
			_Utils_Tuple2('LongLeftRightArrow', '⟷'),
			_Utils_Tuple2('Longleftrightarrow', '⟺'),
			_Utils_Tuple2('longmapsto', '⟼'),
			_Utils_Tuple2('longrightarrow', '⟶'),
			_Utils_Tuple2('LongRightArrow', '⟶'),
			_Utils_Tuple2('Longrightarrow', '⟹'),
			_Utils_Tuple2('looparrowleft', '↫'),
			_Utils_Tuple2('looparrowright', '↬'),
			_Utils_Tuple2('lopar', '⦅'),
			_Utils_Tuple2('Lopf', '\ud835\udd43'),
			_Utils_Tuple2('lopf', '\ud835\udd5d'),
			_Utils_Tuple2('loplus', '⨭'),
			_Utils_Tuple2('lotimes', '⨴'),
			_Utils_Tuple2('lowast', '∗'),
			_Utils_Tuple2('lowbar', '_'),
			_Utils_Tuple2('LowerLeftArrow', '↙'),
			_Utils_Tuple2('LowerRightArrow', '↘'),
			_Utils_Tuple2('loz', '◊'),
			_Utils_Tuple2('lozenge', '◊'),
			_Utils_Tuple2('lozf', '⧫'),
			_Utils_Tuple2('lpar', '('),
			_Utils_Tuple2('lparlt', '⦓'),
			_Utils_Tuple2('lrarr', '⇆'),
			_Utils_Tuple2('lrcorner', '⌟'),
			_Utils_Tuple2('lrhar', '⇋'),
			_Utils_Tuple2('lrhard', '⥭'),
			_Utils_Tuple2('lrm', '\u200e'),
			_Utils_Tuple2('lrtri', '⊿'),
			_Utils_Tuple2('lsaquo', '‹'),
			_Utils_Tuple2('lscr', '\ud835\udcc1'),
			_Utils_Tuple2('Lscr', 'ℒ'),
			_Utils_Tuple2('lsh', '↰'),
			_Utils_Tuple2('Lsh', '↰'),
			_Utils_Tuple2('lsim', '≲'),
			_Utils_Tuple2('lsime', '⪍'),
			_Utils_Tuple2('lsimg', '⪏'),
			_Utils_Tuple2('lsqb', '['),
			_Utils_Tuple2('lsquo', '‘'),
			_Utils_Tuple2('lsquor', '‚'),
			_Utils_Tuple2('Lstrok', 'Ł'),
			_Utils_Tuple2('lstrok', 'ł'),
			_Utils_Tuple2('ltcc', '⪦'),
			_Utils_Tuple2('ltcir', '⩹'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('LT', '<'),
			_Utils_Tuple2('Lt', '≪'),
			_Utils_Tuple2('ltdot', '⋖'),
			_Utils_Tuple2('lthree', '⋋'),
			_Utils_Tuple2('ltimes', '⋉'),
			_Utils_Tuple2('ltlarr', '⥶'),
			_Utils_Tuple2('ltquest', '⩻'),
			_Utils_Tuple2('ltri', '◃'),
			_Utils_Tuple2('ltrie', '⊴'),
			_Utils_Tuple2('ltrif', '◂'),
			_Utils_Tuple2('ltrPar', '⦖'),
			_Utils_Tuple2('lurdshar', '⥊'),
			_Utils_Tuple2('luruhar', '⥦'),
			_Utils_Tuple2('lvertneqq', '≨︀'),
			_Utils_Tuple2('lvnE', '≨︀'),
			_Utils_Tuple2('macr', '¯'),
			_Utils_Tuple2('male', '♂'),
			_Utils_Tuple2('malt', '✠'),
			_Utils_Tuple2('maltese', '✠'),
			_Utils_Tuple2('Map', '⤅'),
			_Utils_Tuple2('map', '↦'),
			_Utils_Tuple2('mapsto', '↦'),
			_Utils_Tuple2('mapstodown', '↧'),
			_Utils_Tuple2('mapstoleft', '↤'),
			_Utils_Tuple2('mapstoup', '↥'),
			_Utils_Tuple2('marker', '▮'),
			_Utils_Tuple2('mcomma', '⨩'),
			_Utils_Tuple2('Mcy', 'М'),
			_Utils_Tuple2('mcy', 'м'),
			_Utils_Tuple2('mdash', '—'),
			_Utils_Tuple2('mDDot', '∺'),
			_Utils_Tuple2('measuredangle', '∡'),
			_Utils_Tuple2('MediumSpace', '\u205f'),
			_Utils_Tuple2('Mellintrf', 'ℳ'),
			_Utils_Tuple2('Mfr', '\ud835\udd10'),
			_Utils_Tuple2('mfr', '\ud835\udd2a'),
			_Utils_Tuple2('mho', '℧'),
			_Utils_Tuple2('micro', 'µ'),
			_Utils_Tuple2('midast', '*'),
			_Utils_Tuple2('midcir', '⫰'),
			_Utils_Tuple2('mid', '∣'),
			_Utils_Tuple2('middot', '·'),
			_Utils_Tuple2('minusb', '⊟'),
			_Utils_Tuple2('minus', '−'),
			_Utils_Tuple2('minusd', '∸'),
			_Utils_Tuple2('minusdu', '⨪'),
			_Utils_Tuple2('MinusPlus', '∓'),
			_Utils_Tuple2('mlcp', '⫛'),
			_Utils_Tuple2('mldr', '…'),
			_Utils_Tuple2('mnplus', '∓'),
			_Utils_Tuple2('models', '⊧'),
			_Utils_Tuple2('Mopf', '\ud835\udd44'),
			_Utils_Tuple2('mopf', '\ud835\udd5e'),
			_Utils_Tuple2('mp', '∓'),
			_Utils_Tuple2('mscr', '\ud835\udcc2'),
			_Utils_Tuple2('Mscr', 'ℳ'),
			_Utils_Tuple2('mstpos', '∾'),
			_Utils_Tuple2('Mu', 'Μ'),
			_Utils_Tuple2('mu', 'μ'),
			_Utils_Tuple2('multimap', '⊸'),
			_Utils_Tuple2('mumap', '⊸'),
			_Utils_Tuple2('nabla', '∇'),
			_Utils_Tuple2('Nacute', 'Ń'),
			_Utils_Tuple2('nacute', 'ń'),
			_Utils_Tuple2('nang', '∠⃒'),
			_Utils_Tuple2('nap', '≉'),
			_Utils_Tuple2('napE', '⩰̸'),
			_Utils_Tuple2('napid', '≋̸'),
			_Utils_Tuple2('napos', 'ŉ'),
			_Utils_Tuple2('napprox', '≉'),
			_Utils_Tuple2('natural', '♮'),
			_Utils_Tuple2('naturals', 'ℕ'),
			_Utils_Tuple2('natur', '♮'),
			_Utils_Tuple2('nbsp', '\u00a0'),
			_Utils_Tuple2('nbump', '≎̸'),
			_Utils_Tuple2('nbumpe', '≏̸'),
			_Utils_Tuple2('ncap', '⩃'),
			_Utils_Tuple2('Ncaron', 'Ň'),
			_Utils_Tuple2('ncaron', 'ň'),
			_Utils_Tuple2('Ncedil', 'Ņ'),
			_Utils_Tuple2('ncedil', 'ņ'),
			_Utils_Tuple2('ncong', '≇'),
			_Utils_Tuple2('ncongdot', '⩭̸'),
			_Utils_Tuple2('ncup', '⩂'),
			_Utils_Tuple2('Ncy', 'Н'),
			_Utils_Tuple2('ncy', 'н'),
			_Utils_Tuple2('ndash', '–'),
			_Utils_Tuple2('nearhk', '⤤'),
			_Utils_Tuple2('nearr', '↗'),
			_Utils_Tuple2('neArr', '⇗'),
			_Utils_Tuple2('nearrow', '↗'),
			_Utils_Tuple2('ne', '≠'),
			_Utils_Tuple2('nedot', '≐̸'),
			_Utils_Tuple2('NegativeMediumSpace', '\u200b'),
			_Utils_Tuple2('NegativeThickSpace', '\u200b'),
			_Utils_Tuple2('NegativeThinSpace', '\u200b'),
			_Utils_Tuple2('NegativeVeryThinSpace', '\u200b'),
			_Utils_Tuple2('nequiv', '≢'),
			_Utils_Tuple2('nesear', '⤨'),
			_Utils_Tuple2('nesim', '≂̸'),
			_Utils_Tuple2('NestedGreaterGreater', '≫'),
			_Utils_Tuple2('NestedLessLess', '≪'),
			_Utils_Tuple2('NewLine', '\n'),
			_Utils_Tuple2('nexist', '∄'),
			_Utils_Tuple2('nexists', '∄'),
			_Utils_Tuple2('Nfr', '\ud835\udd11'),
			_Utils_Tuple2('nfr', '\ud835\udd2b'),
			_Utils_Tuple2('ngE', '≧̸'),
			_Utils_Tuple2('nge', '≱'),
			_Utils_Tuple2('ngeq', '≱'),
			_Utils_Tuple2('ngeqq', '≧̸'),
			_Utils_Tuple2('ngeqslant', '⩾̸'),
			_Utils_Tuple2('nges', '⩾̸'),
			_Utils_Tuple2('nGg', '⋙̸'),
			_Utils_Tuple2('ngsim', '≵'),
			_Utils_Tuple2('nGt', '≫⃒'),
			_Utils_Tuple2('ngt', '≯'),
			_Utils_Tuple2('ngtr', '≯'),
			_Utils_Tuple2('nGtv', '≫̸'),
			_Utils_Tuple2('nharr', '↮'),
			_Utils_Tuple2('nhArr', '⇎'),
			_Utils_Tuple2('nhpar', '⫲'),
			_Utils_Tuple2('ni', '∋'),
			_Utils_Tuple2('nis', '⋼'),
			_Utils_Tuple2('nisd', '⋺'),
			_Utils_Tuple2('niv', '∋'),
			_Utils_Tuple2('NJcy', 'Њ'),
			_Utils_Tuple2('njcy', 'њ'),
			_Utils_Tuple2('nlarr', '↚'),
			_Utils_Tuple2('nlArr', '⇍'),
			_Utils_Tuple2('nldr', '‥'),
			_Utils_Tuple2('nlE', '≦̸'),
			_Utils_Tuple2('nle', '≰'),
			_Utils_Tuple2('nleftarrow', '↚'),
			_Utils_Tuple2('nLeftarrow', '⇍'),
			_Utils_Tuple2('nleftrightarrow', '↮'),
			_Utils_Tuple2('nLeftrightarrow', '⇎'),
			_Utils_Tuple2('nleq', '≰'),
			_Utils_Tuple2('nleqq', '≦̸'),
			_Utils_Tuple2('nleqslant', '⩽̸'),
			_Utils_Tuple2('nles', '⩽̸'),
			_Utils_Tuple2('nless', '≮'),
			_Utils_Tuple2('nLl', '⋘̸'),
			_Utils_Tuple2('nlsim', '≴'),
			_Utils_Tuple2('nLt', '≪⃒'),
			_Utils_Tuple2('nlt', '≮'),
			_Utils_Tuple2('nltri', '⋪'),
			_Utils_Tuple2('nltrie', '⋬'),
			_Utils_Tuple2('nLtv', '≪̸'),
			_Utils_Tuple2('nmid', '∤'),
			_Utils_Tuple2('NoBreak', '\u2060'),
			_Utils_Tuple2('NonBreakingSpace', '\u00a0'),
			_Utils_Tuple2('nopf', '\ud835\udd5f'),
			_Utils_Tuple2('Nopf', 'ℕ'),
			_Utils_Tuple2('Not', '⫬'),
			_Utils_Tuple2('not', '¬'),
			_Utils_Tuple2('NotCongruent', '≢'),
			_Utils_Tuple2('NotCupCap', '≭'),
			_Utils_Tuple2('NotDoubleVerticalBar', '∦'),
			_Utils_Tuple2('NotElement', '∉'),
			_Utils_Tuple2('NotEqual', '≠'),
			_Utils_Tuple2('NotEqualTilde', '≂̸'),
			_Utils_Tuple2('NotExists', '∄'),
			_Utils_Tuple2('NotGreater', '≯'),
			_Utils_Tuple2('NotGreaterEqual', '≱'),
			_Utils_Tuple2('NotGreaterFullEqual', '≧̸'),
			_Utils_Tuple2('NotGreaterGreater', '≫̸'),
			_Utils_Tuple2('NotGreaterLess', '≹'),
			_Utils_Tuple2('NotGreaterSlantEqual', '⩾̸'),
			_Utils_Tuple2('NotGreaterTilde', '≵'),
			_Utils_Tuple2('NotHumpDownHump', '≎̸'),
			_Utils_Tuple2('NotHumpEqual', '≏̸'),
			_Utils_Tuple2('notin', '∉'),
			_Utils_Tuple2('notindot', '⋵̸'),
			_Utils_Tuple2('notinE', '⋹̸'),
			_Utils_Tuple2('notinva', '∉'),
			_Utils_Tuple2('notinvb', '⋷'),
			_Utils_Tuple2('notinvc', '⋶'),
			_Utils_Tuple2('NotLeftTriangleBar', '⧏̸'),
			_Utils_Tuple2('NotLeftTriangle', '⋪'),
			_Utils_Tuple2('NotLeftTriangleEqual', '⋬'),
			_Utils_Tuple2('NotLess', '≮'),
			_Utils_Tuple2('NotLessEqual', '≰'),
			_Utils_Tuple2('NotLessGreater', '≸'),
			_Utils_Tuple2('NotLessLess', '≪̸'),
			_Utils_Tuple2('NotLessSlantEqual', '⩽̸'),
			_Utils_Tuple2('NotLessTilde', '≴'),
			_Utils_Tuple2('NotNestedGreaterGreater', '⪢̸'),
			_Utils_Tuple2('NotNestedLessLess', '⪡̸'),
			_Utils_Tuple2('notni', '∌'),
			_Utils_Tuple2('notniva', '∌'),
			_Utils_Tuple2('notnivb', '⋾'),
			_Utils_Tuple2('notnivc', '⋽'),
			_Utils_Tuple2('NotPrecedes', '⊀'),
			_Utils_Tuple2('NotPrecedesEqual', '⪯̸'),
			_Utils_Tuple2('NotPrecedesSlantEqual', '⋠'),
			_Utils_Tuple2('NotReverseElement', '∌'),
			_Utils_Tuple2('NotRightTriangleBar', '⧐̸'),
			_Utils_Tuple2('NotRightTriangle', '⋫'),
			_Utils_Tuple2('NotRightTriangleEqual', '⋭'),
			_Utils_Tuple2('NotSquareSubset', '⊏̸'),
			_Utils_Tuple2('NotSquareSubsetEqual', '⋢'),
			_Utils_Tuple2('NotSquareSuperset', '⊐̸'),
			_Utils_Tuple2('NotSquareSupersetEqual', '⋣'),
			_Utils_Tuple2('NotSubset', '⊂⃒'),
			_Utils_Tuple2('NotSubsetEqual', '⊈'),
			_Utils_Tuple2('NotSucceeds', '⊁'),
			_Utils_Tuple2('NotSucceedsEqual', '⪰̸'),
			_Utils_Tuple2('NotSucceedsSlantEqual', '⋡'),
			_Utils_Tuple2('NotSucceedsTilde', '≿̸'),
			_Utils_Tuple2('NotSuperset', '⊃⃒'),
			_Utils_Tuple2('NotSupersetEqual', '⊉'),
			_Utils_Tuple2('NotTilde', '≁'),
			_Utils_Tuple2('NotTildeEqual', '≄'),
			_Utils_Tuple2('NotTildeFullEqual', '≇'),
			_Utils_Tuple2('NotTildeTilde', '≉'),
			_Utils_Tuple2('NotVerticalBar', '∤'),
			_Utils_Tuple2('nparallel', '∦'),
			_Utils_Tuple2('npar', '∦'),
			_Utils_Tuple2('nparsl', '⫽⃥'),
			_Utils_Tuple2('npart', '∂̸'),
			_Utils_Tuple2('npolint', '⨔'),
			_Utils_Tuple2('npr', '⊀'),
			_Utils_Tuple2('nprcue', '⋠'),
			_Utils_Tuple2('nprec', '⊀'),
			_Utils_Tuple2('npreceq', '⪯̸'),
			_Utils_Tuple2('npre', '⪯̸'),
			_Utils_Tuple2('nrarrc', '⤳̸'),
			_Utils_Tuple2('nrarr', '↛'),
			_Utils_Tuple2('nrArr', '⇏'),
			_Utils_Tuple2('nrarrw', '↝̸'),
			_Utils_Tuple2('nrightarrow', '↛'),
			_Utils_Tuple2('nRightarrow', '⇏'),
			_Utils_Tuple2('nrtri', '⋫'),
			_Utils_Tuple2('nrtrie', '⋭'),
			_Utils_Tuple2('nsc', '⊁'),
			_Utils_Tuple2('nsccue', '⋡'),
			_Utils_Tuple2('nsce', '⪰̸'),
			_Utils_Tuple2('Nscr', '\ud835\udca9'),
			_Utils_Tuple2('nscr', '\ud835\udcc3'),
			_Utils_Tuple2('nshortmid', '∤'),
			_Utils_Tuple2('nshortparallel', '∦'),
			_Utils_Tuple2('nsim', '≁'),
			_Utils_Tuple2('nsime', '≄'),
			_Utils_Tuple2('nsimeq', '≄'),
			_Utils_Tuple2('nsmid', '∤'),
			_Utils_Tuple2('nspar', '∦'),
			_Utils_Tuple2('nsqsube', '⋢'),
			_Utils_Tuple2('nsqsupe', '⋣'),
			_Utils_Tuple2('nsub', '⊄'),
			_Utils_Tuple2('nsubE', '⫅̸'),
			_Utils_Tuple2('nsube', '⊈'),
			_Utils_Tuple2('nsubset', '⊂⃒'),
			_Utils_Tuple2('nsubseteq', '⊈'),
			_Utils_Tuple2('nsubseteqq', '⫅̸'),
			_Utils_Tuple2('nsucc', '⊁'),
			_Utils_Tuple2('nsucceq', '⪰̸'),
			_Utils_Tuple2('nsup', '⊅'),
			_Utils_Tuple2('nsupE', '⫆̸'),
			_Utils_Tuple2('nsupe', '⊉'),
			_Utils_Tuple2('nsupset', '⊃⃒'),
			_Utils_Tuple2('nsupseteq', '⊉'),
			_Utils_Tuple2('nsupseteqq', '⫆̸'),
			_Utils_Tuple2('ntgl', '≹'),
			_Utils_Tuple2('Ntilde', 'Ñ'),
			_Utils_Tuple2('ntilde', 'ñ'),
			_Utils_Tuple2('ntlg', '≸'),
			_Utils_Tuple2('ntriangleleft', '⋪'),
			_Utils_Tuple2('ntrianglelefteq', '⋬'),
			_Utils_Tuple2('ntriangleright', '⋫'),
			_Utils_Tuple2('ntrianglerighteq', '⋭'),
			_Utils_Tuple2('Nu', 'Ν'),
			_Utils_Tuple2('nu', 'ν'),
			_Utils_Tuple2('num', '#'),
			_Utils_Tuple2('numero', '№'),
			_Utils_Tuple2('numsp', '\u2007'),
			_Utils_Tuple2('nvap', '≍⃒'),
			_Utils_Tuple2('nvdash', '⊬'),
			_Utils_Tuple2('nvDash', '⊭'),
			_Utils_Tuple2('nVdash', '⊮'),
			_Utils_Tuple2('nVDash', '⊯'),
			_Utils_Tuple2('nvge', '≥⃒'),
			_Utils_Tuple2('nvgt', '>⃒'),
			_Utils_Tuple2('nvHarr', '⤄'),
			_Utils_Tuple2('nvinfin', '⧞'),
			_Utils_Tuple2('nvlArr', '⤂'),
			_Utils_Tuple2('nvle', '≤⃒'),
			_Utils_Tuple2('nvlt', '<⃒'),
			_Utils_Tuple2('nvltrie', '⊴⃒'),
			_Utils_Tuple2('nvrArr', '⤃'),
			_Utils_Tuple2('nvrtrie', '⊵⃒'),
			_Utils_Tuple2('nvsim', '∼⃒'),
			_Utils_Tuple2('nwarhk', '⤣'),
			_Utils_Tuple2('nwarr', '↖'),
			_Utils_Tuple2('nwArr', '⇖'),
			_Utils_Tuple2('nwarrow', '↖'),
			_Utils_Tuple2('nwnear', '⤧'),
			_Utils_Tuple2('Oacute', 'Ó'),
			_Utils_Tuple2('oacute', 'ó'),
			_Utils_Tuple2('oast', '⊛'),
			_Utils_Tuple2('Ocirc', 'Ô'),
			_Utils_Tuple2('ocirc', 'ô'),
			_Utils_Tuple2('ocir', '⊚'),
			_Utils_Tuple2('Ocy', 'О'),
			_Utils_Tuple2('ocy', 'о'),
			_Utils_Tuple2('odash', '⊝'),
			_Utils_Tuple2('Odblac', 'Ő'),
			_Utils_Tuple2('odblac', 'ő'),
			_Utils_Tuple2('odiv', '⨸'),
			_Utils_Tuple2('odot', '⊙'),
			_Utils_Tuple2('odsold', '⦼'),
			_Utils_Tuple2('OElig', 'Œ'),
			_Utils_Tuple2('oelig', 'œ'),
			_Utils_Tuple2('ofcir', '⦿'),
			_Utils_Tuple2('Ofr', '\ud835\udd12'),
			_Utils_Tuple2('ofr', '\ud835\udd2c'),
			_Utils_Tuple2('ogon', '˛'),
			_Utils_Tuple2('Ograve', 'Ò'),
			_Utils_Tuple2('ograve', 'ò'),
			_Utils_Tuple2('ogt', '⧁'),
			_Utils_Tuple2('ohbar', '⦵'),
			_Utils_Tuple2('ohm', 'Ω'),
			_Utils_Tuple2('oint', '∮'),
			_Utils_Tuple2('olarr', '↺'),
			_Utils_Tuple2('olcir', '⦾'),
			_Utils_Tuple2('olcross', '⦻'),
			_Utils_Tuple2('oline', '‾'),
			_Utils_Tuple2('olt', '⧀'),
			_Utils_Tuple2('Omacr', 'Ō'),
			_Utils_Tuple2('omacr', 'ō'),
			_Utils_Tuple2('Omega', 'Ω'),
			_Utils_Tuple2('omega', 'ω'),
			_Utils_Tuple2('Omicron', 'Ο'),
			_Utils_Tuple2('omicron', 'ο'),
			_Utils_Tuple2('omid', '⦶'),
			_Utils_Tuple2('ominus', '⊖'),
			_Utils_Tuple2('Oopf', '\ud835\udd46'),
			_Utils_Tuple2('oopf', '\ud835\udd60'),
			_Utils_Tuple2('opar', '⦷'),
			_Utils_Tuple2('OpenCurlyDoubleQuote', '“'),
			_Utils_Tuple2('OpenCurlyQuote', '‘'),
			_Utils_Tuple2('operp', '⦹'),
			_Utils_Tuple2('oplus', '⊕'),
			_Utils_Tuple2('orarr', '↻'),
			_Utils_Tuple2('Or', '⩔'),
			_Utils_Tuple2('or', '∨'),
			_Utils_Tuple2('ord', '⩝'),
			_Utils_Tuple2('order', 'ℴ'),
			_Utils_Tuple2('orderof', 'ℴ'),
			_Utils_Tuple2('ordf', 'ª'),
			_Utils_Tuple2('ordm', 'º'),
			_Utils_Tuple2('origof', '⊶'),
			_Utils_Tuple2('oror', '⩖'),
			_Utils_Tuple2('orslope', '⩗'),
			_Utils_Tuple2('orv', '⩛'),
			_Utils_Tuple2('oS', 'Ⓢ'),
			_Utils_Tuple2('Oscr', '\ud835\udcaa'),
			_Utils_Tuple2('oscr', 'ℴ'),
			_Utils_Tuple2('Oslash', 'Ø'),
			_Utils_Tuple2('oslash', 'ø'),
			_Utils_Tuple2('osol', '⊘'),
			_Utils_Tuple2('Otilde', 'Õ'),
			_Utils_Tuple2('otilde', 'õ'),
			_Utils_Tuple2('otimesas', '⨶'),
			_Utils_Tuple2('Otimes', '⨷'),
			_Utils_Tuple2('otimes', '⊗'),
			_Utils_Tuple2('Ouml', 'Ö'),
			_Utils_Tuple2('ouml', 'ö'),
			_Utils_Tuple2('ovbar', '⌽'),
			_Utils_Tuple2('OverBar', '‾'),
			_Utils_Tuple2('OverBrace', '⏞'),
			_Utils_Tuple2('OverBracket', '⎴'),
			_Utils_Tuple2('OverParenthesis', '⏜'),
			_Utils_Tuple2('para', '¶'),
			_Utils_Tuple2('parallel', '∥'),
			_Utils_Tuple2('par', '∥'),
			_Utils_Tuple2('parsim', '⫳'),
			_Utils_Tuple2('parsl', '⫽'),
			_Utils_Tuple2('part', '∂'),
			_Utils_Tuple2('PartialD', '∂'),
			_Utils_Tuple2('Pcy', 'П'),
			_Utils_Tuple2('pcy', 'п'),
			_Utils_Tuple2('percnt', '%'),
			_Utils_Tuple2('period', '.'),
			_Utils_Tuple2('permil', '‰'),
			_Utils_Tuple2('perp', '⊥'),
			_Utils_Tuple2('pertenk', '‱'),
			_Utils_Tuple2('Pfr', '\ud835\udd13'),
			_Utils_Tuple2('pfr', '\ud835\udd2d'),
			_Utils_Tuple2('Phi', 'Φ'),
			_Utils_Tuple2('phi', 'φ'),
			_Utils_Tuple2('phiv', 'ϕ'),
			_Utils_Tuple2('phmmat', 'ℳ'),
			_Utils_Tuple2('phone', '☎'),
			_Utils_Tuple2('Pi', 'Π'),
			_Utils_Tuple2('pi', 'π'),
			_Utils_Tuple2('pitchfork', '⋔'),
			_Utils_Tuple2('piv', 'ϖ'),
			_Utils_Tuple2('planck', 'ℏ'),
			_Utils_Tuple2('planckh', 'ℎ'),
			_Utils_Tuple2('plankv', 'ℏ'),
			_Utils_Tuple2('plusacir', '⨣'),
			_Utils_Tuple2('plusb', '⊞'),
			_Utils_Tuple2('pluscir', '⨢'),
			_Utils_Tuple2('plus', '+'),
			_Utils_Tuple2('plusdo', '∔'),
			_Utils_Tuple2('plusdu', '⨥'),
			_Utils_Tuple2('pluse', '⩲'),
			_Utils_Tuple2('PlusMinus', '±'),
			_Utils_Tuple2('plusmn', '±'),
			_Utils_Tuple2('plussim', '⨦'),
			_Utils_Tuple2('plustwo', '⨧'),
			_Utils_Tuple2('pm', '±'),
			_Utils_Tuple2('Poincareplane', 'ℌ'),
			_Utils_Tuple2('pointint', '⨕'),
			_Utils_Tuple2('popf', '\ud835\udd61'),
			_Utils_Tuple2('Popf', 'ℙ'),
			_Utils_Tuple2('pound', '£'),
			_Utils_Tuple2('prap', '⪷'),
			_Utils_Tuple2('Pr', '⪻'),
			_Utils_Tuple2('pr', '≺'),
			_Utils_Tuple2('prcue', '≼'),
			_Utils_Tuple2('precapprox', '⪷'),
			_Utils_Tuple2('prec', '≺'),
			_Utils_Tuple2('preccurlyeq', '≼'),
			_Utils_Tuple2('Precedes', '≺'),
			_Utils_Tuple2('PrecedesEqual', '⪯'),
			_Utils_Tuple2('PrecedesSlantEqual', '≼'),
			_Utils_Tuple2('PrecedesTilde', '≾'),
			_Utils_Tuple2('preceq', '⪯'),
			_Utils_Tuple2('precnapprox', '⪹'),
			_Utils_Tuple2('precneqq', '⪵'),
			_Utils_Tuple2('precnsim', '⋨'),
			_Utils_Tuple2('pre', '⪯'),
			_Utils_Tuple2('prE', '⪳'),
			_Utils_Tuple2('precsim', '≾'),
			_Utils_Tuple2('prime', '′'),
			_Utils_Tuple2('Prime', '″'),
			_Utils_Tuple2('primes', 'ℙ'),
			_Utils_Tuple2('prnap', '⪹'),
			_Utils_Tuple2('prnE', '⪵'),
			_Utils_Tuple2('prnsim', '⋨'),
			_Utils_Tuple2('prod', '∏'),
			_Utils_Tuple2('Product', '∏'),
			_Utils_Tuple2('profalar', '⌮'),
			_Utils_Tuple2('profline', '⌒'),
			_Utils_Tuple2('profsurf', '⌓'),
			_Utils_Tuple2('prop', '∝'),
			_Utils_Tuple2('Proportional', '∝'),
			_Utils_Tuple2('Proportion', '∷'),
			_Utils_Tuple2('propto', '∝'),
			_Utils_Tuple2('prsim', '≾'),
			_Utils_Tuple2('prurel', '⊰'),
			_Utils_Tuple2('Pscr', '\ud835\udcab'),
			_Utils_Tuple2('pscr', '\ud835\udcc5'),
			_Utils_Tuple2('Psi', 'Ψ'),
			_Utils_Tuple2('psi', 'ψ'),
			_Utils_Tuple2('puncsp', '\u2008'),
			_Utils_Tuple2('Qfr', '\ud835\udd14'),
			_Utils_Tuple2('qfr', '\ud835\udd2e'),
			_Utils_Tuple2('qint', '⨌'),
			_Utils_Tuple2('qopf', '\ud835\udd62'),
			_Utils_Tuple2('Qopf', 'ℚ'),
			_Utils_Tuple2('qprime', '⁗'),
			_Utils_Tuple2('Qscr', '\ud835\udcac'),
			_Utils_Tuple2('qscr', '\ud835\udcc6'),
			_Utils_Tuple2('quaternions', 'ℍ'),
			_Utils_Tuple2('quatint', '⨖'),
			_Utils_Tuple2('quest', '?'),
			_Utils_Tuple2('questeq', '≟'),
			_Utils_Tuple2('quot', '\"'),
			_Utils_Tuple2('QUOT', '\"'),
			_Utils_Tuple2('rAarr', '⇛'),
			_Utils_Tuple2('race', '∽̱'),
			_Utils_Tuple2('Racute', 'Ŕ'),
			_Utils_Tuple2('racute', 'ŕ'),
			_Utils_Tuple2('radic', '√'),
			_Utils_Tuple2('raemptyv', '⦳'),
			_Utils_Tuple2('rang', '⟩'),
			_Utils_Tuple2('Rang', '⟫'),
			_Utils_Tuple2('rangd', '⦒'),
			_Utils_Tuple2('range', '⦥'),
			_Utils_Tuple2('rangle', '⟩'),
			_Utils_Tuple2('raquo', '»'),
			_Utils_Tuple2('rarrap', '⥵'),
			_Utils_Tuple2('rarrb', '⇥'),
			_Utils_Tuple2('rarrbfs', '⤠'),
			_Utils_Tuple2('rarrc', '⤳'),
			_Utils_Tuple2('rarr', '→'),
			_Utils_Tuple2('Rarr', '↠'),
			_Utils_Tuple2('rArr', '⇒'),
			_Utils_Tuple2('rarrfs', '⤞'),
			_Utils_Tuple2('rarrhk', '↪'),
			_Utils_Tuple2('rarrlp', '↬'),
			_Utils_Tuple2('rarrpl', '⥅'),
			_Utils_Tuple2('rarrsim', '⥴'),
			_Utils_Tuple2('Rarrtl', '⤖'),
			_Utils_Tuple2('rarrtl', '↣'),
			_Utils_Tuple2('rarrw', '↝'),
			_Utils_Tuple2('ratail', '⤚'),
			_Utils_Tuple2('rAtail', '⤜'),
			_Utils_Tuple2('ratio', '∶'),
			_Utils_Tuple2('rationals', 'ℚ'),
			_Utils_Tuple2('rbarr', '⤍'),
			_Utils_Tuple2('rBarr', '⤏'),
			_Utils_Tuple2('RBarr', '⤐'),
			_Utils_Tuple2('rbbrk', '❳'),
			_Utils_Tuple2('rbrace', '}'),
			_Utils_Tuple2('rbrack', ']'),
			_Utils_Tuple2('rbrke', '⦌'),
			_Utils_Tuple2('rbrksld', '⦎'),
			_Utils_Tuple2('rbrkslu', '⦐'),
			_Utils_Tuple2('Rcaron', 'Ř'),
			_Utils_Tuple2('rcaron', 'ř'),
			_Utils_Tuple2('Rcedil', 'Ŗ'),
			_Utils_Tuple2('rcedil', 'ŗ'),
			_Utils_Tuple2('rceil', '⌉'),
			_Utils_Tuple2('rcub', '}'),
			_Utils_Tuple2('Rcy', 'Р'),
			_Utils_Tuple2('rcy', 'р'),
			_Utils_Tuple2('rdca', '⤷'),
			_Utils_Tuple2('rdldhar', '⥩'),
			_Utils_Tuple2('rdquo', '”'),
			_Utils_Tuple2('rdquor', '”'),
			_Utils_Tuple2('rdsh', '↳'),
			_Utils_Tuple2('real', 'ℜ'),
			_Utils_Tuple2('realine', 'ℛ'),
			_Utils_Tuple2('realpart', 'ℜ'),
			_Utils_Tuple2('reals', 'ℝ'),
			_Utils_Tuple2('Re', 'ℜ'),
			_Utils_Tuple2('rect', '▭'),
			_Utils_Tuple2('reg', '®'),
			_Utils_Tuple2('REG', '®'),
			_Utils_Tuple2('ReverseElement', '∋'),
			_Utils_Tuple2('ReverseEquilibrium', '⇋'),
			_Utils_Tuple2('ReverseUpEquilibrium', '⥯'),
			_Utils_Tuple2('rfisht', '⥽'),
			_Utils_Tuple2('rfloor', '⌋'),
			_Utils_Tuple2('rfr', '\ud835\udd2f'),
			_Utils_Tuple2('Rfr', 'ℜ'),
			_Utils_Tuple2('rHar', '⥤'),
			_Utils_Tuple2('rhard', '⇁'),
			_Utils_Tuple2('rharu', '⇀'),
			_Utils_Tuple2('rharul', '⥬'),
			_Utils_Tuple2('Rho', 'Ρ'),
			_Utils_Tuple2('rho', 'ρ'),
			_Utils_Tuple2('rhov', 'ϱ'),
			_Utils_Tuple2('RightAngleBracket', '⟩'),
			_Utils_Tuple2('RightArrowBar', '⇥'),
			_Utils_Tuple2('rightarrow', '→'),
			_Utils_Tuple2('RightArrow', '→'),
			_Utils_Tuple2('Rightarrow', '⇒'),
			_Utils_Tuple2('RightArrowLeftArrow', '⇄'),
			_Utils_Tuple2('rightarrowtail', '↣'),
			_Utils_Tuple2('RightCeiling', '⌉'),
			_Utils_Tuple2('RightDoubleBracket', '⟧'),
			_Utils_Tuple2('RightDownTeeVector', '⥝'),
			_Utils_Tuple2('RightDownVectorBar', '⥕'),
			_Utils_Tuple2('RightDownVector', '⇂'),
			_Utils_Tuple2('RightFloor', '⌋'),
			_Utils_Tuple2('rightharpoondown', '⇁'),
			_Utils_Tuple2('rightharpoonup', '⇀'),
			_Utils_Tuple2('rightleftarrows', '⇄'),
			_Utils_Tuple2('rightleftharpoons', '⇌'),
			_Utils_Tuple2('rightrightarrows', '⇉'),
			_Utils_Tuple2('rightsquigarrow', '↝'),
			_Utils_Tuple2('RightTeeArrow', '↦'),
			_Utils_Tuple2('RightTee', '⊢'),
			_Utils_Tuple2('RightTeeVector', '⥛'),
			_Utils_Tuple2('rightthreetimes', '⋌'),
			_Utils_Tuple2('RightTriangleBar', '⧐'),
			_Utils_Tuple2('RightTriangle', '⊳'),
			_Utils_Tuple2('RightTriangleEqual', '⊵'),
			_Utils_Tuple2('RightUpDownVector', '⥏'),
			_Utils_Tuple2('RightUpTeeVector', '⥜'),
			_Utils_Tuple2('RightUpVectorBar', '⥔'),
			_Utils_Tuple2('RightUpVector', '↾'),
			_Utils_Tuple2('RightVectorBar', '⥓'),
			_Utils_Tuple2('RightVector', '⇀'),
			_Utils_Tuple2('ring', '˚'),
			_Utils_Tuple2('risingdotseq', '≓'),
			_Utils_Tuple2('rlarr', '⇄'),
			_Utils_Tuple2('rlhar', '⇌'),
			_Utils_Tuple2('rlm', '\u200f'),
			_Utils_Tuple2('rmoustache', '⎱'),
			_Utils_Tuple2('rmoust', '⎱'),
			_Utils_Tuple2('rnmid', '⫮'),
			_Utils_Tuple2('roang', '⟭'),
			_Utils_Tuple2('roarr', '⇾'),
			_Utils_Tuple2('robrk', '⟧'),
			_Utils_Tuple2('ropar', '⦆'),
			_Utils_Tuple2('ropf', '\ud835\udd63'),
			_Utils_Tuple2('Ropf', 'ℝ'),
			_Utils_Tuple2('roplus', '⨮'),
			_Utils_Tuple2('rotimes', '⨵'),
			_Utils_Tuple2('RoundImplies', '⥰'),
			_Utils_Tuple2('rpar', ')'),
			_Utils_Tuple2('rpargt', '⦔'),
			_Utils_Tuple2('rppolint', '⨒'),
			_Utils_Tuple2('rrarr', '⇉'),
			_Utils_Tuple2('Rrightarrow', '⇛'),
			_Utils_Tuple2('rsaquo', '›'),
			_Utils_Tuple2('rscr', '\ud835\udcc7'),
			_Utils_Tuple2('Rscr', 'ℛ'),
			_Utils_Tuple2('rsh', '↱'),
			_Utils_Tuple2('Rsh', '↱'),
			_Utils_Tuple2('rsqb', ']'),
			_Utils_Tuple2('rsquo', '’'),
			_Utils_Tuple2('rsquor', '’'),
			_Utils_Tuple2('rthree', '⋌'),
			_Utils_Tuple2('rtimes', '⋊'),
			_Utils_Tuple2('rtri', '▹'),
			_Utils_Tuple2('rtrie', '⊵'),
			_Utils_Tuple2('rtrif', '▸'),
			_Utils_Tuple2('rtriltri', '⧎'),
			_Utils_Tuple2('RuleDelayed', '⧴'),
			_Utils_Tuple2('ruluhar', '⥨'),
			_Utils_Tuple2('rx', '℞'),
			_Utils_Tuple2('Sacute', 'Ś'),
			_Utils_Tuple2('sacute', 'ś'),
			_Utils_Tuple2('sbquo', '‚'),
			_Utils_Tuple2('scap', '⪸'),
			_Utils_Tuple2('Scaron', 'Š'),
			_Utils_Tuple2('scaron', 'š'),
			_Utils_Tuple2('Sc', '⪼'),
			_Utils_Tuple2('sc', '≻'),
			_Utils_Tuple2('sccue', '≽'),
			_Utils_Tuple2('sce', '⪰'),
			_Utils_Tuple2('scE', '⪴'),
			_Utils_Tuple2('Scedil', 'Ş'),
			_Utils_Tuple2('scedil', 'ş'),
			_Utils_Tuple2('Scirc', 'Ŝ'),
			_Utils_Tuple2('scirc', 'ŝ'),
			_Utils_Tuple2('scnap', '⪺'),
			_Utils_Tuple2('scnE', '⪶'),
			_Utils_Tuple2('scnsim', '⋩'),
			_Utils_Tuple2('scpolint', '⨓'),
			_Utils_Tuple2('scsim', '≿'),
			_Utils_Tuple2('Scy', 'С'),
			_Utils_Tuple2('scy', 'с'),
			_Utils_Tuple2('sdotb', '⊡'),
			_Utils_Tuple2('sdot', '⋅'),
			_Utils_Tuple2('sdote', '⩦'),
			_Utils_Tuple2('searhk', '⤥'),
			_Utils_Tuple2('searr', '↘'),
			_Utils_Tuple2('seArr', '⇘'),
			_Utils_Tuple2('searrow', '↘'),
			_Utils_Tuple2('sect', '§'),
			_Utils_Tuple2('semi', ';'),
			_Utils_Tuple2('seswar', '⤩'),
			_Utils_Tuple2('setminus', '∖'),
			_Utils_Tuple2('setmn', '∖'),
			_Utils_Tuple2('sext', '✶'),
			_Utils_Tuple2('Sfr', '\ud835\udd16'),
			_Utils_Tuple2('sfr', '\ud835\udd30'),
			_Utils_Tuple2('sfrown', '⌢'),
			_Utils_Tuple2('sharp', '♯'),
			_Utils_Tuple2('SHCHcy', 'Щ'),
			_Utils_Tuple2('shchcy', 'щ'),
			_Utils_Tuple2('SHcy', 'Ш'),
			_Utils_Tuple2('shcy', 'ш'),
			_Utils_Tuple2('ShortDownArrow', '↓'),
			_Utils_Tuple2('ShortLeftArrow', '←'),
			_Utils_Tuple2('shortmid', '∣'),
			_Utils_Tuple2('shortparallel', '∥'),
			_Utils_Tuple2('ShortRightArrow', '→'),
			_Utils_Tuple2('ShortUpArrow', '↑'),
			_Utils_Tuple2('shy', '\u00ad'),
			_Utils_Tuple2('Sigma', 'Σ'),
			_Utils_Tuple2('sigma', 'σ'),
			_Utils_Tuple2('sigmaf', 'ς'),
			_Utils_Tuple2('sigmav', 'ς'),
			_Utils_Tuple2('sim', '∼'),
			_Utils_Tuple2('simdot', '⩪'),
			_Utils_Tuple2('sime', '≃'),
			_Utils_Tuple2('simeq', '≃'),
			_Utils_Tuple2('simg', '⪞'),
			_Utils_Tuple2('simgE', '⪠'),
			_Utils_Tuple2('siml', '⪝'),
			_Utils_Tuple2('simlE', '⪟'),
			_Utils_Tuple2('simne', '≆'),
			_Utils_Tuple2('simplus', '⨤'),
			_Utils_Tuple2('simrarr', '⥲'),
			_Utils_Tuple2('slarr', '←'),
			_Utils_Tuple2('SmallCircle', '∘'),
			_Utils_Tuple2('smallsetminus', '∖'),
			_Utils_Tuple2('smashp', '⨳'),
			_Utils_Tuple2('smeparsl', '⧤'),
			_Utils_Tuple2('smid', '∣'),
			_Utils_Tuple2('smile', '⌣'),
			_Utils_Tuple2('smt', '⪪'),
			_Utils_Tuple2('smte', '⪬'),
			_Utils_Tuple2('smtes', '⪬︀'),
			_Utils_Tuple2('SOFTcy', 'Ь'),
			_Utils_Tuple2('softcy', 'ь'),
			_Utils_Tuple2('solbar', '⌿'),
			_Utils_Tuple2('solb', '⧄'),
			_Utils_Tuple2('sol', '/'),
			_Utils_Tuple2('Sopf', '\ud835\udd4a'),
			_Utils_Tuple2('sopf', '\ud835\udd64'),
			_Utils_Tuple2('spades', '♠'),
			_Utils_Tuple2('spadesuit', '♠'),
			_Utils_Tuple2('spar', '∥'),
			_Utils_Tuple2('sqcap', '⊓'),
			_Utils_Tuple2('sqcaps', '⊓︀'),
			_Utils_Tuple2('sqcup', '⊔'),
			_Utils_Tuple2('sqcups', '⊔︀'),
			_Utils_Tuple2('Sqrt', '√'),
			_Utils_Tuple2('sqsub', '⊏'),
			_Utils_Tuple2('sqsube', '⊑'),
			_Utils_Tuple2('sqsubset', '⊏'),
			_Utils_Tuple2('sqsubseteq', '⊑'),
			_Utils_Tuple2('sqsup', '⊐'),
			_Utils_Tuple2('sqsupe', '⊒'),
			_Utils_Tuple2('sqsupset', '⊐'),
			_Utils_Tuple2('sqsupseteq', '⊒'),
			_Utils_Tuple2('square', '□'),
			_Utils_Tuple2('Square', '□'),
			_Utils_Tuple2('SquareIntersection', '⊓'),
			_Utils_Tuple2('SquareSubset', '⊏'),
			_Utils_Tuple2('SquareSubsetEqual', '⊑'),
			_Utils_Tuple2('SquareSuperset', '⊐'),
			_Utils_Tuple2('SquareSupersetEqual', '⊒'),
			_Utils_Tuple2('SquareUnion', '⊔'),
			_Utils_Tuple2('squarf', '▪'),
			_Utils_Tuple2('squ', '□'),
			_Utils_Tuple2('squf', '▪'),
			_Utils_Tuple2('srarr', '→'),
			_Utils_Tuple2('Sscr', '\ud835\udcae'),
			_Utils_Tuple2('sscr', '\ud835\udcc8'),
			_Utils_Tuple2('ssetmn', '∖'),
			_Utils_Tuple2('ssmile', '⌣'),
			_Utils_Tuple2('sstarf', '⋆'),
			_Utils_Tuple2('Star', '⋆'),
			_Utils_Tuple2('star', '☆'),
			_Utils_Tuple2('starf', '★'),
			_Utils_Tuple2('straightepsilon', 'ϵ'),
			_Utils_Tuple2('straightphi', 'ϕ'),
			_Utils_Tuple2('strns', '¯'),
			_Utils_Tuple2('sub', '⊂'),
			_Utils_Tuple2('Sub', '⋐'),
			_Utils_Tuple2('subdot', '⪽'),
			_Utils_Tuple2('subE', '⫅'),
			_Utils_Tuple2('sube', '⊆'),
			_Utils_Tuple2('subedot', '⫃'),
			_Utils_Tuple2('submult', '⫁'),
			_Utils_Tuple2('subnE', '⫋'),
			_Utils_Tuple2('subne', '⊊'),
			_Utils_Tuple2('subplus', '⪿'),
			_Utils_Tuple2('subrarr', '⥹'),
			_Utils_Tuple2('subset', '⊂'),
			_Utils_Tuple2('Subset', '⋐'),
			_Utils_Tuple2('subseteq', '⊆'),
			_Utils_Tuple2('subseteqq', '⫅'),
			_Utils_Tuple2('SubsetEqual', '⊆'),
			_Utils_Tuple2('subsetneq', '⊊'),
			_Utils_Tuple2('subsetneqq', '⫋'),
			_Utils_Tuple2('subsim', '⫇'),
			_Utils_Tuple2('subsub', '⫕'),
			_Utils_Tuple2('subsup', '⫓'),
			_Utils_Tuple2('succapprox', '⪸'),
			_Utils_Tuple2('succ', '≻'),
			_Utils_Tuple2('succcurlyeq', '≽'),
			_Utils_Tuple2('Succeeds', '≻'),
			_Utils_Tuple2('SucceedsEqual', '⪰'),
			_Utils_Tuple2('SucceedsSlantEqual', '≽'),
			_Utils_Tuple2('SucceedsTilde', '≿'),
			_Utils_Tuple2('succeq', '⪰'),
			_Utils_Tuple2('succnapprox', '⪺'),
			_Utils_Tuple2('succneqq', '⪶'),
			_Utils_Tuple2('succnsim', '⋩'),
			_Utils_Tuple2('succsim', '≿'),
			_Utils_Tuple2('SuchThat', '∋'),
			_Utils_Tuple2('sum', '∑'),
			_Utils_Tuple2('Sum', '∑'),
			_Utils_Tuple2('sung', '♪'),
			_Utils_Tuple2('sup1', '¹'),
			_Utils_Tuple2('sup2', '²'),
			_Utils_Tuple2('sup3', '³'),
			_Utils_Tuple2('sup', '⊃'),
			_Utils_Tuple2('Sup', '⋑'),
			_Utils_Tuple2('supdot', '⪾'),
			_Utils_Tuple2('supdsub', '⫘'),
			_Utils_Tuple2('supE', '⫆'),
			_Utils_Tuple2('supe', '⊇'),
			_Utils_Tuple2('supedot', '⫄'),
			_Utils_Tuple2('Superset', '⊃'),
			_Utils_Tuple2('SupersetEqual', '⊇'),
			_Utils_Tuple2('suphsol', '⟉'),
			_Utils_Tuple2('suphsub', '⫗'),
			_Utils_Tuple2('suplarr', '⥻'),
			_Utils_Tuple2('supmult', '⫂'),
			_Utils_Tuple2('supnE', '⫌'),
			_Utils_Tuple2('supne', '⊋'),
			_Utils_Tuple2('supplus', '⫀'),
			_Utils_Tuple2('supset', '⊃'),
			_Utils_Tuple2('Supset', '⋑'),
			_Utils_Tuple2('supseteq', '⊇'),
			_Utils_Tuple2('supseteqq', '⫆'),
			_Utils_Tuple2('supsetneq', '⊋'),
			_Utils_Tuple2('supsetneqq', '⫌'),
			_Utils_Tuple2('supsim', '⫈'),
			_Utils_Tuple2('supsub', '⫔'),
			_Utils_Tuple2('supsup', '⫖'),
			_Utils_Tuple2('swarhk', '⤦'),
			_Utils_Tuple2('swarr', '↙'),
			_Utils_Tuple2('swArr', '⇙'),
			_Utils_Tuple2('swarrow', '↙'),
			_Utils_Tuple2('swnwar', '⤪'),
			_Utils_Tuple2('szlig', 'ß'),
			_Utils_Tuple2('Tab', '\t'),
			_Utils_Tuple2('target', '⌖'),
			_Utils_Tuple2('Tau', 'Τ'),
			_Utils_Tuple2('tau', 'τ'),
			_Utils_Tuple2('tbrk', '⎴'),
			_Utils_Tuple2('Tcaron', 'Ť'),
			_Utils_Tuple2('tcaron', 'ť'),
			_Utils_Tuple2('Tcedil', 'Ţ'),
			_Utils_Tuple2('tcedil', 'ţ'),
			_Utils_Tuple2('Tcy', 'Т'),
			_Utils_Tuple2('tcy', 'т'),
			_Utils_Tuple2('tdot', '⃛'),
			_Utils_Tuple2('telrec', '⌕'),
			_Utils_Tuple2('Tfr', '\ud835\udd17'),
			_Utils_Tuple2('tfr', '\ud835\udd31'),
			_Utils_Tuple2('there4', '∴'),
			_Utils_Tuple2('therefore', '∴'),
			_Utils_Tuple2('Therefore', '∴'),
			_Utils_Tuple2('Theta', 'Θ'),
			_Utils_Tuple2('theta', 'θ'),
			_Utils_Tuple2('thetasym', 'ϑ'),
			_Utils_Tuple2('thetav', 'ϑ'),
			_Utils_Tuple2('thickapprox', '≈'),
			_Utils_Tuple2('thicksim', '∼'),
			_Utils_Tuple2('ThickSpace', '\u205f\u200a'),
			_Utils_Tuple2('ThinSpace', '\u2009'),
			_Utils_Tuple2('thinsp', '\u2009'),
			_Utils_Tuple2('thkap', '≈'),
			_Utils_Tuple2('thksim', '∼'),
			_Utils_Tuple2('THORN', 'Þ'),
			_Utils_Tuple2('thorn', 'þ'),
			_Utils_Tuple2('tilde', '˜'),
			_Utils_Tuple2('Tilde', '∼'),
			_Utils_Tuple2('TildeEqual', '≃'),
			_Utils_Tuple2('TildeFullEqual', '≅'),
			_Utils_Tuple2('TildeTilde', '≈'),
			_Utils_Tuple2('timesbar', '⨱'),
			_Utils_Tuple2('timesb', '⊠'),
			_Utils_Tuple2('times', '×'),
			_Utils_Tuple2('timesd', '⨰'),
			_Utils_Tuple2('tint', '∭'),
			_Utils_Tuple2('toea', '⤨'),
			_Utils_Tuple2('topbot', '⌶'),
			_Utils_Tuple2('topcir', '⫱'),
			_Utils_Tuple2('top', '⊤'),
			_Utils_Tuple2('Topf', '\ud835\udd4b'),
			_Utils_Tuple2('topf', '\ud835\udd65'),
			_Utils_Tuple2('topfork', '⫚'),
			_Utils_Tuple2('tosa', '⤩'),
			_Utils_Tuple2('tprime', '‴'),
			_Utils_Tuple2('trade', '™'),
			_Utils_Tuple2('TRADE', '™'),
			_Utils_Tuple2('triangle', '▵'),
			_Utils_Tuple2('triangledown', '▿'),
			_Utils_Tuple2('triangleleft', '◃'),
			_Utils_Tuple2('trianglelefteq', '⊴'),
			_Utils_Tuple2('triangleq', '≜'),
			_Utils_Tuple2('triangleright', '▹'),
			_Utils_Tuple2('trianglerighteq', '⊵'),
			_Utils_Tuple2('tridot', '◬'),
			_Utils_Tuple2('trie', '≜'),
			_Utils_Tuple2('triminus', '⨺'),
			_Utils_Tuple2('TripleDot', '⃛'),
			_Utils_Tuple2('triplus', '⨹'),
			_Utils_Tuple2('trisb', '⧍'),
			_Utils_Tuple2('tritime', '⨻'),
			_Utils_Tuple2('trpezium', '⏢'),
			_Utils_Tuple2('Tscr', '\ud835\udcaf'),
			_Utils_Tuple2('tscr', '\ud835\udcc9'),
			_Utils_Tuple2('TScy', 'Ц'),
			_Utils_Tuple2('tscy', 'ц'),
			_Utils_Tuple2('TSHcy', 'Ћ'),
			_Utils_Tuple2('tshcy', 'ћ'),
			_Utils_Tuple2('Tstrok', 'Ŧ'),
			_Utils_Tuple2('tstrok', 'ŧ'),
			_Utils_Tuple2('twixt', '≬'),
			_Utils_Tuple2('twoheadleftarrow', '↞'),
			_Utils_Tuple2('twoheadrightarrow', '↠'),
			_Utils_Tuple2('Uacute', 'Ú'),
			_Utils_Tuple2('uacute', 'ú'),
			_Utils_Tuple2('uarr', '↑'),
			_Utils_Tuple2('Uarr', '↟'),
			_Utils_Tuple2('uArr', '⇑'),
			_Utils_Tuple2('Uarrocir', '⥉'),
			_Utils_Tuple2('Ubrcy', 'Ў'),
			_Utils_Tuple2('ubrcy', 'ў'),
			_Utils_Tuple2('Ubreve', 'Ŭ'),
			_Utils_Tuple2('ubreve', 'ŭ'),
			_Utils_Tuple2('Ucirc', 'Û'),
			_Utils_Tuple2('ucirc', 'û'),
			_Utils_Tuple2('Ucy', 'У'),
			_Utils_Tuple2('ucy', 'у'),
			_Utils_Tuple2('udarr', '⇅'),
			_Utils_Tuple2('Udblac', 'Ű'),
			_Utils_Tuple2('udblac', 'ű'),
			_Utils_Tuple2('udhar', '⥮'),
			_Utils_Tuple2('ufisht', '⥾'),
			_Utils_Tuple2('Ufr', '\ud835\udd18'),
			_Utils_Tuple2('ufr', '\ud835\udd32'),
			_Utils_Tuple2('Ugrave', 'Ù'),
			_Utils_Tuple2('ugrave', 'ù'),
			_Utils_Tuple2('uHar', '⥣'),
			_Utils_Tuple2('uharl', '↿'),
			_Utils_Tuple2('uharr', '↾'),
			_Utils_Tuple2('uhblk', '▀'),
			_Utils_Tuple2('ulcorn', '⌜'),
			_Utils_Tuple2('ulcorner', '⌜'),
			_Utils_Tuple2('ulcrop', '⌏'),
			_Utils_Tuple2('ultri', '◸'),
			_Utils_Tuple2('Umacr', 'Ū'),
			_Utils_Tuple2('umacr', 'ū'),
			_Utils_Tuple2('uml', '¨'),
			_Utils_Tuple2('UnderBar', '_'),
			_Utils_Tuple2('UnderBrace', '⏟'),
			_Utils_Tuple2('UnderBracket', '⎵'),
			_Utils_Tuple2('UnderParenthesis', '⏝'),
			_Utils_Tuple2('Union', '⋃'),
			_Utils_Tuple2('UnionPlus', '⊎'),
			_Utils_Tuple2('Uogon', 'Ų'),
			_Utils_Tuple2('uogon', 'ų'),
			_Utils_Tuple2('Uopf', '\ud835\udd4c'),
			_Utils_Tuple2('uopf', '\ud835\udd66'),
			_Utils_Tuple2('UpArrowBar', '⤒'),
			_Utils_Tuple2('uparrow', '↑'),
			_Utils_Tuple2('UpArrow', '↑'),
			_Utils_Tuple2('Uparrow', '⇑'),
			_Utils_Tuple2('UpArrowDownArrow', '⇅'),
			_Utils_Tuple2('updownarrow', '↕'),
			_Utils_Tuple2('UpDownArrow', '↕'),
			_Utils_Tuple2('Updownarrow', '⇕'),
			_Utils_Tuple2('UpEquilibrium', '⥮'),
			_Utils_Tuple2('upharpoonleft', '↿'),
			_Utils_Tuple2('upharpoonright', '↾'),
			_Utils_Tuple2('uplus', '⊎'),
			_Utils_Tuple2('UpperLeftArrow', '↖'),
			_Utils_Tuple2('UpperRightArrow', '↗'),
			_Utils_Tuple2('upsi', 'υ'),
			_Utils_Tuple2('Upsi', 'ϒ'),
			_Utils_Tuple2('upsih', 'ϒ'),
			_Utils_Tuple2('Upsilon', 'Υ'),
			_Utils_Tuple2('upsilon', 'υ'),
			_Utils_Tuple2('UpTeeArrow', '↥'),
			_Utils_Tuple2('UpTee', '⊥'),
			_Utils_Tuple2('upuparrows', '⇈'),
			_Utils_Tuple2('urcorn', '⌝'),
			_Utils_Tuple2('urcorner', '⌝'),
			_Utils_Tuple2('urcrop', '⌎'),
			_Utils_Tuple2('Uring', 'Ů'),
			_Utils_Tuple2('uring', 'ů'),
			_Utils_Tuple2('urtri', '◹'),
			_Utils_Tuple2('Uscr', '\ud835\udcb0'),
			_Utils_Tuple2('uscr', '\ud835\udcca'),
			_Utils_Tuple2('utdot', '⋰'),
			_Utils_Tuple2('Utilde', 'Ũ'),
			_Utils_Tuple2('utilde', 'ũ'),
			_Utils_Tuple2('utri', '▵'),
			_Utils_Tuple2('utrif', '▴'),
			_Utils_Tuple2('uuarr', '⇈'),
			_Utils_Tuple2('Uuml', 'Ü'),
			_Utils_Tuple2('uuml', 'ü'),
			_Utils_Tuple2('uwangle', '⦧'),
			_Utils_Tuple2('vangrt', '⦜'),
			_Utils_Tuple2('varepsilon', 'ϵ'),
			_Utils_Tuple2('varkappa', 'ϰ'),
			_Utils_Tuple2('varnothing', '∅'),
			_Utils_Tuple2('varphi', 'ϕ'),
			_Utils_Tuple2('varpi', 'ϖ'),
			_Utils_Tuple2('varpropto', '∝'),
			_Utils_Tuple2('varr', '↕'),
			_Utils_Tuple2('vArr', '⇕'),
			_Utils_Tuple2('varrho', 'ϱ'),
			_Utils_Tuple2('varsigma', 'ς'),
			_Utils_Tuple2('varsubsetneq', '⊊︀'),
			_Utils_Tuple2('varsubsetneqq', '⫋︀'),
			_Utils_Tuple2('varsupsetneq', '⊋︀'),
			_Utils_Tuple2('varsupsetneqq', '⫌︀'),
			_Utils_Tuple2('vartheta', 'ϑ'),
			_Utils_Tuple2('vartriangleleft', '⊲'),
			_Utils_Tuple2('vartriangleright', '⊳'),
			_Utils_Tuple2('vBar', '⫨'),
			_Utils_Tuple2('Vbar', '⫫'),
			_Utils_Tuple2('vBarv', '⫩'),
			_Utils_Tuple2('Vcy', 'В'),
			_Utils_Tuple2('vcy', 'в'),
			_Utils_Tuple2('vdash', '⊢'),
			_Utils_Tuple2('vDash', '⊨'),
			_Utils_Tuple2('Vdash', '⊩'),
			_Utils_Tuple2('VDash', '⊫'),
			_Utils_Tuple2('Vdashl', '⫦'),
			_Utils_Tuple2('veebar', '⊻'),
			_Utils_Tuple2('vee', '∨'),
			_Utils_Tuple2('Vee', '⋁'),
			_Utils_Tuple2('veeeq', '≚'),
			_Utils_Tuple2('vellip', '⋮'),
			_Utils_Tuple2('verbar', '|'),
			_Utils_Tuple2('Verbar', '‖'),
			_Utils_Tuple2('vert', '|'),
			_Utils_Tuple2('Vert', '‖'),
			_Utils_Tuple2('VerticalBar', '∣'),
			_Utils_Tuple2('VerticalLine', '|'),
			_Utils_Tuple2('VerticalSeparator', '❘'),
			_Utils_Tuple2('VerticalTilde', '≀'),
			_Utils_Tuple2('VeryThinSpace', '\u200a'),
			_Utils_Tuple2('Vfr', '\ud835\udd19'),
			_Utils_Tuple2('vfr', '\ud835\udd33'),
			_Utils_Tuple2('vltri', '⊲'),
			_Utils_Tuple2('vnsub', '⊂⃒'),
			_Utils_Tuple2('vnsup', '⊃⃒'),
			_Utils_Tuple2('Vopf', '\ud835\udd4d'),
			_Utils_Tuple2('vopf', '\ud835\udd67'),
			_Utils_Tuple2('vprop', '∝'),
			_Utils_Tuple2('vrtri', '⊳'),
			_Utils_Tuple2('Vscr', '\ud835\udcb1'),
			_Utils_Tuple2('vscr', '\ud835\udccb'),
			_Utils_Tuple2('vsubnE', '⫋︀'),
			_Utils_Tuple2('vsubne', '⊊︀'),
			_Utils_Tuple2('vsupnE', '⫌︀'),
			_Utils_Tuple2('vsupne', '⊋︀'),
			_Utils_Tuple2('Vvdash', '⊪'),
			_Utils_Tuple2('vzigzag', '⦚'),
			_Utils_Tuple2('Wcirc', 'Ŵ'),
			_Utils_Tuple2('wcirc', 'ŵ'),
			_Utils_Tuple2('wedbar', '⩟'),
			_Utils_Tuple2('wedge', '∧'),
			_Utils_Tuple2('Wedge', '⋀'),
			_Utils_Tuple2('wedgeq', '≙'),
			_Utils_Tuple2('weierp', '℘'),
			_Utils_Tuple2('Wfr', '\ud835\udd1a'),
			_Utils_Tuple2('wfr', '\ud835\udd34'),
			_Utils_Tuple2('Wopf', '\ud835\udd4e'),
			_Utils_Tuple2('wopf', '\ud835\udd68'),
			_Utils_Tuple2('wp', '℘'),
			_Utils_Tuple2('wr', '≀'),
			_Utils_Tuple2('wreath', '≀'),
			_Utils_Tuple2('Wscr', '\ud835\udcb2'),
			_Utils_Tuple2('wscr', '\ud835\udccc'),
			_Utils_Tuple2('xcap', '⋂'),
			_Utils_Tuple2('xcirc', '◯'),
			_Utils_Tuple2('xcup', '⋃'),
			_Utils_Tuple2('xdtri', '▽'),
			_Utils_Tuple2('Xfr', '\ud835\udd1b'),
			_Utils_Tuple2('xfr', '\ud835\udd35'),
			_Utils_Tuple2('xharr', '⟷'),
			_Utils_Tuple2('xhArr', '⟺'),
			_Utils_Tuple2('Xi', 'Ξ'),
			_Utils_Tuple2('xi', 'ξ'),
			_Utils_Tuple2('xlarr', '⟵'),
			_Utils_Tuple2('xlArr', '⟸'),
			_Utils_Tuple2('xmap', '⟼'),
			_Utils_Tuple2('xnis', '⋻'),
			_Utils_Tuple2('xodot', '⨀'),
			_Utils_Tuple2('Xopf', '\ud835\udd4f'),
			_Utils_Tuple2('xopf', '\ud835\udd69'),
			_Utils_Tuple2('xoplus', '⨁'),
			_Utils_Tuple2('xotime', '⨂'),
			_Utils_Tuple2('xrarr', '⟶'),
			_Utils_Tuple2('xrArr', '⟹'),
			_Utils_Tuple2('Xscr', '\ud835\udcb3'),
			_Utils_Tuple2('xscr', '\ud835\udccd'),
			_Utils_Tuple2('xsqcup', '⨆'),
			_Utils_Tuple2('xuplus', '⨄'),
			_Utils_Tuple2('xutri', '△'),
			_Utils_Tuple2('xvee', '⋁'),
			_Utils_Tuple2('xwedge', '⋀'),
			_Utils_Tuple2('Yacute', 'Ý'),
			_Utils_Tuple2('yacute', 'ý'),
			_Utils_Tuple2('YAcy', 'Я'),
			_Utils_Tuple2('yacy', 'я'),
			_Utils_Tuple2('Ycirc', 'Ŷ'),
			_Utils_Tuple2('ycirc', 'ŷ'),
			_Utils_Tuple2('Ycy', 'Ы'),
			_Utils_Tuple2('ycy', 'ы'),
			_Utils_Tuple2('yen', '¥'),
			_Utils_Tuple2('Yfr', '\ud835\udd1c'),
			_Utils_Tuple2('yfr', '\ud835\udd36'),
			_Utils_Tuple2('YIcy', 'Ї'),
			_Utils_Tuple2('yicy', 'ї'),
			_Utils_Tuple2('Yopf', '\ud835\udd50'),
			_Utils_Tuple2('yopf', '\ud835\udd6a'),
			_Utils_Tuple2('Yscr', '\ud835\udcb4'),
			_Utils_Tuple2('yscr', '\ud835\udcce'),
			_Utils_Tuple2('YUcy', 'Ю'),
			_Utils_Tuple2('yucy', 'ю'),
			_Utils_Tuple2('yuml', 'ÿ'),
			_Utils_Tuple2('Yuml', 'Ÿ'),
			_Utils_Tuple2('Zacute', 'Ź'),
			_Utils_Tuple2('zacute', 'ź'),
			_Utils_Tuple2('Zcaron', 'Ž'),
			_Utils_Tuple2('zcaron', 'ž'),
			_Utils_Tuple2('Zcy', 'З'),
			_Utils_Tuple2('zcy', 'з'),
			_Utils_Tuple2('Zdot', 'Ż'),
			_Utils_Tuple2('zdot', 'ż'),
			_Utils_Tuple2('zeetrf', 'ℨ'),
			_Utils_Tuple2('ZeroWidthSpace', '\u200b'),
			_Utils_Tuple2('Zeta', 'Ζ'),
			_Utils_Tuple2('zeta', 'ζ'),
			_Utils_Tuple2('zfr', '\ud835\udd37'),
			_Utils_Tuple2('Zfr', 'ℨ'),
			_Utils_Tuple2('ZHcy', 'Ж'),
			_Utils_Tuple2('zhcy', 'ж'),
			_Utils_Tuple2('zigrarr', '⇝'),
			_Utils_Tuple2('zopf', '\ud835\udd6b'),
			_Utils_Tuple2('Zopf', 'ℤ'),
			_Utils_Tuple2('Zscr', '\ud835\udcb5'),
			_Utils_Tuple2('zscr', '\ud835\udccf'),
			_Utils_Tuple2('zwj', '\u200d'),
			_Utils_Tuple2('zwnj', '\u200c')
		]));
var hecrj$html_parser$Html$Parser$namedCharacterReference = A2(
	elm$parser$Parser$map,
	function (reference) {
		return A2(
			elm$core$Maybe$withDefault,
			'&' + (reference + ';'),
			A2(elm$core$Dict$get, reference, hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict));
	},
	elm$parser$Parser$getChompedString(
		hecrj$html_parser$Html$Parser$chompOneOrMore(elm$core$Char$isAlpha)));
var elm$parser$Parser$ExpectingInt = {$: 1};
var elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {bK: s.bK + (newOffset - s.b), f: s.f, g: s.g, b: newOffset, cy: s.cy, a: s.a};
	});
var elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3(elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3(elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3(elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3(elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2(elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3(elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			elm$parser$Parser$Advanced$consumeExp,
			A2(elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2(elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _n0, s) {
		var endOffset = _n0.a;
		var n = _n0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				elm$parser$Parser$Advanced$Bad,
				true,
				A2(elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.b, startOffset) < 0,
				A2(elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2(elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2(elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.a);
		if (floatOffset < 0) {
			return A2(
				elm$parser$Parser$Advanced$Bad,
				true,
				A4(elm$parser$Parser$Advanced$fromInfo, s.cy, s.bK - (floatOffset + s.b), invalid, s.f));
		} else {
			if (_Utils_eq(s.b, floatOffset)) {
				return A2(
					elm$parser$Parser$Advanced$Bad,
					false,
					A2(elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5(elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.b, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							elm$parser$Parser$Advanced$Bad,
							true,
							A2(elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _n1 = elm$core$String$toFloat(
							A3(elm$core$String$slice, s.b, floatOffset, s.a));
						if (_n1.$ === 1) {
							return A2(
								elm$parser$Parser$Advanced$Bad,
								true,
								A2(elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _n1.a;
							return A3(
								elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2(elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3(elm$parser$Parser$Advanced$isAsciiCode, 48, s.b, s.a)) {
			var zeroOffset = s.b + 1;
			var baseOffset = zeroOffset + 1;
			return A3(elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.a) ? A5(
				elm$parser$Parser$Advanced$finalizeInt,
				c.dI,
				c.b$,
				baseOffset,
				A2(elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.a),
				s) : (A3(elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.a) ? A5(
				elm$parser$Parser$Advanced$finalizeInt,
				c.dI,
				c.ch,
				baseOffset,
				A3(elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.a),
				s) : (A3(elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.a) ? A5(
				elm$parser$Parser$Advanced$finalizeInt,
				c.dI,
				c.bz,
				baseOffset,
				A3(elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.a),
				s) : A6(
				elm$parser$Parser$Advanced$finalizeFloat,
				c.dI,
				c.bU,
				c.b5,
				c.bX,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				elm$parser$Parser$Advanced$finalizeFloat,
				c.dI,
				c.bU,
				c.b5,
				c.bX,
				A3(elm$parser$Parser$Advanced$consumeBase, 10, s.b, s.a),
				s);
		}
	};
};
var elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return elm$parser$Parser$Advanced$number(
			{
				bz: elm$core$Result$Err(invalid),
				bU: expecting,
				bX: elm$core$Result$Err(invalid),
				b$: elm$core$Result$Err(invalid),
				b5: elm$core$Result$Ok(elm$core$Basics$identity),
				dI: invalid,
				ch: elm$core$Result$Err(invalid)
			});
	});
var elm$parser$Parser$int = A2(elm$parser$Parser$Advanced$int, elm$parser$Parser$ExpectingInt, elm$parser$Parser$ExpectingInt);
var elm$core$Char$isHexDigit = function (_char) {
	var code = elm$core$Char$toCode(_char);
	return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
};
var hecrj$html_parser$Html$Parser$hexadecimal = A2(
	elm$parser$Parser$andThen,
	function (hex) {
		var _n0 = rtfeldman$elm_hex$Hex$fromString(
			elm$core$String$toLower(hex));
		if (!_n0.$) {
			var value = _n0.a;
			return elm$parser$Parser$succeed(value);
		} else {
			var error = _n0.a;
			return elm$parser$Parser$problem(error);
		}
	},
	elm$parser$Parser$getChompedString(
		hecrj$html_parser$Html$Parser$chompOneOrMore(elm$core$Char$isHexDigit)));
var hecrj$html_parser$Html$Parser$numericCharacterReference = function () {
	var codepoint = elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(elm$core$Basics$identity),
					elm$parser$Parser$chompIf(
						function (c) {
							return (c === 'x') || (c === 'X');
						})),
				hecrj$html_parser$Html$Parser$hexadecimal),
				A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(elm$core$Basics$identity),
					elm$parser$Parser$chompWhile(
						elm$core$Basics$eq('0'))),
				elm$parser$Parser$int)
			]));
	return A2(
		elm$parser$Parser$keeper,
		A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(elm$core$Basics$identity),
			elm$parser$Parser$chompIf(
				elm$core$Basics$eq('#'))),
		A2(
			elm$parser$Parser$map,
			A2(elm$core$Basics$composeR, elm$core$Char$fromCode, elm$core$String$fromChar),
			codepoint));
}();
var hecrj$html_parser$Html$Parser$characterReference = A2(
	elm$parser$Parser$keeper,
	A2(
		elm$parser$Parser$ignorer,
		elm$parser$Parser$succeed(elm$core$Basics$identity),
		elm$parser$Parser$chompIf(
			elm$core$Basics$eq('&'))),
	elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$backtrackable(hecrj$html_parser$Html$Parser$namedCharacterReference),
				hecrj$html_parser$Html$Parser$chompSemicolon),
				A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$backtrackable(hecrj$html_parser$Html$Parser$numericCharacterReference),
				hecrj$html_parser$Html$Parser$chompSemicolon),
				elm$parser$Parser$succeed('&')
			])));
var hecrj$html_parser$Html$Parser$tagAttributeQuotedValue = function (quote) {
	var isQuotedValueChar = function (c) {
		return (!_Utils_eq(c, quote)) && (c !== '&');
	};
	return A2(
		elm$parser$Parser$keeper,
		A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(elm$core$Basics$identity),
			elm$parser$Parser$chompIf(
				elm$core$Basics$eq(quote))),
		A2(
			elm$parser$Parser$ignorer,
			A2(
				elm$parser$Parser$map,
				elm$core$String$join(''),
				hecrj$html_parser$Html$Parser$many(
					elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								elm$parser$Parser$getChompedString(
								hecrj$html_parser$Html$Parser$chompOneOrMore(isQuotedValueChar)),
								hecrj$html_parser$Html$Parser$characterReference
							])))),
			elm$parser$Parser$chompIf(
				elm$core$Basics$eq(quote))));
};
var hecrj$html_parser$Html$Parser$oneOrMore = F2(
	function (type_, parser_) {
		return A2(
			elm$parser$Parser$loop,
			_List_Nil,
			function (list) {
				return elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							elm$parser$Parser$map,
							function (_new) {
								return elm$parser$Parser$Loop(
									A2(elm$core$List$cons, _new, list));
							},
							parser_),
							elm$core$List$isEmpty(list) ? elm$parser$Parser$problem('expecting at least one ' + type_) : elm$parser$Parser$succeed(
							elm$parser$Parser$Done(
								elm$core$List$reverse(list)))
						]));
			});
	});
var hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue = function () {
	var isUnquotedValueChar = function (c) {
		return (!hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '=') && ((c !== '<') && ((c !== '>') && ((c !== '`') && (c !== '&')))))));
	};
	return A2(
		elm$parser$Parser$map,
		elm$core$String$join(''),
		A2(
			hecrj$html_parser$Html$Parser$oneOrMore,
			'attribute value',
			elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						elm$parser$Parser$getChompedString(
						hecrj$html_parser$Html$Parser$chompOneOrMore(isUnquotedValueChar)),
						hecrj$html_parser$Html$Parser$characterReference
					]))));
}();
var hecrj$html_parser$Html$Parser$tagAttributeValue = elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			elm$parser$Parser$keeper,
			A2(
				elm$parser$Parser$ignorer,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(elm$core$Basics$identity),
					elm$parser$Parser$chompIf(
						elm$core$Basics$eq('='))),
				elm$parser$Parser$chompWhile(hecrj$html_parser$Html$Parser$isSpaceCharacter)),
			elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue,
						hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\"'),
						hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\'')
					]))),
			elm$parser$Parser$succeed('')
		]));
var hecrj$html_parser$Html$Parser$tagAttribute = A2(
	elm$parser$Parser$keeper,
	A2(
		elm$parser$Parser$keeper,
		elm$parser$Parser$succeed(elm$core$Tuple$pair),
		A2(
			elm$parser$Parser$ignorer,
			hecrj$html_parser$Html$Parser$tagAttributeName,
			elm$parser$Parser$chompWhile(hecrj$html_parser$Html$Parser$isSpaceCharacter))),
	A2(
		elm$parser$Parser$ignorer,
		hecrj$html_parser$Html$Parser$tagAttributeValue,
		elm$parser$Parser$chompWhile(hecrj$html_parser$Html$Parser$isSpaceCharacter)));
var hecrj$html_parser$Html$Parser$tagAttributes = hecrj$html_parser$Html$Parser$many(hecrj$html_parser$Html$Parser$tagAttribute);
var hecrj$html_parser$Html$Parser$tagName = A2(
	elm$parser$Parser$map,
	elm$core$String$toLower,
	elm$parser$Parser$getChompedString(
		A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$chompIf(elm$core$Char$isAlphaNum),
			elm$parser$Parser$chompWhile(
				function (c) {
					return elm$core$Char$isAlphaNum(c) || (c === '-');
				}))));
var hecrj$html_parser$Html$Parser$Text = function (a) {
	return {$: 0, a: a};
};
var hecrj$html_parser$Html$Parser$text = A2(
	elm$parser$Parser$map,
	A2(
		elm$core$Basics$composeR,
		elm$core$String$join(''),
		hecrj$html_parser$Html$Parser$Text),
	A2(
		hecrj$html_parser$Html$Parser$oneOrMore,
		'text element',
		elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					elm$parser$Parser$getChompedString(
					hecrj$html_parser$Html$Parser$chompOneOrMore(
						function (c) {
							return (c !== '<') && (c !== '&');
						})),
					hecrj$html_parser$Html$Parser$characterReference
				]))));
function hecrj$html_parser$Html$Parser$cyclic$node() {
	return elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				hecrj$html_parser$Html$Parser$text,
				hecrj$html_parser$Html$Parser$comment,
				hecrj$html_parser$Html$Parser$cyclic$element()
			]));
}
function hecrj$html_parser$Html$Parser$cyclic$element() {
	return A2(
		elm$parser$Parser$andThen,
		function (_n0) {
			var name = _n0.a;
			var attributes = _n0.b;
			return hecrj$html_parser$Html$Parser$isVoidElement(name) ? A2(
				elm$parser$Parser$ignorer,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(
						A3(hecrj$html_parser$Html$Parser$Element, name, attributes, _List_Nil)),
					elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								elm$parser$Parser$chompIf(
								elm$core$Basics$eq('/')),
								elm$parser$Parser$succeed(0)
							]))),
				elm$parser$Parser$chompIf(
					elm$core$Basics$eq('>'))) : A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(
						A2(hecrj$html_parser$Html$Parser$Element, name, attributes)),
					elm$parser$Parser$chompIf(
						elm$core$Basics$eq('>'))),
				A2(
					elm$parser$Parser$ignorer,
					hecrj$html_parser$Html$Parser$many(
						elm$parser$Parser$backtrackable(
							hecrj$html_parser$Html$Parser$cyclic$node())),
					hecrj$html_parser$Html$Parser$closingTag(name)));
		},
		A2(
			elm$parser$Parser$keeper,
			A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(elm$core$Tuple$pair),
					elm$parser$Parser$chompIf(
						elm$core$Basics$eq('<'))),
				A2(
					elm$parser$Parser$ignorer,
					hecrj$html_parser$Html$Parser$tagName,
					elm$parser$Parser$chompWhile(hecrj$html_parser$Html$Parser$isSpaceCharacter))),
			hecrj$html_parser$Html$Parser$tagAttributes));
}
var hecrj$html_parser$Html$Parser$node = hecrj$html_parser$Html$Parser$cyclic$node();
hecrj$html_parser$Html$Parser$cyclic$node = function () {
	return hecrj$html_parser$Html$Parser$node;
};
var hecrj$html_parser$Html$Parser$element = hecrj$html_parser$Html$Parser$cyclic$element();
hecrj$html_parser$Html$Parser$cyclic$element = function () {
	return hecrj$html_parser$Html$Parser$element;
};
var hecrj$html_parser$Html$Parser$run = function (str) {
	return elm$core$String$isEmpty(str) ? elm$core$Result$Ok(_List_Nil) : A2(
		elm$parser$Parser$run,
		A2(hecrj$html_parser$Html$Parser$oneOrMore, 'node', hecrj$html_parser$Html$Parser$node),
		str);
};
var elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var elm$html$Html$node = elm$virtual_dom$VirtualDom$node;
var elm$html$Html$text = elm$virtual_dom$VirtualDom$text;
var hecrj$html_parser$Html$Parser$Util$toAttribute = function (_n0) {
	var name = _n0.a;
	var value = _n0.b;
	return A2(elm$html$Html$Attributes$attribute, name, value);
};
var hecrj$html_parser$Html$Parser$Util$toVirtualDom = function (nodes) {
	return A2(elm$core$List$map, hecrj$html_parser$Html$Parser$Util$toVirtualDomEach, nodes);
};
var hecrj$html_parser$Html$Parser$Util$toVirtualDomEach = function (node) {
	switch (node.$) {
		case 1:
			var name = node.a;
			var attrs = node.b;
			var children = node.c;
			return A3(
				elm$html$Html$node,
				name,
				A2(elm$core$List$map, hecrj$html_parser$Html$Parser$Util$toAttribute, attrs),
				hecrj$html_parser$Html$Parser$Util$toVirtualDom(children));
		case 0:
			var s = node.a;
			return elm$html$Html$text(s);
		default:
			return elm$html$Html$text('');
	}
};
var rtfeldman$elm_css$Css$lineHeight = rtfeldman$elm_css$Css$prop1('line-height');
var rtfeldman$elm_css$Css$marginTop = rtfeldman$elm_css$Css$prop1('margin-top');
var rtfeldman$elm_css$Css$maxHeight = rtfeldman$elm_css$Css$prop1('max-height');
var rtfeldman$elm_css$Css$Addition = 0;
var rtfeldman$elm_css$Css$plus = 0;
var rtfeldman$elm_css$Css$static = {aH: 0, ed: 'static'};
var rtfeldman$elm_css$Css$Structure$TypeSelector = elm$core$Basics$identity;
var rtfeldman$elm_css$Css$Global$typeSelector = F2(
	function (selectorStr, styles) {
		var sequence = A2(rtfeldman$elm_css$Css$Structure$TypeSelectorSequence, selectorStr, _List_Nil);
		var sel = A3(rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3(rtfeldman$elm_css$Css$Preprocess$StyleBlock, sel, _List_Nil, styles))
			]);
	});
var rtfeldman$elm_css$Html$Styled$a = rtfeldman$elm_css$Html$Styled$node('a');
var rtfeldman$elm_css$VirtualDom$Styled$unstyledNode = rtfeldman$elm_css$VirtualDom$Styled$Unstyled;
var rtfeldman$elm_css$Html$Styled$fromUnstyled = rtfeldman$elm_css$VirtualDom$Styled$unstyledNode;
var rtfeldman$elm_css$Html$Styled$li = rtfeldman$elm_css$Html$Styled$node('li');
var rtfeldman$elm_css$Html$Styled$Attributes$href = function (url) {
	return A2(rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'href', url);
};
var rtfeldman$elm_css$Html$Styled$Attributes$target = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('target');
var author$project$PartialViews$Article$renderArticle = F3(
	function (articlePreviewHeight, sites, articleToRender) {
		var starredLabel = articleToRender.d4 ? 'starred' : '';
		var site = A2(author$project$Helpers$getArticleSite, sites, articleToRender);
		var domId = 'article_' + elm$core$String$fromInt(articleToRender.dE);
		var date = articleToRender.ba;
		var articleExcerptParsed = function () {
			var _n2 = hecrj$html_parser$Html$Parser$run(articleToRender.dr);
			if (!_n2.$) {
				var listNodes = _n2.a;
				return listNodes;
			} else {
				var err = _n2.a;
				return _List_Nil;
			}
		}();
		var imageUrl = A2(
			elm$core$Maybe$withDefault,
			'',
			elm$core$List$head(
				A2(
					author$project$HtmlParserUtils$mapElements,
					F3(
						function (_n0, attr, _n1) {
							return A2(
								elm$core$Maybe$withDefault,
								'',
								A2(author$project$HtmlParserUtils$getValue, 'src', attr));
						}),
					A2(author$project$HtmlParserUtils$getElementsByTagName, 'img', articleExcerptParsed))));
		return A2(
			rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$class('article')
				]),
			_List_fromArray(
				[
					A2(
					author$project$PartialViews$UiKit$article,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('article'),
							rtfeldman$elm_css$Html$Styled$Attributes$id(domId)
						]),
					_List_fromArray(
						[
							A4(
							rtfeldman$elm_css$Html$Styled$styled,
							rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$marginBottom(author$project$PartialViews$UiKit$theme.aV),
									author$project$PartialViews$UiKit$onDesktop(
									_List_fromArray(
										[rtfeldman$elm_css$Css$displayFlex]))
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('starAndArticle')
								]),
							_List_fromArray(
								[
									A4(
									rtfeldman$elm_css$Html$Styled$styled,
									rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$absolute),
											author$project$PartialViews$UiKit$onDesktop(
											_List_fromArray(
												[
													rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$static),
													rtfeldman$elm_css$Css$marginRight(
													rtfeldman$elm_css$Css$em(0.5))
												]))
										]),
									_List_Nil,
									_List_fromArray(
										[
											A3(
											author$project$PartialViews$UiKit$starBtn,
											'starred_' + elm$core$String$fromInt(articleToRender.dE),
											articleToRender.d4,
											function (checked) {
												return checked ? author$project$Models$SaveArticle(articleToRender) : author$project$Models$DeleteMsg(
													author$project$Models$DeleteArticles(
														_List_fromArray(
															[articleToRender.dE])));
											})
										])),
									A4(
									rtfeldman$elm_css$Html$Styled$styled,
									rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											author$project$PartialViews$UiKit$onDesktop(
											_List_fromArray(
												[
													rtfeldman$elm_css$Css$width(
													A3(
														rtfeldman$elm_css$Css$calc,
														rtfeldman$elm_css$Css$pct(100),
														rtfeldman$elm_css$Css$minus,
														A3(
															rtfeldman$elm_css$Css$calc,
															rtfeldman$elm_css$Css$rem(2.05),
															rtfeldman$elm_css$Css$plus,
															rtfeldman$elm_css$Css$em(0.5))))
												]))
										]),
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$Attributes$class('article-content')
										]),
									_List_fromArray(
										[
											A4(
											rtfeldman$elm_css$Html$Styled$styled,
											rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													rtfeldman$elm_css$Css$marginLeft(
													rtfeldman$elm_css$Css$rem(2)),
													rtfeldman$elm_css$Css$marginBottom(author$project$PartialViews$UiKit$theme.$7),
													author$project$PartialViews$UiKit$onDesktop(
													_List_fromArray(
														[
															rtfeldman$elm_css$Css$marginLeft(rtfeldman$elm_css$Css$zero)
														]))
												]),
											_List_fromArray(
												[
													rtfeldman$elm_css$Html$Styled$Attributes$class('articleDateAndSite')
												]),
											_List_fromArray(
												[
													A2(
													rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															rtfeldman$elm_css$Html$Styled$Attributes$class('articleDate')
														]),
													_List_fromArray(
														[
															rtfeldman$elm_css$Html$Styled$text(
															elm$core$String$fromInt(
																A2(elm$time$Time$toDay, elm$time$Time$utc, date)) + (' ' + (author$project$Models$toEnglishMonth(
																A2(elm$time$Time$toMonth, elm$time$Time$utc, date)) + (' ' + elm$core$String$fromInt(
																A2(elm$time$Time$toYear, elm$time$Time$utc, date))))))
														])),
													A2(
													rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															rtfeldman$elm_css$Html$Styled$Attributes$class('articleSite')
														]),
													_List_fromArray(
														[
															rtfeldman$elm_css$Html$Styled$text(site.aZ)
														]))
												])),
											A2(
											author$project$PartialViews$UiKit$articleTitle,
											_List_fromArray(
												[
													rtfeldman$elm_css$Html$Styled$Attributes$class('article-title')
												]),
											_List_fromArray(
												[
													A2(
													rtfeldman$elm_css$Html$Styled$a,
													_List_fromArray(
														[
															rtfeldman$elm_css$Html$Styled$Attributes$class('article-link'),
															rtfeldman$elm_css$Html$Styled$Attributes$href(articleToRender.dO),
															rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
														]),
													_List_fromArray(
														[
															rtfeldman$elm_css$Html$Styled$text(articleToRender.d9)
														]))
												])),
											author$project$PartialViews$Article$articleImage(imageUrl),
											A4(
											rtfeldman$elm_css$Html$Styled$styled,
											rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													rtfeldman$elm_css$Css$Global$descendants(
													_List_fromArray(
														[
															A2(
															rtfeldman$elm_css$Css$Global$typeSelector,
															'img',
															_List_fromArray(
																[
																	rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$none)
																]))
														])),
													rtfeldman$elm_css$Css$maxHeight(
													rtfeldman$elm_css$Css$em(articlePreviewHeight)),
													rtfeldman$elm_css$Css$lineHeight(
													rtfeldman$elm_css$Css$em(1.4)),
													author$project$PartialViews$UiKit$transition('max-height 0.3s'),
													rtfeldman$elm_css$Css$overflow(rtfeldman$elm_css$Css$hidden)
												]),
											_List_fromArray(
												[
													rtfeldman$elm_css$Html$Styled$Attributes$class('article-excerpt')
												]),
											_List_fromArray(
												[
													A4(
													rtfeldman$elm_css$Html$Styled$styled,
													rtfeldman$elm_css$Html$Styled$div,
													_List_Nil,
													_List_fromArray(
														[
															rtfeldman$elm_css$Html$Styled$Attributes$class('article-excerptInner')
														]),
													A2(
														elm$core$List$map,
														function (el) {
															return rtfeldman$elm_css$Html$Styled$fromUnstyled(el);
														},
														hecrj$html_parser$Html$Parser$Util$toVirtualDom(articleExcerptParsed)))
												])),
											A4(
											rtfeldman$elm_css$Html$Styled$styled,
											author$project$PartialViews$UiKit$btn,
											_List_fromArray(
												[
													rtfeldman$elm_css$Css$marginTop(author$project$PartialViews$UiKit$theme.aV),
													rtfeldman$elm_css$Css$opacity(rtfeldman$elm_css$Css$zero),
													author$project$PartialViews$UiKit$transition('opacity 0.3s')
												]),
											_List_fromArray(
												[
													rtfeldman$elm_css$Html$Styled$Attributes$class('readMoreButton'),
													rtfeldman$elm_css$Html$Styled$Events$onClick(
													A3(author$project$Models$ToggleExcerpt, articleToRender.dE, domId, !articleToRender.dL)),
													rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled(
													fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true))
												]),
											_List_fromArray(
												[
													rtfeldman$elm_css$Html$Styled$text(
													articleToRender.dL ? 'read less' : 'read more')
												]))
										]))
								]))
						]))
				]));
	});
var author$project$Models$ChangePage = function (a) {
	return {$: 21, a: a};
};
var author$project$Models$ChangeNumberOfArticlesPerPage = function (a) {
	return {$: 22, a: a};
};
var author$project$PartialViews$UiKit$selectableBtn = function (selected) {
	return A2(
		rtfeldman$elm_css$Html$Styled$styled,
		rtfeldman$elm_css$Html$Styled$button,
		_List_fromArray(
			[
				author$project$PartialViews$UiKit$btnStyle(selected)
			]));
};
var author$project$PartialViews$MainContent$renderChangeNumberOfArticlesPerPageButton = F2(
	function (currentArticlesPerPage, newArticlesPerPage) {
		return A4(
			rtfeldman$elm_css$Html$Styled$styled,
			rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$marginLeft(
					rtfeldman$elm_css$Css$rem(0.5))
				]),
			_List_Nil,
			_List_fromArray(
				[
					A3(
					author$project$PartialViews$UiKit$selectableBtn,
					_Utils_eq(currentArticlesPerPage, newArticlesPerPage),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('changeNumberOfArticlesPerPageButton'),
							rtfeldman$elm_css$Html$Styled$Events$onClick(
							author$project$Models$ChangeNumberOfArticlesPerPage(newArticlesPerPage))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text(
							elm$core$String$fromInt(newArticlesPerPage))
						]))
				]));
	});
var elm$core$String$endsWith = _String_endsWith;
var rtfeldman$elm_css$Css$makeImportant = function (str) {
	return A2(
		elm$core$String$endsWith,
		' !important',
		elm$core$String$toLower(str)) ? str : (str + ' !important');
};
var rtfeldman$elm_css$Css$Preprocess$mapAllLastProperty = F2(
	function (update, styles) {
		if (!styles.b) {
			return styles;
		} else {
			if (!styles.b.b) {
				var only = styles.a;
				return _List_fromArray(
					[
						A2(rtfeldman$elm_css$Css$Preprocess$mapLastProperty, update, only)
					]);
			} else {
				var first = styles.a;
				var rest = styles.b;
				return A2(
					elm$core$List$cons,
					first,
					A2(rtfeldman$elm_css$Css$Preprocess$mapAllLastProperty, update, rest));
			}
		}
	});
var rtfeldman$elm_css$Css$Preprocess$mapLastProperty = F2(
	function (update, style) {
		switch (style.$) {
			case 0:
				var property = style.a;
				return rtfeldman$elm_css$Css$Preprocess$AppendProperty(
					update(property));
			case 1:
				var selector = style.a;
				var styles = style.b;
				return A2(
					rtfeldman$elm_css$Css$Preprocess$ExtendSelector,
					selector,
					A2(rtfeldman$elm_css$Css$Preprocess$mapAllLastProperty, update, styles));
			case 2:
				return style;
			case 3:
				return style;
			case 4:
				return style;
			case 5:
				return style;
			default:
				var otherStyles = style.a;
				return rtfeldman$elm_css$Css$Preprocess$ApplyStyles(
					A2(
						rtfeldman$elm_css$Css$Structure$mapLast,
						rtfeldman$elm_css$Css$Preprocess$mapLastProperty(update),
						otherStyles));
		}
	});
var rtfeldman$elm_css$Css$important = rtfeldman$elm_css$Css$Preprocess$mapLastProperty(rtfeldman$elm_css$Css$makeImportant);
var author$project$PartialViews$MainContent$showIf = function (condition) {
	return condition ? rtfeldman$elm_css$Css$batch(_List_Nil) : rtfeldman$elm_css$Css$important(
		rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$none));
};
var elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var rtfeldman$elm_css$Css$columnReverse = _Utils_update(
	rtfeldman$elm_css$Css$row,
	{ed: 'column-reverse'});
var author$project$PartialViews$MainContent$renderPagination = F4(
	function (articlesToDisplay, articlesPerPage, currentPage, lastPage) {
		return A4(
			rtfeldman$elm_css$Html$Styled$styled,
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$textAlign(rtfeldman$elm_css$Css$center),
					rtfeldman$elm_css$Css$displayFlex,
					rtfeldman$elm_css$Css$flexDirection(rtfeldman$elm_css$Css$columnReverse),
					rtfeldman$elm_css$Css$justifyContent(rtfeldman$elm_css$Css$spaceBetween),
					author$project$PartialViews$MainContent$showIf(
					_Utils_eq(
						elm$core$List$length(articlesToDisplay),
						articlesPerPage)),
					author$project$PartialViews$UiKit$onDesktop(
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$flexDirection(rtfeldman$elm_css$Css$row)
						]))
				]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$class('pagerToolbar')
				]),
			_List_fromArray(
				[
					A4(
					rtfeldman$elm_css$Html$Styled$styled,
					rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$marginBottom(
							rtfeldman$elm_css$Css$rem(0.5))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('pagerWrapper')
						]),
					_List_fromArray(
						[
							A4(
							rtfeldman$elm_css$Html$Styled$styled,
							author$project$PartialViews$UiKit$btn,
							_List_fromArray(
								[
									author$project$PartialViews$MainContent$showIf(currentPage > 1),
									rtfeldman$elm_css$Css$marginRight(
									rtfeldman$elm_css$Css$rem(0.5))
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('firstPageButton'),
									rtfeldman$elm_css$Html$Styled$Events$onClick(
									author$project$Models$ChangePage(1))
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('<<')
								])),
							A4(
							rtfeldman$elm_css$Html$Styled$styled,
							author$project$PartialViews$UiKit$btn,
							_List_fromArray(
								[
									author$project$PartialViews$MainContent$showIf(currentPage > 1),
									rtfeldman$elm_css$Css$marginRight(
									rtfeldman$elm_css$Css$rem(0.5))
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('prevPageButton'),
									rtfeldman$elm_css$Html$Styled$Events$onClick(
									author$project$Models$ChangePage(
										A2(elm$core$Basics$max, 1, currentPage - 1)))
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('<')
								])),
							A4(
							rtfeldman$elm_css$Html$Styled$styled,
							rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$marginRight(
									rtfeldman$elm_css$Css$em(0.5))
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('currentPage')
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text(
									elm$core$String$fromInt(currentPage) + ('/' + elm$core$String$fromInt(lastPage)))
								])),
							A4(
							rtfeldman$elm_css$Html$Styled$styled,
							author$project$PartialViews$UiKit$btn,
							_List_fromArray(
								[
									author$project$PartialViews$MainContent$showIf(
									_Utils_cmp(currentPage, lastPage) < 0),
									rtfeldman$elm_css$Css$marginRight(
									rtfeldman$elm_css$Css$rem(0.5))
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('nextPageButton'),
									rtfeldman$elm_css$Html$Styled$Events$onClick(
									author$project$Models$ChangePage(
										A2(elm$core$Basics$min, lastPage, currentPage + 1)))
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('>')
								])),
							A4(
							rtfeldman$elm_css$Html$Styled$styled,
							author$project$PartialViews$UiKit$btn,
							_List_fromArray(
								[
									author$project$PartialViews$MainContent$showIf(
									_Utils_cmp(currentPage, lastPage) < 0)
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('nextPageButton'),
									rtfeldman$elm_css$Html$Styled$Events$onClick(
									author$project$Models$ChangePage(lastPage))
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('>>')
								]))
						])),
					A4(
					rtfeldman$elm_css$Html$Styled$styled,
					rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$marginBottom(
							rtfeldman$elm_css$Css$rem(0.5))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('changeNumberOfArticlesPerPageButtonsWrapper')
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$Attributes$class('articlesPerPageLabel')
									]),
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$text('articles per page ')
									]))
							]),
						A2(
							elm$core$List$map,
							author$project$PartialViews$MainContent$renderChangeNumberOfArticlesPerPageButton(articlesPerPage),
							_List_fromArray(
								[10, 25, 50]))))
				]));
	});
var elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var rtfeldman$elm_css$Css$backgroundPosition2 = rtfeldman$elm_css$Css$prop2('background-position');
var rtfeldman$elm_css$Css$contain = {H: 0, ed: 'contain'};
var rtfeldman$elm_css$Css$maxWidth = rtfeldman$elm_css$Css$prop1('max-width');
var rtfeldman$elm_css$Css$VhUnits = 0;
var rtfeldman$elm_css$Css$vh = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'vh');
var rtfeldman$elm_css$Html$Styled$main_ = rtfeldman$elm_css$Html$Styled$node('main');
var rtfeldman$elm_css$Html$Styled$ul = rtfeldman$elm_css$Html$Styled$node('ul');
var author$project$PartialViews$MainContent$mainContent = F6(
	function (categories, sites, articles, options, currentPage, sidebarCollapsed) {
		var selectedArticles = A3(author$project$Helpers$getSelectedArticles, categories, sites, articles);
		var lastPage = (elm$core$List$length(selectedArticles) / options.c1) | 0;
		var articlesToDisplay = A2(
			elm$core$List$take,
			options.c1,
			A2(elm$core$List$drop, options.c1 * (currentPage - 1), selectedArticles));
		return A4(
			rtfeldman$elm_css$Html$Styled$styled,
			rtfeldman$elm_css$Html$Styled$main_,
			_List_fromArray(
				[
					author$project$PartialViews$UiKit$standardPadding,
					author$project$PartialViews$UiKit$onDesktop(
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$maxWidth(
							A3(
								rtfeldman$elm_css$Css$calc,
								rtfeldman$elm_css$Css$pct(100),
								rtfeldman$elm_css$Css$minus,
								sidebarCollapsed ? rtfeldman$elm_css$Css$rem(0) : rtfeldman$elm_css$Css$rem(25)))
						]))
				]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$class('mainContent')
				]),
			(!elm$core$List$length(articles)) ? _List_fromArray(
				[
					A4(
					rtfeldman$elm_css$Html$Styled$styled,
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$backgroundImage(
							rtfeldman$elm_css$Css$url('/no_articles.svg')),
							rtfeldman$elm_css$Css$backgroundSize(rtfeldman$elm_css$Css$contain),
							rtfeldman$elm_css$Css$backgroundRepeat(rtfeldman$elm_css$Css$noRepeat),
							A2(
							rtfeldman$elm_css$Css$backgroundPosition2,
							rtfeldman$elm_css$Css$pct(100),
							rtfeldman$elm_css$Css$zero),
							rtfeldman$elm_css$Css$width(
							rtfeldman$elm_css$Css$pct(100)),
							rtfeldman$elm_css$Css$height(
							rtfeldman$elm_css$Css$vh(80))
						]),
					_List_Nil,
					_List_fromArray(
						[
							A4(
							rtfeldman$elm_css$Html$Styled$styled,
							rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[author$project$PartialViews$UiKit$visuallyHiddenStyle]),
							_List_Nil,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('no article yet, click the refresh button')
								]))
						]))
				]) : ((elm$core$List$length(articlesToDisplay) > 0) ? _List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('selectedArticles')
						]),
					A2(
						elm$core$List$map,
						A2(author$project$PartialViews$Article$renderArticle, options.c$, sites),
						articlesToDisplay)),
					A4(author$project$PartialViews$MainContent$renderPagination, articlesToDisplay, options.c1, currentPage, lastPage)
				]) : _List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('noArticleSelected')
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text('No article selected, try to select another site o category')
						]))
				])));
	});
var rtfeldman$elm_css$Css$borderColor = function (c) {
	return A2(rtfeldman$elm_css$Css$property, 'border-color', c.ed);
};
var author$project$PartialViews$UiKit$secondaryBtn = A2(
	rtfeldman$elm_css$Html$Styled$styled,
	rtfeldman$elm_css$Html$Styled$button,
	_List_fromArray(
		[
			author$project$PartialViews$UiKit$btnStyle(false),
			rtfeldman$elm_css$Css$backgroundColor(rtfeldman$elm_css$Css$transparent),
			rtfeldman$elm_css$Css$borderColor(author$project$PartialViews$UiKit$theme.da),
			rtfeldman$elm_css$Css$color(author$project$PartialViews$UiKit$theme.da),
			rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$backgroundColor(author$project$PartialViews$UiKit$theme.da),
					rtfeldman$elm_css$Css$color(author$project$PartialViews$UiKit$theme.eh)
				]))
		]));
var rtfeldman$elm_css$Css$auto = {cY: 0, c: 0, ac: 0, aX: 0, dM: 0, ah: 0, H: 0, A: 0, ak: 0, x: 0, a5: 0, ar: 0, v: 0, ed: 'auto'};
var rtfeldman$elm_css$Css$margin2 = rtfeldman$elm_css$Css$prop2('margin');
var rtfeldman$elm_css$Css$padding3 = rtfeldman$elm_css$Css$prop3('padding');
var rtfeldman$elm_css$Css$translate2 = F2(
	function (tx, ty) {
		return {
			i: 0,
			ed: A2(
				rtfeldman$elm_css$Css$cssFunction,
				'translate',
				_List_fromArray(
					[tx.ed, ty.ed]))
		};
	});
var author$project$PartialViews$Modal$modal = F2(
	function (data, animationClass) {
		return A4(
			rtfeldman$elm_css$Html$Styled$styled,
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$width(
					rtfeldman$elm_css$Css$em(30)),
					rtfeldman$elm_css$Css$maxWidth(
					rtfeldman$elm_css$Css$pct(90)),
					rtfeldman$elm_css$Css$zIndex(
					rtfeldman$elm_css$Css$int(50)),
					rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$absolute),
					rtfeldman$elm_css$Css$top(
					rtfeldman$elm_css$Css$pct(50)),
					rtfeldman$elm_css$Css$left(
					rtfeldman$elm_css$Css$pct(50)),
					rtfeldman$elm_css$Css$transforms(
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Css$translate2,
							rtfeldman$elm_css$Css$pct(-50),
							rtfeldman$elm_css$Css$pct(-50))
						])),
					rtfeldman$elm_css$Css$backgroundColor(author$project$PartialViews$UiKit$theme.c8),
					rtfeldman$elm_css$Css$borderRadius(
					rtfeldman$elm_css$Css$px(3)),
					A3(
					rtfeldman$elm_css$Css$border3,
					rtfeldman$elm_css$Css$px(1),
					rtfeldman$elm_css$Css$solid,
					author$project$PartialViews$UiKit$theme.c9)
				]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$class('modal' + animationClass)
				]),
			_List_fromArray(
				[
					A4(
					rtfeldman$elm_css$Html$Styled$styled,
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							A3(rtfeldman$elm_css$Css$padding3, author$project$PartialViews$UiKit$theme.aV, author$project$PartialViews$UiKit$theme.aV, rtfeldman$elm_css$Css$zero),
							A3(
							rtfeldman$elm_css$Css$borderBottom3,
							rtfeldman$elm_css$Css$px(2),
							rtfeldman$elm_css$Css$solid,
							author$project$PartialViews$UiKit$theme.c9)
						]),
					_List_Nil,
					_List_fromArray(
						[
							author$project$PartialViews$UiKit$closeButton(
							author$project$Models$TogglePanel(2))
						])),
					A4(
					rtfeldman$elm_css$Html$Styled$styled,
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							author$project$PartialViews$UiKit$standardPadding,
							rtfeldman$elm_css$Css$marginBottom(
							rtfeldman$elm_css$Css$em(1))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('modal-text')
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text(data.d8)
						])),
					A4(
					rtfeldman$elm_css$Html$Styled$styled,
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$displayFlex,
							rtfeldman$elm_css$Css$width(
							rtfeldman$elm_css$Css$pct(80)),
							A2(rtfeldman$elm_css$Css$margin2, rtfeldman$elm_css$Css$zero, rtfeldman$elm_css$Css$auto),
							author$project$PartialViews$UiKit$standardPadding,
							rtfeldman$elm_css$Css$justifyContent(rtfeldman$elm_css$Css$spaceBetween)
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('modal-buttons')
						]),
					_List_fromArray(
						[
							A2(
							author$project$PartialViews$UiKit$btn,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('modal-okButton'),
									rtfeldman$elm_css$Html$Styled$Events$onClick(data.bt)
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('yes')
								])),
							A2(
							author$project$PartialViews$UiKit$secondaryBtn,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('modal-cancelButton'),
									rtfeldman$elm_css$Html$Styled$Events$onClick(
									author$project$Models$TogglePanel(2))
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('no')
								]))
						]))
				]));
	});
var author$project$Models$ChangeMaxNumberOfFailures = function (a) {
	return {$: 24, a: a};
};
var author$project$Models$ChangePreviewHeight = function (a) {
	return {$: 23, a: a};
};
var author$project$Models$OpenImportPanel = {$: 18};
var author$project$Models$SignOut = {$: 28};
var author$project$Models$TriggerExportData = {$: 34};
var author$project$PartialViews$Icons$exitIcon = function (styles) {
	return A4(
		rtfeldman$elm_css$Svg$Styled$styled,
		rtfeldman$elm_css$Svg$Styled$svg,
		_Utils_ap(
			_List_fromArray(
				[author$project$PartialViews$Icons$iconStyle]),
			styles),
		_List_fromArray(
			[
				rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 16 16')
			]),
		_List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M12 10v-2h-5v-2h5v-2l3 3zM11 9v4h-5v3l-6-3v-13h11v5h-1v-4h-8l4 2v9h4v-3z')
					]),
				_List_Nil)
			]));
};
var author$project$PartialViews$Icons$exportIcon = function (styles) {
	return A4(
		rtfeldman$elm_css$Svg$Styled$styled,
		rtfeldman$elm_css$Svg$Styled$svg,
		_Utils_ap(
			_List_fromArray(
				[author$project$PartialViews$Icons$iconStyle]),
			styles),
		_List_fromArray(
			[
				rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 16 16')
			]),
		_List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M 8,1 4,5 H 7 V 9 H 9 V 5 h 3 z')
					]),
				_List_Nil),
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M 11.636,7.364 10.515,8.485 14.579,10 8,12.453 1.421,10 5.485,8.485 4.364,7.364 0,9 v 4 l 8,3 8,-3 V 9 Z')
					]),
				_List_Nil)
			]));
};
var author$project$PartialViews$Icons$importIcon = function (styles) {
	return A4(
		rtfeldman$elm_css$Svg$Styled$styled,
		rtfeldman$elm_css$Svg$Styled$svg,
		_Utils_ap(
			_List_fromArray(
				[author$project$PartialViews$Icons$iconStyle]),
			styles),
		_List_fromArray(
			[
				rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 16 16')
			]),
		_List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M8 9l4-4h-3v-4h-2v4h-3zM11.636 7.364l-1.121 1.121 4.064 1.515-6.579 2.453-6.579-2.453 4.064-1.515-1.121-1.121-4.364 1.636v4l8 3 8-3v-4z')
					]),
				_List_Nil)
			]));
};
var author$project$PartialViews$SettingsLayer$settingsLayer = F2(
	function (options, animationClass) {
		return A3(
			author$project$PartialViews$UiKit$layerTop,
			author$project$Models$TogglePanel(4),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$class('settingsLayer' + animationClass)
				]),
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('layer-inner')
						]),
					_List_fromArray(
						[
							A2(
							author$project$PartialViews$UiKit$inputRow,
							_List_Nil,
							_List_fromArray(
								[
									A4(
									rtfeldman$elm_css$Html$Styled$styled,
									rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											rtfeldman$elm_css$Css$marginRight(author$project$PartialViews$UiKit$theme.dl)
										]),
									_List_Nil,
									_List_fromArray(
										[
											A4(
											rtfeldman$elm_css$Html$Styled$styled,
											rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													rtfeldman$elm_css$Css$marginRight(author$project$PartialViews$UiKit$theme.dl)
												]),
											_List_Nil,
											_List_fromArray(
												[
													A3(
													author$project$PartialViews$IconButton$iconButton,
													author$project$PartialViews$Icons$importIcon(_List_Nil),
													_Utils_Tuple2('import', true),
													_List_fromArray(
														[
															rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$Models$OpenImportPanel)
														]))
												])),
											A3(
											author$project$PartialViews$IconButton$iconButton,
											author$project$PartialViews$Icons$exportIcon(_List_Nil),
											_Utils_Tuple2('export', true),
											_List_fromArray(
												[
													rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$Models$TriggerExportData)
												]))
										]))
								])),
							A2(
							author$project$PartialViews$UiKit$inputRow,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									author$project$PartialViews$IconButton$iconButton,
									author$project$PartialViews$Icons$exitIcon(_List_Nil),
									_Utils_Tuple2('sign out', true),
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$Models$SignOut)
										]))
								])),
							A2(
							author$project$PartialViews$UiKit$inputRow,
							_List_Nil,
							_List_fromArray(
								[
									A2(author$project$PartialViews$UiKit$inputRowLabel, 'previewRows', 'Text preview height (in rows)'),
									A4(
									rtfeldman$elm_css$Html$Styled$styled,
									author$project$PartialViews$UiKit$input,
									_List_fromArray(
										[
											rtfeldman$elm_css$Css$flex(
											rtfeldman$elm_css$Css$int(5))
										]),
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$Attributes$class('input'),
											rtfeldman$elm_css$Html$Styled$Attributes$id('previewRows'),
											rtfeldman$elm_css$Html$Styled$Attributes$value(
											elm$core$String$fromFloat(options.c$)),
											rtfeldman$elm_css$Html$Styled$Events$onInput(author$project$Models$ChangePreviewHeight),
											rtfeldman$elm_css$Html$Styled$Attributes$type_('number')
										]),
									_List_Nil)
								])),
							A2(
							author$project$PartialViews$UiKit$inputRow,
							_List_Nil,
							_List_fromArray(
								[
									A2(author$project$PartialViews$UiKit$inputRowLabel, 'maxNumberOfFailures', 'Number of consecutive failures before disabling a site'),
									A4(
									rtfeldman$elm_css$Html$Styled$styled,
									author$project$PartialViews$UiKit$input,
									_List_fromArray(
										[
											rtfeldman$elm_css$Css$flex(
											rtfeldman$elm_css$Css$int(5))
										]),
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$Attributes$class('input'),
											rtfeldman$elm_css$Html$Styled$Attributes$id('maxNumberOfFailures'),
											rtfeldman$elm_css$Html$Styled$Attributes$value(
											elm$core$String$fromInt(options.dP)),
											rtfeldman$elm_css$Html$Styled$Events$onInput(author$project$Models$ChangeMaxNumberOfFailures),
											rtfeldman$elm_css$Html$Styled$Attributes$type_('number')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var author$project$Models$Swiped = function (a) {
	return {$: 26, a: a};
};
var author$project$Models$ToggleSidebar = {$: 15};
var author$project$PartialViews$IconButton$iconButtonStyled = F4(
	function (icon, labelData, styles, attributes) {
		return A5(
			author$project$PartialViews$IconButton$iconButton_,
			author$project$PartialViews$UiKit$btnNoStyle,
			icon,
			labelData,
			_Utils_ap(
				_List_fromArray(
					[
						A2(rtfeldman$elm_css$Css$padding2, author$project$PartialViews$UiKit$theme.$7, author$project$PartialViews$UiKit$theme.aV)
					]),
				styles),
			attributes);
	});
var author$project$PartialViews$Icons$arrowLeftIcon = function (styles) {
	return A4(
		rtfeldman$elm_css$Svg$Styled$styled,
		rtfeldman$elm_css$Svg$Styled$svg,
		styles,
		_List_fromArray(
			[
				rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 18 18')
			]),
		_List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M11.56 5.56L10.5 4.5 6 9l4.5 4.5 1.06-1.06L8.12 9z')
					]),
				_List_Nil)
			]));
};
var author$project$Models$OpenEditSitePanel = function (a) {
	return {$: 0, a: a};
};
var author$project$Models$ToggleSelectSite = function (a) {
	return {$: 2, a: a};
};
var author$project$PartialViews$IconButton$iconButtonNoStyle = F3(
	function (icon, labelData, attributes) {
		return A5(
			author$project$PartialViews$IconButton$iconButton_,
			author$project$PartialViews$UiKit$btnNoStyle,
			icon,
			labelData,
			_List_fromArray(
				[
					A2(rtfeldman$elm_css$Css$padding2, author$project$PartialViews$UiKit$theme.$7, author$project$PartialViews$UiKit$theme.aV)
				]),
			attributes);
	});
var author$project$PartialViews$Icons$editIcon = function (styles) {
	return A4(
		rtfeldman$elm_css$Svg$Styled$styled,
		rtfeldman$elm_css$Svg$Styled$svg,
		_Utils_ap(
			_List_fromArray(
				[author$project$PartialViews$Icons$iconStyle]),
			styles),
		_List_fromArray(
			[
				rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 16 16')
			]),
		_List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M13.5 0c1.381 0 2.5 1.119 2.5 2.5 0 0.563-0.186 1.082-0.5 1.5l-1 1-3.5-3.5 1-1c0.418-0.314 0.937-0.5 1.5-0.5zM1 11.5l-1 4.5 4.5-1 9.25-9.25-3.5-3.5-9.25 9.25zM11.181 5.681l-7 7-0.862-0.862 7-7 0.862 0.862z')
					]),
				_List_Nil)
			]));
};
var author$project$PartialViews$UiKit$badge = A2(
	rtfeldman$elm_css$Html$Styled$styled,
	rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
			rtfeldman$elm_css$Css$backgroundColor(author$project$PartialViews$UiKit$theme.aS),
			rtfeldman$elm_css$Css$color(author$project$PartialViews$UiKit$theme.eh),
			rtfeldman$elm_css$Css$fontSize(
			rtfeldman$elm_css$Css$rem(0.7)),
			rtfeldman$elm_css$Css$borderRadius(
			rtfeldman$elm_css$Css$pct(25)),
			rtfeldman$elm_css$Css$textAlign(rtfeldman$elm_css$Css$center),
			rtfeldman$elm_css$Css$padding(
			rtfeldman$elm_css$Css$rem(0.2)),
			rtfeldman$elm_css$Css$verticalAlign(rtfeldman$elm_css$Css$middle),
			rtfeldman$elm_css$Css$marginRight(
			rtfeldman$elm_css$Css$rem(0.5))
		]));
var author$project$PartialViews$UiKit$customCss = F2(
	function (prop, val) {
		return A2(rtfeldman$elm_css$Css$property, prop, val);
	});
var author$project$PartialViews$UiKit$sidebarRow = function (selected) {
	var selectedStyle = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$backgroundColor(author$project$PartialViews$UiKit$theme.aT),
				rtfeldman$elm_css$Css$zIndex(author$project$PartialViews$UiKit$theme.cX.cE)
			]));
	return A2(
		rtfeldman$elm_css$Html$Styled$styled,
		rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$displayFlex,
				rtfeldman$elm_css$Css$justifyContent(rtfeldman$elm_css$Css$spaceBetween),
				rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$relative),
				rtfeldman$elm_css$Css$alignItems(rtfeldman$elm_css$Css$center),
				rtfeldman$elm_css$Css$backgroundColor(author$project$PartialViews$UiKit$theme.c8),
				rtfeldman$elm_css$Css$width(
				rtfeldman$elm_css$Css$pct(100)),
				rtfeldman$elm_css$Css$zIndex(
				rtfeldman$elm_css$Css$int(2)),
				author$project$PartialViews$UiKit$transition('background-color 0.5s'),
				selected ? selectedStyle : rtfeldman$elm_css$Css$batch(_List_Nil),
				rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[selectedStyle]))
			]));
};
var author$project$PartialViews$UiKit$sidebarSelectionBtn = A2(
	rtfeldman$elm_css$Html$Styled$styled,
	rtfeldman$elm_css$Html$Styled$button,
	_List_fromArray(
		[
			author$project$PartialViews$UiKit$btnNoStyleStyle,
			author$project$PartialViews$UiKit$standardPadding,
			rtfeldman$elm_css$Css$textAlign(rtfeldman$elm_css$Css$left),
			rtfeldman$elm_css$Css$displayFlex,
			rtfeldman$elm_css$Css$alignItems(rtfeldman$elm_css$Css$center),
			rtfeldman$elm_css$Css$flex(
			rtfeldman$elm_css$Css$int(1))
		]));
var rtfeldman$elm_css$Css$flexShrink = rtfeldman$elm_css$Css$prop1('flex-shrink');
var rtfeldman$elm_css$Css$lineThrough = {ap: 0, ed: 'line-through'};
var author$project$PartialViews$CategoryTree$renderSiteEntry = function (site) {
	return A2(
		rtfeldman$elm_css$Html$Styled$li,
		_List_fromArray(
			[
				rtfeldman$elm_css$Html$Styled$Attributes$class('category-siteInCategory ')
			]),
		_List_fromArray(
			[
				A3(
				author$project$PartialViews$UiKit$sidebarRow,
				site.aD,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$class('sidebarRow')
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A4(
							rtfeldman$elm_css$Html$Styled$styled,
							author$project$PartialViews$UiKit$sidebarSelectionBtn,
							_List_fromArray(
								[
									site.aD ? rtfeldman$elm_css$Css$batch(_List_Nil) : A2(author$project$PartialViews$UiKit$customCss, 'padding-right', 'calc(3.75rem + 2em)')
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('siteInCategoryBtn'),
									rtfeldman$elm_css$Html$Styled$Events$onClick(
									author$project$Models$ToggleSelectSite(site.dE))
								]),
							_List_fromArray(
								[
									A2(
									author$project$PartialViews$UiKit$badge,
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$Attributes$class('site-numberOfArticles')
										]),
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$text(
											elm$core$String$fromInt(site.dT))
										])),
									A4(
									rtfeldman$elm_css$Html$Styled$styled,
									rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											site.dJ ? rtfeldman$elm_css$Css$textDecoration(rtfeldman$elm_css$Css$none) : rtfeldman$elm_css$Css$textDecoration(rtfeldman$elm_css$Css$lineThrough)
										]),
									_List_Nil,
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$text(site.aZ)
										]))
								]))
						]),
					site.aD ? _List_fromArray(
						[
							A4(
							rtfeldman$elm_css$Html$Styled$styled,
							rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$flexShrink(
									rtfeldman$elm_css$Css$int(0))
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('siteInCategory-actions button-group')
								]),
							_List_fromArray(
								[
									A3(
									author$project$PartialViews$IconButton$iconButtonNoStyle,
									author$project$PartialViews$Icons$editIcon(
										_List_fromArray(
											[
												rtfeldman$elm_css$Css$fill(author$project$PartialViews$UiKit$theme.eh)
											])),
									_Utils_Tuple2('edit', false),
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$Events$onClick(
											author$project$Models$EditSiteMsg(
												author$project$Models$OpenEditSitePanel(site)))
										])),
									A3(
									author$project$PartialViews$IconButton$iconButtonNoStyle,
									author$project$PartialViews$Icons$deleteIcon(
										_List_fromArray(
											[
												rtfeldman$elm_css$Css$fill(author$project$PartialViews$UiKit$theme.eh)
											])),
									_Utils_Tuple2('delete', false),
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$Events$onClick(
											author$project$Models$DeleteMsg(
												author$project$Models$RequestDeleteSites(
													_List_fromArray(
														[site.dE]))))
										]))
								]))
						]) : _List_Nil))
			]));
};
var author$project$PartialViews$UiKit$sidebarBoxStyle = rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[author$project$PartialViews$UiKit$standardPadding]));
var author$project$PartialViews$SearchResult$searchResult = F2(
	function (sites, searchTerm) {
		var selectedSites = A2(
			elm$core$List$filter,
			function (site) {
				return (!elm$core$String$isEmpty(searchTerm)) && A2(
					elm$core$String$contains,
					elm$core$String$toLower(searchTerm),
					elm$core$String$toLower(site.aZ));
			},
			sites);
		var searchInProgress = elm$core$String$length(searchTerm) > 0;
		return A4(
			rtfeldman$elm_css$Html$Styled$styled,
			rtfeldman$elm_css$Html$Styled$ul,
			searchInProgress ? _List_fromArray(
				[author$project$PartialViews$UiKit$sidebarBoxStyle]) : _List_Nil,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$class('searchResult')
				]),
			(elm$core$List$length(selectedSites) > 0) ? A2(elm$core$List$map, author$project$PartialViews$CategoryTree$renderSiteEntry, selectedSites) : (searchInProgress ? _List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$text('no sites found')
				]) : _List_Nil));
	});
var author$project$Helpers$idPrefix = 'cat_';
var author$project$Helpers$getInnerTabId = function (categoryId) {
	return author$project$Helpers$idPrefix + (elm$core$String$fromInt(categoryId) + '_inner');
};
var author$project$Helpers$getOuterTabId = function (categoryId) {
	return _Utils_ap(
		author$project$Helpers$idPrefix,
		elm$core$String$fromInt(categoryId));
};
var author$project$PartialViews$CategoryTree$countNewArticlesInCategory = function (sitesInCategory) {
	return A3(
		elm$core$List$foldl,
		F2(
			function (site, numberOfNewArticlesTot) {
				return numberOfNewArticlesTot + site.dT;
			}),
		0,
		sitesInCategory);
};
var author$project$Models$EditCategory = function (a) {
	return {$: 0, a: a};
};
var author$project$Models$EditCategoryMsg = function (a) {
	return {$: 29, a: a};
};
var author$project$Models$ToggleDeleteActions = function (a) {
	return {$: 3, a: a};
};
var author$project$Models$ToggleSelectedCategory = function (a) {
	return {$: 9, a: a};
};
var rtfeldman$elm_css$Svg$Styled$Attributes$class = rtfeldman$elm_css$VirtualDom$Styled$attribute('class');
var rtfeldman$elm_css$Svg$Styled$Attributes$fill = rtfeldman$elm_css$VirtualDom$Styled$attribute('fill');
var author$project$PartialViews$Icons$folderIcon = F2(
	function (styles, selected) {
		var plusVerticalStyle = 'transition: transform 0.5s; transform-origin: center 62%;';
		return A4(
			rtfeldman$elm_css$Svg$Styled$styled,
			rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[author$project$PartialViews$Icons$iconStyle]),
				styles),
			_List_fromArray(
				[
					rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 16 16')
				]),
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							rtfeldman$elm_css$Svg$Styled$Attributes$d('M9 4L7 2H0v13h16V4z')
						]),
					_List_Nil),
					A2(
					rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							rtfeldman$elm_css$Svg$Styled$Attributes$d('M5.017 9H11v2H5.017z'),
							rtfeldman$elm_css$Svg$Styled$Attributes$fill('#fff'),
							rtfeldman$elm_css$Svg$Styled$Attributes$class('plusHorizontal')
						]),
					_List_Nil),
					A2(
					rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							rtfeldman$elm_css$Svg$Styled$Attributes$d('M7.008 7.008h2v5.983h-2z'),
							rtfeldman$elm_css$Svg$Styled$Attributes$fill('#fff'),
							rtfeldman$elm_css$Svg$Styled$Attributes$class('plusVertical'),
							rtfeldman$elm_css$Svg$Styled$Attributes$style(
							selected ? (plusVerticalStyle + 'transform: rotate(90deg);') : plusVerticalStyle)
						]),
					_List_Nil)
				]));
	});
var author$project$PartialViews$CategoryTree$renderCategoryName = F2(
	function (category, newArticlesInCategory) {
		return _Utils_ap(
			_List_fromArray(
				[
					A4(
					rtfeldman$elm_css$Html$Styled$styled,
					author$project$PartialViews$UiKit$sidebarSelectionBtn,
					_List_fromArray(
						[
							category.aD ? rtfeldman$elm_css$Css$batch(_List_Nil) : A2(author$project$PartialViews$UiKit$customCss, 'padding-right', 'calc(3.75rem + 2em)')
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('categoryBtn'),
							rtfeldman$elm_css$Html$Styled$Events$onClick(
							author$project$Models$ToggleSelectedCategory(category.dE))
						]),
					_List_fromArray(
						[
							A4(
							rtfeldman$elm_css$Html$Styled$styled,
							rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$verticalAlign(rtfeldman$elm_css$Css$middle),
									rtfeldman$elm_css$Css$marginRight(
									rtfeldman$elm_css$Css$em(0.5))
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('icon folderIcon')
								]),
							_List_fromArray(
								[
									A2(
									author$project$PartialViews$Icons$folderIcon,
									_List_fromArray(
										[
											rtfeldman$elm_css$Css$fill(author$project$PartialViews$UiKit$theme.da)
										]),
									category.aD)
								])),
							A2(
							author$project$PartialViews$UiKit$badge,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('category-numberOfArticles')
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text(
									elm$core$String$fromInt(newArticlesInCategory))
								])),
							A4(
							rtfeldman$elm_css$Html$Styled$styled,
							rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$verticalAlign(rtfeldman$elm_css$Css$middle)
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('category-name')
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text(' ' + category.aZ)
								]))
						]))
				]),
			category.aD ? _List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('category-action')
						]),
					_List_fromArray(
						[
							A3(
							author$project$PartialViews$IconButton$iconButtonNoStyle,
							author$project$PartialViews$Icons$editIcon(
								_List_fromArray(
									[
										rtfeldman$elm_css$Css$fill(author$project$PartialViews$UiKit$theme.eh)
									])),
							_Utils_Tuple2('edit', false),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Events$onClick(
									author$project$Models$EditCategoryMsg(
										author$project$Models$EditCategory(category.dE)))
								])),
							A3(
							author$project$PartialViews$IconButton$iconButtonNoStyle,
							author$project$PartialViews$Icons$deleteIcon(
								_List_fromArray(
									[
										rtfeldman$elm_css$Css$fill(author$project$PartialViews$UiKit$theme.eh)
									])),
							_Utils_Tuple2('delete', false),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Events$onClick(
									author$project$Models$ToggleDeleteActions(category.dE))
								]))
						]))
				]) : _List_Nil);
	});
var author$project$Models$EndCategoryEditing = {$: 2};
var author$project$Models$UpdateCategoryName = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var author$project$PartialViews$Icons$checkIcon = function (styles) {
	return A4(
		rtfeldman$elm_css$Svg$Styled$styled,
		rtfeldman$elm_css$Svg$Styled$svg,
		_Utils_ap(
			_List_fromArray(
				[author$project$PartialViews$Icons$iconStyle]),
			styles),
		_List_fromArray(
			[
				rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 16 16')
			]),
		_List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M13.5 2l-7.5 7.5-3.5-3.5-2.5 2.5 6 6 10-10z')
					]),
				_List_Nil)
			]));
};
var author$project$PartialViews$CategoryTree$renderEditCategory = function (category) {
	return _List_fromArray(
		[
			A4(
			rtfeldman$elm_css$Html$Styled$styled,
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$displayFlex,
					rtfeldman$elm_css$Css$width(
					rtfeldman$elm_css$Css$pct(100))
				]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$class('editCategoryName')
				]),
			_List_fromArray(
				[
					A4(
					rtfeldman$elm_css$Html$Styled$styled,
					author$project$PartialViews$UiKit$input,
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$flex(
							rtfeldman$elm_css$Css$int(1))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('editCategoryName-input'),
							rtfeldman$elm_css$Html$Styled$Attributes$id(
							'editCategoryName-' + elm$core$String$fromInt(category.dE)),
							rtfeldman$elm_css$Html$Styled$Attributes$value(category.aZ),
							rtfeldman$elm_css$Html$Styled$Events$onInput(
							A2(
								elm$core$Basics$composeL,
								author$project$Models$EditCategoryMsg,
								author$project$Models$UpdateCategoryName(category)))
						]),
					_List_Nil),
					A3(
					author$project$PartialViews$IconButton$iconButton,
					author$project$PartialViews$Icons$checkIcon(_List_Nil),
					_Utils_Tuple2('ok', false),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Events$onClick(
							author$project$Models$EditCategoryMsg(author$project$Models$EndCategoryEditing))
						]))
				]))
		]);
};
var author$project$Models$RequestDeleteCategories = function (a) {
	return {$: 0, a: a};
};
var author$project$Models$RequestDeleteCategoryAndSites = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var author$project$PartialViews$UiKit$alertBtn = A2(
	rtfeldman$elm_css$Html$Styled$styled,
	rtfeldman$elm_css$Html$Styled$button,
	_List_fromArray(
		[
			author$project$PartialViews$UiKit$btnStyle(false),
			rtfeldman$elm_css$Css$borderColor(author$project$PartialViews$UiKit$theme.c7),
			rtfeldman$elm_css$Css$backgroundColor(author$project$PartialViews$UiKit$theme.c7),
			rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$borderColor(author$project$PartialViews$UiKit$theme.c7),
					rtfeldman$elm_css$Css$backgroundColor(rtfeldman$elm_css$Css$transparent),
					rtfeldman$elm_css$Css$color(author$project$PartialViews$UiKit$theme.bB)
				]))
		]));
var author$project$PartialViews$UiKit$deleteActionsPanel = A2(
	rtfeldman$elm_css$Html$Styled$styled,
	rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$absolute),
			rtfeldman$elm_css$Css$top(
			rtfeldman$elm_css$Css$px(1)),
			rtfeldman$elm_css$Css$right(
			rtfeldman$elm_css$Css$px(1)),
			rtfeldman$elm_css$Css$displayFlex,
			rtfeldman$elm_css$Css$backgroundColor(author$project$PartialViews$UiKit$theme.c8),
			author$project$PartialViews$UiKit$transition('transform 0.5s'),
			rtfeldman$elm_css$Css$zIndex(author$project$PartialViews$UiKit$theme.cX.bO)
		]));
var rtfeldman$elm_css$Html$Styled$Attributes$disabled = rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('disabled');
var author$project$PartialViews$DeleteActions$deleteActions = F3(
	function (animationClass, category, sitesInCategoryIds) {
		return A2(
			author$project$PartialViews$UiKit$deleteActionsPanel,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$class('delete-actions' + animationClass)
				]),
			_List_fromArray(
				[
					A4(
					rtfeldman$elm_css$Html$Styled$styled,
					author$project$PartialViews$UiKit$btn,
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$height(
							rtfeldman$elm_css$Css$rem(2.5))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
							rtfeldman$elm_css$Html$Styled$Events$onClick(
							author$project$Models$DeleteMsg(
								author$project$Models$RequestDeleteCategories(
									_List_fromArray(
										[category.dE]))))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text('Delete category only')
						])),
					A4(
					rtfeldman$elm_css$Html$Styled$styled,
					author$project$PartialViews$UiKit$alertBtn,
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$height(
							rtfeldman$elm_css$Css$rem(2.5))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('button'),
							rtfeldman$elm_css$Html$Styled$Events$onClick(
							author$project$Models$DeleteMsg(
								A2(
									author$project$Models$RequestDeleteCategoryAndSites,
									_List_fromArray(
										[category.dE]),
									sitesInCategoryIds))),
							rtfeldman$elm_css$Html$Styled$Attributes$disabled(
							elm$core$List$isEmpty(sitesInCategoryIds) ? true : false)
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text('Delete sites as well')
						]))
				]));
	});
var rtfeldman$elm_css$Css$borderBottom = rtfeldman$elm_css$Css$prop1('border-bottom');
var rtfeldman$elm_css$Css$lastChild = rtfeldman$elm_css$Css$pseudoClass('last-child');
var author$project$PartialViews$UiKit$categoryWrapper = A2(
	rtfeldman$elm_css$Html$Styled$styled,
	rtfeldman$elm_css$Html$Styled$li,
	_List_fromArray(
		[
			rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$relative),
			rtfeldman$elm_css$Css$minHeight(
			rtfeldman$elm_css$Css$rem(2)),
			A3(
			rtfeldman$elm_css$Css$border3,
			rtfeldman$elm_css$Css$px(2),
			rtfeldman$elm_css$Css$solid,
			author$project$PartialViews$UiKit$theme.c9),
			rtfeldman$elm_css$Css$borderBottom(rtfeldman$elm_css$Css$zero),
			rtfeldman$elm_css$Css$lastChild(
			_List_fromArray(
				[
					A3(
					rtfeldman$elm_css$Css$borderBottom3,
					rtfeldman$elm_css$Css$px(2),
					rtfeldman$elm_css$Css$solid,
					author$project$PartialViews$UiKit$theme.c9)
				]))
		]));
var author$project$PartialViews$UiKit$tabContentOuter = function (h) {
	return A2(
		rtfeldman$elm_css$Html$Styled$styled,
		rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				author$project$PartialViews$UiKit$transition('height 0.5s'),
				rtfeldman$elm_css$Css$overflow(rtfeldman$elm_css$Css$hidden),
				rtfeldman$elm_css$Css$height(
				rtfeldman$elm_css$Css$px(h))
			]));
};
var elm$virtual_dom$VirtualDom$lazy2 = _VirtualDom_lazy2;
var elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
	return _VirtualDom_nodeNS(
		_VirtualDom_noScript(tag));
};
var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
	function (_n0, styles) {
		var newStyles = _n0.b;
		var classname = _n0.c;
		return elm$core$List$isEmpty(newStyles) ? styles : A3(elm$core$Dict$insert, classname, newStyles, styles);
	});
var rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = function (_n0) {
	var val = _n0.a;
	return val;
};
var rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
	function (_n6, _n7) {
		var key = _n6.a;
		var html = _n6.b;
		var pairs = _n7.a;
		var styles = _n7.b;
		switch (html.$) {
			case 4:
				var vdom = html.a;
				return _Utils_Tuple2(
					A2(
						elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _n9 = A3(
					elm$core$List$foldl,
					rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _n9.a;
				var finalStyles = _n9.b;
				var vdom = A3(
					elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _n10 = A3(
					elm$core$List$foldl,
					rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _n10.a;
				var finalStyles = _n10.b;
				var vdom = A4(
					elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _n11 = A3(
					elm$core$List$foldl,
					rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _n11.a;
				var finalStyles = _n11.b;
				var vdom = A3(
					elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _n12 = A3(
					elm$core$List$foldl,
					rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _n12.a;
				var finalStyles = _n12.b;
				var vdom = A4(
					elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
		}
	});
var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
	function (html, _n0) {
		var nodes = _n0.a;
		var styles = _n0.b;
		switch (html.$) {
			case 4:
				var vdomNode = html.a;
				return _Utils_Tuple2(
					A2(elm$core$List$cons, vdomNode, nodes),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _n2 = A3(
					elm$core$List$foldl,
					rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _n2.a;
				var finalStyles = _n2.b;
				var vdomNode = A3(
					elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _n3 = A3(
					elm$core$List$foldl,
					rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _n3.a;
				var finalStyles = _n3.b;
				var vdomNode = A4(
					elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _n4 = A3(
					elm$core$List$foldl,
					rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _n4.a;
				var finalStyles = _n4.b;
				var vdomNode = A3(
					elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _n5 = A3(
					elm$core$List$foldl,
					rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _n5.a;
				var finalStyles = _n5.b;
				var vdomNode = A4(
					elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(elm$core$List$cons, vdomNode, nodes),
					finalStyles);
		}
	});
var elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5(elm$core$Dict$RBNode_elm_builtin, 1, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
	});
var rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
	function (candidate, properties) {
		stylesFromPropertiesHelp:
		while (true) {
			if (!properties.b) {
				return candidate;
			} else {
				var _n1 = properties.a;
				var styles = _n1.b;
				var classname = _n1.c;
				var rest = properties.b;
				if (elm$core$String$isEmpty(classname)) {
					var $temp$candidate = candidate,
						$temp$properties = rest;
					candidate = $temp$candidate;
					properties = $temp$properties;
					continue stylesFromPropertiesHelp;
				} else {
					var $temp$candidate = elm$core$Maybe$Just(
						_Utils_Tuple2(classname, styles)),
						$temp$properties = rest;
					candidate = $temp$candidate;
					properties = $temp$properties;
					continue stylesFromPropertiesHelp;
				}
			}
		}
	});
var rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
	var _n0 = A2(rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, elm$core$Maybe$Nothing, properties);
	if (_n0.$ === 1) {
		return elm$core$Dict$empty;
	} else {
		var _n1 = _n0.a;
		var classname = _n1.a;
		var styles = _n1.b;
		return A2(elm$core$Dict$singleton, classname, styles);
	}
};
var rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
	return {$: 0, a: a};
};
var rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair = function (_n0) {
	var classname = _n0.a;
	var styles = _n0.b;
	return A2(
		rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
		styles,
		rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$ClassSelector(classname)
				])));
};
var rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
	return rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
		elm$core$List$singleton(
			rtfeldman$elm_css$Css$Preprocess$stylesheet(
				A2(
					elm$core$List$map,
					rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair,
					elm$core$Dict$toList(dict)))));
};
var rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
	return A3(
		elm$virtual_dom$VirtualDom$node,
		'style',
		_List_Nil,
		elm$core$List$singleton(
			elm$virtual_dom$VirtualDom$text(
				rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))));
};
var rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
	function (elemType, properties, children) {
		var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _n0 = A3(
			elm$core$List$foldl,
			rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _n0.a;
		var styles = _n0.b;
		var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
		return A3(
			elm$virtual_dom$VirtualDom$node,
			elemType,
			unstyledProperties,
			A2(
				elm$core$List$cons,
				styleNode,
				elm$core$List$reverse(childNodes)));
	});
var rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
	function (key, pairs) {
		containsKey:
		while (true) {
			if (!pairs.b) {
				return false;
			} else {
				var _n1 = pairs.a;
				var str = _n1.a;
				var rest = pairs.b;
				if (_Utils_eq(key, str)) {
					return true;
				} else {
					var $temp$key = key,
						$temp$pairs = rest;
					key = $temp$key;
					pairs = $temp$pairs;
					continue containsKey;
				}
			}
		}
	});
var rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
	function (_default, pairs) {
		getUnusedKey:
		while (true) {
			if (!pairs.b) {
				return _default;
			} else {
				var _n1 = pairs.a;
				var firstKey = _n1.a;
				var rest = pairs.b;
				var newKey = '_' + firstKey;
				if (A2(rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
					var $temp$default = newKey,
						$temp$pairs = rest;
					_default = $temp$default;
					pairs = $temp$pairs;
					continue getUnusedKey;
				} else {
					return newKey;
				}
			}
		}
	});
var rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
	function (allStyles, keyedChildNodes) {
		var styleNodeKey = A2(rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
		var finalNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
		return _Utils_Tuple2(styleNodeKey, finalNode);
	});
var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
	function (elemType, properties, keyedChildren) {
		var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _n0 = A3(
			elm$core$List$foldl,
			rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _n0.a;
		var styles = _n0.b;
		var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
		return A3(
			elm$virtual_dom$VirtualDom$keyedNode,
			elemType,
			unstyledProperties,
			A2(
				elm$core$List$cons,
				keyedStyleNode,
				elm$core$List$reverse(keyedChildNodes)));
	});
var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
	function (ns, elemType, properties, keyedChildren) {
		var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _n0 = A3(
			elm$core$List$foldl,
			rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _n0.a;
		var styles = _n0.b;
		var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
		return A4(
			elm$virtual_dom$VirtualDom$keyedNodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				elm$core$List$cons,
				keyedStyleNode,
				elm$core$List$reverse(keyedChildNodes)));
	});
var rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
	function (ns, elemType, properties, children) {
		var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _n0 = A3(
			elm$core$List$foldl,
			rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _n0.a;
		var styles = _n0.b;
		var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
		return A4(
			elm$virtual_dom$VirtualDom$nodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				elm$core$List$cons,
				styleNode,
				elm$core$List$reverse(childNodes)));
	});
var rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
	switch (vdom.$) {
		case 4:
			var plainNode = vdom.a;
			return plainNode;
		case 0:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
		case 1:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
		case 2:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
		default:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
	}
};
var rtfeldman$elm_css$VirtualDom$Styled$lazyHelp = F2(
	function (fn, arg) {
		return rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(
			fn(arg));
	});
var rtfeldman$elm_css$VirtualDom$Styled$lazy = F2(
	function (fn, arg) {
		return rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			A3(elm$virtual_dom$VirtualDom$lazy2, rtfeldman$elm_css$VirtualDom$Styled$lazyHelp, fn, arg));
	});
var rtfeldman$elm_css$Html$Styled$Lazy$lazy = rtfeldman$elm_css$VirtualDom$Styled$lazy;
var author$project$PartialViews$CategoryTree$renderCategory = F3(
	function (sites, panelsState, category) {
		var sitesInCategory = A2(
			author$project$Helpers$getSitesInCategories,
			_List_fromArray(
				[category.dE]),
			sites);
		var newArticlesInCategory = author$project$PartialViews$CategoryTree$countNewArticlesInCategory(sitesInCategory);
		var domId = author$project$Helpers$getOuterTabId(category.dE);
		return A2(
			author$project$PartialViews$UiKit$categoryWrapper,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$class('tab'),
					rtfeldman$elm_css$Html$Styled$Attributes$id(domId)
				]),
			_List_fromArray(
				[
					A3(
					author$project$PartialViews$DeleteActions$deleteActions,
					A4(
						author$project$PanelsManager$getPanelClass,
						'is-hidden',
						'deletePanelOpen',
						'deletePanelClosed',
						A2(author$project$PanelsManager$getPanelState, domId, panelsState)),
					category,
					author$project$Helpers$extractId(sitesInCategory)),
					A3(
					author$project$PartialViews$UiKit$sidebarRow,
					category.aD,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('tabTitle sidebarRow')
						]),
					category.dK ? author$project$PartialViews$CategoryTree$renderEditCategory(category) : A2(author$project$PartialViews$CategoryTree$renderCategoryName, category, newArticlesInCategory)),
					A3(
					author$project$PartialViews$UiKit$tabContentOuter,
					category.dB,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('tabContentOuter')
						]),
					_List_fromArray(
						[
							A4(
							rtfeldman$elm_css$Html$Styled$styled,
							rtfeldman$elm_css$Html$Styled$ul,
							_List_Nil,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('category-sitesInCategory tabContentInner'),
									rtfeldman$elm_css$Html$Styled$Attributes$id(
									author$project$Helpers$getInnerTabId(category.dE))
								]),
							A2(
								elm$core$List$map,
								rtfeldman$elm_css$Html$Styled$Lazy$lazy(author$project$PartialViews$CategoryTree$renderSiteEntry),
								sitesInCategory))
						]))
				]));
	});
var elm$virtual_dom$VirtualDom$lazy4 = _VirtualDom_lazy4;
var rtfeldman$elm_css$VirtualDom$Styled$lazyHelp3 = F4(
	function (fn, arg1, arg2, arg3) {
		return rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(
			A3(fn, arg1, arg2, arg3));
	});
var rtfeldman$elm_css$VirtualDom$Styled$lazy3 = F4(
	function (fn, arg1, arg2, arg3) {
		return rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			A5(elm$virtual_dom$VirtualDom$lazy4, rtfeldman$elm_css$VirtualDom$Styled$lazyHelp3, fn, arg1, arg2, arg3));
	});
var rtfeldman$elm_css$Html$Styled$Lazy$lazy3 = rtfeldman$elm_css$VirtualDom$Styled$lazy3;
var author$project$PartialViews$Sidebar$renderCategories = F3(
	function (categories, sites, panelsState) {
		return A4(
			rtfeldman$elm_css$Html$Styled$styled,
			rtfeldman$elm_css$Html$Styled$ul,
			_List_fromArray(
				[author$project$PartialViews$UiKit$sidebarBoxStyle]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$class('categories accordion')
				]),
			A2(
				elm$core$List$map,
				A3(rtfeldman$elm_css$Html$Styled$Lazy$lazy3, author$project$PartialViews$CategoryTree$renderCategory, sites, panelsState),
				categories));
	});
var author$project$Models$UpdateSearch = function (a) {
	return {$: 20, a: a};
};
var rtfeldman$elm_css$Css$stretch = rtfeldman$elm_css$Css$prop1('stretch');
var rtfeldman$elm_css$Html$Styled$Attributes$placeholder = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('placeholder');
var author$project$PartialViews$Sidebar$renderSearchBox = function (searchTerm) {
	return A4(
		rtfeldman$elm_css$Html$Styled$styled,
		rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$displayFlex,
				author$project$PartialViews$UiKit$standardPadding,
				rtfeldman$elm_css$Css$alignItems(rtfeldman$elm_css$Css$stretch),
				rtfeldman$elm_css$Css$flexDirection(rtfeldman$elm_css$Css$column)
			]),
		_List_fromArray(
			[
				rtfeldman$elm_css$Html$Styled$Attributes$class('searchWrapper')
			]),
		_List_fromArray(
			[
				A4(
				rtfeldman$elm_css$Html$Styled$styled,
				rtfeldman$elm_css$Html$Styled$label,
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$marginBottom(
						rtfeldman$elm_css$Css$em(0.5))
					]),
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$for('searchInput')
					]),
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$text('Search sites by name: ')
					])),
				A2(
				author$project$PartialViews$UiKit$input,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$type_('search'),
						rtfeldman$elm_css$Html$Styled$Attributes$id('searchInput'),
						rtfeldman$elm_css$Html$Styled$Attributes$placeholder('example.com'),
						rtfeldman$elm_css$Html$Styled$Events$onInput(author$project$Models$UpdateSearch),
						rtfeldman$elm_css$Html$Styled$Attributes$value(searchTerm)
					]),
				_List_Nil)
			]));
};
var author$project$Models$AddNewCategory = {$: 11};
var author$project$Models$AddNewSite = {$: 12};
var author$project$PartialViews$Icons$cogIcon = function (styles) {
	return A4(
		rtfeldman$elm_css$Svg$Styled$styled,
		rtfeldman$elm_css$Svg$Styled$svg,
		_Utils_ap(
			_List_fromArray(
				[author$project$PartialViews$Icons$iconStyle]),
			styles),
		_List_fromArray(
			[
				rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 16 16')
			]),
		_List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M14.59 9.535c-0.839-1.454-0.335-3.317 1.127-4.164l-1.572-2.723c-0.449 0.263-0.972 0.414-1.529 0.414-1.68 0-3.042-1.371-3.042-3.062h-3.145c0.004 0.522-0.126 1.051-0.406 1.535-0.839 1.454-2.706 1.948-4.17 1.106l-1.572 2.723c0.453 0.257 0.845 0.634 1.123 1.117 0.838 1.452 0.336 3.311-1.12 4.16l1.572 2.723c0.448-0.261 0.967-0.41 1.522-0.41 1.675 0 3.033 1.362 3.042 3.046h3.145c-0.001-0.517 0.129-1.040 0.406-1.519 0.838-1.452 2.7-1.947 4.163-1.11l1.572-2.723c-0.45-0.257-0.839-0.633-1.116-1.113zM8 11.24c-1.789 0-3.24-1.45-3.24-3.24s1.45-3.24 3.24-3.24c1.789 0 3.24 1.45 3.24 3.24s-1.45 3.24-3.24 3.24z')
					]),
				_List_Nil)
			]));
};
var author$project$PartialViews$Icons$plusIcon = function (styles) {
	return A4(
		rtfeldman$elm_css$Svg$Styled$styled,
		rtfeldman$elm_css$Svg$Styled$svg,
		_Utils_ap(
			_List_fromArray(
				[author$project$PartialViews$Icons$iconStyle]),
			styles),
		_List_fromArray(
			[
				rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 16 16')
			]),
		_List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$d('M15.5 6h-5.5v-5.5c0-0.276-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5v5.5h-5.5c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h5.5v5.5c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-5.5h5.5c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5z')
					]),
				_List_Nil)
			]));
};
var author$project$PartialViews$Sidebar$renderSidebarToolbar = A4(
	rtfeldman$elm_css$Html$Styled$styled,
	rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			rtfeldman$elm_css$Css$padding(author$project$PartialViews$UiKit$theme.aV),
			rtfeldman$elm_css$Css$displayFlex,
			rtfeldman$elm_css$Css$justifyContent(rtfeldman$elm_css$Css$spaceBetween)
		]),
	_List_fromArray(
		[
			rtfeldman$elm_css$Html$Styled$Attributes$class('sidebar-toolbar')
		]),
	_List_fromArray(
		[
			A3(
			author$project$PartialViews$IconButton$iconButton,
			author$project$PartialViews$Icons$plusIcon(_List_Nil),
			_Utils_Tuple2('new category', true),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$Models$AddNewCategory)
				])),
			A3(
			author$project$PartialViews$IconButton$iconButton,
			author$project$PartialViews$Icons$plusIcon(_List_Nil),
			_Utils_Tuple2('new site', true),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$Models$AddNewSite)
				])),
			A3(
			author$project$PartialViews$IconButton$iconButtonNoStyle,
			author$project$PartialViews$Icons$cogIcon(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$fill(author$project$PartialViews$UiKit$theme.da)
					])),
			_Utils_Tuple2('settings', false),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Events$onClick(
					author$project$Models$TogglePanel(4))
				]))
		]));
var author$project$PartialViews$Sidebar$renderSitesWithoutCategory = function (sitesWithoutCategory) {
	return A4(
		rtfeldman$elm_css$Html$Styled$styled,
		rtfeldman$elm_css$Html$Styled$ul,
		_List_fromArray(
			[author$project$PartialViews$UiKit$sidebarBoxStyle]),
		_List_fromArray(
			[
				rtfeldman$elm_css$Html$Styled$Attributes$class('sitesWithoutCategory')
			]),
		A2(
			elm$core$List$map,
			rtfeldman$elm_css$Html$Styled$Lazy$lazy(author$project$PartialViews$CategoryTree$renderSiteEntry),
			sitesWithoutCategory));
};
var author$project$Swiper$TouchEnd = function (a) {
	return {$: 1, a: a};
};
var author$project$Swiper$Coords = F2(
	function (clientX, clientY) {
		return {az: clientX, aA: clientY};
	});
var author$project$Swiper$coordDecoder = A3(
	elm$json$Json$Decode$map2,
	author$project$Swiper$Coords,
	A2(elm$json$Json$Decode$field, 'clientX', elm$json$Json$Decode$float),
	A2(elm$json$Json$Decode$field, 'clientY', elm$json$Json$Decode$float));
var author$project$Swiper$touchDecoder = function (eventType) {
	return A2(
		elm$json$Json$Decode$at,
		_List_fromArray(
			[eventType, '0']),
		author$project$Swiper$coordDecoder);
};
var elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			elm$virtual_dom$VirtualDom$on,
			event,
			elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var author$project$Swiper$onTouchEnd = function (msg) {
	return A2(
		elm$html$Html$Events$on,
		'touchend',
		A2(
			elm$json$Json$Decode$map,
			msg,
			A2(
				elm$json$Json$Decode$map,
				author$project$Swiper$TouchEnd,
				author$project$Swiper$touchDecoder('changedTouches'))));
};
var author$project$Swiper$TouchStart = function (a) {
	return {$: 0, a: a};
};
var author$project$Swiper$onTouchStart = function (msg) {
	return A2(
		elm$html$Html$Events$on,
		'touchstart',
		A2(
			elm$json$Json$Decode$map,
			msg,
			A2(
				elm$json$Json$Decode$map,
				author$project$Swiper$TouchStart,
				author$project$Swiper$touchDecoder('targetTouches'))));
};
var author$project$Swiper$onSwipeEvents = function (msg) {
	return _List_fromArray(
		[
			author$project$Swiper$onTouchStart(msg),
			author$project$Swiper$onTouchEnd(msg)
		]);
};
var rtfeldman$elm_css$Css$boxShadow4 = rtfeldman$elm_css$Css$prop4('box-shadow');
var rtfeldman$elm_css$Css$angleConverter = F2(
	function (suffix, angleVal) {
		return {
			cZ: 0,
			y: 0,
			ed: _Utils_ap(
				elm$core$String$fromFloat(angleVal),
				suffix)
		};
	});
var rtfeldman$elm_css$Css$deg = rtfeldman$elm_css$Css$angleConverter('deg');
var rtfeldman$elm_css$Css$rotate = function (_n0) {
	var value = _n0.ed;
	return {
		i: 0,
		ed: A2(
			rtfeldman$elm_css$Css$cssFunction,
			'rotate',
			_List_fromArray(
				[value]))
	};
};
var rtfeldman$elm_css$Css$visible = {ak: 0, x: 0, ed: 'visible', aP: 0};
var rtfeldman$elm_css$Html$Styled$aside = rtfeldman$elm_css$Html$Styled$node('aside');
var elm$virtual_dom$VirtualDom$lazy3 = _VirtualDom_lazy3;
var rtfeldman$elm_css$VirtualDom$Styled$lazyHelp2 = F3(
	function (fn, arg1, arg2) {
		return rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(
			A2(fn, arg1, arg2));
	});
var rtfeldman$elm_css$VirtualDom$Styled$lazy2 = F3(
	function (fn, arg1, arg2) {
		return rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			A4(elm$virtual_dom$VirtualDom$lazy3, rtfeldman$elm_css$VirtualDom$Styled$lazyHelp2, fn, arg1, arg2));
	});
var rtfeldman$elm_css$Html$Styled$Lazy$lazy2 = rtfeldman$elm_css$VirtualDom$Styled$lazy2;
var author$project$PartialViews$Sidebar$sidebar = F5(
	function (sites, searchTerm, categories, panelsState, sidebarCollapsed) {
		var sitesWithoutCategory = A2(
			elm$core$List$filter,
			function (site) {
				return elm$core$List$isEmpty(site.bH);
			},
			sites);
		var searchInProgress = !elm$core$String$isEmpty(searchTerm);
		return A4(
			rtfeldman$elm_css$Html$Styled$styled,
			rtfeldman$elm_css$Html$Styled$aside,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$fixed),
					rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
					rtfeldman$elm_css$Css$verticalAlign(rtfeldman$elm_css$Css$top),
					rtfeldman$elm_css$Css$top(
					A3(rtfeldman$elm_css$Css$calc, author$project$PartialViews$UiKit$theme.b_, rtfeldman$elm_css$Css$plus, author$project$PartialViews$UiKit$theme.dy)),
					rtfeldman$elm_css$Css$height(
					A3(
						rtfeldman$elm_css$Css$calc,
						rtfeldman$elm_css$Css$vh(100),
						rtfeldman$elm_css$Css$minus,
						A3(rtfeldman$elm_css$Css$calc, author$project$PartialViews$UiKit$theme.b_, rtfeldman$elm_css$Css$plus, author$project$PartialViews$UiKit$theme.dy))),
					rtfeldman$elm_css$Css$left(rtfeldman$elm_css$Css$zero),
					author$project$PartialViews$UiKit$transition('transform 0.3s, width 0.3s, box-shadow 0.3s'),
					rtfeldman$elm_css$Css$overflow(rtfeldman$elm_css$Css$auto),
					rtfeldman$elm_css$Css$maxWidth(
					rtfeldman$elm_css$Css$rem(25)),
					rtfeldman$elm_css$Css$backgroundColor(author$project$PartialViews$UiKit$theme.c8),
					rtfeldman$elm_css$Css$zIndex(author$project$PartialViews$UiKit$theme.cX.dQ),
					author$project$PartialViews$UiKit$onDesktop(
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$relative),
							rtfeldman$elm_css$Css$top(rtfeldman$elm_css$Css$zero),
							rtfeldman$elm_css$Css$zIndex(author$project$PartialViews$UiKit$theme.cX.c3),
							rtfeldman$elm_css$Css$width(
							sidebarCollapsed ? rtfeldman$elm_css$Css$rem(1.5) : rtfeldman$elm_css$Css$rem(25)),
							rtfeldman$elm_css$Css$height(rtfeldman$elm_css$Css$auto),
							rtfeldman$elm_css$Css$overflow(rtfeldman$elm_css$Css$visible),
							rtfeldman$elm_css$Css$transforms(_List_Nil),
							A4(
							rtfeldman$elm_css$Css$boxShadow4,
							rtfeldman$elm_css$Css$px(0),
							rtfeldman$elm_css$Css$px(0),
							rtfeldman$elm_css$Css$px(0),
							author$project$PartialViews$UiKit$theme.c9),
							rtfeldman$elm_css$Css$hover(
							_List_fromArray(
								[
									A4(
									rtfeldman$elm_css$Css$boxShadow4,
									rtfeldman$elm_css$Css$px(3),
									rtfeldman$elm_css$Css$px(0),
									rtfeldman$elm_css$Css$px(5),
									author$project$PartialViews$UiKit$theme.c9)
								]))
						]))
				]),
			_Utils_ap(
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$class(
						'sidebar' + (sidebarCollapsed ? ' collapsed' : ''))
					]),
				A2(
					elm$core$List$map,
					rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
					author$project$Swiper$onSwipeEvents(author$project$Models$Swiped))),
			_List_fromArray(
				[
					A4(
					author$project$PartialViews$IconButton$iconButtonStyled,
					author$project$PartialViews$Icons$arrowLeftIcon(
						_List_fromArray(
							[
								rtfeldman$elm_css$Css$fill(author$project$PartialViews$UiKit$theme.da),
								rtfeldman$elm_css$Css$width(
								rtfeldman$elm_css$Css$pct(100)),
								rtfeldman$elm_css$Css$height(
								rtfeldman$elm_css$Css$pct(100)),
								rtfeldman$elm_css$Css$transforms(
								_List_fromArray(
									[
										rtfeldman$elm_css$Css$rotate(
										sidebarCollapsed ? rtfeldman$elm_css$Css$deg(180) : rtfeldman$elm_css$Css$deg(0))
									]))
							])),
					_Utils_Tuple2('toggle siedebar', false),
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$sticky),
							rtfeldman$elm_css$Css$top(
							rtfeldman$elm_css$Css$rem(9)),
							rtfeldman$elm_css$Css$width(author$project$PartialViews$UiKit$theme.bF),
							rtfeldman$elm_css$Css$height(author$project$PartialViews$UiKit$theme.bF),
							rtfeldman$elm_css$Css$borderRadius(
							rtfeldman$elm_css$Css$pct(50)),
							rtfeldman$elm_css$Css$backgroundColor(author$project$PartialViews$UiKit$theme.c8),
							rtfeldman$elm_css$Css$overflow(rtfeldman$elm_css$Css$hidden),
							rtfeldman$elm_css$Css$opacity(
							rtfeldman$elm_css$Css$int(0)),
							author$project$PartialViews$UiKit$transition('opacity 0.3s'),
							rtfeldman$elm_css$Css$left(
							rtfeldman$elm_css$Css$rem(25)),
							rtfeldman$elm_css$Css$zIndex(
							rtfeldman$elm_css$Css$int(100)),
							rtfeldman$elm_css$Css$marginRight(
							rtfeldman$elm_css$Css$rem(-1.25)),
							A4(
							rtfeldman$elm_css$Css$boxShadow4,
							rtfeldman$elm_css$Css$px(3),
							rtfeldman$elm_css$Css$px(0),
							rtfeldman$elm_css$Css$px(15),
							author$project$PartialViews$UiKit$theme.c9),
							rtfeldman$elm_css$Css$fill(author$project$PartialViews$UiKit$theme.da),
							A3(
							rtfeldman$elm_css$Css$border3,
							rtfeldman$elm_css$Css$px(1),
							rtfeldman$elm_css$Css$solid,
							author$project$PartialViews$UiKit$theme.c9),
							rtfeldman$elm_css$Css$padding(rtfeldman$elm_css$Css$zero)
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$Models$ToggleSidebar),
							rtfeldman$elm_css$Html$Styled$Attributes$class('collapseSidebarBtn')
						])),
					A4(
					rtfeldman$elm_css$Html$Styled$styled,
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							author$project$PartialViews$UiKit$onDesktop(
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$overflow(rtfeldman$elm_css$Css$hidden),
									author$project$PartialViews$UiKit$transition('opacity 0.3s'),
									rtfeldman$elm_css$Css$opacity(
									sidebarCollapsed ? rtfeldman$elm_css$Css$int(0) : rtfeldman$elm_css$Css$int(1))
								]))
						]),
					_List_Nil,
					_List_fromArray(
						[
							A4(
							rtfeldman$elm_css$Html$Styled$styled,
							rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$width(
									rtfeldman$elm_css$Css$pct(100)),
									author$project$PartialViews$UiKit$onDesktop(
									_List_fromArray(
										[
											rtfeldman$elm_css$Css$width(
											rtfeldman$elm_css$Css$rem(25))
										]))
								]),
							_List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										author$project$PartialViews$Sidebar$renderSidebarToolbar,
										A2(rtfeldman$elm_css$Html$Styled$Lazy$lazy, author$project$PartialViews$Sidebar$renderSearchBox, searchTerm),
										A3(rtfeldman$elm_css$Html$Styled$Lazy$lazy2, author$project$PartialViews$SearchResult$searchResult, sites, searchTerm)
									]),
								(!searchInProgress) ? _List_fromArray(
									[
										A2(rtfeldman$elm_css$Html$Styled$Lazy$lazy, author$project$PartialViews$Sidebar$renderSitesWithoutCategory, sitesWithoutCategory),
										A4(rtfeldman$elm_css$Html$Styled$Lazy$lazy3, author$project$PartialViews$Sidebar$renderCategories, categories, sites, panelsState)
									]) : _List_Nil))
						]))
				]));
	});
var author$project$PartialViews$UiKit$getAnimationClassTopLayers = function (panelState) {
	return A4(author$project$PanelsManager$getPanelClass, 'is-hidden', 'slideDown', 'slideUp', panelState);
};
var author$project$PartialViews$UiKit$getModalAnimationClass = function (panelState) {
	return A4(author$project$PanelsManager$getPanelClass, 'is-hidden', 'popInCentered', 'popOutCentered', panelState);
};
var author$project$Models$CloseAllPanels = {$: 19};
var author$project$PartialViews$UiKit$pointerEventsNone = A2(rtfeldman$elm_css$Css$property, 'pointer-events', 'none');
var rtfeldman$elm_css$Css$VwUnits = 0;
var rtfeldman$elm_css$Css$vw = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'vw');
var author$project$PartialViews$UiKit$overlay = function (active) {
	var activeStyle = active ? rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$opacity(
				rtfeldman$elm_css$Css$int(1))
			])) : rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$opacity(
				rtfeldman$elm_css$Css$int(0)),
				author$project$PartialViews$UiKit$pointerEventsNone
			]));
	return A4(
		rtfeldman$elm_css$Html$Styled$styled,
		rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$fixed),
				rtfeldman$elm_css$Css$width(
				rtfeldman$elm_css$Css$vw(100)),
				rtfeldman$elm_css$Css$height(
				rtfeldman$elm_css$Css$vh(100)),
				rtfeldman$elm_css$Css$top(rtfeldman$elm_css$Css$zero),
				rtfeldman$elm_css$Css$left(rtfeldman$elm_css$Css$zero),
				rtfeldman$elm_css$Css$backgroundColor(
				A4(rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.5)),
				author$project$PartialViews$UiKit$transition('opacity 0.5s'),
				rtfeldman$elm_css$Css$zIndex(author$project$PartialViews$UiKit$theme.cX.ci),
				activeStyle
			]),
		_List_fromArray(
			[
				rtfeldman$elm_css$Html$Styled$Attributes$class('overlay'),
				rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$Models$CloseAllPanels)
			]),
		_List_Nil);
};
var author$project$View$isRefreshButtonVisible = function (sites) {
	return !elm$core$List$isEmpty(sites);
};
var rtfeldman$elm_css$Html$Styled$toUnstyled = rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
var elm$virtual_dom$VirtualDom$lazy6 = _VirtualDom_lazy6;
var rtfeldman$elm_css$VirtualDom$Styled$lazyHelp5 = F6(
	function (fn, arg1, arg2, arg3, arg4, arg5) {
		return rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(
			A5(fn, arg1, arg2, arg3, arg4, arg5));
	});
var rtfeldman$elm_css$VirtualDom$Styled$lazy5 = F6(
	function (fn, arg1, arg2, arg3, arg4, arg5) {
		return rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			A7(elm$virtual_dom$VirtualDom$lazy6, rtfeldman$elm_css$VirtualDom$Styled$lazyHelp5, fn, arg1, arg2, arg3, arg4, arg5));
	});
var rtfeldman$elm_css$Html$Styled$Lazy$lazy5 = rtfeldman$elm_css$VirtualDom$Styled$lazy5;
var elm$virtual_dom$VirtualDom$lazy7 = _VirtualDom_lazy7;
var rtfeldman$elm_css$VirtualDom$Styled$lazyHelp6 = F7(
	function (fn, arg1, arg2, arg3, arg4, arg5, arg6) {
		return rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(
			A6(fn, arg1, arg2, arg3, arg4, arg5, arg6));
	});
var rtfeldman$elm_css$VirtualDom$Styled$lazy6 = F7(
	function (fn, arg1, arg2, arg3, arg4, arg5, arg6) {
		return rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			A8(elm$virtual_dom$VirtualDom$lazy7, rtfeldman$elm_css$VirtualDom$Styled$lazyHelp6, fn, arg1, arg2, arg3, arg4, arg5, arg6));
	});
var rtfeldman$elm_css$Html$Styled$Lazy$lazy6 = rtfeldman$elm_css$VirtualDom$Styled$lazy6;
var author$project$View$view = function (model) {
	var bodyClass = 'appWrapper' + ((model.ca ? ' keyboardNavigation' : ' mouseNavigation') + ((model.bW ? ' fetchingRss' : '') + (model.cd ? ' menuOpen' : '')));
	var content = rtfeldman$elm_css$Html$Styled$toUnstyled(
		A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$class(bodyClass),
					rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$Models$SetMouseNavigation),
					author$project$Helpers$onKeyDown(author$project$Models$VerifyKeyboardNavigation)
				]),
			_List_fromArray(
				[
					author$project$PartialViews$Header$siteHeader(
					author$project$View$isRefreshButtonVisible(model.d3)),
					A2(author$project$PartialViews$ErrorContainer$errorContainer, model.cj, model.bS),
					A4(
					rtfeldman$elm_css$Html$Styled$styled,
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							author$project$PartialViews$UiKit$onDesktop(
							_List_fromArray(
								[rtfeldman$elm_css$Css$displayFlex]))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('mainWrapper')
						]),
					_List_fromArray(
						[
							A6(rtfeldman$elm_css$Html$Styled$Lazy$lazy5, author$project$PartialViews$Sidebar$sidebar, model.d3, model.cB, model.c5, model.cj, model.cD),
							A7(rtfeldman$elm_css$Html$Styled$Lazy$lazy6, author$project$PartialViews$MainContent$mainContent, model.c5, model.d3, model.c0, model.bj, model.bM, model.cD)
						])),
					author$project$PartialViews$UiKit$overlay(
					model.cd || A2(author$project$PanelsManager$isSomePanelOpen, 'Panel', model.cj)),
					A2(
					author$project$PartialViews$Modal$modal,
					model.ce,
					author$project$PartialViews$UiKit$getModalAnimationClass(
						A2(
							author$project$PanelsManager$getPanelState,
							author$project$Models$panelToString(2),
							model.cj))),
					A3(
					author$project$PartialViews$EditSiteLayer$editSiteLayer,
					author$project$PartialViews$UiKit$getAnimationClassTopLayers(
						A2(
							author$project$PanelsManager$getPanelState,
							author$project$Models$panelToString(0),
							model.cj)),
					model.cF,
					model.c5),
					author$project$PartialViews$ImportLayer$importLayer(
					author$project$PartialViews$UiKit$getAnimationClassTopLayers(
						A2(
							author$project$PanelsManager$getPanelState,
							author$project$Models$panelToString(1),
							model.cj))),
					A2(
					author$project$PartialViews$SettingsLayer$settingsLayer,
					model.bj,
					author$project$PartialViews$UiKit$getAnimationClassTopLayers(
						A2(
							author$project$PanelsManager$getPanelState,
							author$project$Models$panelToString(4),
							model.cj))),
					author$project$PartialViews$BackToTop$backToTop(model.b6)
				])));
	return {
		c4: _List_fromArray(
			[content]),
		d9: 'FlyFeed'
	};
};
var elm$browser$Browser$document = _Browser_document;
var author$project$Main$main = elm$browser$Browser$document(
	{dH: author$project$Models$init, d6: author$project$Subscriptions$subscriptions, ea: author$project$Update$update, ee: author$project$View$view});
_Platform_export({'Main':{'init':author$project$Main$main(
	elm$json$Json$Decode$succeed(0))(0)}});}(this));